import ee, { createElement as e0, useState as vn, useRef as Yl, useEffect as Ze, createContext as Gv, useContext as Iv, useMemo as Fv } from "react";
import kv from "react-dom";
function qv(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var Ef = { exports: {} }, Jo = {}, Tf = { exports: {} }, xf = {};
var Mp;
function Kv() {
  return Mp || (Mp = 1, (function(l) {
    function o(Y, X) {
      var Z = Y.length;
      Y.push(X);
      t: for (; 0 < Z; ) {
        var ut = Z - 1 >>> 1, gt = Y[ut];
        if (0 < u(gt, X))
          Y[ut] = X, Y[Z] = gt, Z = ut;
        else break t;
      }
    }
    function c(Y) {
      return Y.length === 0 ? null : Y[0];
    }
    function s(Y) {
      if (Y.length === 0) return null;
      var X = Y[0], Z = Y.pop();
      if (Z !== X) {
        Y[0] = Z;
        t: for (var ut = 0, gt = Y.length, ft = gt >>> 1; ut < ft; ) {
          var Bt = 2 * (ut + 1) - 1, rt = Y[Bt], lt = Bt + 1, wt = Y[lt];
          if (0 > u(rt, Z))
            lt < gt && 0 > u(wt, rt) ? (Y[ut] = wt, Y[lt] = Z, ut = lt) : (Y[ut] = rt, Y[Bt] = Z, ut = Bt);
          else if (lt < gt && 0 > u(wt, Z))
            Y[ut] = wt, Y[lt] = Z, ut = lt;
          else break t;
        }
      }
      return X;
    }
    function u(Y, X) {
      var Z = Y.sortIndex - X.sortIndex;
      return Z !== 0 ? Z : Y.id - X.id;
    }
    if (l.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var d = performance;
      l.unstable_now = function() {
        return d.now();
      };
    } else {
      var h = Date, p = h.now();
      l.unstable_now = function() {
        return h.now() - p;
      };
    }
    var y = [], O = [], M = 1, w = null, x = 3, $ = !1, j = !1, q = !1, I = !1, K = typeof setTimeout == "function" ? setTimeout : null, H = typeof clearTimeout == "function" ? clearTimeout : null, et = typeof setImmediate < "u" ? setImmediate : null;
    function nt(Y) {
      for (var X = c(O); X !== null; ) {
        if (X.callback === null) s(O);
        else if (X.startTime <= Y)
          s(O), X.sortIndex = X.expirationTime, o(y, X);
        else break;
        X = c(O);
      }
    }
    function V(Y) {
      if (q = !1, nt(Y), !j)
        if (c(y) !== null)
          j = !0, P || (P = !0, zt());
        else {
          var X = c(O);
          X !== null && Nt(V, X.startTime - Y);
        }
    }
    var P = !1, G = -1, W = 5, ct = -1;
    function Tt() {
      return I ? !0 : !(l.unstable_now() - ct < W);
    }
    function yt() {
      if (I = !1, P) {
        var Y = l.unstable_now();
        ct = Y;
        var X = !0;
        try {
          t: {
            j = !1, q && (q = !1, H(G), G = -1), $ = !0;
            var Z = x;
            try {
              e: {
                for (nt(Y), w = c(y); w !== null && !(w.expirationTime > Y && Tt()); ) {
                  var ut = w.callback;
                  if (typeof ut == "function") {
                    w.callback = null, x = w.priorityLevel;
                    var gt = ut(
                      w.expirationTime <= Y
                    );
                    if (Y = l.unstable_now(), typeof gt == "function") {
                      w.callback = gt, nt(Y), X = !0;
                      break e;
                    }
                    w === c(y) && s(y), nt(Y);
                  } else s(y);
                  w = c(y);
                }
                if (w !== null) X = !0;
                else {
                  var ft = c(O);
                  ft !== null && Nt(
                    V,
                    ft.startTime - Y
                  ), X = !1;
                }
              }
              break t;
            } finally {
              w = null, x = Z, $ = !1;
            }
            X = void 0;
          }
        } finally {
          X ? zt() : P = !1;
        }
      }
    }
    var zt;
    if (typeof et == "function")
      zt = function() {
        et(yt);
      };
    else if (typeof MessageChannel < "u") {
      var Ct = new MessageChannel(), le = Ct.port2;
      Ct.port1.onmessage = yt, zt = function() {
        le.postMessage(null);
      };
    } else
      zt = function() {
        K(yt, 0);
      };
    function Nt(Y, X) {
      G = K(function() {
        Y(l.unstable_now());
      }, X);
    }
    l.unstable_IdlePriority = 5, l.unstable_ImmediatePriority = 1, l.unstable_LowPriority = 4, l.unstable_NormalPriority = 3, l.unstable_Profiling = null, l.unstable_UserBlockingPriority = 2, l.unstable_cancelCallback = function(Y) {
      Y.callback = null;
    }, l.unstable_forceFrameRate = function(Y) {
      0 > Y || 125 < Y ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : W = 0 < Y ? Math.floor(1e3 / Y) : 5;
    }, l.unstable_getCurrentPriorityLevel = function() {
      return x;
    }, l.unstable_next = function(Y) {
      switch (x) {
        case 1:
        case 2:
        case 3:
          var X = 3;
          break;
        default:
          X = x;
      }
      var Z = x;
      x = X;
      try {
        return Y();
      } finally {
        x = Z;
      }
    }, l.unstable_requestPaint = function() {
      I = !0;
    }, l.unstable_runWithPriority = function(Y, X) {
      switch (Y) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          Y = 3;
      }
      var Z = x;
      x = Y;
      try {
        return X();
      } finally {
        x = Z;
      }
    }, l.unstable_scheduleCallback = function(Y, X, Z) {
      var ut = l.unstable_now();
      switch (typeof Z == "object" && Z !== null ? (Z = Z.delay, Z = typeof Z == "number" && 0 < Z ? ut + Z : ut) : Z = ut, Y) {
        case 1:
          var gt = -1;
          break;
        case 2:
          gt = 250;
          break;
        case 5:
          gt = 1073741823;
          break;
        case 4:
          gt = 1e4;
          break;
        default:
          gt = 5e3;
      }
      return gt = Z + gt, Y = {
        id: M++,
        callback: X,
        priorityLevel: Y,
        startTime: Z,
        expirationTime: gt,
        sortIndex: -1
      }, Z > ut ? (Y.sortIndex = Z, o(O, Y), c(y) === null && Y === c(O) && (q ? (H(G), G = -1) : q = !0, Nt(V, Z - ut))) : (Y.sortIndex = gt, o(y, Y), j || $ || (j = !0, P || (P = !0, zt()))), Y;
    }, l.unstable_shouldYield = Tt, l.unstable_wrapCallback = function(Y) {
      var X = x;
      return function() {
        var Z = x;
        x = X;
        try {
          return Y.apply(this, arguments);
        } finally {
          x = Z;
        }
      };
    };
  })(xf)), xf;
}
var zp;
function Zv() {
  return zp || (zp = 1, Tf.exports = Kv()), Tf.exports;
}
var Lp;
function Pv() {
  if (Lp) return Jo;
  Lp = 1;
  var l = { env: { NODE_ENV: "production" } };
  var o = Zv(), c = ee, s = kv;
  function u(t) {
    var e = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      e += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        e += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function d(t) {
    return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11);
  }
  function h(t) {
    var e = t, n = t;
    if (t.alternate) for (; e.return; ) e = e.return;
    else {
      t = e;
      do
        e = t, (e.flags & 4098) !== 0 && (n = e.return), t = e.return;
      while (t);
    }
    return e.tag === 3 ? n : null;
  }
  function p(t) {
    if (t.tag === 13) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function y(t) {
    if (t.tag === 31) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function O(t) {
    if (h(t) !== t)
      throw Error(u(188));
  }
  function M(t) {
    var e = t.alternate;
    if (!e) {
      if (e = h(t), e === null) throw Error(u(188));
      return e !== t ? null : t;
    }
    for (var n = t, a = e; ; ) {
      var i = n.return;
      if (i === null) break;
      var r = i.alternate;
      if (r === null) {
        if (a = i.return, a !== null) {
          n = a;
          continue;
        }
        break;
      }
      if (i.child === r.child) {
        for (r = i.child; r; ) {
          if (r === n) return O(i), t;
          if (r === a) return O(i), e;
          r = r.sibling;
        }
        throw Error(u(188));
      }
      if (n.return !== a.return) n = i, a = r;
      else {
        for (var f = !1, m = i.child; m; ) {
          if (m === n) {
            f = !0, n = i, a = r;
            break;
          }
          if (m === a) {
            f = !0, a = i, n = r;
            break;
          }
          m = m.sibling;
        }
        if (!f) {
          for (m = r.child; m; ) {
            if (m === n) {
              f = !0, n = r, a = i;
              break;
            }
            if (m === a) {
              f = !0, a = r, n = i;
              break;
            }
            m = m.sibling;
          }
          if (!f) throw Error(u(189));
        }
      }
      if (n.alternate !== a) throw Error(u(190));
    }
    if (n.tag !== 3) throw Error(u(188));
    return n.stateNode.current === n ? t : e;
  }
  function w(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t;
    for (t = t.child; t !== null; ) {
      if (e = w(t), e !== null) return e;
      t = t.sibling;
    }
    return null;
  }
  var x = Object.assign, $ = Symbol.for("react.element"), j = Symbol.for("react.transitional.element"), q = Symbol.for("react.portal"), I = Symbol.for("react.fragment"), K = Symbol.for("react.strict_mode"), H = Symbol.for("react.profiler"), et = Symbol.for("react.consumer"), nt = Symbol.for("react.context"), V = Symbol.for("react.forward_ref"), P = Symbol.for("react.suspense"), G = Symbol.for("react.suspense_list"), W = Symbol.for("react.memo"), ct = Symbol.for("react.lazy"), Tt = Symbol.for("react.activity"), yt = Symbol.for("react.memo_cache_sentinel"), zt = Symbol.iterator;
  function Ct(t) {
    return t === null || typeof t != "object" ? null : (t = zt && t[zt] || t["@@iterator"], typeof t == "function" ? t : null);
  }
  var le = Symbol.for("react.client.reference");
  function Nt(t) {
    if (t == null) return null;
    if (typeof t == "function")
      return t.$$typeof === le ? null : t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case I:
        return "Fragment";
      case H:
        return "Profiler";
      case K:
        return "StrictMode";
      case P:
        return "Suspense";
      case G:
        return "SuspenseList";
      case Tt:
        return "Activity";
    }
    if (typeof t == "object")
      switch (t.$$typeof) {
        case q:
          return "Portal";
        case nt:
          return t.displayName || "Context";
        case et:
          return (t._context.displayName || "Context") + ".Consumer";
        case V:
          var e = t.render;
          return t = t.displayName, t || (t = e.displayName || e.name || "", t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"), t;
        case W:
          return e = t.displayName || null, e !== null ? e : Nt(t.type) || "Memo";
        case ct:
          e = t._payload, t = t._init;
          try {
            return Nt(t(e));
          } catch {
          }
      }
    return null;
  }
  var Y = Array.isArray, X = c.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Z = s.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ut = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, gt = [], ft = -1;
  function Bt(t) {
    return { current: t };
  }
  function rt(t) {
    0 > ft || (t.current = gt[ft], gt[ft] = null, ft--);
  }
  function lt(t, e) {
    ft++, gt[ft] = t.current, t.current = e;
  }
  var wt = Bt(null), ze = Bt(null), ye = Bt(null), Sn = Bt(null);
  function On(t, e) {
    switch (lt(ye, e), lt(ze, t), lt(wt, null), e.nodeType) {
      case 9:
      case 11:
        t = (t = e.documentElement) && (t = t.namespaceURI) ? tp(t) : 0;
        break;
      default:
        if (t = e.tagName, e = e.namespaceURI)
          e = tp(e), t = ep(e, t);
        else
          switch (t) {
            case "svg":
              t = 1;
              break;
            case "math":
              t = 2;
              break;
            default:
              t = 0;
          }
    }
    rt(wt), lt(wt, t);
  }
  function ve() {
    rt(wt), rt(ze), rt(ye);
  }
  function kt(t) {
    t.memoizedState !== null && lt(Sn, t);
    var e = wt.current, n = ep(e, t.type);
    e !== n && (lt(ze, t), lt(wt, n));
  }
  function fl(t) {
    ze.current === t && (rt(wt), rt(ze)), Sn.current === t && (rt(Sn), Ko._currentValue = ut);
  }
  var qt, Wi;
  function Xt(t) {
    if (qt === void 0)
      try {
        throw Error();
      } catch (n) {
        var e = n.stack.trim().match(/\n( *(at )?)/);
        qt = e && e[1] || "", Wi = -1 < n.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < n.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + qt + t + Wi;
  }
  var Zn = !1;
  function Kl(t, e) {
    if (!t || Zn) return "";
    Zn = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (e) {
              var U = function() {
                throw Error();
              };
              if (Object.defineProperty(U.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(U, []);
                } catch (z) {
                  var D = z;
                }
                Reflect.construct(t, [], U);
              } else {
                try {
                  U.call();
                } catch (z) {
                  D = z;
                }
                t.call(U.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (z) {
                D = z;
              }
              (U = t()) && typeof U.catch == "function" && U.catch(function() {
              });
            }
          } catch (z) {
            if (z && D && typeof z.stack == "string")
              return [z.stack, D.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var i = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      i && i.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var r = a.DetermineComponentFrameRoot(), f = r[0], m = r[1];
      if (f && m) {
        var A = f.split(`
`), C = m.split(`
`);
        for (i = a = 0; a < A.length && !A[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; i < C.length && !C[i].includes(
          "DetermineComponentFrameRoot"
        ); )
          i++;
        if (a === A.length || i === C.length)
          for (a = A.length - 1, i = C.length - 1; 1 <= a && 0 <= i && A[a] !== C[i]; )
            i--;
        for (; 1 <= a && 0 <= i; a--, i--)
          if (A[a] !== C[i]) {
            if (a !== 1 || i !== 1)
              do
                if (a--, i--, 0 > i || A[a] !== C[i]) {
                  var L = `
` + A[a].replace(" at new ", " at ");
                  return t.displayName && L.includes("<anonymous>") && (L = L.replace("<anonymous>", t.displayName)), L;
                }
              while (1 <= a && 0 <= i);
            break;
          }
      }
    } finally {
      Zn = !1, Error.prepareStackTrace = n;
    }
    return (n = t ? t.displayName || t.name : "") ? Xt(n) : "";
  }
  function Bn(t, e) {
    switch (t.tag) {
      case 26:
      case 27:
      case 5:
        return Xt(t.type);
      case 16:
        return Xt("Lazy");
      case 13:
        return t.child !== e && e !== null ? Xt("Suspense Fallback") : Xt("Suspense");
      case 19:
        return Xt("SuspenseList");
      case 0:
      case 15:
        return Kl(t.type, !1);
      case 11:
        return Kl(t.type.render, !1);
      case 1:
        return Kl(t.type, !0);
      case 31:
        return Xt("Activity");
      default:
        return "";
    }
  }
  function Ji(t) {
    try {
      var e = "", n = null;
      do
        e += Bn(t, n), n = t, t = t.return;
      while (t);
      return e;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  var dl = Object.prototype.hasOwnProperty, Zl = o.unstable_scheduleCallback, Pl = o.unstable_cancelCallback, Mn = o.unstable_shouldYield, ml = o.unstable_requestPaint, ie = o.unstable_now, _i = o.unstable_getCurrentPriorityLevel, Wl = o.unstable_ImmediatePriority, Jl = o.unstable_UserBlockingPriority, ba = o.unstable_NormalPriority, Sa = o.unstable_LowPriority, hl = o.unstable_IdlePriority, _l = o.log, Er = o.unstable_setDisableYieldValue, Oa = null, Be = null;
  function cn(t) {
    if (typeof _l == "function" && Er(t), Be && typeof Be.setStrictMode == "function")
      try {
        Be.setStrictMode(Oa, t);
      } catch {
      }
  }
  var Oe = Math.clz32 ? Math.clz32 : $i, Ea = Math.log, un = Math.LN2;
  function $i(t) {
    return t >>>= 0, t === 0 ? 32 : 31 - (Ea(t) / un | 0) | 0;
  }
  var gl = 256, pl = 262144, Ta = 4194304;
  function zn(t) {
    var e = t & 42;
    if (e !== 0) return e;
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return t & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return t & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return t;
    }
  }
  function Pn(t, e, n) {
    var a = t.pendingLanes;
    if (a === 0) return 0;
    var i = 0, r = t.suspendedLanes, f = t.pingedLanes;
    t = t.warmLanes;
    var m = a & 134217727;
    return m !== 0 ? (a = m & ~r, a !== 0 ? i = zn(a) : (f &= m, f !== 0 ? i = zn(f) : n || (n = m & ~t, n !== 0 && (i = zn(n))))) : (m = a & ~r, m !== 0 ? i = zn(m) : f !== 0 ? i = zn(f) : n || (n = a & ~t, n !== 0 && (i = zn(n)))), i === 0 ? 0 : e !== 0 && e !== i && (e & r) === 0 && (r = i & -i, n = e & -e, r >= n || r === 32 && (n & 4194048) !== 0) ? e : i;
  }
  function Ln(t, e) {
    return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & e) === 0;
  }
  function sn(t, e) {
    switch (t) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return e + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Wn() {
    var t = Ta;
    return Ta <<= 1, (Ta & 62914560) === 0 && (Ta = 4194304), t;
  }
  function Al(t) {
    for (var e = [], n = 0; 31 > n; n++) e.push(t);
    return e;
  }
  function Jn(t, e) {
    t.pendingLanes |= e, e !== 268435456 && (t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0);
  }
  function Au(t, e, n, a, i, r) {
    var f = t.pendingLanes;
    t.pendingLanes = n, t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0, t.expiredLanes &= n, t.entangledLanes &= n, t.errorRecoveryDisabledLanes &= n, t.shellSuspendCounter = 0;
    var m = t.entanglements, A = t.expirationTimes, C = t.hiddenUpdates;
    for (n = f & ~n; 0 < n; ) {
      var L = 31 - Oe(n), U = 1 << L;
      m[L] = 0, A[L] = -1;
      var D = C[L];
      if (D !== null)
        for (C[L] = null, L = 0; L < D.length; L++) {
          var z = D[L];
          z !== null && (z.lane &= -536870913);
        }
      n &= ~U;
    }
    a !== 0 && to(t, a, 0), r !== 0 && i === 0 && t.tag !== 0 && (t.suspendedLanes |= r & ~(f & ~e));
  }
  function to(t, e, n) {
    t.pendingLanes |= e, t.suspendedLanes &= ~e;
    var a = 31 - Oe(e);
    t.entangledLanes |= e, t.entanglements[a] = t.entanglements[a] | 1073741824 | n & 261930;
  }
  function $l(t, e) {
    var n = t.entangledLanes |= e;
    for (t = t.entanglements; n; ) {
      var a = 31 - Oe(n), i = 1 << a;
      i & e | t[a] & e && (t[a] |= e), n &= ~i;
    }
  }
  function eo(t, e) {
    var n = e & -e;
    return n = (n & 42) !== 0 ? 1 : yl(n), (n & (t.suspendedLanes | e)) !== 0 ? 0 : n;
  }
  function yl(t) {
    switch (t) {
      case 2:
        t = 1;
        break;
      case 8:
        t = 4;
        break;
      case 32:
        t = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        t = 128;
        break;
      case 268435456:
        t = 134217728;
        break;
      default:
        t = 0;
    }
    return t;
  }
  function no(t) {
    return t &= -t, 2 < t ? 8 < t ? (t & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function xa() {
    var t = Z.p;
    return t !== 0 ? t : (t = window.event, t === void 0 ? 32 : Tp(t.type));
  }
  function Tr(t, e) {
    var n = Z.p;
    try {
      return Z.p = t, e();
    } finally {
      Z.p = n;
    }
  }
  var Rn = Math.random().toString(36).slice(2), pt = "__reactFiber$" + Rn, oe = "__reactProps$" + Rn, Ca = "__reactContainer$" + Rn, ti = "__reactEvents$" + Rn, ao = "__reactListeners$" + Rn, xr = "__reactHandles$" + Rn, lo = "__reactResources$" + Rn, vl = "__reactMarker$" + Rn;
  function io(t) {
    delete t[pt], delete t[oe], delete t[ti], delete t[ao], delete t[xr];
  }
  function Na(t) {
    var e = t[pt];
    if (e) return e;
    for (var n = t.parentNode; n; ) {
      if (e = n[Ca] || n[pt]) {
        if (n = e.alternate, e.child !== null || n !== null && n.child !== null)
          for (t = cp(t); t !== null; ) {
            if (n = t[pt]) return n;
            t = cp(t);
          }
        return e;
      }
      t = n, n = t.parentNode;
    }
    return null;
  }
  function wa(t) {
    if (t = t[pt] || t[Ca]) {
      var e = t.tag;
      if (e === 5 || e === 6 || e === 13 || e === 31 || e === 26 || e === 27 || e === 3)
        return t;
    }
    return null;
  }
  function je(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t.stateNode;
    throw Error(u(33));
  }
  function _n(t) {
    var e = t[lo];
    return e || (e = t[lo] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), e;
  }
  function Kt(t) {
    t[vl] = !0;
  }
  var Cr = /* @__PURE__ */ new Set(), Nr = {};
  function Un(t, e) {
    $n(t, e), $n(t + "Capture", e);
  }
  function $n(t, e) {
    for (Nr[t] = e, t = 0; t < e.length; t++)
      Cr.add(e[t]);
  }
  var ei = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), ni = {}, bl = {};
  function Da(t) {
    return dl.call(bl, t) ? !0 : dl.call(ni, t) ? !1 : ei.test(t) ? bl[t] = !0 : (ni[t] = !0, !1);
  }
  function Hn(t, e, n) {
    if (Da(e))
      if (n === null) t.removeAttribute(e);
      else {
        switch (typeof n) {
          case "undefined":
          case "function":
          case "symbol":
            t.removeAttribute(e);
            return;
          case "boolean":
            var a = e.toLowerCase().slice(0, 5);
            if (a !== "data-" && a !== "aria-") {
              t.removeAttribute(e);
              return;
            }
        }
        t.setAttribute(e, "" + n);
      }
  }
  function Xe(t, e, n) {
    if (n === null) t.removeAttribute(e);
    else {
      switch (typeof n) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(e);
          return;
      }
      t.setAttribute(e, "" + n);
    }
  }
  function En(t, e, n, a) {
    if (a === null) t.removeAttribute(n);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(n);
          return;
      }
      t.setAttributeNS(e, n, "" + a);
    }
  }
  function Qe(t) {
    switch (typeof t) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return t;
      case "object":
        return t;
      default:
        return "";
    }
  }
  function oo(t) {
    var e = t.type;
    return (t = t.nodeName) && t.toLowerCase() === "input" && (e === "checkbox" || e === "radio");
  }
  function wr(t, e, n) {
    var a = Object.getOwnPropertyDescriptor(
      t.constructor.prototype,
      e
    );
    if (!t.hasOwnProperty(e) && typeof a < "u" && typeof a.get == "function" && typeof a.set == "function") {
      var i = a.get, r = a.set;
      return Object.defineProperty(t, e, {
        configurable: !0,
        get: function() {
          return i.call(this);
        },
        set: function(f) {
          n = "" + f, r.call(this, f);
        }
      }), Object.defineProperty(t, e, {
        enumerable: a.enumerable
      }), {
        getValue: function() {
          return n;
        },
        setValue: function(f) {
          n = "" + f;
        },
        stopTracking: function() {
          t._valueTracker = null, delete t[e];
        }
      };
    }
  }
  function ro(t) {
    if (!t._valueTracker) {
      var e = oo(t) ? "checked" : "value";
      t._valueTracker = wr(
        t,
        e,
        "" + t[e]
      );
    }
  }
  function co(t) {
    if (!t) return !1;
    var e = t._valueTracker;
    if (!e) return !0;
    var n = e.getValue(), a = "";
    return t && (a = oo(t) ? t.checked ? "true" : "false" : t.value), t = a, t !== n ? (e.setValue(t), !0) : !1;
  }
  function ai(t) {
    if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u") return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  var yu = /[\n"\\]/g;
  function Le(t) {
    return t.replace(
      yu,
      function(e) {
        return "\\" + e.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Ba(t, e, n, a, i, r, f, m) {
    t.name = "", f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" ? t.type = f : t.removeAttribute("type"), e != null ? f === "number" ? (e === 0 && t.value === "" || t.value != e) && (t.value = "" + Qe(e)) : t.value !== "" + Qe(e) && (t.value = "" + Qe(e)) : f !== "submit" && f !== "reset" || t.removeAttribute("value"), e != null ? F(t, f, Qe(e)) : n != null ? F(t, f, Qe(n)) : a != null && t.removeAttribute("value"), i == null && r != null && (t.defaultChecked = !!r), i != null && (t.checked = i && typeof i != "function" && typeof i != "symbol"), m != null && typeof m != "function" && typeof m != "symbol" && typeof m != "boolean" ? t.name = "" + Qe(m) : t.removeAttribute("name");
  }
  function li(t, e, n, a, i, r, f, m) {
    if (r != null && typeof r != "function" && typeof r != "symbol" && typeof r != "boolean" && (t.type = r), e != null || n != null) {
      if (!(r !== "submit" && r !== "reset" || e != null)) {
        ro(t);
        return;
      }
      n = n != null ? "" + Qe(n) : "", e = e != null ? "" + Qe(e) : n, m || e === t.value || (t.value = e), t.defaultValue = e;
    }
    a = a ?? i, a = typeof a != "function" && typeof a != "symbol" && !!a, t.checked = m ? t.checked : !!a, t.defaultChecked = !!a, f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" && (t.name = f), ro(t);
  }
  function F(t, e, n) {
    e === "number" && ai(t.ownerDocument) === t || t.defaultValue === "" + n || (t.defaultValue = "" + n);
  }
  function g(t, e, n, a) {
    if (t = t.options, e) {
      e = {};
      for (var i = 0; i < n.length; i++)
        e["$" + n[i]] = !0;
      for (n = 0; n < t.length; n++)
        i = e.hasOwnProperty("$" + t[n].value), t[n].selected !== i && (t[n].selected = i), i && a && (t[n].defaultSelected = !0);
    } else {
      for (n = "" + Qe(n), e = null, i = 0; i < t.length; i++) {
        if (t[i].value === n) {
          t[i].selected = !0, a && (t[i].defaultSelected = !0);
          return;
        }
        e !== null || t[i].disabled || (e = t[i]);
      }
      e !== null && (e.selected = !0);
    }
  }
  function N(t, e, n) {
    if (e != null && (e = "" + Qe(e), e !== t.value && (t.value = e), n == null)) {
      t.defaultValue !== e && (t.defaultValue = e);
      return;
    }
    t.defaultValue = n != null ? "" + Qe(n) : "";
  }
  function k(t, e, n, a) {
    if (e == null) {
      if (a != null) {
        if (n != null) throw Error(u(92));
        if (Y(a)) {
          if (1 < a.length) throw Error(u(93));
          a = a[0];
        }
        n = a;
      }
      n == null && (n = ""), e = n;
    }
    n = Qe(e), t.defaultValue = n, a = t.textContent, a === n && a !== "" && a !== null && (t.value = a), ro(t);
  }
  function J(t, e) {
    if (e) {
      var n = t.firstChild;
      if (n && n === t.lastChild && n.nodeType === 3) {
        n.nodeValue = e;
        return;
      }
    }
    t.textContent = e;
  }
  var mt = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function St(t, e, n) {
    var a = e.indexOf("--") === 0;
    n == null || typeof n == "boolean" || n === "" ? a ? t.setProperty(e, "") : e === "float" ? t.cssFloat = "" : t[e] = "" : a ? t.setProperty(e, n) : typeof n != "number" || n === 0 || mt.has(e) ? e === "float" ? t.cssFloat = n : t[e] = ("" + n).trim() : t[e] = n + "px";
  }
  function re(t, e, n) {
    if (e != null && typeof e != "object")
      throw Error(u(62));
    if (t = t.style, n != null) {
      for (var a in n)
        !n.hasOwnProperty(a) || e != null && e.hasOwnProperty(a) || (a.indexOf("--") === 0 ? t.setProperty(a, "") : a === "float" ? t.cssFloat = "" : t[a] = "");
      for (var i in e)
        a = e[i], e.hasOwnProperty(i) && n[i] !== a && St(t, i, a);
    } else
      for (var r in e)
        e.hasOwnProperty(r) && St(t, r, e[r]);
  }
  function $t(t) {
    if (t.indexOf("-") === -1) return !1;
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ve = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Pe = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Ma(t) {
    return Pe.test("" + t) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : t;
  }
  function Zt() {
  }
  var vu = null;
  function bu(t) {
    return t = t.target || t.srcElement || window, t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === 3 ? t.parentNode : t;
  }
  var ii = null, oi = null;
  function $d(t) {
    var e = wa(t);
    if (e && (t = e.stateNode)) {
      var n = t[oe] || null;
      t: switch (t = e.stateNode, e.type) {
        case "input":
          if (Ba(
            t,
            n.value,
            n.defaultValue,
            n.defaultValue,
            n.checked,
            n.defaultChecked,
            n.type,
            n.name
          ), e = n.name, n.type === "radio" && e != null) {
            for (n = t; n.parentNode; ) n = n.parentNode;
            for (n = n.querySelectorAll(
              'input[name="' + Le(
                "" + e
              ) + '"][type="radio"]'
            ), e = 0; e < n.length; e++) {
              var a = n[e];
              if (a !== t && a.form === t.form) {
                var i = a[oe] || null;
                if (!i) throw Error(u(90));
                Ba(
                  a,
                  i.value,
                  i.defaultValue,
                  i.defaultValue,
                  i.checked,
                  i.defaultChecked,
                  i.type,
                  i.name
                );
              }
            }
            for (e = 0; e < n.length; e++)
              a = n[e], a.form === t.form && co(a);
          }
          break t;
        case "textarea":
          N(t, n.value, n.defaultValue);
          break t;
        case "select":
          e = n.value, e != null && g(t, !!n.multiple, e, !1);
      }
    }
  }
  var Su = !1;
  function tm(t, e, n) {
    if (Su) return t(e, n);
    Su = !0;
    try {
      var a = t(e);
      return a;
    } finally {
      if (Su = !1, (ii !== null || oi !== null) && (gc(), ii && (e = ii, t = oi, oi = ii = null, $d(e), t)))
        for (e = 0; e < t.length; e++) $d(t[e]);
    }
  }
  function uo(t, e) {
    var n = t.stateNode;
    if (n === null) return null;
    var a = n[oe] || null;
    if (a === null) return null;
    n = a[e];
    t: switch (e) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (a = !a.disabled) || (t = t.type, a = !(t === "button" || t === "input" || t === "select" || t === "textarea")), t = !a;
        break t;
      default:
        t = !1;
    }
    if (t) return null;
    if (n && typeof n != "function")
      throw Error(
        u(231, e, typeof n)
      );
    return n;
  }
  var ta = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Ou = !1;
  if (ta)
    try {
      var so = {};
      Object.defineProperty(so, "passive", {
        get: function() {
          Ou = !0;
        }
      }), window.addEventListener("test", so, so), window.removeEventListener("test", so, so);
    } catch {
      Ou = !1;
    }
  var za = null, Eu = null, Dr = null;
  function em() {
    if (Dr) return Dr;
    var t, e = Eu, n = e.length, a, i = "value" in za ? za.value : za.textContent, r = i.length;
    for (t = 0; t < n && e[t] === i[t]; t++) ;
    var f = n - t;
    for (a = 1; a <= f && e[n - a] === i[r - a]; a++) ;
    return Dr = i.slice(t, 1 < a ? 1 - a : void 0);
  }
  function Br(t) {
    var e = t.keyCode;
    return "charCode" in t ? (t = t.charCode, t === 0 && e === 13 && (t = 13)) : t = e, t === 10 && (t = 13), 32 <= t || t === 13 ? t : 0;
  }
  function Mr() {
    return !0;
  }
  function nm() {
    return !1;
  }
  function Ye(t) {
    function e(n, a, i, r, f) {
      this._reactName = n, this._targetInst = i, this.type = a, this.nativeEvent = r, this.target = f, this.currentTarget = null;
      for (var m in t)
        t.hasOwnProperty(m) && (n = t[m], this[m] = n ? n(r) : r[m]);
      return this.isDefaultPrevented = (r.defaultPrevented != null ? r.defaultPrevented : r.returnValue === !1) ? Mr : nm, this.isPropagationStopped = nm, this;
    }
    return x(e.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = Mr);
      },
      stopPropagation: function() {
        var n = this.nativeEvent;
        n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = Mr);
      },
      persist: function() {
      },
      isPersistent: Mr
    }), e;
  }
  var Sl = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(t) {
      return t.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, zr = Ye(Sl), fo = x({}, Sl, { view: 0, detail: 0 }), V1 = Ye(fo), Tu, xu, mo, Lr = x({}, fo, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Nu,
    button: 0,
    buttons: 0,
    relatedTarget: function(t) {
      return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
    },
    movementX: function(t) {
      return "movementX" in t ? t.movementX : (t !== mo && (mo && t.type === "mousemove" ? (Tu = t.screenX - mo.screenX, xu = t.screenY - mo.screenY) : xu = Tu = 0, mo = t), Tu);
    },
    movementY: function(t) {
      return "movementY" in t ? t.movementY : xu;
    }
  }), am = Ye(Lr), Y1 = x({}, Lr, { dataTransfer: 0 }), G1 = Ye(Y1), I1 = x({}, fo, { relatedTarget: 0 }), Cu = Ye(I1), F1 = x({}, Sl, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), k1 = Ye(F1), q1 = x({}, Sl, {
    clipboardData: function(t) {
      return "clipboardData" in t ? t.clipboardData : window.clipboardData;
    }
  }), K1 = Ye(q1), Z1 = x({}, Sl, { data: 0 }), lm = Ye(Z1), P1 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, W1 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, J1 = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function _1(t) {
    var e = this.nativeEvent;
    return e.getModifierState ? e.getModifierState(t) : (t = J1[t]) ? !!e[t] : !1;
  }
  function Nu() {
    return _1;
  }
  var $1 = x({}, fo, {
    key: function(t) {
      if (t.key) {
        var e = P1[t.key] || t.key;
        if (e !== "Unidentified") return e;
      }
      return t.type === "keypress" ? (t = Br(t), t === 13 ? "Enter" : String.fromCharCode(t)) : t.type === "keydown" || t.type === "keyup" ? W1[t.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Nu,
    charCode: function(t) {
      return t.type === "keypress" ? Br(t) : 0;
    },
    keyCode: function(t) {
      return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    },
    which: function(t) {
      return t.type === "keypress" ? Br(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    }
  }), ty = Ye($1), ey = x({}, Lr, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), im = Ye(ey), ny = x({}, fo, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Nu
  }), ay = Ye(ny), ly = x({}, Sl, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), iy = Ye(ly), oy = x({}, Lr, {
    deltaX: function(t) {
      return "deltaX" in t ? t.deltaX : "wheelDeltaX" in t ? -t.wheelDeltaX : 0;
    },
    deltaY: function(t) {
      return "deltaY" in t ? t.deltaY : "wheelDeltaY" in t ? -t.wheelDeltaY : "wheelDelta" in t ? -t.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), ry = Ye(oy), cy = x({}, Sl, {
    newState: 0,
    oldState: 0
  }), uy = Ye(cy), sy = [9, 13, 27, 32], wu = ta && "CompositionEvent" in window, ho = null;
  ta && "documentMode" in document && (ho = document.documentMode);
  var fy = ta && "TextEvent" in window && !ho, om = ta && (!wu || ho && 8 < ho && 11 >= ho), rm = " ", cm = !1;
  function um(t, e) {
    switch (t) {
      case "keyup":
        return sy.indexOf(e.keyCode) !== -1;
      case "keydown":
        return e.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function sm(t) {
    return t = t.detail, typeof t == "object" && "data" in t ? t.data : null;
  }
  var ri = !1;
  function dy(t, e) {
    switch (t) {
      case "compositionend":
        return sm(e);
      case "keypress":
        return e.which !== 32 ? null : (cm = !0, rm);
      case "textInput":
        return t = e.data, t === rm && cm ? null : t;
      default:
        return null;
    }
  }
  function my(t, e) {
    if (ri)
      return t === "compositionend" || !wu && um(t, e) ? (t = em(), Dr = Eu = za = null, ri = !1, t) : null;
    switch (t) {
      case "paste":
        return null;
      case "keypress":
        if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
          if (e.char && 1 < e.char.length)
            return e.char;
          if (e.which) return String.fromCharCode(e.which);
        }
        return null;
      case "compositionend":
        return om && e.locale !== "ko" ? null : e.data;
      default:
        return null;
    }
  }
  var hy = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function fm(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e === "input" ? !!hy[t.type] : e === "textarea";
  }
  function dm(t, e, n, a) {
    ii ? oi ? oi.push(a) : oi = [a] : ii = a, e = Oc(e, "onChange"), 0 < e.length && (n = new zr(
      "onChange",
      "change",
      null,
      n,
      a
    ), t.push({ event: n, listeners: e }));
  }
  var go = null, po = null;
  function gy(t) {
    Zg(t, 0);
  }
  function Rr(t) {
    var e = je(t);
    if (co(e)) return t;
  }
  function mm(t, e) {
    if (t === "change") return e;
  }
  var hm = !1;
  if (ta) {
    var Du;
    if (ta) {
      var Bu = "oninput" in document;
      if (!Bu) {
        var gm = document.createElement("div");
        gm.setAttribute("oninput", "return;"), Bu = typeof gm.oninput == "function";
      }
      Du = Bu;
    } else Du = !1;
    hm = Du && (!document.documentMode || 9 < document.documentMode);
  }
  function pm() {
    go && (go.detachEvent("onpropertychange", Am), po = go = null);
  }
  function Am(t) {
    if (t.propertyName === "value" && Rr(po)) {
      var e = [];
      dm(
        e,
        po,
        t,
        bu(t)
      ), tm(gy, e);
    }
  }
  function py(t, e, n) {
    t === "focusin" ? (pm(), go = e, po = n, go.attachEvent("onpropertychange", Am)) : t === "focusout" && pm();
  }
  function Ay(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown")
      return Rr(po);
  }
  function yy(t, e) {
    if (t === "click") return Rr(e);
  }
  function vy(t, e) {
    if (t === "input" || t === "change")
      return Rr(e);
  }
  function by(t, e) {
    return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
  }
  var We = typeof Object.is == "function" ? Object.is : by;
  function Ao(t, e) {
    if (We(t, e)) return !0;
    if (typeof t != "object" || t === null || typeof e != "object" || e === null)
      return !1;
    var n = Object.keys(t), a = Object.keys(e);
    if (n.length !== a.length) return !1;
    for (a = 0; a < n.length; a++) {
      var i = n[a];
      if (!dl.call(e, i) || !We(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  function ym(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function vm(t, e) {
    var n = ym(t);
    t = 0;
    for (var a; n; ) {
      if (n.nodeType === 3) {
        if (a = t + n.textContent.length, t <= e && a >= e)
          return { node: n, offset: e - t };
        t = a;
      }
      t: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break t;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = ym(n);
    }
  }
  function bm(t, e) {
    return t && e ? t === e ? !0 : t && t.nodeType === 3 ? !1 : e && e.nodeType === 3 ? bm(t, e.parentNode) : "contains" in t ? t.contains(e) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(e) & 16) : !1 : !1;
  }
  function Sm(t) {
    t = t != null && t.ownerDocument != null && t.ownerDocument.defaultView != null ? t.ownerDocument.defaultView : window;
    for (var e = ai(t.document); e instanceof t.HTMLIFrameElement; ) {
      try {
        var n = typeof e.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) t = e.contentWindow;
      else break;
      e = ai(t.document);
    }
    return e;
  }
  function Mu(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e && (e === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || e === "textarea" || t.contentEditable === "true");
  }
  var Sy = ta && "documentMode" in document && 11 >= document.documentMode, ci = null, zu = null, yo = null, Lu = !1;
  function Om(t, e, n) {
    var a = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    Lu || ci == null || ci !== ai(a) || (a = ci, "selectionStart" in a && Mu(a) ? a = { start: a.selectionStart, end: a.selectionEnd } : (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection(), a = {
      anchorNode: a.anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }), yo && Ao(yo, a) || (yo = a, a = Oc(zu, "onSelect"), 0 < a.length && (e = new zr(
      "onSelect",
      "select",
      null,
      e,
      n
    ), t.push({ event: e, listeners: a }), e.target = ci)));
  }
  function Ol(t, e) {
    var n = {};
    return n[t.toLowerCase()] = e.toLowerCase(), n["Webkit" + t] = "webkit" + e, n["Moz" + t] = "moz" + e, n;
  }
  var ui = {
    animationend: Ol("Animation", "AnimationEnd"),
    animationiteration: Ol("Animation", "AnimationIteration"),
    animationstart: Ol("Animation", "AnimationStart"),
    transitionrun: Ol("Transition", "TransitionRun"),
    transitionstart: Ol("Transition", "TransitionStart"),
    transitioncancel: Ol("Transition", "TransitionCancel"),
    transitionend: Ol("Transition", "TransitionEnd")
  }, Ru = {}, Em = {};
  ta && (Em = document.createElement("div").style, "AnimationEvent" in window || (delete ui.animationend.animation, delete ui.animationiteration.animation, delete ui.animationstart.animation), "TransitionEvent" in window || delete ui.transitionend.transition);
  function El(t) {
    if (Ru[t]) return Ru[t];
    if (!ui[t]) return t;
    var e = ui[t], n;
    for (n in e)
      if (e.hasOwnProperty(n) && n in Em)
        return Ru[t] = e[n];
    return t;
  }
  var Tm = El("animationend"), xm = El("animationiteration"), Cm = El("animationstart"), Oy = El("transitionrun"), Ey = El("transitionstart"), Ty = El("transitioncancel"), Nm = El("transitionend"), wm = /* @__PURE__ */ new Map(), Uu = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Uu.push("scrollEnd");
  function Tn(t, e) {
    wm.set(t, e), Un(e, [t]);
  }
  var Ur = typeof reportError == "function" ? reportError : function(t) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var e = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof t == "object" && t !== null && typeof t.message == "string" ? String(t.message) : String(t),
        error: t
      });
      if (!window.dispatchEvent(e)) return;
    } else if (typeof l == "object" && typeof l.emit == "function") {
      l.emit("uncaughtException", t);
      return;
    }
    console.error(t);
  }, fn = [], si = 0, Hu = 0;
  function Hr() {
    for (var t = si, e = Hu = si = 0; e < t; ) {
      var n = fn[e];
      fn[e++] = null;
      var a = fn[e];
      fn[e++] = null;
      var i = fn[e];
      fn[e++] = null;
      var r = fn[e];
      if (fn[e++] = null, a !== null && i !== null) {
        var f = a.pending;
        f === null ? i.next = i : (i.next = f.next, f.next = i), a.pending = i;
      }
      r !== 0 && Dm(n, i, r);
    }
  }
  function jr(t, e, n, a) {
    fn[si++] = t, fn[si++] = e, fn[si++] = n, fn[si++] = a, Hu |= a, t.lanes |= a, t = t.alternate, t !== null && (t.lanes |= a);
  }
  function ju(t, e, n, a) {
    return jr(t, e, n, a), Xr(t);
  }
  function Tl(t, e) {
    return jr(t, null, null, e), Xr(t);
  }
  function Dm(t, e, n) {
    t.lanes |= n;
    var a = t.alternate;
    a !== null && (a.lanes |= n);
    for (var i = !1, r = t.return; r !== null; )
      r.childLanes |= n, a = r.alternate, a !== null && (a.childLanes |= n), r.tag === 22 && (t = r.stateNode, t === null || t._visibility & 1 || (i = !0)), t = r, r = r.return;
    return t.tag === 3 ? (r = t.stateNode, i && e !== null && (i = 31 - Oe(n), t = r.hiddenUpdates, a = t[i], a === null ? t[i] = [e] : a.push(e), e.lane = n | 536870912), r) : null;
  }
  function Xr(t) {
    if (50 < Vo)
      throw Vo = 0, qs = null, Error(u(185));
    for (var e = t.return; e !== null; )
      t = e, e = t.return;
    return t.tag === 3 ? t.stateNode : null;
  }
  var fi = {};
  function xy(t, e, n, a) {
    this.tag = t, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = a, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Je(t, e, n, a) {
    return new xy(t, e, n, a);
  }
  function Xu(t) {
    return t = t.prototype, !(!t || !t.isReactComponent);
  }
  function ea(t, e) {
    var n = t.alternate;
    return n === null ? (n = Je(
      t.tag,
      e,
      t.key,
      t.mode
    ), n.elementType = t.elementType, n.type = t.type, n.stateNode = t.stateNode, n.alternate = t, t.alternate = n) : (n.pendingProps = e, n.type = t.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = t.flags & 65011712, n.childLanes = t.childLanes, n.lanes = t.lanes, n.child = t.child, n.memoizedProps = t.memoizedProps, n.memoizedState = t.memoizedState, n.updateQueue = t.updateQueue, e = t.dependencies, n.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }, n.sibling = t.sibling, n.index = t.index, n.ref = t.ref, n.refCleanup = t.refCleanup, n;
  }
  function Bm(t, e) {
    t.flags &= 65011714;
    var n = t.alternate;
    return n === null ? (t.childLanes = 0, t.lanes = e, t.child = null, t.subtreeFlags = 0, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null) : (t.childLanes = n.childLanes, t.lanes = n.lanes, t.child = n.child, t.subtreeFlags = 0, t.deletions = null, t.memoizedProps = n.memoizedProps, t.memoizedState = n.memoizedState, t.updateQueue = n.updateQueue, t.type = n.type, e = n.dependencies, t.dependencies = e === null ? null : {
      lanes: e.lanes,
      firstContext: e.firstContext
    }), t;
  }
  function Qr(t, e, n, a, i, r) {
    var f = 0;
    if (a = t, typeof t == "function") Xu(t) && (f = 1);
    else if (typeof t == "string")
      f = Bv(
        t,
        n,
        wt.current
      ) ? 26 : t === "html" || t === "head" || t === "body" ? 27 : 5;
    else
      t: switch (t) {
        case Tt:
          return t = Je(31, n, e, i), t.elementType = Tt, t.lanes = r, t;
        case I:
          return xl(n.children, i, r, e);
        case K:
          f = 8, i |= 24;
          break;
        case H:
          return t = Je(12, n, e, i | 2), t.elementType = H, t.lanes = r, t;
        case P:
          return t = Je(13, n, e, i), t.elementType = P, t.lanes = r, t;
        case G:
          return t = Je(19, n, e, i), t.elementType = G, t.lanes = r, t;
        default:
          if (typeof t == "object" && t !== null)
            switch (t.$$typeof) {
              case nt:
                f = 10;
                break t;
              case et:
                f = 9;
                break t;
              case V:
                f = 11;
                break t;
              case W:
                f = 14;
                break t;
              case ct:
                f = 16, a = null;
                break t;
            }
          f = 29, n = Error(
            u(130, t === null ? "null" : typeof t, "")
          ), a = null;
      }
    return e = Je(f, n, e, i), e.elementType = t, e.type = a, e.lanes = r, e;
  }
  function xl(t, e, n, a) {
    return t = Je(7, t, a, e), t.lanes = n, t;
  }
  function Qu(t, e, n) {
    return t = Je(6, t, null, e), t.lanes = n, t;
  }
  function Mm(t) {
    var e = Je(18, null, null, 0);
    return e.stateNode = t, e;
  }
  function Vu(t, e, n) {
    return e = Je(
      4,
      t.children !== null ? t.children : [],
      t.key,
      e
    ), e.lanes = n, e.stateNode = {
      containerInfo: t.containerInfo,
      pendingChildren: null,
      implementation: t.implementation
    }, e;
  }
  var zm = /* @__PURE__ */ new WeakMap();
  function dn(t, e) {
    if (typeof t == "object" && t !== null) {
      var n = zm.get(t);
      return n !== void 0 ? n : (e = {
        value: t,
        source: e,
        stack: Ji(e)
      }, zm.set(t, e), e);
    }
    return {
      value: t,
      source: e,
      stack: Ji(e)
    };
  }
  var di = [], mi = 0, Vr = null, vo = 0, mn = [], hn = 0, La = null, jn = 1, Xn = "";
  function na(t, e) {
    di[mi++] = vo, di[mi++] = Vr, Vr = t, vo = e;
  }
  function Lm(t, e, n) {
    mn[hn++] = jn, mn[hn++] = Xn, mn[hn++] = La, La = t;
    var a = jn;
    t = Xn;
    var i = 32 - Oe(a) - 1;
    a &= ~(1 << i), n += 1;
    var r = 32 - Oe(e) + i;
    if (30 < r) {
      var f = i - i % 5;
      r = (a & (1 << f) - 1).toString(32), a >>= f, i -= f, jn = 1 << 32 - Oe(e) + i | n << i | a, Xn = r + t;
    } else
      jn = 1 << r | n << i | a, Xn = t;
  }
  function Yu(t) {
    t.return !== null && (na(t, 1), Lm(t, 1, 0));
  }
  function Gu(t) {
    for (; t === Vr; )
      Vr = di[--mi], di[mi] = null, vo = di[--mi], di[mi] = null;
    for (; t === La; )
      La = mn[--hn], mn[hn] = null, Xn = mn[--hn], mn[hn] = null, jn = mn[--hn], mn[hn] = null;
  }
  function Rm(t, e) {
    mn[hn++] = jn, mn[hn++] = Xn, mn[hn++] = La, jn = e.id, Xn = e.overflow, La = t;
  }
  var Ee = null, Pt = null, xt = !1, Ra = null, gn = !1, Iu = Error(u(519));
  function Ua(t) {
    var e = Error(
      u(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw bo(dn(e, t)), Iu;
  }
  function Um(t) {
    var e = t.stateNode, n = t.type, a = t.memoizedProps;
    switch (e[pt] = t, e[oe] = a, n) {
      case "dialog":
        bt("cancel", e), bt("close", e);
        break;
      case "iframe":
      case "object":
      case "embed":
        bt("load", e);
        break;
      case "video":
      case "audio":
        for (n = 0; n < Go.length; n++)
          bt(Go[n], e);
        break;
      case "source":
        bt("error", e);
        break;
      case "img":
      case "image":
      case "link":
        bt("error", e), bt("load", e);
        break;
      case "details":
        bt("toggle", e);
        break;
      case "input":
        bt("invalid", e), li(
          e,
          a.value,
          a.defaultValue,
          a.checked,
          a.defaultChecked,
          a.type,
          a.name,
          !0
        );
        break;
      case "select":
        bt("invalid", e);
        break;
      case "textarea":
        bt("invalid", e), k(e, a.value, a.defaultValue, a.children);
    }
    n = a.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || e.textContent === "" + n || a.suppressHydrationWarning === !0 || _g(e.textContent, n) ? (a.popover != null && (bt("beforetoggle", e), bt("toggle", e)), a.onScroll != null && bt("scroll", e), a.onScrollEnd != null && bt("scrollend", e), a.onClick != null && (e.onclick = Zt), e = !0) : e = !1, e || Ua(t, !0);
  }
  function Hm(t) {
    for (Ee = t.return; Ee; )
      switch (Ee.tag) {
        case 5:
        case 31:
        case 13:
          gn = !1;
          return;
        case 27:
        case 3:
          gn = !0;
          return;
        default:
          Ee = Ee.return;
      }
  }
  function hi(t) {
    if (t !== Ee) return !1;
    if (!xt) return Hm(t), xt = !0, !1;
    var e = t.tag, n;
    if ((n = e !== 3 && e !== 27) && ((n = e === 5) && (n = t.type, n = !(n !== "form" && n !== "button") || cf(t.type, t.memoizedProps)), n = !n), n && Pt && Ua(t), Hm(t), e === 13) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(u(317));
      Pt = rp(t);
    } else if (e === 31) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(u(317));
      Pt = rp(t);
    } else
      e === 27 ? (e = Pt, Pa(t.type) ? (t = mf, mf = null, Pt = t) : Pt = e) : Pt = Ee ? An(t.stateNode.nextSibling) : null;
    return !0;
  }
  function Cl() {
    Pt = Ee = null, xt = !1;
  }
  function Fu() {
    var t = Ra;
    return t !== null && (ke === null ? ke = t : ke.push.apply(
      ke,
      t
    ), Ra = null), t;
  }
  function bo(t) {
    Ra === null ? Ra = [t] : Ra.push(t);
  }
  var ku = Bt(null), Nl = null, aa = null;
  function Ha(t, e, n) {
    lt(ku, e._currentValue), e._currentValue = n;
  }
  function la(t) {
    t._currentValue = ku.current, rt(ku);
  }
  function qu(t, e, n) {
    for (; t !== null; ) {
      var a = t.alternate;
      if ((t.childLanes & e) !== e ? (t.childLanes |= e, a !== null && (a.childLanes |= e)) : a !== null && (a.childLanes & e) !== e && (a.childLanes |= e), t === n) break;
      t = t.return;
    }
  }
  function Ku(t, e, n, a) {
    var i = t.child;
    for (i !== null && (i.return = t); i !== null; ) {
      var r = i.dependencies;
      if (r !== null) {
        var f = i.child;
        r = r.firstContext;
        t: for (; r !== null; ) {
          var m = r;
          r = i;
          for (var A = 0; A < e.length; A++)
            if (m.context === e[A]) {
              r.lanes |= n, m = r.alternate, m !== null && (m.lanes |= n), qu(
                r.return,
                n,
                t
              ), a || (f = null);
              break t;
            }
          r = m.next;
        }
      } else if (i.tag === 18) {
        if (f = i.return, f === null) throw Error(u(341));
        f.lanes |= n, r = f.alternate, r !== null && (r.lanes |= n), qu(f, n, t), f = null;
      } else f = i.child;
      if (f !== null) f.return = i;
      else
        for (f = i; f !== null; ) {
          if (f === t) {
            f = null;
            break;
          }
          if (i = f.sibling, i !== null) {
            i.return = f.return, f = i;
            break;
          }
          f = f.return;
        }
      i = f;
    }
  }
  function gi(t, e, n, a) {
    t = null;
    for (var i = e, r = !1; i !== null; ) {
      if (!r) {
        if ((i.flags & 524288) !== 0) r = !0;
        else if ((i.flags & 262144) !== 0) break;
      }
      if (i.tag === 10) {
        var f = i.alternate;
        if (f === null) throw Error(u(387));
        if (f = f.memoizedProps, f !== null) {
          var m = i.type;
          We(i.pendingProps.value, f.value) || (t !== null ? t.push(m) : t = [m]);
        }
      } else if (i === Sn.current) {
        if (f = i.alternate, f === null) throw Error(u(387));
        f.memoizedState.memoizedState !== i.memoizedState.memoizedState && (t !== null ? t.push(Ko) : t = [Ko]);
      }
      i = i.return;
    }
    t !== null && Ku(
      e,
      t,
      n,
      a
    ), e.flags |= 262144;
  }
  function Yr(t) {
    for (t = t.firstContext; t !== null; ) {
      if (!We(
        t.context._currentValue,
        t.memoizedValue
      ))
        return !0;
      t = t.next;
    }
    return !1;
  }
  function wl(t) {
    Nl = t, aa = null, t = t.dependencies, t !== null && (t.firstContext = null);
  }
  function Te(t) {
    return jm(Nl, t);
  }
  function Gr(t, e) {
    return Nl === null && wl(t), jm(t, e);
  }
  function jm(t, e) {
    var n = e._currentValue;
    if (e = { context: e, memoizedValue: n, next: null }, aa === null) {
      if (t === null) throw Error(u(308));
      aa = e, t.dependencies = { lanes: 0, firstContext: e }, t.flags |= 524288;
    } else aa = aa.next = e;
    return n;
  }
  var Cy = typeof AbortController < "u" ? AbortController : function() {
    var t = [], e = this.signal = {
      aborted: !1,
      addEventListener: function(n, a) {
        t.push(a);
      }
    };
    this.abort = function() {
      e.aborted = !0, t.forEach(function(n) {
        return n();
      });
    };
  }, Ny = o.unstable_scheduleCallback, wy = o.unstable_NormalPriority, se = {
    $$typeof: nt,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Zu() {
    return {
      controller: new Cy(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function So(t) {
    t.refCount--, t.refCount === 0 && Ny(wy, function() {
      t.controller.abort();
    });
  }
  var Oo = null, Pu = 0, pi = 0, Ai = null;
  function Dy(t, e) {
    if (Oo === null) {
      var n = Oo = [];
      Pu = 0, pi = _s(), Ai = {
        status: "pending",
        value: void 0,
        then: function(a) {
          n.push(a);
        }
      };
    }
    return Pu++, e.then(Xm, Xm), e;
  }
  function Xm() {
    if (--Pu === 0 && Oo !== null) {
      Ai !== null && (Ai.status = "fulfilled");
      var t = Oo;
      Oo = null, pi = 0, Ai = null;
      for (var e = 0; e < t.length; e++) (0, t[e])();
    }
  }
  function By(t, e) {
    var n = [], a = {
      status: "pending",
      value: null,
      reason: null,
      then: function(i) {
        n.push(i);
      }
    };
    return t.then(
      function() {
        a.status = "fulfilled", a.value = e;
        for (var i = 0; i < n.length; i++) (0, n[i])(e);
      },
      function(i) {
        for (a.status = "rejected", a.reason = i, i = 0; i < n.length; i++)
          (0, n[i])(void 0);
      }
    ), a;
  }
  var Qm = X.S;
  X.S = function(t, e) {
    Og = ie(), typeof e == "object" && e !== null && typeof e.then == "function" && Dy(t, e), Qm !== null && Qm(t, e);
  };
  var Dl = Bt(null);
  function Wu() {
    var t = Dl.current;
    return t !== null ? t : Ft.pooledCache;
  }
  function Ir(t, e) {
    e === null ? lt(Dl, Dl.current) : lt(Dl, e.pool);
  }
  function Vm() {
    var t = Wu();
    return t === null ? null : { parent: se._currentValue, pool: t };
  }
  var yi = Error(u(460)), Ju = Error(u(474)), Fr = Error(u(542)), kr = { then: function() {
  } };
  function Ym(t) {
    return t = t.status, t === "fulfilled" || t === "rejected";
  }
  function Gm(t, e, n) {
    switch (n = t[n], n === void 0 ? t.push(e) : n !== e && (e.then(Zt, Zt), e = n), e.status) {
      case "fulfilled":
        return e.value;
      case "rejected":
        throw t = e.reason, Fm(t), t;
      default:
        if (typeof e.status == "string") e.then(Zt, Zt);
        else {
          if (t = Ft, t !== null && 100 < t.shellSuspendCounter)
            throw Error(u(482));
          t = e, t.status = "pending", t.then(
            function(a) {
              if (e.status === "pending") {
                var i = e;
                i.status = "fulfilled", i.value = a;
              }
            },
            function(a) {
              if (e.status === "pending") {
                var i = e;
                i.status = "rejected", i.reason = a;
              }
            }
          );
        }
        switch (e.status) {
          case "fulfilled":
            return e.value;
          case "rejected":
            throw t = e.reason, Fm(t), t;
        }
        throw Ml = e, yi;
    }
  }
  function Bl(t) {
    try {
      var e = t._init;
      return e(t._payload);
    } catch (n) {
      throw n !== null && typeof n == "object" && typeof n.then == "function" ? (Ml = n, yi) : n;
    }
  }
  var Ml = null;
  function Im() {
    if (Ml === null) throw Error(u(459));
    var t = Ml;
    return Ml = null, t;
  }
  function Fm(t) {
    if (t === yi || t === Fr)
      throw Error(u(483));
  }
  var vi = null, Eo = 0;
  function qr(t) {
    var e = Eo;
    return Eo += 1, vi === null && (vi = []), Gm(vi, t, e);
  }
  function To(t, e) {
    e = e.props.ref, t.ref = e !== void 0 ? e : null;
  }
  function Kr(t, e) {
    throw e.$$typeof === $ ? Error(u(525)) : (t = Object.prototype.toString.call(e), Error(
      u(
        31,
        t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t
      )
    ));
  }
  function km(t) {
    function e(S, v) {
      if (t) {
        var T = S.deletions;
        T === null ? (S.deletions = [v], S.flags |= 16) : T.push(v);
      }
    }
    function n(S, v) {
      if (!t) return null;
      for (; v !== null; )
        e(S, v), v = v.sibling;
      return null;
    }
    function a(S) {
      for (var v = /* @__PURE__ */ new Map(); S !== null; )
        S.key !== null ? v.set(S.key, S) : v.set(S.index, S), S = S.sibling;
      return v;
    }
    function i(S, v) {
      return S = ea(S, v), S.index = 0, S.sibling = null, S;
    }
    function r(S, v, T) {
      return S.index = T, t ? (T = S.alternate, T !== null ? (T = T.index, T < v ? (S.flags |= 67108866, v) : T) : (S.flags |= 67108866, v)) : (S.flags |= 1048576, v);
    }
    function f(S) {
      return t && S.alternate === null && (S.flags |= 67108866), S;
    }
    function m(S, v, T, R) {
      return v === null || v.tag !== 6 ? (v = Qu(T, S.mode, R), v.return = S, v) : (v = i(v, T), v.return = S, v);
    }
    function A(S, v, T, R) {
      var it = T.type;
      return it === I ? L(
        S,
        v,
        T.props.children,
        R,
        T.key
      ) : v !== null && (v.elementType === it || typeof it == "object" && it !== null && it.$$typeof === ct && Bl(it) === v.type) ? (v = i(v, T.props), To(v, T), v.return = S, v) : (v = Qr(
        T.type,
        T.key,
        T.props,
        null,
        S.mode,
        R
      ), To(v, T), v.return = S, v);
    }
    function C(S, v, T, R) {
      return v === null || v.tag !== 4 || v.stateNode.containerInfo !== T.containerInfo || v.stateNode.implementation !== T.implementation ? (v = Vu(T, S.mode, R), v.return = S, v) : (v = i(v, T.children || []), v.return = S, v);
    }
    function L(S, v, T, R, it) {
      return v === null || v.tag !== 7 ? (v = xl(
        T,
        S.mode,
        R,
        it
      ), v.return = S, v) : (v = i(v, T), v.return = S, v);
    }
    function U(S, v, T) {
      if (typeof v == "string" && v !== "" || typeof v == "number" || typeof v == "bigint")
        return v = Qu(
          "" + v,
          S.mode,
          T
        ), v.return = S, v;
      if (typeof v == "object" && v !== null) {
        switch (v.$$typeof) {
          case j:
            return T = Qr(
              v.type,
              v.key,
              v.props,
              null,
              S.mode,
              T
            ), To(T, v), T.return = S, T;
          case q:
            return v = Vu(
              v,
              S.mode,
              T
            ), v.return = S, v;
          case ct:
            return v = Bl(v), U(S, v, T);
        }
        if (Y(v) || Ct(v))
          return v = xl(
            v,
            S.mode,
            T,
            null
          ), v.return = S, v;
        if (typeof v.then == "function")
          return U(S, qr(v), T);
        if (v.$$typeof === nt)
          return U(
            S,
            Gr(S, v),
            T
          );
        Kr(S, v);
      }
      return null;
    }
    function D(S, v, T, R) {
      var it = v !== null ? v.key : null;
      if (typeof T == "string" && T !== "" || typeof T == "number" || typeof T == "bigint")
        return it !== null ? null : m(S, v, "" + T, R);
      if (typeof T == "object" && T !== null) {
        switch (T.$$typeof) {
          case j:
            return T.key === it ? A(S, v, T, R) : null;
          case q:
            return T.key === it ? C(S, v, T, R) : null;
          case ct:
            return T = Bl(T), D(S, v, T, R);
        }
        if (Y(T) || Ct(T))
          return it !== null ? null : L(S, v, T, R, null);
        if (typeof T.then == "function")
          return D(
            S,
            v,
            qr(T),
            R
          );
        if (T.$$typeof === nt)
          return D(
            S,
            v,
            Gr(S, T),
            R
          );
        Kr(S, T);
      }
      return null;
    }
    function z(S, v, T, R, it) {
      if (typeof R == "string" && R !== "" || typeof R == "number" || typeof R == "bigint")
        return S = S.get(T) || null, m(v, S, "" + R, it);
      if (typeof R == "object" && R !== null) {
        switch (R.$$typeof) {
          case j:
            return S = S.get(
              R.key === null ? T : R.key
            ) || null, A(v, S, R, it);
          case q:
            return S = S.get(
              R.key === null ? T : R.key
            ) || null, C(v, S, R, it);
          case ct:
            return R = Bl(R), z(
              S,
              v,
              T,
              R,
              it
            );
        }
        if (Y(R) || Ct(R))
          return S = S.get(T) || null, L(v, S, R, it, null);
        if (typeof R.then == "function")
          return z(
            S,
            v,
            T,
            qr(R),
            it
          );
        if (R.$$typeof === nt)
          return z(
            S,
            v,
            T,
            Gr(v, R),
            it
          );
        Kr(v, R);
      }
      return null;
    }
    function _(S, v, T, R) {
      for (var it = null, Lt = null, tt = v, ht = v = 0, Et = null; tt !== null && ht < T.length; ht++) {
        tt.index > ht ? (Et = tt, tt = null) : Et = tt.sibling;
        var Rt = D(
          S,
          tt,
          T[ht],
          R
        );
        if (Rt === null) {
          tt === null && (tt = Et);
          break;
        }
        t && tt && Rt.alternate === null && e(S, tt), v = r(Rt, v, ht), Lt === null ? it = Rt : Lt.sibling = Rt, Lt = Rt, tt = Et;
      }
      if (ht === T.length)
        return n(S, tt), xt && na(S, ht), it;
      if (tt === null) {
        for (; ht < T.length; ht++)
          tt = U(S, T[ht], R), tt !== null && (v = r(
            tt,
            v,
            ht
          ), Lt === null ? it = tt : Lt.sibling = tt, Lt = tt);
        return xt && na(S, ht), it;
      }
      for (tt = a(tt); ht < T.length; ht++)
        Et = z(
          tt,
          S,
          ht,
          T[ht],
          R
        ), Et !== null && (t && Et.alternate !== null && tt.delete(
          Et.key === null ? ht : Et.key
        ), v = r(
          Et,
          v,
          ht
        ), Lt === null ? it = Et : Lt.sibling = Et, Lt = Et);
      return t && tt.forEach(function(tl) {
        return e(S, tl);
      }), xt && na(S, ht), it;
    }
    function ot(S, v, T, R) {
      if (T == null) throw Error(u(151));
      for (var it = null, Lt = null, tt = v, ht = v = 0, Et = null, Rt = T.next(); tt !== null && !Rt.done; ht++, Rt = T.next()) {
        tt.index > ht ? (Et = tt, tt = null) : Et = tt.sibling;
        var tl = D(S, tt, Rt.value, R);
        if (tl === null) {
          tt === null && (tt = Et);
          break;
        }
        t && tt && tl.alternate === null && e(S, tt), v = r(tl, v, ht), Lt === null ? it = tl : Lt.sibling = tl, Lt = tl, tt = Et;
      }
      if (Rt.done)
        return n(S, tt), xt && na(S, ht), it;
      if (tt === null) {
        for (; !Rt.done; ht++, Rt = T.next())
          Rt = U(S, Rt.value, R), Rt !== null && (v = r(Rt, v, ht), Lt === null ? it = Rt : Lt.sibling = Rt, Lt = Rt);
        return xt && na(S, ht), it;
      }
      for (tt = a(tt); !Rt.done; ht++, Rt = T.next())
        Rt = z(tt, S, ht, Rt.value, R), Rt !== null && (t && Rt.alternate !== null && tt.delete(Rt.key === null ? ht : Rt.key), v = r(Rt, v, ht), Lt === null ? it = Rt : Lt.sibling = Rt, Lt = Rt);
      return t && tt.forEach(function(Yv) {
        return e(S, Yv);
      }), xt && na(S, ht), it;
    }
    function It(S, v, T, R) {
      if (typeof T == "object" && T !== null && T.type === I && T.key === null && (T = T.props.children), typeof T == "object" && T !== null) {
        switch (T.$$typeof) {
          case j:
            t: {
              for (var it = T.key; v !== null; ) {
                if (v.key === it) {
                  if (it = T.type, it === I) {
                    if (v.tag === 7) {
                      n(
                        S,
                        v.sibling
                      ), R = i(
                        v,
                        T.props.children
                      ), R.return = S, S = R;
                      break t;
                    }
                  } else if (v.elementType === it || typeof it == "object" && it !== null && it.$$typeof === ct && Bl(it) === v.type) {
                    n(
                      S,
                      v.sibling
                    ), R = i(v, T.props), To(R, T), R.return = S, S = R;
                    break t;
                  }
                  n(S, v);
                  break;
                } else e(S, v);
                v = v.sibling;
              }
              T.type === I ? (R = xl(
                T.props.children,
                S.mode,
                R,
                T.key
              ), R.return = S, S = R) : (R = Qr(
                T.type,
                T.key,
                T.props,
                null,
                S.mode,
                R
              ), To(R, T), R.return = S, S = R);
            }
            return f(S);
          case q:
            t: {
              for (it = T.key; v !== null; ) {
                if (v.key === it)
                  if (v.tag === 4 && v.stateNode.containerInfo === T.containerInfo && v.stateNode.implementation === T.implementation) {
                    n(
                      S,
                      v.sibling
                    ), R = i(v, T.children || []), R.return = S, S = R;
                    break t;
                  } else {
                    n(S, v);
                    break;
                  }
                else e(S, v);
                v = v.sibling;
              }
              R = Vu(T, S.mode, R), R.return = S, S = R;
            }
            return f(S);
          case ct:
            return T = Bl(T), It(
              S,
              v,
              T,
              R
            );
        }
        if (Y(T))
          return _(
            S,
            v,
            T,
            R
          );
        if (Ct(T)) {
          if (it = Ct(T), typeof it != "function") throw Error(u(150));
          return T = it.call(T), ot(
            S,
            v,
            T,
            R
          );
        }
        if (typeof T.then == "function")
          return It(
            S,
            v,
            qr(T),
            R
          );
        if (T.$$typeof === nt)
          return It(
            S,
            v,
            Gr(S, T),
            R
          );
        Kr(S, T);
      }
      return typeof T == "string" && T !== "" || typeof T == "number" || typeof T == "bigint" ? (T = "" + T, v !== null && v.tag === 6 ? (n(S, v.sibling), R = i(v, T), R.return = S, S = R) : (n(S, v), R = Qu(T, S.mode, R), R.return = S, S = R), f(S)) : n(S, v);
    }
    return function(S, v, T, R) {
      try {
        Eo = 0;
        var it = It(
          S,
          v,
          T,
          R
        );
        return vi = null, it;
      } catch (tt) {
        if (tt === yi || tt === Fr) throw tt;
        var Lt = Je(29, tt, null, S.mode);
        return Lt.lanes = R, Lt.return = S, Lt;
      } finally {
      }
    };
  }
  var zl = km(!0), qm = km(!1), ja = !1;
  function _u(t) {
    t.updateQueue = {
      baseState: t.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function $u(t, e) {
    t = t.updateQueue, e.updateQueue === t && (e.updateQueue = {
      baseState: t.baseState,
      firstBaseUpdate: t.firstBaseUpdate,
      lastBaseUpdate: t.lastBaseUpdate,
      shared: t.shared,
      callbacks: null
    });
  }
  function Xa(t) {
    return { lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function Qa(t, e, n) {
    var a = t.updateQueue;
    if (a === null) return null;
    if (a = a.shared, (Ut & 2) !== 0) {
      var i = a.pending;
      return i === null ? e.next = e : (e.next = i.next, i.next = e), a.pending = e, e = Xr(t), Dm(t, null, n), e;
    }
    return jr(t, a, e, n), Xr(t);
  }
  function xo(t, e, n) {
    if (e = e.updateQueue, e !== null && (e = e.shared, (n & 4194048) !== 0)) {
      var a = e.lanes;
      a &= t.pendingLanes, n |= a, e.lanes = n, $l(t, n);
    }
  }
  function ts(t, e) {
    var n = t.updateQueue, a = t.alternate;
    if (a !== null && (a = a.updateQueue, n === a)) {
      var i = null, r = null;
      if (n = n.firstBaseUpdate, n !== null) {
        do {
          var f = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null
          };
          r === null ? i = r = f : r = r.next = f, n = n.next;
        } while (n !== null);
        r === null ? i = r = e : r = r.next = e;
      } else i = r = e;
      n = {
        baseState: a.baseState,
        firstBaseUpdate: i,
        lastBaseUpdate: r,
        shared: a.shared,
        callbacks: a.callbacks
      }, t.updateQueue = n;
      return;
    }
    t = n.lastBaseUpdate, t === null ? n.firstBaseUpdate = e : t.next = e, n.lastBaseUpdate = e;
  }
  var es = !1;
  function Co() {
    if (es) {
      var t = Ai;
      if (t !== null) throw t;
    }
  }
  function No(t, e, n, a) {
    es = !1;
    var i = t.updateQueue;
    ja = !1;
    var r = i.firstBaseUpdate, f = i.lastBaseUpdate, m = i.shared.pending;
    if (m !== null) {
      i.shared.pending = null;
      var A = m, C = A.next;
      A.next = null, f === null ? r = C : f.next = C, f = A;
      var L = t.alternate;
      L !== null && (L = L.updateQueue, m = L.lastBaseUpdate, m !== f && (m === null ? L.firstBaseUpdate = C : m.next = C, L.lastBaseUpdate = A));
    }
    if (r !== null) {
      var U = i.baseState;
      f = 0, L = C = A = null, m = r;
      do {
        var D = m.lane & -536870913, z = D !== m.lane;
        if (z ? (Ot & D) === D : (a & D) === D) {
          D !== 0 && D === pi && (es = !0), L !== null && (L = L.next = {
            lane: 0,
            tag: m.tag,
            payload: m.payload,
            callback: null,
            next: null
          });
          t: {
            var _ = t, ot = m;
            D = e;
            var It = n;
            switch (ot.tag) {
              case 1:
                if (_ = ot.payload, typeof _ == "function") {
                  U = _.call(It, U, D);
                  break t;
                }
                U = _;
                break t;
              case 3:
                _.flags = _.flags & -65537 | 128;
              case 0:
                if (_ = ot.payload, D = typeof _ == "function" ? _.call(It, U, D) : _, D == null) break t;
                U = x({}, U, D);
                break t;
              case 2:
                ja = !0;
            }
          }
          D = m.callback, D !== null && (t.flags |= 64, z && (t.flags |= 8192), z = i.callbacks, z === null ? i.callbacks = [D] : z.push(D));
        } else
          z = {
            lane: D,
            tag: m.tag,
            payload: m.payload,
            callback: m.callback,
            next: null
          }, L === null ? (C = L = z, A = U) : L = L.next = z, f |= D;
        if (m = m.next, m === null) {
          if (m = i.shared.pending, m === null)
            break;
          z = m, m = z.next, z.next = null, i.lastBaseUpdate = z, i.shared.pending = null;
        }
      } while (!0);
      L === null && (A = U), i.baseState = A, i.firstBaseUpdate = C, i.lastBaseUpdate = L, r === null && (i.shared.lanes = 0), Fa |= f, t.lanes = f, t.memoizedState = U;
    }
  }
  function Km(t, e) {
    if (typeof t != "function")
      throw Error(u(191, t));
    t.call(e);
  }
  function Zm(t, e) {
    var n = t.callbacks;
    if (n !== null)
      for (t.callbacks = null, t = 0; t < n.length; t++)
        Km(n[t], e);
  }
  var bi = Bt(null), Zr = Bt(0);
  function Pm(t, e) {
    t = ma, lt(Zr, t), lt(bi, e), ma = t | e.baseLanes;
  }
  function ns() {
    lt(Zr, ma), lt(bi, bi.current);
  }
  function as() {
    ma = Zr.current, rt(bi), rt(Zr);
  }
  var _e = Bt(null), pn = null;
  function Va(t) {
    var e = t.alternate;
    lt(ce, ce.current & 1), lt(_e, t), pn === null && (e === null || bi.current !== null || e.memoizedState !== null) && (pn = t);
  }
  function ls(t) {
    lt(ce, ce.current), lt(_e, t), pn === null && (pn = t);
  }
  function Wm(t) {
    t.tag === 22 ? (lt(ce, ce.current), lt(_e, t), pn === null && (pn = t)) : Ya();
  }
  function Ya() {
    lt(ce, ce.current), lt(_e, _e.current);
  }
  function $e(t) {
    rt(_e), pn === t && (pn = null), rt(ce);
  }
  var ce = Bt(0);
  function Pr(t) {
    for (var e = t; e !== null; ) {
      if (e.tag === 13) {
        var n = e.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || ff(n) || df(n)))
          return e;
      } else if (e.tag === 19 && (e.memoizedProps.revealOrder === "forwards" || e.memoizedProps.revealOrder === "backwards" || e.memoizedProps.revealOrder === "unstable_legacy-backwards" || e.memoizedProps.revealOrder === "together")) {
        if ((e.flags & 128) !== 0) return e;
      } else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) return null;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    return null;
  }
  var ia = 0, dt = null, Yt = null, fe = null, Wr = !1, Si = !1, Ll = !1, Jr = 0, wo = 0, Oi = null, My = 0;
  function ne() {
    throw Error(u(321));
  }
  function is(t, e) {
    if (e === null) return !1;
    for (var n = 0; n < e.length && n < t.length; n++)
      if (!We(t[n], e[n])) return !1;
    return !0;
  }
  function os(t, e, n, a, i, r) {
    return ia = r, dt = e, e.memoizedState = null, e.updateQueue = null, e.lanes = 0, X.H = t === null || t.memoizedState === null ? Lh : Ss, Ll = !1, r = n(a, i), Ll = !1, Si && (r = _m(
      e,
      n,
      a,
      i
    )), Jm(t), r;
  }
  function Jm(t) {
    X.H = Mo;
    var e = Yt !== null && Yt.next !== null;
    if (ia = 0, fe = Yt = dt = null, Wr = !1, wo = 0, Oi = null, e) throw Error(u(300));
    t === null || de || (t = t.dependencies, t !== null && Yr(t) && (de = !0));
  }
  function _m(t, e, n, a) {
    dt = t;
    var i = 0;
    do {
      if (Si && (Oi = null), wo = 0, Si = !1, 25 <= i) throw Error(u(301));
      if (i += 1, fe = Yt = null, t.updateQueue != null) {
        var r = t.updateQueue;
        r.lastEffect = null, r.events = null, r.stores = null, r.memoCache != null && (r.memoCache.index = 0);
      }
      X.H = Rh, r = e(n, a);
    } while (Si);
    return r;
  }
  function zy() {
    var t = X.H, e = t.useState()[0];
    return e = typeof e.then == "function" ? Do(e) : e, t = t.useState()[0], (Yt !== null ? Yt.memoizedState : null) !== t && (dt.flags |= 1024), e;
  }
  function rs() {
    var t = Jr !== 0;
    return Jr = 0, t;
  }
  function cs(t, e, n) {
    e.updateQueue = t.updateQueue, e.flags &= -2053, t.lanes &= ~n;
  }
  function us(t) {
    if (Wr) {
      for (t = t.memoizedState; t !== null; ) {
        var e = t.queue;
        e !== null && (e.pending = null), t = t.next;
      }
      Wr = !1;
    }
    ia = 0, fe = Yt = dt = null, Si = !1, wo = Jr = 0, Oi = null;
  }
  function Re() {
    var t = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return fe === null ? dt.memoizedState = fe = t : fe = fe.next = t, fe;
  }
  function ue() {
    if (Yt === null) {
      var t = dt.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = Yt.next;
    var e = fe === null ? dt.memoizedState : fe.next;
    if (e !== null)
      fe = e, Yt = t;
    else {
      if (t === null)
        throw dt.alternate === null ? Error(u(467)) : Error(u(310));
      Yt = t, t = {
        memoizedState: Yt.memoizedState,
        baseState: Yt.baseState,
        baseQueue: Yt.baseQueue,
        queue: Yt.queue,
        next: null
      }, fe === null ? dt.memoizedState = fe = t : fe = fe.next = t;
    }
    return fe;
  }
  function _r() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Do(t) {
    var e = wo;
    return wo += 1, Oi === null && (Oi = []), t = Gm(Oi, t, e), e = dt, (fe === null ? e.memoizedState : fe.next) === null && (e = e.alternate, X.H = e === null || e.memoizedState === null ? Lh : Ss), t;
  }
  function $r(t) {
    if (t !== null && typeof t == "object") {
      if (typeof t.then == "function") return Do(t);
      if (t.$$typeof === nt) return Te(t);
    }
    throw Error(u(438, String(t)));
  }
  function ss(t) {
    var e = null, n = dt.updateQueue;
    if (n !== null && (e = n.memoCache), e == null) {
      var a = dt.alternate;
      a !== null && (a = a.updateQueue, a !== null && (a = a.memoCache, a != null && (e = {
        data: a.data.map(function(i) {
          return i.slice();
        }),
        index: 0
      })));
    }
    if (e == null && (e = { data: [], index: 0 }), n === null && (n = _r(), dt.updateQueue = n), n.memoCache = e, n = e.data[e.index], n === void 0)
      for (n = e.data[e.index] = Array(t), a = 0; a < t; a++)
        n[a] = yt;
    return e.index++, n;
  }
  function oa(t, e) {
    return typeof e == "function" ? e(t) : e;
  }
  function tc(t) {
    var e = ue();
    return fs(e, Yt, t);
  }
  function fs(t, e, n) {
    var a = t.queue;
    if (a === null) throw Error(u(311));
    a.lastRenderedReducer = n;
    var i = t.baseQueue, r = a.pending;
    if (r !== null) {
      if (i !== null) {
        var f = i.next;
        i.next = r.next, r.next = f;
      }
      e.baseQueue = i = r, a.pending = null;
    }
    if (r = t.baseState, i === null) t.memoizedState = r;
    else {
      e = i.next;
      var m = f = null, A = null, C = e, L = !1;
      do {
        var U = C.lane & -536870913;
        if (U !== C.lane ? (Ot & U) === U : (ia & U) === U) {
          var D = C.revertLane;
          if (D === 0)
            A !== null && (A = A.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: C.action,
              hasEagerState: C.hasEagerState,
              eagerState: C.eagerState,
              next: null
            }), U === pi && (L = !0);
          else if ((ia & D) === D) {
            C = C.next, D === pi && (L = !0);
            continue;
          } else
            U = {
              lane: 0,
              revertLane: C.revertLane,
              gesture: null,
              action: C.action,
              hasEagerState: C.hasEagerState,
              eagerState: C.eagerState,
              next: null
            }, A === null ? (m = A = U, f = r) : A = A.next = U, dt.lanes |= D, Fa |= D;
          U = C.action, Ll && n(r, U), r = C.hasEagerState ? C.eagerState : n(r, U);
        } else
          D = {
            lane: U,
            revertLane: C.revertLane,
            gesture: C.gesture,
            action: C.action,
            hasEagerState: C.hasEagerState,
            eagerState: C.eagerState,
            next: null
          }, A === null ? (m = A = D, f = r) : A = A.next = D, dt.lanes |= U, Fa |= U;
        C = C.next;
      } while (C !== null && C !== e);
      if (A === null ? f = r : A.next = m, !We(r, t.memoizedState) && (de = !0, L && (n = Ai, n !== null)))
        throw n;
      t.memoizedState = r, t.baseState = f, t.baseQueue = A, a.lastRenderedState = r;
    }
    return i === null && (a.lanes = 0), [t.memoizedState, a.dispatch];
  }
  function ds(t) {
    var e = ue(), n = e.queue;
    if (n === null) throw Error(u(311));
    n.lastRenderedReducer = t;
    var a = n.dispatch, i = n.pending, r = e.memoizedState;
    if (i !== null) {
      n.pending = null;
      var f = i = i.next;
      do
        r = t(r, f.action), f = f.next;
      while (f !== i);
      We(r, e.memoizedState) || (de = !0), e.memoizedState = r, e.baseQueue === null && (e.baseState = r), n.lastRenderedState = r;
    }
    return [r, a];
  }
  function $m(t, e, n) {
    var a = dt, i = ue(), r = xt;
    if (r) {
      if (n === void 0) throw Error(u(407));
      n = n();
    } else n = e();
    var f = !We(
      (Yt || i).memoizedState,
      n
    );
    if (f && (i.memoizedState = n, de = !0), i = i.queue, gs(nh.bind(null, a, i, t), [
      t
    ]), i.getSnapshot !== e || f || fe !== null && fe.memoizedState.tag & 1) {
      if (a.flags |= 2048, Ei(
        9,
        { destroy: void 0 },
        eh.bind(
          null,
          a,
          i,
          n,
          e
        ),
        null
      ), Ft === null) throw Error(u(349));
      r || (ia & 127) !== 0 || th(a, e, n);
    }
    return n;
  }
  function th(t, e, n) {
    t.flags |= 16384, t = { getSnapshot: e, value: n }, e = dt.updateQueue, e === null ? (e = _r(), dt.updateQueue = e, e.stores = [t]) : (n = e.stores, n === null ? e.stores = [t] : n.push(t));
  }
  function eh(t, e, n, a) {
    e.value = n, e.getSnapshot = a, ah(e) && lh(t);
  }
  function nh(t, e, n) {
    return n(function() {
      ah(e) && lh(t);
    });
  }
  function ah(t) {
    var e = t.getSnapshot;
    t = t.value;
    try {
      var n = e();
      return !We(t, n);
    } catch {
      return !0;
    }
  }
  function lh(t) {
    var e = Tl(t, 2);
    e !== null && qe(e, t, 2);
  }
  function ms(t) {
    var e = Re();
    if (typeof t == "function") {
      var n = t;
      if (t = n(), Ll) {
        cn(!0);
        try {
          n();
        } finally {
          cn(!1);
        }
      }
    }
    return e.memoizedState = e.baseState = t, e.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: oa,
      lastRenderedState: t
    }, e;
  }
  function ih(t, e, n, a) {
    return t.baseState = n, fs(
      t,
      Yt,
      typeof a == "function" ? a : oa
    );
  }
  function Ly(t, e, n, a, i) {
    if (ac(t)) throw Error(u(485));
    if (t = e.action, t !== null) {
      var r = {
        payload: i,
        action: t,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(f) {
          r.listeners.push(f);
        }
      };
      X.T !== null ? n(!0) : r.isTransition = !1, a(r), n = e.pending, n === null ? (r.next = e.pending = r, oh(e, r)) : (r.next = n.next, e.pending = n.next = r);
    }
  }
  function oh(t, e) {
    var n = e.action, a = e.payload, i = t.state;
    if (e.isTransition) {
      var r = X.T, f = {};
      X.T = f;
      try {
        var m = n(i, a), A = X.S;
        A !== null && A(f, m), rh(t, e, m);
      } catch (C) {
        hs(t, e, C);
      } finally {
        r !== null && f.types !== null && (r.types = f.types), X.T = r;
      }
    } else
      try {
        r = n(i, a), rh(t, e, r);
      } catch (C) {
        hs(t, e, C);
      }
  }
  function rh(t, e, n) {
    n !== null && typeof n == "object" && typeof n.then == "function" ? n.then(
      function(a) {
        ch(t, e, a);
      },
      function(a) {
        return hs(t, e, a);
      }
    ) : ch(t, e, n);
  }
  function ch(t, e, n) {
    e.status = "fulfilled", e.value = n, uh(e), t.state = n, e = t.pending, e !== null && (n = e.next, n === e ? t.pending = null : (n = n.next, e.next = n, oh(t, n)));
  }
  function hs(t, e, n) {
    var a = t.pending;
    if (t.pending = null, a !== null) {
      a = a.next;
      do
        e.status = "rejected", e.reason = n, uh(e), e = e.next;
      while (e !== a);
    }
    t.action = null;
  }
  function uh(t) {
    t = t.listeners;
    for (var e = 0; e < t.length; e++) (0, t[e])();
  }
  function sh(t, e) {
    return e;
  }
  function fh(t, e) {
    if (xt) {
      var n = Ft.formState;
      if (n !== null) {
        t: {
          var a = dt;
          if (xt) {
            if (Pt) {
              e: {
                for (var i = Pt, r = gn; i.nodeType !== 8; ) {
                  if (!r) {
                    i = null;
                    break e;
                  }
                  if (i = An(
                    i.nextSibling
                  ), i === null) {
                    i = null;
                    break e;
                  }
                }
                r = i.data, i = r === "F!" || r === "F" ? i : null;
              }
              if (i) {
                Pt = An(
                  i.nextSibling
                ), a = i.data === "F!";
                break t;
              }
            }
            Ua(a);
          }
          a = !1;
        }
        a && (e = n[0]);
      }
    }
    return n = Re(), n.memoizedState = n.baseState = e, a = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: sh,
      lastRenderedState: e
    }, n.queue = a, n = Bh.bind(
      null,
      dt,
      a
    ), a.dispatch = n, a = ms(!1), r = bs.bind(
      null,
      dt,
      !1,
      a.queue
    ), a = Re(), i = {
      state: e,
      dispatch: null,
      action: t,
      pending: null
    }, a.queue = i, n = Ly.bind(
      null,
      dt,
      i,
      r,
      n
    ), i.dispatch = n, a.memoizedState = t, [e, n, !1];
  }
  function dh(t) {
    var e = ue();
    return mh(e, Yt, t);
  }
  function mh(t, e, n) {
    if (e = fs(
      t,
      e,
      sh
    )[0], t = tc(oa)[0], typeof e == "object" && e !== null && typeof e.then == "function")
      try {
        var a = Do(e);
      } catch (f) {
        throw f === yi ? Fr : f;
      }
    else a = e;
    e = ue();
    var i = e.queue, r = i.dispatch;
    return n !== e.memoizedState && (dt.flags |= 2048, Ei(
      9,
      { destroy: void 0 },
      Ry.bind(null, i, n),
      null
    )), [a, r, t];
  }
  function Ry(t, e) {
    t.action = e;
  }
  function hh(t) {
    var e = ue(), n = Yt;
    if (n !== null)
      return mh(e, n, t);
    ue(), e = e.memoizedState, n = ue();
    var a = n.queue.dispatch;
    return n.memoizedState = t, [e, a, !1];
  }
  function Ei(t, e, n, a) {
    return t = { tag: t, create: n, deps: a, inst: e, next: null }, e = dt.updateQueue, e === null && (e = _r(), dt.updateQueue = e), n = e.lastEffect, n === null ? e.lastEffect = t.next = t : (a = n.next, n.next = t, t.next = a, e.lastEffect = t), t;
  }
  function gh() {
    return ue().memoizedState;
  }
  function ec(t, e, n, a) {
    var i = Re();
    dt.flags |= t, i.memoizedState = Ei(
      1 | e,
      { destroy: void 0 },
      n,
      a === void 0 ? null : a
    );
  }
  function nc(t, e, n, a) {
    var i = ue();
    a = a === void 0 ? null : a;
    var r = i.memoizedState.inst;
    Yt !== null && a !== null && is(a, Yt.memoizedState.deps) ? i.memoizedState = Ei(e, r, n, a) : (dt.flags |= t, i.memoizedState = Ei(
      1 | e,
      r,
      n,
      a
    ));
  }
  function ph(t, e) {
    ec(8390656, 8, t, e);
  }
  function gs(t, e) {
    nc(2048, 8, t, e);
  }
  function Uy(t) {
    dt.flags |= 4;
    var e = dt.updateQueue;
    if (e === null)
      e = _r(), dt.updateQueue = e, e.events = [t];
    else {
      var n = e.events;
      n === null ? e.events = [t] : n.push(t);
    }
  }
  function Ah(t) {
    var e = ue().memoizedState;
    return Uy({ ref: e, nextImpl: t }), function() {
      if ((Ut & 2) !== 0) throw Error(u(440));
      return e.impl.apply(void 0, arguments);
    };
  }
  function yh(t, e) {
    return nc(4, 2, t, e);
  }
  function vh(t, e) {
    return nc(4, 4, t, e);
  }
  function bh(t, e) {
    if (typeof e == "function") {
      t = t();
      var n = e(t);
      return function() {
        typeof n == "function" ? n() : e(null);
      };
    }
    if (e != null)
      return t = t(), e.current = t, function() {
        e.current = null;
      };
  }
  function Sh(t, e, n) {
    n = n != null ? n.concat([t]) : null, nc(4, 4, bh.bind(null, e, t), n);
  }
  function ps() {
  }
  function Oh(t, e) {
    var n = ue();
    e = e === void 0 ? null : e;
    var a = n.memoizedState;
    return e !== null && is(e, a[1]) ? a[0] : (n.memoizedState = [t, e], t);
  }
  function Eh(t, e) {
    var n = ue();
    e = e === void 0 ? null : e;
    var a = n.memoizedState;
    if (e !== null && is(e, a[1]))
      return a[0];
    if (a = t(), Ll) {
      cn(!0);
      try {
        t();
      } finally {
        cn(!1);
      }
    }
    return n.memoizedState = [a, e], a;
  }
  function As(t, e, n) {
    return n === void 0 || (ia & 1073741824) !== 0 && (Ot & 261930) === 0 ? t.memoizedState = e : (t.memoizedState = n, t = Tg(), dt.lanes |= t, Fa |= t, n);
  }
  function Th(t, e, n, a) {
    return We(n, e) ? n : bi.current !== null ? (t = As(t, n, a), We(t, e) || (de = !0), t) : (ia & 42) === 0 || (ia & 1073741824) !== 0 && (Ot & 261930) === 0 ? (de = !0, t.memoizedState = n) : (t = Tg(), dt.lanes |= t, Fa |= t, e);
  }
  function xh(t, e, n, a, i) {
    var r = Z.p;
    Z.p = r !== 0 && 8 > r ? r : 8;
    var f = X.T, m = {};
    X.T = m, bs(t, !1, e, n);
    try {
      var A = i(), C = X.S;
      if (C !== null && C(m, A), A !== null && typeof A == "object" && typeof A.then == "function") {
        var L = By(
          A,
          a
        );
        Bo(
          t,
          e,
          L,
          nn(t)
        );
      } else
        Bo(
          t,
          e,
          a,
          nn(t)
        );
    } catch (U) {
      Bo(
        t,
        e,
        { then: function() {
        }, status: "rejected", reason: U },
        nn()
      );
    } finally {
      Z.p = r, f !== null && m.types !== null && (f.types = m.types), X.T = f;
    }
  }
  function Hy() {
  }
  function ys(t, e, n, a) {
    if (t.tag !== 5) throw Error(u(476));
    var i = Ch(t).queue;
    xh(
      t,
      i,
      e,
      ut,
      n === null ? Hy : function() {
        return Nh(t), n(a);
      }
    );
  }
  function Ch(t) {
    var e = t.memoizedState;
    if (e !== null) return e;
    e = {
      memoizedState: ut,
      baseState: ut,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: oa,
        lastRenderedState: ut
      },
      next: null
    };
    var n = {};
    return e.next = {
      memoizedState: n,
      baseState: n,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: oa,
        lastRenderedState: n
      },
      next: null
    }, t.memoizedState = e, t = t.alternate, t !== null && (t.memoizedState = e), e;
  }
  function Nh(t) {
    var e = Ch(t);
    e.next === null && (e = t.alternate.memoizedState), Bo(
      t,
      e.next.queue,
      {},
      nn()
    );
  }
  function vs() {
    return Te(Ko);
  }
  function wh() {
    return ue().memoizedState;
  }
  function Dh() {
    return ue().memoizedState;
  }
  function jy(t) {
    for (var e = t.return; e !== null; ) {
      switch (e.tag) {
        case 24:
        case 3:
          var n = nn();
          t = Xa(n);
          var a = Qa(e, t, n);
          a !== null && (qe(a, e, n), xo(a, e, n)), e = { cache: Zu() }, t.payload = e;
          return;
      }
      e = e.return;
    }
  }
  function Xy(t, e, n) {
    var a = nn();
    n = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, ac(t) ? Mh(e, n) : (n = ju(t, e, n, a), n !== null && (qe(n, t, a), zh(n, e, a)));
  }
  function Bh(t, e, n) {
    var a = nn();
    Bo(t, e, n, a);
  }
  function Bo(t, e, n, a) {
    var i = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (ac(t)) Mh(e, i);
    else {
      var r = t.alternate;
      if (t.lanes === 0 && (r === null || r.lanes === 0) && (r = e.lastRenderedReducer, r !== null))
        try {
          var f = e.lastRenderedState, m = r(f, n);
          if (i.hasEagerState = !0, i.eagerState = m, We(m, f))
            return jr(t, e, i, 0), Ft === null && Hr(), !1;
        } catch {
        } finally {
        }
      if (n = ju(t, e, i, a), n !== null)
        return qe(n, t, a), zh(n, e, a), !0;
    }
    return !1;
  }
  function bs(t, e, n, a) {
    if (a = {
      lane: 2,
      revertLane: _s(),
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, ac(t)) {
      if (e) throw Error(u(479));
    } else
      e = ju(
        t,
        n,
        a,
        2
      ), e !== null && qe(e, t, 2);
  }
  function ac(t) {
    var e = t.alternate;
    return t === dt || e !== null && e === dt;
  }
  function Mh(t, e) {
    Si = Wr = !0;
    var n = t.pending;
    n === null ? e.next = e : (e.next = n.next, n.next = e), t.pending = e;
  }
  function zh(t, e, n) {
    if ((n & 4194048) !== 0) {
      var a = e.lanes;
      a &= t.pendingLanes, n |= a, e.lanes = n, $l(t, n);
    }
  }
  var Mo = {
    readContext: Te,
    use: $r,
    useCallback: ne,
    useContext: ne,
    useEffect: ne,
    useImperativeHandle: ne,
    useLayoutEffect: ne,
    useInsertionEffect: ne,
    useMemo: ne,
    useReducer: ne,
    useRef: ne,
    useState: ne,
    useDebugValue: ne,
    useDeferredValue: ne,
    useTransition: ne,
    useSyncExternalStore: ne,
    useId: ne,
    useHostTransitionStatus: ne,
    useFormState: ne,
    useActionState: ne,
    useOptimistic: ne,
    useMemoCache: ne,
    useCacheRefresh: ne
  };
  Mo.useEffectEvent = ne;
  var Lh = {
    readContext: Te,
    use: $r,
    useCallback: function(t, e) {
      return Re().memoizedState = [
        t,
        e === void 0 ? null : e
      ], t;
    },
    useContext: Te,
    useEffect: ph,
    useImperativeHandle: function(t, e, n) {
      n = n != null ? n.concat([t]) : null, ec(
        4194308,
        4,
        bh.bind(null, e, t),
        n
      );
    },
    useLayoutEffect: function(t, e) {
      return ec(4194308, 4, t, e);
    },
    useInsertionEffect: function(t, e) {
      ec(4, 2, t, e);
    },
    useMemo: function(t, e) {
      var n = Re();
      e = e === void 0 ? null : e;
      var a = t();
      if (Ll) {
        cn(!0);
        try {
          t();
        } finally {
          cn(!1);
        }
      }
      return n.memoizedState = [a, e], a;
    },
    useReducer: function(t, e, n) {
      var a = Re();
      if (n !== void 0) {
        var i = n(e);
        if (Ll) {
          cn(!0);
          try {
            n(e);
          } finally {
            cn(!1);
          }
        }
      } else i = e;
      return a.memoizedState = a.baseState = i, t = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: i
      }, a.queue = t, t = t.dispatch = Xy.bind(
        null,
        dt,
        t
      ), [a.memoizedState, t];
    },
    useRef: function(t) {
      var e = Re();
      return t = { current: t }, e.memoizedState = t;
    },
    useState: function(t) {
      t = ms(t);
      var e = t.queue, n = Bh.bind(null, dt, e);
      return e.dispatch = n, [t.memoizedState, n];
    },
    useDebugValue: ps,
    useDeferredValue: function(t, e) {
      var n = Re();
      return As(n, t, e);
    },
    useTransition: function() {
      var t = ms(!1);
      return t = xh.bind(
        null,
        dt,
        t.queue,
        !0,
        !1
      ), Re().memoizedState = t, [!1, t];
    },
    useSyncExternalStore: function(t, e, n) {
      var a = dt, i = Re();
      if (xt) {
        if (n === void 0)
          throw Error(u(407));
        n = n();
      } else {
        if (n = e(), Ft === null)
          throw Error(u(349));
        (Ot & 127) !== 0 || th(a, e, n);
      }
      i.memoizedState = n;
      var r = { value: n, getSnapshot: e };
      return i.queue = r, ph(nh.bind(null, a, r, t), [
        t
      ]), a.flags |= 2048, Ei(
        9,
        { destroy: void 0 },
        eh.bind(
          null,
          a,
          r,
          n,
          e
        ),
        null
      ), n;
    },
    useId: function() {
      var t = Re(), e = Ft.identifierPrefix;
      if (xt) {
        var n = Xn, a = jn;
        n = (a & ~(1 << 32 - Oe(a) - 1)).toString(32) + n, e = "_" + e + "R_" + n, n = Jr++, 0 < n && (e += "H" + n.toString(32)), e += "_";
      } else
        n = My++, e = "_" + e + "r_" + n.toString(32) + "_";
      return t.memoizedState = e;
    },
    useHostTransitionStatus: vs,
    useFormState: fh,
    useActionState: fh,
    useOptimistic: function(t) {
      var e = Re();
      e.memoizedState = e.baseState = t;
      var n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return e.queue = n, e = bs.bind(
        null,
        dt,
        !0,
        n
      ), n.dispatch = e, [t, e];
    },
    useMemoCache: ss,
    useCacheRefresh: function() {
      return Re().memoizedState = jy.bind(
        null,
        dt
      );
    },
    useEffectEvent: function(t) {
      var e = Re(), n = { impl: t };
      return e.memoizedState = n, function() {
        if ((Ut & 2) !== 0)
          throw Error(u(440));
        return n.impl.apply(void 0, arguments);
      };
    }
  }, Ss = {
    readContext: Te,
    use: $r,
    useCallback: Oh,
    useContext: Te,
    useEffect: gs,
    useImperativeHandle: Sh,
    useInsertionEffect: yh,
    useLayoutEffect: vh,
    useMemo: Eh,
    useReducer: tc,
    useRef: gh,
    useState: function() {
      return tc(oa);
    },
    useDebugValue: ps,
    useDeferredValue: function(t, e) {
      var n = ue();
      return Th(
        n,
        Yt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = tc(oa)[0], e = ue().memoizedState;
      return [
        typeof t == "boolean" ? t : Do(t),
        e
      ];
    },
    useSyncExternalStore: $m,
    useId: wh,
    useHostTransitionStatus: vs,
    useFormState: dh,
    useActionState: dh,
    useOptimistic: function(t, e) {
      var n = ue();
      return ih(n, Yt, t, e);
    },
    useMemoCache: ss,
    useCacheRefresh: Dh
  };
  Ss.useEffectEvent = Ah;
  var Rh = {
    readContext: Te,
    use: $r,
    useCallback: Oh,
    useContext: Te,
    useEffect: gs,
    useImperativeHandle: Sh,
    useInsertionEffect: yh,
    useLayoutEffect: vh,
    useMemo: Eh,
    useReducer: ds,
    useRef: gh,
    useState: function() {
      return ds(oa);
    },
    useDebugValue: ps,
    useDeferredValue: function(t, e) {
      var n = ue();
      return Yt === null ? As(n, t, e) : Th(
        n,
        Yt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = ds(oa)[0], e = ue().memoizedState;
      return [
        typeof t == "boolean" ? t : Do(t),
        e
      ];
    },
    useSyncExternalStore: $m,
    useId: wh,
    useHostTransitionStatus: vs,
    useFormState: hh,
    useActionState: hh,
    useOptimistic: function(t, e) {
      var n = ue();
      return Yt !== null ? ih(n, Yt, t, e) : (n.baseState = t, [t, n.queue.dispatch]);
    },
    useMemoCache: ss,
    useCacheRefresh: Dh
  };
  Rh.useEffectEvent = Ah;
  function Os(t, e, n, a) {
    e = t.memoizedState, n = n(a, e), n = n == null ? e : x({}, e, n), t.memoizedState = n, t.lanes === 0 && (t.updateQueue.baseState = n);
  }
  var Es = {
    enqueueSetState: function(t, e, n) {
      t = t._reactInternals;
      var a = nn(), i = Xa(a);
      i.payload = e, n != null && (i.callback = n), e = Qa(t, i, a), e !== null && (qe(e, t, a), xo(e, t, a));
    },
    enqueueReplaceState: function(t, e, n) {
      t = t._reactInternals;
      var a = nn(), i = Xa(a);
      i.tag = 1, i.payload = e, n != null && (i.callback = n), e = Qa(t, i, a), e !== null && (qe(e, t, a), xo(e, t, a));
    },
    enqueueForceUpdate: function(t, e) {
      t = t._reactInternals;
      var n = nn(), a = Xa(n);
      a.tag = 2, e != null && (a.callback = e), e = Qa(t, a, n), e !== null && (qe(e, t, n), xo(e, t, n));
    }
  };
  function Uh(t, e, n, a, i, r, f) {
    return t = t.stateNode, typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(a, r, f) : e.prototype && e.prototype.isPureReactComponent ? !Ao(n, a) || !Ao(i, r) : !0;
  }
  function Hh(t, e, n, a) {
    t = e.state, typeof e.componentWillReceiveProps == "function" && e.componentWillReceiveProps(n, a), typeof e.UNSAFE_componentWillReceiveProps == "function" && e.UNSAFE_componentWillReceiveProps(n, a), e.state !== t && Es.enqueueReplaceState(e, e.state, null);
  }
  function Rl(t, e) {
    var n = e;
    if ("ref" in e) {
      n = {};
      for (var a in e)
        a !== "ref" && (n[a] = e[a]);
    }
    if (t = t.defaultProps) {
      n === e && (n = x({}, n));
      for (var i in t)
        n[i] === void 0 && (n[i] = t[i]);
    }
    return n;
  }
  function jh(t) {
    Ur(t);
  }
  function Xh(t) {
    console.error(t);
  }
  function Qh(t) {
    Ur(t);
  }
  function lc(t, e) {
    try {
      var n = t.onUncaughtError;
      n(e.value, { componentStack: e.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function Vh(t, e, n) {
    try {
      var a = t.onCaughtError;
      a(n.value, {
        componentStack: n.stack,
        errorBoundary: e.tag === 1 ? e.stateNode : null
      });
    } catch (i) {
      setTimeout(function() {
        throw i;
      });
    }
  }
  function Ts(t, e, n) {
    return n = Xa(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
      lc(t, e);
    }, n;
  }
  function Yh(t) {
    return t = Xa(t), t.tag = 3, t;
  }
  function Gh(t, e, n, a) {
    var i = n.type.getDerivedStateFromError;
    if (typeof i == "function") {
      var r = a.value;
      t.payload = function() {
        return i(r);
      }, t.callback = function() {
        Vh(e, n, a);
      };
    }
    var f = n.stateNode;
    f !== null && typeof f.componentDidCatch == "function" && (t.callback = function() {
      Vh(e, n, a), typeof i != "function" && (ka === null ? ka = /* @__PURE__ */ new Set([this]) : ka.add(this));
      var m = a.stack;
      this.componentDidCatch(a.value, {
        componentStack: m !== null ? m : ""
      });
    });
  }
  function Qy(t, e, n, a, i) {
    if (n.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
      if (e = n.alternate, e !== null && gi(
        e,
        n,
        i,
        !0
      ), n = _e.current, n !== null) {
        switch (n.tag) {
          case 31:
          case 13:
            return pn === null ? pc() : n.alternate === null && ae === 0 && (ae = 3), n.flags &= -257, n.flags |= 65536, n.lanes = i, a === kr ? n.flags |= 16384 : (e = n.updateQueue, e === null ? n.updateQueue = /* @__PURE__ */ new Set([a]) : e.add(a), Ps(t, a, i)), !1;
          case 22:
            return n.flags |= 65536, a === kr ? n.flags |= 16384 : (e = n.updateQueue, e === null ? (e = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([a])
            }, n.updateQueue = e) : (n = e.retryQueue, n === null ? e.retryQueue = /* @__PURE__ */ new Set([a]) : n.add(a)), Ps(t, a, i)), !1;
        }
        throw Error(u(435, n.tag));
      }
      return Ps(t, a, i), pc(), !1;
    }
    if (xt)
      return e = _e.current, e !== null ? ((e.flags & 65536) === 0 && (e.flags |= 256), e.flags |= 65536, e.lanes = i, a !== Iu && (t = Error(u(422), { cause: a }), bo(dn(t, n)))) : (a !== Iu && (e = Error(u(423), {
        cause: a
      }), bo(
        dn(e, n)
      )), t = t.current.alternate, t.flags |= 65536, i &= -i, t.lanes |= i, a = dn(a, n), i = Ts(
        t.stateNode,
        a,
        i
      ), ts(t, i), ae !== 4 && (ae = 2)), !1;
    var r = Error(u(520), { cause: a });
    if (r = dn(r, n), Qo === null ? Qo = [r] : Qo.push(r), ae !== 4 && (ae = 2), e === null) return !0;
    a = dn(a, n), n = e;
    do {
      switch (n.tag) {
        case 3:
          return n.flags |= 65536, t = i & -i, n.lanes |= t, t = Ts(n.stateNode, a, t), ts(n, t), !1;
        case 1:
          if (e = n.type, r = n.stateNode, (n.flags & 128) === 0 && (typeof e.getDerivedStateFromError == "function" || r !== null && typeof r.componentDidCatch == "function" && (ka === null || !ka.has(r))))
            return n.flags |= 65536, i &= -i, n.lanes |= i, i = Yh(i), Gh(
              i,
              t,
              n,
              a
            ), ts(n, i), !1;
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var xs = Error(u(461)), de = !1;
  function xe(t, e, n, a) {
    e.child = t === null ? qm(e, null, n, a) : zl(
      e,
      t.child,
      n,
      a
    );
  }
  function Ih(t, e, n, a, i) {
    n = n.render;
    var r = e.ref;
    if ("ref" in a) {
      var f = {};
      for (var m in a)
        m !== "ref" && (f[m] = a[m]);
    } else f = a;
    return wl(e), a = os(
      t,
      e,
      n,
      f,
      r,
      i
    ), m = rs(), t !== null && !de ? (cs(t, e, i), ra(t, e, i)) : (xt && m && Yu(e), e.flags |= 1, xe(t, e, a, i), e.child);
  }
  function Fh(t, e, n, a, i) {
    if (t === null) {
      var r = n.type;
      return typeof r == "function" && !Xu(r) && r.defaultProps === void 0 && n.compare === null ? (e.tag = 15, e.type = r, kh(
        t,
        e,
        r,
        a,
        i
      )) : (t = Qr(
        n.type,
        null,
        a,
        e,
        e.mode,
        i
      ), t.ref = e.ref, t.return = e, e.child = t);
    }
    if (r = t.child, !Ls(t, i)) {
      var f = r.memoizedProps;
      if (n = n.compare, n = n !== null ? n : Ao, n(f, a) && t.ref === e.ref)
        return ra(t, e, i);
    }
    return e.flags |= 1, t = ea(r, a), t.ref = e.ref, t.return = e, e.child = t;
  }
  function kh(t, e, n, a, i) {
    if (t !== null) {
      var r = t.memoizedProps;
      if (Ao(r, a) && t.ref === e.ref)
        if (de = !1, e.pendingProps = a = r, Ls(t, i))
          (t.flags & 131072) !== 0 && (de = !0);
        else
          return e.lanes = t.lanes, ra(t, e, i);
    }
    return Cs(
      t,
      e,
      n,
      a,
      i
    );
  }
  function qh(t, e, n, a) {
    var i = a.children, r = t !== null ? t.memoizedState : null;
    if (t === null && e.stateNode === null && (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.mode === "hidden") {
      if ((e.flags & 128) !== 0) {
        if (r = r !== null ? r.baseLanes | n : n, t !== null) {
          for (a = e.child = t.child, i = 0; a !== null; )
            i = i | a.lanes | a.childLanes, a = a.sibling;
          a = i & ~r;
        } else a = 0, e.child = null;
        return Kh(
          t,
          e,
          r,
          n,
          a
        );
      }
      if ((n & 536870912) !== 0)
        e.memoizedState = { baseLanes: 0, cachePool: null }, t !== null && Ir(
          e,
          r !== null ? r.cachePool : null
        ), r !== null ? Pm(e, r) : ns(), Wm(e);
      else
        return a = e.lanes = 536870912, Kh(
          t,
          e,
          r !== null ? r.baseLanes | n : n,
          n,
          a
        );
    } else
      r !== null ? (Ir(e, r.cachePool), Pm(e, r), Ya(), e.memoizedState = null) : (t !== null && Ir(e, null), ns(), Ya());
    return xe(t, e, i, n), e.child;
  }
  function zo(t, e) {
    return t !== null && t.tag === 22 || e.stateNode !== null || (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), e.sibling;
  }
  function Kh(t, e, n, a, i) {
    var r = Wu();
    return r = r === null ? null : { parent: se._currentValue, pool: r }, e.memoizedState = {
      baseLanes: n,
      cachePool: r
    }, t !== null && Ir(e, null), ns(), Wm(e), t !== null && gi(t, e, a, !0), e.childLanes = i, null;
  }
  function ic(t, e) {
    return e = rc(
      { mode: e.mode, children: e.children },
      t.mode
    ), e.ref = t.ref, t.child = e, e.return = t, e;
  }
  function Zh(t, e, n) {
    return zl(e, t.child, null, n), t = ic(e, e.pendingProps), t.flags |= 2, $e(e), e.memoizedState = null, t;
  }
  function Vy(t, e, n) {
    var a = e.pendingProps, i = (e.flags & 128) !== 0;
    if (e.flags &= -129, t === null) {
      if (xt) {
        if (a.mode === "hidden")
          return t = ic(e, a), e.lanes = 536870912, zo(null, t);
        if (ls(e), (t = Pt) ? (t = op(
          t,
          gn
        ), t = t !== null && t.data === "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: La !== null ? { id: jn, overflow: Xn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = Mm(t), n.return = e, e.child = n, Ee = e, Pt = null)) : t = null, t === null) throw Ua(e);
        return e.lanes = 536870912, null;
      }
      return ic(e, a);
    }
    var r = t.memoizedState;
    if (r !== null) {
      var f = r.dehydrated;
      if (ls(e), i)
        if (e.flags & 256)
          e.flags &= -257, e = Zh(
            t,
            e,
            n
          );
        else if (e.memoizedState !== null)
          e.child = t.child, e.flags |= 128, e = null;
        else throw Error(u(558));
      else if (de || gi(t, e, n, !1), i = (n & t.childLanes) !== 0, de || i) {
        if (a = Ft, a !== null && (f = eo(a, n), f !== 0 && f !== r.retryLane))
          throw r.retryLane = f, Tl(t, f), qe(a, t, f), xs;
        pc(), e = Zh(
          t,
          e,
          n
        );
      } else
        t = r.treeContext, Pt = An(f.nextSibling), Ee = e, xt = !0, Ra = null, gn = !1, t !== null && Rm(e, t), e = ic(e, a), e.flags |= 4096;
      return e;
    }
    return t = ea(t.child, {
      mode: a.mode,
      children: a.children
    }), t.ref = e.ref, e.child = t, t.return = e, t;
  }
  function oc(t, e) {
    var n = e.ref;
    if (n === null)
      t !== null && t.ref !== null && (e.flags |= 4194816);
    else {
      if (typeof n != "function" && typeof n != "object")
        throw Error(u(284));
      (t === null || t.ref !== n) && (e.flags |= 4194816);
    }
  }
  function Cs(t, e, n, a, i) {
    return wl(e), n = os(
      t,
      e,
      n,
      a,
      void 0,
      i
    ), a = rs(), t !== null && !de ? (cs(t, e, i), ra(t, e, i)) : (xt && a && Yu(e), e.flags |= 1, xe(t, e, n, i), e.child);
  }
  function Ph(t, e, n, a, i, r) {
    return wl(e), e.updateQueue = null, n = _m(
      e,
      a,
      n,
      i
    ), Jm(t), a = rs(), t !== null && !de ? (cs(t, e, r), ra(t, e, r)) : (xt && a && Yu(e), e.flags |= 1, xe(t, e, n, r), e.child);
  }
  function Wh(t, e, n, a, i) {
    if (wl(e), e.stateNode === null) {
      var r = fi, f = n.contextType;
      typeof f == "object" && f !== null && (r = Te(f)), r = new n(a, r), e.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = Es, e.stateNode = r, r._reactInternals = e, r = e.stateNode, r.props = a, r.state = e.memoizedState, r.refs = {}, _u(e), f = n.contextType, r.context = typeof f == "object" && f !== null ? Te(f) : fi, r.state = e.memoizedState, f = n.getDerivedStateFromProps, typeof f == "function" && (Os(
        e,
        n,
        f,
        a
      ), r.state = e.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof r.getSnapshotBeforeUpdate == "function" || typeof r.UNSAFE_componentWillMount != "function" && typeof r.componentWillMount != "function" || (f = r.state, typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount(), f !== r.state && Es.enqueueReplaceState(r, r.state, null), No(e, a, r, i), Co(), r.state = e.memoizedState), typeof r.componentDidMount == "function" && (e.flags |= 4194308), a = !0;
    } else if (t === null) {
      r = e.stateNode;
      var m = e.memoizedProps, A = Rl(n, m);
      r.props = A;
      var C = r.context, L = n.contextType;
      f = fi, typeof L == "object" && L !== null && (f = Te(L));
      var U = n.getDerivedStateFromProps;
      L = typeof U == "function" || typeof r.getSnapshotBeforeUpdate == "function", m = e.pendingProps !== m, L || typeof r.UNSAFE_componentWillReceiveProps != "function" && typeof r.componentWillReceiveProps != "function" || (m || C !== f) && Hh(
        e,
        r,
        a,
        f
      ), ja = !1;
      var D = e.memoizedState;
      r.state = D, No(e, a, r, i), Co(), C = e.memoizedState, m || D !== C || ja ? (typeof U == "function" && (Os(
        e,
        n,
        U,
        a
      ), C = e.memoizedState), (A = ja || Uh(
        e,
        n,
        A,
        a,
        D,
        C,
        f
      )) ? (L || typeof r.UNSAFE_componentWillMount != "function" && typeof r.componentWillMount != "function" || (typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount()), typeof r.componentDidMount == "function" && (e.flags |= 4194308)) : (typeof r.componentDidMount == "function" && (e.flags |= 4194308), e.memoizedProps = a, e.memoizedState = C), r.props = a, r.state = C, r.context = f, a = A) : (typeof r.componentDidMount == "function" && (e.flags |= 4194308), a = !1);
    } else {
      r = e.stateNode, $u(t, e), f = e.memoizedProps, L = Rl(n, f), r.props = L, U = e.pendingProps, D = r.context, C = n.contextType, A = fi, typeof C == "object" && C !== null && (A = Te(C)), m = n.getDerivedStateFromProps, (C = typeof m == "function" || typeof r.getSnapshotBeforeUpdate == "function") || typeof r.UNSAFE_componentWillReceiveProps != "function" && typeof r.componentWillReceiveProps != "function" || (f !== U || D !== A) && Hh(
        e,
        r,
        a,
        A
      ), ja = !1, D = e.memoizedState, r.state = D, No(e, a, r, i), Co();
      var z = e.memoizedState;
      f !== U || D !== z || ja || t !== null && t.dependencies !== null && Yr(t.dependencies) ? (typeof m == "function" && (Os(
        e,
        n,
        m,
        a
      ), z = e.memoizedState), (L = ja || Uh(
        e,
        n,
        L,
        a,
        D,
        z,
        A
      ) || t !== null && t.dependencies !== null && Yr(t.dependencies)) ? (C || typeof r.UNSAFE_componentWillUpdate != "function" && typeof r.componentWillUpdate != "function" || (typeof r.componentWillUpdate == "function" && r.componentWillUpdate(a, z, A), typeof r.UNSAFE_componentWillUpdate == "function" && r.UNSAFE_componentWillUpdate(
        a,
        z,
        A
      )), typeof r.componentDidUpdate == "function" && (e.flags |= 4), typeof r.getSnapshotBeforeUpdate == "function" && (e.flags |= 1024)) : (typeof r.componentDidUpdate != "function" || f === t.memoizedProps && D === t.memoizedState || (e.flags |= 4), typeof r.getSnapshotBeforeUpdate != "function" || f === t.memoizedProps && D === t.memoizedState || (e.flags |= 1024), e.memoizedProps = a, e.memoizedState = z), r.props = a, r.state = z, r.context = A, a = L) : (typeof r.componentDidUpdate != "function" || f === t.memoizedProps && D === t.memoizedState || (e.flags |= 4), typeof r.getSnapshotBeforeUpdate != "function" || f === t.memoizedProps && D === t.memoizedState || (e.flags |= 1024), a = !1);
    }
    return r = a, oc(t, e), a = (e.flags & 128) !== 0, r || a ? (r = e.stateNode, n = a && typeof n.getDerivedStateFromError != "function" ? null : r.render(), e.flags |= 1, t !== null && a ? (e.child = zl(
      e,
      t.child,
      null,
      i
    ), e.child = zl(
      e,
      null,
      n,
      i
    )) : xe(t, e, n, i), e.memoizedState = r.state, t = e.child) : t = ra(
      t,
      e,
      i
    ), t;
  }
  function Jh(t, e, n, a) {
    return Cl(), e.flags |= 256, xe(t, e, n, a), e.child;
  }
  var Ns = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function ws(t) {
    return { baseLanes: t, cachePool: Vm() };
  }
  function Ds(t, e, n) {
    return t = t !== null ? t.childLanes & ~n : 0, e && (t |= en), t;
  }
  function _h(t, e, n) {
    var a = e.pendingProps, i = !1, r = (e.flags & 128) !== 0, f;
    if ((f = r) || (f = t !== null && t.memoizedState === null ? !1 : (ce.current & 2) !== 0), f && (i = !0, e.flags &= -129), f = (e.flags & 32) !== 0, e.flags &= -33, t === null) {
      if (xt) {
        if (i ? Va(e) : Ya(), (t = Pt) ? (t = op(
          t,
          gn
        ), t = t !== null && t.data !== "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: La !== null ? { id: jn, overflow: Xn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = Mm(t), n.return = e, e.child = n, Ee = e, Pt = null)) : t = null, t === null) throw Ua(e);
        return df(t) ? e.lanes = 32 : e.lanes = 536870912, null;
      }
      var m = a.children;
      return a = a.fallback, i ? (Ya(), i = e.mode, m = rc(
        { mode: "hidden", children: m },
        i
      ), a = xl(
        a,
        i,
        n,
        null
      ), m.return = e, a.return = e, m.sibling = a, e.child = m, a = e.child, a.memoizedState = ws(n), a.childLanes = Ds(
        t,
        f,
        n
      ), e.memoizedState = Ns, zo(null, a)) : (Va(e), Bs(e, m));
    }
    var A = t.memoizedState;
    if (A !== null && (m = A.dehydrated, m !== null)) {
      if (r)
        e.flags & 256 ? (Va(e), e.flags &= -257, e = Ms(
          t,
          e,
          n
        )) : e.memoizedState !== null ? (Ya(), e.child = t.child, e.flags |= 128, e = null) : (Ya(), m = a.fallback, i = e.mode, a = rc(
          { mode: "visible", children: a.children },
          i
        ), m = xl(
          m,
          i,
          n,
          null
        ), m.flags |= 2, a.return = e, m.return = e, a.sibling = m, e.child = a, zl(
          e,
          t.child,
          null,
          n
        ), a = e.child, a.memoizedState = ws(n), a.childLanes = Ds(
          t,
          f,
          n
        ), e.memoizedState = Ns, e = zo(null, a));
      else if (Va(e), df(m)) {
        if (f = m.nextSibling && m.nextSibling.dataset, f) var C = f.dgst;
        f = C, a = Error(u(419)), a.stack = "", a.digest = f, bo({ value: a, source: null, stack: null }), e = Ms(
          t,
          e,
          n
        );
      } else if (de || gi(t, e, n, !1), f = (n & t.childLanes) !== 0, de || f) {
        if (f = Ft, f !== null && (a = eo(f, n), a !== 0 && a !== A.retryLane))
          throw A.retryLane = a, Tl(t, a), qe(f, t, a), xs;
        ff(m) || pc(), e = Ms(
          t,
          e,
          n
        );
      } else
        ff(m) ? (e.flags |= 192, e.child = t.child, e = null) : (t = A.treeContext, Pt = An(
          m.nextSibling
        ), Ee = e, xt = !0, Ra = null, gn = !1, t !== null && Rm(e, t), e = Bs(
          e,
          a.children
        ), e.flags |= 4096);
      return e;
    }
    return i ? (Ya(), m = a.fallback, i = e.mode, A = t.child, C = A.sibling, a = ea(A, {
      mode: "hidden",
      children: a.children
    }), a.subtreeFlags = A.subtreeFlags & 65011712, C !== null ? m = ea(
      C,
      m
    ) : (m = xl(
      m,
      i,
      n,
      null
    ), m.flags |= 2), m.return = e, a.return = e, a.sibling = m, e.child = a, zo(null, a), a = e.child, m = t.child.memoizedState, m === null ? m = ws(n) : (i = m.cachePool, i !== null ? (A = se._currentValue, i = i.parent !== A ? { parent: A, pool: A } : i) : i = Vm(), m = {
      baseLanes: m.baseLanes | n,
      cachePool: i
    }), a.memoizedState = m, a.childLanes = Ds(
      t,
      f,
      n
    ), e.memoizedState = Ns, zo(t.child, a)) : (Va(e), n = t.child, t = n.sibling, n = ea(n, {
      mode: "visible",
      children: a.children
    }), n.return = e, n.sibling = null, t !== null && (f = e.deletions, f === null ? (e.deletions = [t], e.flags |= 16) : f.push(t)), e.child = n, e.memoizedState = null, n);
  }
  function Bs(t, e) {
    return e = rc(
      { mode: "visible", children: e },
      t.mode
    ), e.return = t, t.child = e;
  }
  function rc(t, e) {
    return t = Je(22, t, null, e), t.lanes = 0, t;
  }
  function Ms(t, e, n) {
    return zl(e, t.child, null, n), t = Bs(
      e,
      e.pendingProps.children
    ), t.flags |= 2, e.memoizedState = null, t;
  }
  function $h(t, e, n) {
    t.lanes |= e;
    var a = t.alternate;
    a !== null && (a.lanes |= e), qu(t.return, e, n);
  }
  function zs(t, e, n, a, i, r) {
    var f = t.memoizedState;
    f === null ? t.memoizedState = {
      isBackwards: e,
      rendering: null,
      renderingStartTime: 0,
      last: a,
      tail: n,
      tailMode: i,
      treeForkCount: r
    } : (f.isBackwards = e, f.rendering = null, f.renderingStartTime = 0, f.last = a, f.tail = n, f.tailMode = i, f.treeForkCount = r);
  }
  function tg(t, e, n) {
    var a = e.pendingProps, i = a.revealOrder, r = a.tail;
    a = a.children;
    var f = ce.current, m = (f & 2) !== 0;
    if (m ? (f = f & 1 | 2, e.flags |= 128) : f &= 1, lt(ce, f), xe(t, e, a, n), a = xt ? vo : 0, !m && t !== null && (t.flags & 128) !== 0)
      t: for (t = e.child; t !== null; ) {
        if (t.tag === 13)
          t.memoizedState !== null && $h(t, n, e);
        else if (t.tag === 19)
          $h(t, n, e);
        else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break t;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            break t;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    switch (i) {
      case "forwards":
        for (n = e.child, i = null; n !== null; )
          t = n.alternate, t !== null && Pr(t) === null && (i = n), n = n.sibling;
        n = i, n === null ? (i = e.child, e.child = null) : (i = n.sibling, n.sibling = null), zs(
          e,
          !1,
          i,
          n,
          r,
          a
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (n = null, i = e.child, e.child = null; i !== null; ) {
          if (t = i.alternate, t !== null && Pr(t) === null) {
            e.child = i;
            break;
          }
          t = i.sibling, i.sibling = n, n = i, i = t;
        }
        zs(
          e,
          !0,
          n,
          null,
          r,
          a
        );
        break;
      case "together":
        zs(
          e,
          !1,
          null,
          null,
          void 0,
          a
        );
        break;
      default:
        e.memoizedState = null;
    }
    return e.child;
  }
  function ra(t, e, n) {
    if (t !== null && (e.dependencies = t.dependencies), Fa |= e.lanes, (n & e.childLanes) === 0)
      if (t !== null) {
        if (gi(
          t,
          e,
          n,
          !1
        ), (n & e.childLanes) === 0)
          return null;
      } else return null;
    if (t !== null && e.child !== t.child)
      throw Error(u(153));
    if (e.child !== null) {
      for (t = e.child, n = ea(t, t.pendingProps), e.child = n, n.return = e; t.sibling !== null; )
        t = t.sibling, n = n.sibling = ea(t, t.pendingProps), n.return = e;
      n.sibling = null;
    }
    return e.child;
  }
  function Ls(t, e) {
    return (t.lanes & e) !== 0 ? !0 : (t = t.dependencies, !!(t !== null && Yr(t)));
  }
  function Yy(t, e, n) {
    switch (e.tag) {
      case 3:
        On(e, e.stateNode.containerInfo), Ha(e, se, t.memoizedState.cache), Cl();
        break;
      case 27:
      case 5:
        kt(e);
        break;
      case 4:
        On(e, e.stateNode.containerInfo);
        break;
      case 10:
        Ha(
          e,
          e.type,
          e.memoizedProps.value
        );
        break;
      case 31:
        if (e.memoizedState !== null)
          return e.flags |= 128, ls(e), null;
        break;
      case 13:
        var a = e.memoizedState;
        if (a !== null)
          return a.dehydrated !== null ? (Va(e), e.flags |= 128, null) : (n & e.child.childLanes) !== 0 ? _h(t, e, n) : (Va(e), t = ra(
            t,
            e,
            n
          ), t !== null ? t.sibling : null);
        Va(e);
        break;
      case 19:
        var i = (t.flags & 128) !== 0;
        if (a = (n & e.childLanes) !== 0, a || (gi(
          t,
          e,
          n,
          !1
        ), a = (n & e.childLanes) !== 0), i) {
          if (a)
            return tg(
              t,
              e,
              n
            );
          e.flags |= 128;
        }
        if (i = e.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), lt(ce, ce.current), a) break;
        return null;
      case 22:
        return e.lanes = 0, qh(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        Ha(e, se, t.memoizedState.cache);
    }
    return ra(t, e, n);
  }
  function eg(t, e, n) {
    if (t !== null)
      if (t.memoizedProps !== e.pendingProps)
        de = !0;
      else {
        if (!Ls(t, n) && (e.flags & 128) === 0)
          return de = !1, Yy(
            t,
            e,
            n
          );
        de = (t.flags & 131072) !== 0;
      }
    else
      de = !1, xt && (e.flags & 1048576) !== 0 && Lm(e, vo, e.index);
    switch (e.lanes = 0, e.tag) {
      case 16:
        t: {
          var a = e.pendingProps;
          if (t = Bl(e.elementType), e.type = t, typeof t == "function")
            Xu(t) ? (a = Rl(t, a), e.tag = 1, e = Wh(
              null,
              e,
              t,
              a,
              n
            )) : (e.tag = 0, e = Cs(
              null,
              e,
              t,
              a,
              n
            ));
          else {
            if (t != null) {
              var i = t.$$typeof;
              if (i === V) {
                e.tag = 11, e = Ih(
                  null,
                  e,
                  t,
                  a,
                  n
                );
                break t;
              } else if (i === W) {
                e.tag = 14, e = Fh(
                  null,
                  e,
                  t,
                  a,
                  n
                );
                break t;
              }
            }
            throw e = Nt(t) || t, Error(u(306, e, ""));
          }
        }
        return e;
      case 0:
        return Cs(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 1:
        return a = e.type, i = Rl(
          a,
          e.pendingProps
        ), Wh(
          t,
          e,
          a,
          i,
          n
        );
      case 3:
        t: {
          if (On(
            e,
            e.stateNode.containerInfo
          ), t === null) throw Error(u(387));
          a = e.pendingProps;
          var r = e.memoizedState;
          i = r.element, $u(t, e), No(e, a, null, n);
          var f = e.memoizedState;
          if (a = f.cache, Ha(e, se, a), a !== r.cache && Ku(
            e,
            [se],
            n,
            !0
          ), Co(), a = f.element, r.isDehydrated)
            if (r = {
              element: a,
              isDehydrated: !1,
              cache: f.cache
            }, e.updateQueue.baseState = r, e.memoizedState = r, e.flags & 256) {
              e = Jh(
                t,
                e,
                a,
                n
              );
              break t;
            } else if (a !== i) {
              i = dn(
                Error(u(424)),
                e
              ), bo(i), e = Jh(
                t,
                e,
                a,
                n
              );
              break t;
            } else {
              switch (t = e.stateNode.containerInfo, t.nodeType) {
                case 9:
                  t = t.body;
                  break;
                default:
                  t = t.nodeName === "HTML" ? t.ownerDocument.body : t;
              }
              for (Pt = An(t.firstChild), Ee = e, xt = !0, Ra = null, gn = !0, n = qm(
                e,
                null,
                a,
                n
              ), e.child = n; n; )
                n.flags = n.flags & -3 | 4096, n = n.sibling;
            }
          else {
            if (Cl(), a === i) {
              e = ra(
                t,
                e,
                n
              );
              break t;
            }
            xe(t, e, a, n);
          }
          e = e.child;
        }
        return e;
      case 26:
        return oc(t, e), t === null ? (n = dp(
          e.type,
          null,
          e.pendingProps,
          null
        )) ? e.memoizedState = n : xt || (n = e.type, t = e.pendingProps, a = Ec(
          ye.current
        ).createElement(n), a[pt] = e, a[oe] = t, Ce(a, n, t), Kt(a), e.stateNode = a) : e.memoizedState = dp(
          e.type,
          t.memoizedProps,
          e.pendingProps,
          t.memoizedState
        ), null;
      case 27:
        return kt(e), t === null && xt && (a = e.stateNode = up(
          e.type,
          e.pendingProps,
          ye.current
        ), Ee = e, gn = !0, i = Pt, Pa(e.type) ? (mf = i, Pt = An(a.firstChild)) : Pt = i), xe(
          t,
          e,
          e.pendingProps.children,
          n
        ), oc(t, e), t === null && (e.flags |= 4194304), e.child;
      case 5:
        return t === null && xt && ((i = a = Pt) && (a = Av(
          a,
          e.type,
          e.pendingProps,
          gn
        ), a !== null ? (e.stateNode = a, Ee = e, Pt = An(a.firstChild), gn = !1, i = !0) : i = !1), i || Ua(e)), kt(e), i = e.type, r = e.pendingProps, f = t !== null ? t.memoizedProps : null, a = r.children, cf(i, r) ? a = null : f !== null && cf(i, f) && (e.flags |= 32), e.memoizedState !== null && (i = os(
          t,
          e,
          zy,
          null,
          null,
          n
        ), Ko._currentValue = i), oc(t, e), xe(t, e, a, n), e.child;
      case 6:
        return t === null && xt && ((t = n = Pt) && (n = yv(
          n,
          e.pendingProps,
          gn
        ), n !== null ? (e.stateNode = n, Ee = e, Pt = null, t = !0) : t = !1), t || Ua(e)), null;
      case 13:
        return _h(t, e, n);
      case 4:
        return On(
          e,
          e.stateNode.containerInfo
        ), a = e.pendingProps, t === null ? e.child = zl(
          e,
          null,
          a,
          n
        ) : xe(t, e, a, n), e.child;
      case 11:
        return Ih(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 7:
        return xe(
          t,
          e,
          e.pendingProps,
          n
        ), e.child;
      case 8:
        return xe(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 12:
        return xe(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 10:
        return a = e.pendingProps, Ha(e, e.type, a.value), xe(t, e, a.children, n), e.child;
      case 9:
        return i = e.type._context, a = e.pendingProps.children, wl(e), i = Te(i), a = a(i), e.flags |= 1, xe(t, e, a, n), e.child;
      case 14:
        return Fh(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 15:
        return kh(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 19:
        return tg(t, e, n);
      case 31:
        return Vy(t, e, n);
      case 22:
        return qh(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        return wl(e), a = Te(se), t === null ? (i = Wu(), i === null && (i = Ft, r = Zu(), i.pooledCache = r, r.refCount++, r !== null && (i.pooledCacheLanes |= n), i = r), e.memoizedState = { parent: a, cache: i }, _u(e), Ha(e, se, i)) : ((t.lanes & n) !== 0 && ($u(t, e), No(e, null, null, n), Co()), i = t.memoizedState, r = e.memoizedState, i.parent !== a ? (i = { parent: a, cache: a }, e.memoizedState = i, e.lanes === 0 && (e.memoizedState = e.updateQueue.baseState = i), Ha(e, se, a)) : (a = r.cache, Ha(e, se, a), a !== i.cache && Ku(
          e,
          [se],
          n,
          !0
        ))), xe(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 29:
        throw e.pendingProps;
    }
    throw Error(u(156, e.tag));
  }
  function ca(t) {
    t.flags |= 4;
  }
  function Rs(t, e, n, a, i) {
    if ((e = (t.mode & 32) !== 0) && (e = !1), e) {
      if (t.flags |= 16777216, (i & 335544128) === i)
        if (t.stateNode.complete) t.flags |= 8192;
        else if (wg()) t.flags |= 8192;
        else
          throw Ml = kr, Ju;
    } else t.flags &= -16777217;
  }
  function ng(t, e) {
    if (e.type !== "stylesheet" || (e.state.loading & 4) !== 0)
      t.flags &= -16777217;
    else if (t.flags |= 16777216, !Ap(e))
      if (wg()) t.flags |= 8192;
      else
        throw Ml = kr, Ju;
  }
  function cc(t, e) {
    e !== null && (t.flags |= 4), t.flags & 16384 && (e = t.tag !== 22 ? Wn() : 536870912, t.lanes |= e, Ni |= e);
  }
  function Lo(t, e) {
    if (!xt)
      switch (t.tailMode) {
        case "hidden":
          e = t.tail;
          for (var n = null; e !== null; )
            e.alternate !== null && (n = e), e = e.sibling;
          n === null ? t.tail = null : n.sibling = null;
          break;
        case "collapsed":
          n = t.tail;
          for (var a = null; n !== null; )
            n.alternate !== null && (a = n), n = n.sibling;
          a === null ? e || t.tail === null ? t.tail = null : t.tail.sibling = null : a.sibling = null;
      }
  }
  function Wt(t) {
    var e = t.alternate !== null && t.alternate.child === t.child, n = 0, a = 0;
    if (e)
      for (var i = t.child; i !== null; )
        n |= i.lanes | i.childLanes, a |= i.subtreeFlags & 65011712, a |= i.flags & 65011712, i.return = t, i = i.sibling;
    else
      for (i = t.child; i !== null; )
        n |= i.lanes | i.childLanes, a |= i.subtreeFlags, a |= i.flags, i.return = t, i = i.sibling;
    return t.subtreeFlags |= a, t.childLanes = n, e;
  }
  function Gy(t, e, n) {
    var a = e.pendingProps;
    switch (Gu(e), e.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Wt(e), null;
      case 1:
        return Wt(e), null;
      case 3:
        return n = e.stateNode, a = null, t !== null && (a = t.memoizedState.cache), e.memoizedState.cache !== a && (e.flags |= 2048), la(se), ve(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (t === null || t.child === null) && (hi(e) ? ca(e) : t === null || t.memoizedState.isDehydrated && (e.flags & 256) === 0 || (e.flags |= 1024, Fu())), Wt(e), null;
      case 26:
        var i = e.type, r = e.memoizedState;
        return t === null ? (ca(e), r !== null ? (Wt(e), ng(e, r)) : (Wt(e), Rs(
          e,
          i,
          null,
          a,
          n
        ))) : r ? r !== t.memoizedState ? (ca(e), Wt(e), ng(e, r)) : (Wt(e), e.flags &= -16777217) : (t = t.memoizedProps, t !== a && ca(e), Wt(e), Rs(
          e,
          i,
          t,
          a,
          n
        )), null;
      case 27:
        if (fl(e), n = ye.current, i = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== a && ca(e);
        else {
          if (!a) {
            if (e.stateNode === null)
              throw Error(u(166));
            return Wt(e), null;
          }
          t = wt.current, hi(e) ? Um(e) : (t = up(i, a, n), e.stateNode = t, ca(e));
        }
        return Wt(e), null;
      case 5:
        if (fl(e), i = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== a && ca(e);
        else {
          if (!a) {
            if (e.stateNode === null)
              throw Error(u(166));
            return Wt(e), null;
          }
          if (r = wt.current, hi(e))
            Um(e);
          else {
            var f = Ec(
              ye.current
            );
            switch (r) {
              case 1:
                r = f.createElementNS(
                  "http://www.w3.org/2000/svg",
                  i
                );
                break;
              case 2:
                r = f.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  i
                );
                break;
              default:
                switch (i) {
                  case "svg":
                    r = f.createElementNS(
                      "http://www.w3.org/2000/svg",
                      i
                    );
                    break;
                  case "math":
                    r = f.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      i
                    );
                    break;
                  case "script":
                    r = f.createElement("div"), r.innerHTML = "<script><\/script>", r = r.removeChild(
                      r.firstChild
                    );
                    break;
                  case "select":
                    r = typeof a.is == "string" ? f.createElement("select", {
                      is: a.is
                    }) : f.createElement("select"), a.multiple ? r.multiple = !0 : a.size && (r.size = a.size);
                    break;
                  default:
                    r = typeof a.is == "string" ? f.createElement(i, { is: a.is }) : f.createElement(i);
                }
            }
            r[pt] = e, r[oe] = a;
            t: for (f = e.child; f !== null; ) {
              if (f.tag === 5 || f.tag === 6)
                r.appendChild(f.stateNode);
              else if (f.tag !== 4 && f.tag !== 27 && f.child !== null) {
                f.child.return = f, f = f.child;
                continue;
              }
              if (f === e) break t;
              for (; f.sibling === null; ) {
                if (f.return === null || f.return === e)
                  break t;
                f = f.return;
              }
              f.sibling.return = f.return, f = f.sibling;
            }
            e.stateNode = r;
            t: switch (Ce(r, i, a), i) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                a = !!a.autoFocus;
                break t;
              case "img":
                a = !0;
                break t;
              default:
                a = !1;
            }
            a && ca(e);
          }
        }
        return Wt(e), Rs(
          e,
          e.type,
          t === null ? null : t.memoizedProps,
          e.pendingProps,
          n
        ), null;
      case 6:
        if (t && e.stateNode != null)
          t.memoizedProps !== a && ca(e);
        else {
          if (typeof a != "string" && e.stateNode === null)
            throw Error(u(166));
          if (t = ye.current, hi(e)) {
            if (t = e.stateNode, n = e.memoizedProps, a = null, i = Ee, i !== null)
              switch (i.tag) {
                case 27:
                case 5:
                  a = i.memoizedProps;
              }
            t[pt] = e, t = !!(t.nodeValue === n || a !== null && a.suppressHydrationWarning === !0 || _g(t.nodeValue, n)), t || Ua(e, !0);
          } else
            t = Ec(t).createTextNode(
              a
            ), t[pt] = e, e.stateNode = t;
        }
        return Wt(e), null;
      case 31:
        if (n = e.memoizedState, t === null || t.memoizedState !== null) {
          if (a = hi(e), n !== null) {
            if (t === null) {
              if (!a) throw Error(u(318));
              if (t = e.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(u(557));
              t[pt] = e;
            } else
              Cl(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            Wt(e), t = !1;
          } else
            n = Fu(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = n), t = !0;
          if (!t)
            return e.flags & 256 ? ($e(e), e) : ($e(e), null);
          if ((e.flags & 128) !== 0)
            throw Error(u(558));
        }
        return Wt(e), null;
      case 13:
        if (a = e.memoizedState, t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
          if (i = hi(e), a !== null && a.dehydrated !== null) {
            if (t === null) {
              if (!i) throw Error(u(318));
              if (i = e.memoizedState, i = i !== null ? i.dehydrated : null, !i) throw Error(u(317));
              i[pt] = e;
            } else
              Cl(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            Wt(e), i = !1;
          } else
            i = Fu(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = i), i = !0;
          if (!i)
            return e.flags & 256 ? ($e(e), e) : ($e(e), null);
        }
        return $e(e), (e.flags & 128) !== 0 ? (e.lanes = n, e) : (n = a !== null, t = t !== null && t.memoizedState !== null, n && (a = e.child, i = null, a.alternate !== null && a.alternate.memoizedState !== null && a.alternate.memoizedState.cachePool !== null && (i = a.alternate.memoizedState.cachePool.pool), r = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (r = a.memoizedState.cachePool.pool), r !== i && (a.flags |= 2048)), n !== t && n && (e.child.flags |= 8192), cc(e, e.updateQueue), Wt(e), null);
      case 4:
        return ve(), t === null && nf(e.stateNode.containerInfo), Wt(e), null;
      case 10:
        return la(e.type), Wt(e), null;
      case 19:
        if (rt(ce), a = e.memoizedState, a === null) return Wt(e), null;
        if (i = (e.flags & 128) !== 0, r = a.rendering, r === null)
          if (i) Lo(a, !1);
          else {
            if (ae !== 0 || t !== null && (t.flags & 128) !== 0)
              for (t = e.child; t !== null; ) {
                if (r = Pr(t), r !== null) {
                  for (e.flags |= 128, Lo(a, !1), t = r.updateQueue, e.updateQueue = t, cc(e, t), e.subtreeFlags = 0, t = n, n = e.child; n !== null; )
                    Bm(n, t), n = n.sibling;
                  return lt(
                    ce,
                    ce.current & 1 | 2
                  ), xt && na(e, a.treeForkCount), e.child;
                }
                t = t.sibling;
              }
            a.tail !== null && ie() > mc && (e.flags |= 128, i = !0, Lo(a, !1), e.lanes = 4194304);
          }
        else {
          if (!i)
            if (t = Pr(r), t !== null) {
              if (e.flags |= 128, i = !0, t = t.updateQueue, e.updateQueue = t, cc(e, t), Lo(a, !0), a.tail === null && a.tailMode === "hidden" && !r.alternate && !xt)
                return Wt(e), null;
            } else
              2 * ie() - a.renderingStartTime > mc && n !== 536870912 && (e.flags |= 128, i = !0, Lo(a, !1), e.lanes = 4194304);
          a.isBackwards ? (r.sibling = e.child, e.child = r) : (t = a.last, t !== null ? t.sibling = r : e.child = r, a.last = r);
        }
        return a.tail !== null ? (t = a.tail, a.rendering = t, a.tail = t.sibling, a.renderingStartTime = ie(), t.sibling = null, n = ce.current, lt(
          ce,
          i ? n & 1 | 2 : n & 1
        ), xt && na(e, a.treeForkCount), t) : (Wt(e), null);
      case 22:
      case 23:
        return $e(e), as(), a = e.memoizedState !== null, t !== null ? t.memoizedState !== null !== a && (e.flags |= 8192) : a && (e.flags |= 8192), a ? (n & 536870912) !== 0 && (e.flags & 128) === 0 && (Wt(e), e.subtreeFlags & 6 && (e.flags |= 8192)) : Wt(e), n = e.updateQueue, n !== null && cc(e, n.retryQueue), n = null, t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), a = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), a !== n && (e.flags |= 2048), t !== null && rt(Dl), null;
      case 24:
        return n = null, t !== null && (n = t.memoizedState.cache), e.memoizedState.cache !== n && (e.flags |= 2048), la(se), Wt(e), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(u(156, e.tag));
  }
  function Iy(t, e) {
    switch (Gu(e), e.tag) {
      case 1:
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 3:
        return la(se), ve(), t = e.flags, (t & 65536) !== 0 && (t & 128) === 0 ? (e.flags = t & -65537 | 128, e) : null;
      case 26:
      case 27:
      case 5:
        return fl(e), null;
      case 31:
        if (e.memoizedState !== null) {
          if ($e(e), e.alternate === null)
            throw Error(u(340));
          Cl();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 13:
        if ($e(e), t = e.memoizedState, t !== null && t.dehydrated !== null) {
          if (e.alternate === null)
            throw Error(u(340));
          Cl();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 19:
        return rt(ce), null;
      case 4:
        return ve(), null;
      case 10:
        return la(e.type), null;
      case 22:
      case 23:
        return $e(e), as(), t !== null && rt(Dl), t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 24:
        return la(se), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function ag(t, e) {
    switch (Gu(e), e.tag) {
      case 3:
        la(se), ve();
        break;
      case 26:
      case 27:
      case 5:
        fl(e);
        break;
      case 4:
        ve();
        break;
      case 31:
        e.memoizedState !== null && $e(e);
        break;
      case 13:
        $e(e);
        break;
      case 19:
        rt(ce);
        break;
      case 10:
        la(e.type);
        break;
      case 22:
      case 23:
        $e(e), as(), t !== null && rt(Dl);
        break;
      case 24:
        la(se);
    }
  }
  function Ro(t, e) {
    try {
      var n = e.updateQueue, a = n !== null ? n.lastEffect : null;
      if (a !== null) {
        var i = a.next;
        n = i;
        do {
          if ((n.tag & t) === t) {
            a = void 0;
            var r = n.create, f = n.inst;
            a = r(), f.destroy = a;
          }
          n = n.next;
        } while (n !== i);
      }
    } catch (m) {
      Vt(e, e.return, m);
    }
  }
  function Ga(t, e, n) {
    try {
      var a = e.updateQueue, i = a !== null ? a.lastEffect : null;
      if (i !== null) {
        var r = i.next;
        a = r;
        do {
          if ((a.tag & t) === t) {
            var f = a.inst, m = f.destroy;
            if (m !== void 0) {
              f.destroy = void 0, i = e;
              var A = n, C = m;
              try {
                C();
              } catch (L) {
                Vt(
                  i,
                  A,
                  L
                );
              }
            }
          }
          a = a.next;
        } while (a !== r);
      }
    } catch (L) {
      Vt(e, e.return, L);
    }
  }
  function lg(t) {
    var e = t.updateQueue;
    if (e !== null) {
      var n = t.stateNode;
      try {
        Zm(e, n);
      } catch (a) {
        Vt(t, t.return, a);
      }
    }
  }
  function ig(t, e, n) {
    n.props = Rl(
      t.type,
      t.memoizedProps
    ), n.state = t.memoizedState;
    try {
      n.componentWillUnmount();
    } catch (a) {
      Vt(t, e, a);
    }
  }
  function Uo(t, e) {
    try {
      var n = t.ref;
      if (n !== null) {
        switch (t.tag) {
          case 26:
          case 27:
          case 5:
            var a = t.stateNode;
            break;
          case 30:
            a = t.stateNode;
            break;
          default:
            a = t.stateNode;
        }
        typeof n == "function" ? t.refCleanup = n(a) : n.current = a;
      }
    } catch (i) {
      Vt(t, e, i);
    }
  }
  function Qn(t, e) {
    var n = t.ref, a = t.refCleanup;
    if (n !== null)
      if (typeof a == "function")
        try {
          a();
        } catch (i) {
          Vt(t, e, i);
        } finally {
          t.refCleanup = null, t = t.alternate, t != null && (t.refCleanup = null);
        }
      else if (typeof n == "function")
        try {
          n(null);
        } catch (i) {
          Vt(t, e, i);
        }
      else n.current = null;
  }
  function og(t) {
    var e = t.type, n = t.memoizedProps, a = t.stateNode;
    try {
      t: switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n.autoFocus && a.focus();
          break t;
        case "img":
          n.src ? a.src = n.src : n.srcSet && (a.srcset = n.srcSet);
      }
    } catch (i) {
      Vt(t, t.return, i);
    }
  }
  function Us(t, e, n) {
    try {
      var a = t.stateNode;
      fv(a, t.type, n, e), a[oe] = e;
    } catch (i) {
      Vt(t, t.return, i);
    }
  }
  function rg(t) {
    return t.tag === 5 || t.tag === 3 || t.tag === 26 || t.tag === 27 && Pa(t.type) || t.tag === 4;
  }
  function Hs(t) {
    t: for (; ; ) {
      for (; t.sibling === null; ) {
        if (t.return === null || rg(t.return)) return null;
        t = t.return;
      }
      for (t.sibling.return = t.return, t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18; ) {
        if (t.tag === 27 && Pa(t.type) || t.flags & 2 || t.child === null || t.tag === 4) continue t;
        t.child.return = t, t = t.child;
      }
      if (!(t.flags & 2)) return t.stateNode;
    }
  }
  function js(t, e, n) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, e ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(t, e) : (e = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, e.appendChild(t), n = n._reactRootContainer, n != null || e.onclick !== null || (e.onclick = Zt));
    else if (a !== 4 && (a === 27 && Pa(t.type) && (n = t.stateNode, e = null), t = t.child, t !== null))
      for (js(t, e, n), t = t.sibling; t !== null; )
        js(t, e, n), t = t.sibling;
  }
  function uc(t, e, n) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, e ? n.insertBefore(t, e) : n.appendChild(t);
    else if (a !== 4 && (a === 27 && Pa(t.type) && (n = t.stateNode), t = t.child, t !== null))
      for (uc(t, e, n), t = t.sibling; t !== null; )
        uc(t, e, n), t = t.sibling;
  }
  function cg(t) {
    var e = t.stateNode, n = t.memoizedProps;
    try {
      for (var a = t.type, i = e.attributes; i.length; )
        e.removeAttributeNode(i[0]);
      Ce(e, a, n), e[pt] = t, e[oe] = n;
    } catch (r) {
      Vt(t, t.return, r);
    }
  }
  var ua = !1, me = !1, Xs = !1, ug = typeof WeakSet == "function" ? WeakSet : Set, be = null;
  function Fy(t, e) {
    if (t = t.containerInfo, of = Bc, t = Sm(t), Mu(t)) {
      if ("selectionStart" in t)
        var n = {
          start: t.selectionStart,
          end: t.selectionEnd
        };
      else
        t: {
          n = (n = t.ownerDocument) && n.defaultView || window;
          var a = n.getSelection && n.getSelection();
          if (a && a.rangeCount !== 0) {
            n = a.anchorNode;
            var i = a.anchorOffset, r = a.focusNode;
            a = a.focusOffset;
            try {
              n.nodeType, r.nodeType;
            } catch {
              n = null;
              break t;
            }
            var f = 0, m = -1, A = -1, C = 0, L = 0, U = t, D = null;
            e: for (; ; ) {
              for (var z; U !== n || i !== 0 && U.nodeType !== 3 || (m = f + i), U !== r || a !== 0 && U.nodeType !== 3 || (A = f + a), U.nodeType === 3 && (f += U.nodeValue.length), (z = U.firstChild) !== null; )
                D = U, U = z;
              for (; ; ) {
                if (U === t) break e;
                if (D === n && ++C === i && (m = f), D === r && ++L === a && (A = f), (z = U.nextSibling) !== null) break;
                U = D, D = U.parentNode;
              }
              U = z;
            }
            n = m === -1 || A === -1 ? null : { start: m, end: A };
          } else n = null;
        }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (rf = { focusedElem: t, selectionRange: n }, Bc = !1, be = e; be !== null; )
      if (e = be, t = e.child, (e.subtreeFlags & 1028) !== 0 && t !== null)
        t.return = e, be = t;
      else
        for (; be !== null; ) {
          switch (e = be, r = e.alternate, t = e.flags, e.tag) {
            case 0:
              if ((t & 4) !== 0 && (t = e.updateQueue, t = t !== null ? t.events : null, t !== null))
                for (n = 0; n < t.length; n++)
                  i = t[n], i.ref.impl = i.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((t & 1024) !== 0 && r !== null) {
                t = void 0, n = e, i = r.memoizedProps, r = r.memoizedState, a = n.stateNode;
                try {
                  var _ = Rl(
                    n.type,
                    i
                  );
                  t = a.getSnapshotBeforeUpdate(
                    _,
                    r
                  ), a.__reactInternalSnapshotBeforeUpdate = t;
                } catch (ot) {
                  Vt(
                    n,
                    n.return,
                    ot
                  );
                }
              }
              break;
            case 3:
              if ((t & 1024) !== 0) {
                if (t = e.stateNode.containerInfo, n = t.nodeType, n === 9)
                  sf(t);
                else if (n === 1)
                  switch (t.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      sf(t);
                      break;
                    default:
                      t.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((t & 1024) !== 0) throw Error(u(163));
          }
          if (t = e.sibling, t !== null) {
            t.return = e.return, be = t;
            break;
          }
          be = e.return;
        }
  }
  function sg(t, e, n) {
    var a = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        fa(t, n), a & 4 && Ro(5, n);
        break;
      case 1:
        if (fa(t, n), a & 4)
          if (t = n.stateNode, e === null)
            try {
              t.componentDidMount();
            } catch (f) {
              Vt(n, n.return, f);
            }
          else {
            var i = Rl(
              n.type,
              e.memoizedProps
            );
            e = e.memoizedState;
            try {
              t.componentDidUpdate(
                i,
                e,
                t.__reactInternalSnapshotBeforeUpdate
              );
            } catch (f) {
              Vt(
                n,
                n.return,
                f
              );
            }
          }
        a & 64 && lg(n), a & 512 && Uo(n, n.return);
        break;
      case 3:
        if (fa(t, n), a & 64 && (t = n.updateQueue, t !== null)) {
          if (e = null, n.child !== null)
            switch (n.child.tag) {
              case 27:
              case 5:
                e = n.child.stateNode;
                break;
              case 1:
                e = n.child.stateNode;
            }
          try {
            Zm(t, e);
          } catch (f) {
            Vt(n, n.return, f);
          }
        }
        break;
      case 27:
        e === null && a & 4 && cg(n);
      case 26:
      case 5:
        fa(t, n), e === null && a & 4 && og(n), a & 512 && Uo(n, n.return);
        break;
      case 12:
        fa(t, n);
        break;
      case 31:
        fa(t, n), a & 4 && mg(t, n);
        break;
      case 13:
        fa(t, n), a & 4 && hg(t, n), a & 64 && (t = n.memoizedState, t !== null && (t = t.dehydrated, t !== null && (n = $y.bind(
          null,
          n
        ), vv(t, n))));
        break;
      case 22:
        if (a = n.memoizedState !== null || ua, !a) {
          e = e !== null && e.memoizedState !== null || me, i = ua;
          var r = me;
          ua = a, (me = e) && !r ? da(
            t,
            n,
            (n.subtreeFlags & 8772) !== 0
          ) : fa(t, n), ua = i, me = r;
        }
        break;
      case 30:
        break;
      default:
        fa(t, n);
    }
  }
  function fg(t) {
    var e = t.alternate;
    e !== null && (t.alternate = null, fg(e)), t.child = null, t.deletions = null, t.sibling = null, t.tag === 5 && (e = t.stateNode, e !== null && io(e)), t.stateNode = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
  }
  var te = null, Ge = !1;
  function sa(t, e, n) {
    for (n = n.child; n !== null; )
      dg(t, e, n), n = n.sibling;
  }
  function dg(t, e, n) {
    if (Be && typeof Be.onCommitFiberUnmount == "function")
      try {
        Be.onCommitFiberUnmount(Oa, n);
      } catch {
      }
    switch (n.tag) {
      case 26:
        me || Qn(n, e), sa(
          t,
          e,
          n
        ), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
        break;
      case 27:
        me || Qn(n, e);
        var a = te, i = Ge;
        Pa(n.type) && (te = n.stateNode, Ge = !1), sa(
          t,
          e,
          n
        ), Fo(n.stateNode), te = a, Ge = i;
        break;
      case 5:
        me || Qn(n, e);
      case 6:
        if (a = te, i = Ge, te = null, sa(
          t,
          e,
          n
        ), te = a, Ge = i, te !== null)
          if (Ge)
            try {
              (te.nodeType === 9 ? te.body : te.nodeName === "HTML" ? te.ownerDocument.body : te).removeChild(n.stateNode);
            } catch (r) {
              Vt(
                n,
                e,
                r
              );
            }
          else
            try {
              te.removeChild(n.stateNode);
            } catch (r) {
              Vt(
                n,
                e,
                r
              );
            }
        break;
      case 18:
        te !== null && (Ge ? (t = te, lp(
          t.nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t,
          n.stateNode
        ), Ui(t)) : lp(te, n.stateNode));
        break;
      case 4:
        a = te, i = Ge, te = n.stateNode.containerInfo, Ge = !0, sa(
          t,
          e,
          n
        ), te = a, Ge = i;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Ga(2, n, e), me || Ga(4, n, e), sa(
          t,
          e,
          n
        );
        break;
      case 1:
        me || (Qn(n, e), a = n.stateNode, typeof a.componentWillUnmount == "function" && ig(
          n,
          e,
          a
        )), sa(
          t,
          e,
          n
        );
        break;
      case 21:
        sa(
          t,
          e,
          n
        );
        break;
      case 22:
        me = (a = me) || n.memoizedState !== null, sa(
          t,
          e,
          n
        ), me = a;
        break;
      default:
        sa(
          t,
          e,
          n
        );
    }
  }
  function mg(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null))) {
      t = t.dehydrated;
      try {
        Ui(t);
      } catch (n) {
        Vt(e, e.return, n);
      }
    }
  }
  function hg(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null && (t = t.dehydrated, t !== null))))
      try {
        Ui(t);
      } catch (n) {
        Vt(e, e.return, n);
      }
  }
  function ky(t) {
    switch (t.tag) {
      case 31:
      case 13:
      case 19:
        var e = t.stateNode;
        return e === null && (e = t.stateNode = new ug()), e;
      case 22:
        return t = t.stateNode, e = t._retryCache, e === null && (e = t._retryCache = new ug()), e;
      default:
        throw Error(u(435, t.tag));
    }
  }
  function sc(t, e) {
    var n = ky(t);
    e.forEach(function(a) {
      if (!n.has(a)) {
        n.add(a);
        var i = tv.bind(null, t, a);
        a.then(i, i);
      }
    });
  }
  function Ie(t, e) {
    var n = e.deletions;
    if (n !== null)
      for (var a = 0; a < n.length; a++) {
        var i = n[a], r = t, f = e, m = f;
        t: for (; m !== null; ) {
          switch (m.tag) {
            case 27:
              if (Pa(m.type)) {
                te = m.stateNode, Ge = !1;
                break t;
              }
              break;
            case 5:
              te = m.stateNode, Ge = !1;
              break t;
            case 3:
            case 4:
              te = m.stateNode.containerInfo, Ge = !0;
              break t;
          }
          m = m.return;
        }
        if (te === null) throw Error(u(160));
        dg(r, f, i), te = null, Ge = !1, r = i.alternate, r !== null && (r.return = null), i.return = null;
      }
    if (e.subtreeFlags & 13886)
      for (e = e.child; e !== null; )
        gg(e, t), e = e.sibling;
  }
  var xn = null;
  function gg(t, e) {
    var n = t.alternate, a = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Ie(e, t), Fe(t), a & 4 && (Ga(3, t, t.return), Ro(3, t), Ga(5, t, t.return));
        break;
      case 1:
        Ie(e, t), Fe(t), a & 512 && (me || n === null || Qn(n, n.return)), a & 64 && ua && (t = t.updateQueue, t !== null && (a = t.callbacks, a !== null && (n = t.shared.hiddenCallbacks, t.shared.hiddenCallbacks = n === null ? a : n.concat(a))));
        break;
      case 26:
        var i = xn;
        if (Ie(e, t), Fe(t), a & 512 && (me || n === null || Qn(n, n.return)), a & 4) {
          var r = n !== null ? n.memoizedState : null;
          if (a = t.memoizedState, n === null)
            if (a === null)
              if (t.stateNode === null) {
                t: {
                  a = t.type, n = t.memoizedProps, i = i.ownerDocument || i;
                  e: switch (a) {
                    case "title":
                      r = i.getElementsByTagName("title")[0], (!r || r[vl] || r[pt] || r.namespaceURI === "http://www.w3.org/2000/svg" || r.hasAttribute("itemprop")) && (r = i.createElement(a), i.head.insertBefore(
                        r,
                        i.querySelector("head > title")
                      )), Ce(r, a, n), r[pt] = t, Kt(r), a = r;
                      break t;
                    case "link":
                      var f = gp(
                        "link",
                        "href",
                        i
                      ).get(a + (n.href || ""));
                      if (f) {
                        for (var m = 0; m < f.length; m++)
                          if (r = f[m], r.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && r.getAttribute("rel") === (n.rel == null ? null : n.rel) && r.getAttribute("title") === (n.title == null ? null : n.title) && r.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
                            f.splice(m, 1);
                            break e;
                          }
                      }
                      r = i.createElement(a), Ce(r, a, n), i.head.appendChild(r);
                      break;
                    case "meta":
                      if (f = gp(
                        "meta",
                        "content",
                        i
                      ).get(a + (n.content || ""))) {
                        for (m = 0; m < f.length; m++)
                          if (r = f[m], r.getAttribute("content") === (n.content == null ? null : "" + n.content) && r.getAttribute("name") === (n.name == null ? null : n.name) && r.getAttribute("property") === (n.property == null ? null : n.property) && r.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && r.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
                            f.splice(m, 1);
                            break e;
                          }
                      }
                      r = i.createElement(a), Ce(r, a, n), i.head.appendChild(r);
                      break;
                    default:
                      throw Error(u(468, a));
                  }
                  r[pt] = t, Kt(r), a = r;
                }
                t.stateNode = a;
              } else
                pp(
                  i,
                  t.type,
                  t.stateNode
                );
            else
              t.stateNode = hp(
                i,
                a,
                t.memoizedProps
              );
          else
            r !== a ? (r === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : r.count--, a === null ? pp(
              i,
              t.type,
              t.stateNode
            ) : hp(
              i,
              a,
              t.memoizedProps
            )) : a === null && t.stateNode !== null && Us(
              t,
              t.memoizedProps,
              n.memoizedProps
            );
        }
        break;
      case 27:
        Ie(e, t), Fe(t), a & 512 && (me || n === null || Qn(n, n.return)), n !== null && a & 4 && Us(
          t,
          t.memoizedProps,
          n.memoizedProps
        );
        break;
      case 5:
        if (Ie(e, t), Fe(t), a & 512 && (me || n === null || Qn(n, n.return)), t.flags & 32) {
          i = t.stateNode;
          try {
            J(i, "");
          } catch (_) {
            Vt(t, t.return, _);
          }
        }
        a & 4 && t.stateNode != null && (i = t.memoizedProps, Us(
          t,
          i,
          n !== null ? n.memoizedProps : i
        )), a & 1024 && (Xs = !0);
        break;
      case 6:
        if (Ie(e, t), Fe(t), a & 4) {
          if (t.stateNode === null)
            throw Error(u(162));
          a = t.memoizedProps, n = t.stateNode;
          try {
            n.nodeValue = a;
          } catch (_) {
            Vt(t, t.return, _);
          }
        }
        break;
      case 3:
        if (Cc = null, i = xn, xn = Tc(e.containerInfo), Ie(e, t), xn = i, Fe(t), a & 4 && n !== null && n.memoizedState.isDehydrated)
          try {
            Ui(e.containerInfo);
          } catch (_) {
            Vt(t, t.return, _);
          }
        Xs && (Xs = !1, pg(t));
        break;
      case 4:
        a = xn, xn = Tc(
          t.stateNode.containerInfo
        ), Ie(e, t), Fe(t), xn = a;
        break;
      case 12:
        Ie(e, t), Fe(t);
        break;
      case 31:
        Ie(e, t), Fe(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, sc(t, a)));
        break;
      case 13:
        Ie(e, t), Fe(t), t.child.flags & 8192 && t.memoizedState !== null != (n !== null && n.memoizedState !== null) && (dc = ie()), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, sc(t, a)));
        break;
      case 22:
        i = t.memoizedState !== null;
        var A = n !== null && n.memoizedState !== null, C = ua, L = me;
        if (ua = C || i, me = L || A, Ie(e, t), me = L, ua = C, Fe(t), a & 8192)
          t: for (e = t.stateNode, e._visibility = i ? e._visibility & -2 : e._visibility | 1, i && (n === null || A || ua || me || Ul(t)), n = null, e = t; ; ) {
            if (e.tag === 5 || e.tag === 26) {
              if (n === null) {
                A = n = e;
                try {
                  if (r = A.stateNode, i)
                    f = r.style, typeof f.setProperty == "function" ? f.setProperty("display", "none", "important") : f.display = "none";
                  else {
                    m = A.stateNode;
                    var U = A.memoizedProps.style, D = U != null && U.hasOwnProperty("display") ? U.display : null;
                    m.style.display = D == null || typeof D == "boolean" ? "" : ("" + D).trim();
                  }
                } catch (_) {
                  Vt(A, A.return, _);
                }
              }
            } else if (e.tag === 6) {
              if (n === null) {
                A = e;
                try {
                  A.stateNode.nodeValue = i ? "" : A.memoizedProps;
                } catch (_) {
                  Vt(A, A.return, _);
                }
              }
            } else if (e.tag === 18) {
              if (n === null) {
                A = e;
                try {
                  var z = A.stateNode;
                  i ? ip(z, !0) : ip(A.stateNode, !1);
                } catch (_) {
                  Vt(A, A.return, _);
                }
              }
            } else if ((e.tag !== 22 && e.tag !== 23 || e.memoizedState === null || e === t) && e.child !== null) {
              e.child.return = e, e = e.child;
              continue;
            }
            if (e === t) break t;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === t) break t;
              n === e && (n = null), e = e.return;
            }
            n === e && (n = null), e.sibling.return = e.return, e = e.sibling;
          }
        a & 4 && (a = t.updateQueue, a !== null && (n = a.retryQueue, n !== null && (a.retryQueue = null, sc(t, n))));
        break;
      case 19:
        Ie(e, t), Fe(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, sc(t, a)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Ie(e, t), Fe(t);
    }
  }
  function Fe(t) {
    var e = t.flags;
    if (e & 2) {
      try {
        for (var n, a = t.return; a !== null; ) {
          if (rg(a)) {
            n = a;
            break;
          }
          a = a.return;
        }
        if (n == null) throw Error(u(160));
        switch (n.tag) {
          case 27:
            var i = n.stateNode, r = Hs(t);
            uc(t, r, i);
            break;
          case 5:
            var f = n.stateNode;
            n.flags & 32 && (J(f, ""), n.flags &= -33);
            var m = Hs(t);
            uc(t, m, f);
            break;
          case 3:
          case 4:
            var A = n.stateNode.containerInfo, C = Hs(t);
            js(
              t,
              C,
              A
            );
            break;
          default:
            throw Error(u(161));
        }
      } catch (L) {
        Vt(t, t.return, L);
      }
      t.flags &= -3;
    }
    e & 4096 && (t.flags &= -4097);
  }
  function pg(t) {
    if (t.subtreeFlags & 1024)
      for (t = t.child; t !== null; ) {
        var e = t;
        pg(e), e.tag === 5 && e.flags & 1024 && e.stateNode.reset(), t = t.sibling;
      }
  }
  function fa(t, e) {
    if (e.subtreeFlags & 8772)
      for (e = e.child; e !== null; )
        sg(t, e.alternate, e), e = e.sibling;
  }
  function Ul(t) {
    for (t = t.child; t !== null; ) {
      var e = t;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Ga(4, e, e.return), Ul(e);
          break;
        case 1:
          Qn(e, e.return);
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && ig(
            e,
            e.return,
            n
          ), Ul(e);
          break;
        case 27:
          Fo(e.stateNode);
        case 26:
        case 5:
          Qn(e, e.return), Ul(e);
          break;
        case 22:
          e.memoizedState === null && Ul(e);
          break;
        case 30:
          Ul(e);
          break;
        default:
          Ul(e);
      }
      t = t.sibling;
    }
  }
  function da(t, e, n) {
    for (n = n && (e.subtreeFlags & 8772) !== 0, e = e.child; e !== null; ) {
      var a = e.alternate, i = t, r = e, f = r.flags;
      switch (r.tag) {
        case 0:
        case 11:
        case 15:
          da(
            i,
            r,
            n
          ), Ro(4, r);
          break;
        case 1:
          if (da(
            i,
            r,
            n
          ), a = r, i = a.stateNode, typeof i.componentDidMount == "function")
            try {
              i.componentDidMount();
            } catch (C) {
              Vt(a, a.return, C);
            }
          if (a = r, i = a.updateQueue, i !== null) {
            var m = a.stateNode;
            try {
              var A = i.shared.hiddenCallbacks;
              if (A !== null)
                for (i.shared.hiddenCallbacks = null, i = 0; i < A.length; i++)
                  Km(A[i], m);
            } catch (C) {
              Vt(a, a.return, C);
            }
          }
          n && f & 64 && lg(r), Uo(r, r.return);
          break;
        case 27:
          cg(r);
        case 26:
        case 5:
          da(
            i,
            r,
            n
          ), n && a === null && f & 4 && og(r), Uo(r, r.return);
          break;
        case 12:
          da(
            i,
            r,
            n
          );
          break;
        case 31:
          da(
            i,
            r,
            n
          ), n && f & 4 && mg(i, r);
          break;
        case 13:
          da(
            i,
            r,
            n
          ), n && f & 4 && hg(i, r);
          break;
        case 22:
          r.memoizedState === null && da(
            i,
            r,
            n
          ), Uo(r, r.return);
          break;
        case 30:
          break;
        default:
          da(
            i,
            r,
            n
          );
      }
      e = e.sibling;
    }
  }
  function Qs(t, e) {
    var n = null;
    t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), t = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (t = e.memoizedState.cachePool.pool), t !== n && (t != null && t.refCount++, n != null && So(n));
  }
  function Vs(t, e) {
    t = null, e.alternate !== null && (t = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== t && (e.refCount++, t != null && So(t));
  }
  function Cn(t, e, n, a) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; )
        Ag(
          t,
          e,
          n,
          a
        ), e = e.sibling;
  }
  function Ag(t, e, n, a) {
    var i = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Cn(
          t,
          e,
          n,
          a
        ), i & 2048 && Ro(9, e);
        break;
      case 1:
        Cn(
          t,
          e,
          n,
          a
        );
        break;
      case 3:
        Cn(
          t,
          e,
          n,
          a
        ), i & 2048 && (t = null, e.alternate !== null && (t = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== t && (e.refCount++, t != null && So(t)));
        break;
      case 12:
        if (i & 2048) {
          Cn(
            t,
            e,
            n,
            a
          ), t = e.stateNode;
          try {
            var r = e.memoizedProps, f = r.id, m = r.onPostCommit;
            typeof m == "function" && m(
              f,
              e.alternate === null ? "mount" : "update",
              t.passiveEffectDuration,
              -0
            );
          } catch (A) {
            Vt(e, e.return, A);
          }
        } else
          Cn(
            t,
            e,
            n,
            a
          );
        break;
      case 31:
        Cn(
          t,
          e,
          n,
          a
        );
        break;
      case 13:
        Cn(
          t,
          e,
          n,
          a
        );
        break;
      case 23:
        break;
      case 22:
        r = e.stateNode, f = e.alternate, e.memoizedState !== null ? r._visibility & 2 ? Cn(
          t,
          e,
          n,
          a
        ) : Ho(t, e) : r._visibility & 2 ? Cn(
          t,
          e,
          n,
          a
        ) : (r._visibility |= 2, Ti(
          t,
          e,
          n,
          a,
          (e.subtreeFlags & 10256) !== 0 || !1
        )), i & 2048 && Qs(f, e);
        break;
      case 24:
        Cn(
          t,
          e,
          n,
          a
        ), i & 2048 && Vs(e.alternate, e);
        break;
      default:
        Cn(
          t,
          e,
          n,
          a
        );
    }
  }
  function Ti(t, e, n, a, i) {
    for (i = i && ((e.subtreeFlags & 10256) !== 0 || !1), e = e.child; e !== null; ) {
      var r = t, f = e, m = n, A = a, C = f.flags;
      switch (f.tag) {
        case 0:
        case 11:
        case 15:
          Ti(
            r,
            f,
            m,
            A,
            i
          ), Ro(8, f);
          break;
        case 23:
          break;
        case 22:
          var L = f.stateNode;
          f.memoizedState !== null ? L._visibility & 2 ? Ti(
            r,
            f,
            m,
            A,
            i
          ) : Ho(
            r,
            f
          ) : (L._visibility |= 2, Ti(
            r,
            f,
            m,
            A,
            i
          )), i && C & 2048 && Qs(
            f.alternate,
            f
          );
          break;
        case 24:
          Ti(
            r,
            f,
            m,
            A,
            i
          ), i && C & 2048 && Vs(f.alternate, f);
          break;
        default:
          Ti(
            r,
            f,
            m,
            A,
            i
          );
      }
      e = e.sibling;
    }
  }
  function Ho(t, e) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; ) {
        var n = t, a = e, i = a.flags;
        switch (a.tag) {
          case 22:
            Ho(n, a), i & 2048 && Qs(
              a.alternate,
              a
            );
            break;
          case 24:
            Ho(n, a), i & 2048 && Vs(a.alternate, a);
            break;
          default:
            Ho(n, a);
        }
        e = e.sibling;
      }
  }
  var jo = 8192;
  function xi(t, e, n) {
    if (t.subtreeFlags & jo)
      for (t = t.child; t !== null; )
        yg(
          t,
          e,
          n
        ), t = t.sibling;
  }
  function yg(t, e, n) {
    switch (t.tag) {
      case 26:
        xi(
          t,
          e,
          n
        ), t.flags & jo && t.memoizedState !== null && Mv(
          n,
          xn,
          t.memoizedState,
          t.memoizedProps
        );
        break;
      case 5:
        xi(
          t,
          e,
          n
        );
        break;
      case 3:
      case 4:
        var a = xn;
        xn = Tc(t.stateNode.containerInfo), xi(
          t,
          e,
          n
        ), xn = a;
        break;
      case 22:
        t.memoizedState === null && (a = t.alternate, a !== null && a.memoizedState !== null ? (a = jo, jo = 16777216, xi(
          t,
          e,
          n
        ), jo = a) : xi(
          t,
          e,
          n
        ));
        break;
      default:
        xi(
          t,
          e,
          n
        );
    }
  }
  function vg(t) {
    var e = t.alternate;
    if (e !== null && (t = e.child, t !== null)) {
      e.child = null;
      do
        e = t.sibling, t.sibling = null, t = e;
      while (t !== null);
    }
  }
  function Xo(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var a = e[n];
          be = a, Sg(
            a,
            t
          );
        }
      vg(t);
    }
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        bg(t), t = t.sibling;
  }
  function bg(t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Xo(t), t.flags & 2048 && Ga(9, t, t.return);
        break;
      case 3:
        Xo(t);
        break;
      case 12:
        Xo(t);
        break;
      case 22:
        var e = t.stateNode;
        t.memoizedState !== null && e._visibility & 2 && (t.return === null || t.return.tag !== 13) ? (e._visibility &= -3, fc(t)) : Xo(t);
        break;
      default:
        Xo(t);
    }
  }
  function fc(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var a = e[n];
          be = a, Sg(
            a,
            t
          );
        }
      vg(t);
    }
    for (t = t.child; t !== null; ) {
      switch (e = t, e.tag) {
        case 0:
        case 11:
        case 15:
          Ga(8, e, e.return), fc(e);
          break;
        case 22:
          n = e.stateNode, n._visibility & 2 && (n._visibility &= -3, fc(e));
          break;
        default:
          fc(e);
      }
      t = t.sibling;
    }
  }
  function Sg(t, e) {
    for (; be !== null; ) {
      var n = be;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Ga(8, n, e);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var a = n.memoizedState.cachePool.pool;
            a != null && a.refCount++;
          }
          break;
        case 24:
          So(n.memoizedState.cache);
      }
      if (a = n.child, a !== null) a.return = n, be = a;
      else
        t: for (n = t; be !== null; ) {
          a = be;
          var i = a.sibling, r = a.return;
          if (fg(a), a === n) {
            be = null;
            break t;
          }
          if (i !== null) {
            i.return = r, be = i;
            break t;
          }
          be = r;
        }
    }
  }
  var qy = {
    getCacheForType: function(t) {
      var e = Te(se), n = e.data.get(t);
      return n === void 0 && (n = t(), e.data.set(t, n)), n;
    },
    cacheSignal: function() {
      return Te(se).controller.signal;
    }
  }, Ky = typeof WeakMap == "function" ? WeakMap : Map, Ut = 0, Ft = null, vt = null, Ot = 0, Qt = 0, tn = null, Ia = !1, Ci = !1, Ys = !1, ma = 0, ae = 0, Fa = 0, Hl = 0, Gs = 0, en = 0, Ni = 0, Qo = null, ke = null, Is = !1, dc = 0, Og = 0, mc = 1 / 0, hc = null, ka = null, pe = 0, qa = null, wi = null, ha = 0, Fs = 0, ks = null, Eg = null, Vo = 0, qs = null;
  function nn() {
    return (Ut & 2) !== 0 && Ot !== 0 ? Ot & -Ot : X.T !== null ? _s() : xa();
  }
  function Tg() {
    if (en === 0)
      if ((Ot & 536870912) === 0 || xt) {
        var t = pl;
        pl <<= 1, (pl & 3932160) === 0 && (pl = 262144), en = t;
      } else en = 536870912;
    return t = _e.current, t !== null && (t.flags |= 32), en;
  }
  function qe(t, e, n) {
    (t === Ft && (Qt === 2 || Qt === 9) || t.cancelPendingCommit !== null) && (Di(t, 0), Ka(
      t,
      Ot,
      en,
      !1
    )), Jn(t, n), ((Ut & 2) === 0 || t !== Ft) && (t === Ft && ((Ut & 2) === 0 && (Hl |= n), ae === 4 && Ka(
      t,
      Ot,
      en,
      !1
    )), Vn(t));
  }
  function xg(t, e, n) {
    if ((Ut & 6) !== 0) throw Error(u(327));
    var a = !n && (e & 127) === 0 && (e & t.expiredLanes) === 0 || Ln(t, e), i = a ? Wy(t, e) : Zs(t, e, !0), r = a;
    do {
      if (i === 0) {
        Ci && !a && Ka(t, e, 0, !1);
        break;
      } else {
        if (n = t.current.alternate, r && !Zy(n)) {
          i = Zs(t, e, !1), r = !1;
          continue;
        }
        if (i === 2) {
          if (r = e, t.errorRecoveryDisabledLanes & r)
            var f = 0;
          else
            f = t.pendingLanes & -536870913, f = f !== 0 ? f : f & 536870912 ? 536870912 : 0;
          if (f !== 0) {
            e = f;
            t: {
              var m = t;
              i = Qo;
              var A = m.current.memoizedState.isDehydrated;
              if (A && (Di(m, f).flags |= 256), f = Zs(
                m,
                f,
                !1
              ), f !== 2) {
                if (Ys && !A) {
                  m.errorRecoveryDisabledLanes |= r, Hl |= r, i = 4;
                  break t;
                }
                r = ke, ke = i, r !== null && (ke === null ? ke = r : ke.push.apply(
                  ke,
                  r
                ));
              }
              i = f;
            }
            if (r = !1, i !== 2) continue;
          }
        }
        if (i === 1) {
          Di(t, 0), Ka(t, e, 0, !0);
          break;
        }
        t: {
          switch (a = t, r = i, r) {
            case 0:
            case 1:
              throw Error(u(345));
            case 4:
              if ((e & 4194048) !== e) break;
            case 6:
              Ka(
                a,
                e,
                en,
                !Ia
              );
              break t;
            case 2:
              ke = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(u(329));
          }
          if ((e & 62914560) === e && (i = dc + 300 - ie(), 10 < i)) {
            if (Ka(
              a,
              e,
              en,
              !Ia
            ), Pn(a, 0, !0) !== 0) break t;
            ha = e, a.timeoutHandle = np(
              Cg.bind(
                null,
                a,
                n,
                ke,
                hc,
                Is,
                e,
                en,
                Hl,
                Ni,
                Ia,
                r,
                "Throttled",
                -0,
                0
              ),
              i
            );
            break t;
          }
          Cg(
            a,
            n,
            ke,
            hc,
            Is,
            e,
            en,
            Hl,
            Ni,
            Ia,
            r,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    Vn(t);
  }
  function Cg(t, e, n, a, i, r, f, m, A, C, L, U, D, z) {
    if (t.timeoutHandle = -1, U = e.subtreeFlags, U & 8192 || (U & 16785408) === 16785408) {
      U = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Zt
      }, yg(
        e,
        r,
        U
      );
      var _ = (r & 62914560) === r ? dc - ie() : (r & 4194048) === r ? Og - ie() : 0;
      if (_ = zv(
        U,
        _
      ), _ !== null) {
        ha = r, t.cancelPendingCommit = _(
          Rg.bind(
            null,
            t,
            e,
            r,
            n,
            a,
            i,
            f,
            m,
            A,
            L,
            U,
            null,
            D,
            z
          )
        ), Ka(t, r, f, !C);
        return;
      }
    }
    Rg(
      t,
      e,
      r,
      n,
      a,
      i,
      f,
      m,
      A
    );
  }
  function Zy(t) {
    for (var e = t; ; ) {
      var n = e.tag;
      if ((n === 0 || n === 11 || n === 15) && e.flags & 16384 && (n = e.updateQueue, n !== null && (n = n.stores, n !== null)))
        for (var a = 0; a < n.length; a++) {
          var i = n[a], r = i.getSnapshot;
          i = i.value;
          try {
            if (!We(r(), i)) return !1;
          } catch {
            return !1;
          }
        }
      if (n = e.child, e.subtreeFlags & 16384 && n !== null)
        n.return = e, e = n;
      else {
        if (e === t) break;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) return !0;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    }
    return !0;
  }
  function Ka(t, e, n, a) {
    e &= ~Gs, e &= ~Hl, t.suspendedLanes |= e, t.pingedLanes &= ~e, a && (t.warmLanes |= e), a = t.expirationTimes;
    for (var i = e; 0 < i; ) {
      var r = 31 - Oe(i), f = 1 << r;
      a[r] = -1, i &= ~f;
    }
    n !== 0 && to(t, n, e);
  }
  function gc() {
    return (Ut & 6) === 0 ? (Yo(0), !1) : !0;
  }
  function Ks() {
    if (vt !== null) {
      if (Qt === 0)
        var t = vt.return;
      else
        t = vt, aa = Nl = null, us(t), vi = null, Eo = 0, t = vt;
      for (; t !== null; )
        ag(t.alternate, t), t = t.return;
      vt = null;
    }
  }
  function Di(t, e) {
    var n = t.timeoutHandle;
    n !== -1 && (t.timeoutHandle = -1, hv(n)), n = t.cancelPendingCommit, n !== null && (t.cancelPendingCommit = null, n()), ha = 0, Ks(), Ft = t, vt = n = ea(t.current, null), Ot = e, Qt = 0, tn = null, Ia = !1, Ci = Ln(t, e), Ys = !1, Ni = en = Gs = Hl = Fa = ae = 0, ke = Qo = null, Is = !1, (e & 8) !== 0 && (e |= e & 32);
    var a = t.entangledLanes;
    if (a !== 0)
      for (t = t.entanglements, a &= e; 0 < a; ) {
        var i = 31 - Oe(a), r = 1 << i;
        e |= t[i], a &= ~r;
      }
    return ma = e, Hr(), n;
  }
  function Ng(t, e) {
    dt = null, X.H = Mo, e === yi || e === Fr ? (e = Im(), Qt = 3) : e === Ju ? (e = Im(), Qt = 4) : Qt = e === xs ? 8 : e !== null && typeof e == "object" && typeof e.then == "function" ? 6 : 1, tn = e, vt === null && (ae = 1, lc(
      t,
      dn(e, t.current)
    ));
  }
  function wg() {
    var t = _e.current;
    return t === null ? !0 : (Ot & 4194048) === Ot ? pn === null : (Ot & 62914560) === Ot || (Ot & 536870912) !== 0 ? t === pn : !1;
  }
  function Dg() {
    var t = X.H;
    return X.H = Mo, t === null ? Mo : t;
  }
  function Bg() {
    var t = X.A;
    return X.A = qy, t;
  }
  function pc() {
    ae = 4, Ia || (Ot & 4194048) !== Ot && _e.current !== null || (Ci = !0), (Fa & 134217727) === 0 && (Hl & 134217727) === 0 || Ft === null || Ka(
      Ft,
      Ot,
      en,
      !1
    );
  }
  function Zs(t, e, n) {
    var a = Ut;
    Ut |= 2;
    var i = Dg(), r = Bg();
    (Ft !== t || Ot !== e) && (hc = null, Di(t, e)), e = !1;
    var f = ae;
    t: do
      try {
        if (Qt !== 0 && vt !== null) {
          var m = vt, A = tn;
          switch (Qt) {
            case 8:
              Ks(), f = 6;
              break t;
            case 3:
            case 2:
            case 9:
            case 6:
              _e.current === null && (e = !0);
              var C = Qt;
              if (Qt = 0, tn = null, Bi(t, m, A, C), n && Ci) {
                f = 0;
                break t;
              }
              break;
            default:
              C = Qt, Qt = 0, tn = null, Bi(t, m, A, C);
          }
        }
        Py(), f = ae;
        break;
      } catch (L) {
        Ng(t, L);
      }
    while (!0);
    return e && t.shellSuspendCounter++, aa = Nl = null, Ut = a, X.H = i, X.A = r, vt === null && (Ft = null, Ot = 0, Hr()), f;
  }
  function Py() {
    for (; vt !== null; ) Mg(vt);
  }
  function Wy(t, e) {
    var n = Ut;
    Ut |= 2;
    var a = Dg(), i = Bg();
    Ft !== t || Ot !== e ? (hc = null, mc = ie() + 500, Di(t, e)) : Ci = Ln(
      t,
      e
    );
    t: do
      try {
        if (Qt !== 0 && vt !== null) {
          e = vt;
          var r = tn;
          e: switch (Qt) {
            case 1:
              Qt = 0, tn = null, Bi(t, e, r, 1);
              break;
            case 2:
            case 9:
              if (Ym(r)) {
                Qt = 0, tn = null, zg(e);
                break;
              }
              e = function() {
                Qt !== 2 && Qt !== 9 || Ft !== t || (Qt = 7), Vn(t);
              }, r.then(e, e);
              break t;
            case 3:
              Qt = 7;
              break t;
            case 4:
              Qt = 5;
              break t;
            case 7:
              Ym(r) ? (Qt = 0, tn = null, zg(e)) : (Qt = 0, tn = null, Bi(t, e, r, 7));
              break;
            case 5:
              var f = null;
              switch (vt.tag) {
                case 26:
                  f = vt.memoizedState;
                case 5:
                case 27:
                  var m = vt;
                  if (f ? Ap(f) : m.stateNode.complete) {
                    Qt = 0, tn = null;
                    var A = m.sibling;
                    if (A !== null) vt = A;
                    else {
                      var C = m.return;
                      C !== null ? (vt = C, Ac(C)) : vt = null;
                    }
                    break e;
                  }
              }
              Qt = 0, tn = null, Bi(t, e, r, 5);
              break;
            case 6:
              Qt = 0, tn = null, Bi(t, e, r, 6);
              break;
            case 8:
              Ks(), ae = 6;
              break t;
            default:
              throw Error(u(462));
          }
        }
        Jy();
        break;
      } catch (L) {
        Ng(t, L);
      }
    while (!0);
    return aa = Nl = null, X.H = a, X.A = i, Ut = n, vt !== null ? 0 : (Ft = null, Ot = 0, Hr(), ae);
  }
  function Jy() {
    for (; vt !== null && !Mn(); )
      Mg(vt);
  }
  function Mg(t) {
    var e = eg(t.alternate, t, ma);
    t.memoizedProps = t.pendingProps, e === null ? Ac(t) : vt = e;
  }
  function zg(t) {
    var e = t, n = e.alternate;
    switch (e.tag) {
      case 15:
      case 0:
        e = Ph(
          n,
          e,
          e.pendingProps,
          e.type,
          void 0,
          Ot
        );
        break;
      case 11:
        e = Ph(
          n,
          e,
          e.pendingProps,
          e.type.render,
          e.ref,
          Ot
        );
        break;
      case 5:
        us(e);
      default:
        ag(n, e), e = vt = Bm(e, ma), e = eg(n, e, ma);
    }
    t.memoizedProps = t.pendingProps, e === null ? Ac(t) : vt = e;
  }
  function Bi(t, e, n, a) {
    aa = Nl = null, us(e), vi = null, Eo = 0;
    var i = e.return;
    try {
      if (Qy(
        t,
        i,
        e,
        n,
        Ot
      )) {
        ae = 1, lc(
          t,
          dn(n, t.current)
        ), vt = null;
        return;
      }
    } catch (r) {
      if (i !== null) throw vt = i, r;
      ae = 1, lc(
        t,
        dn(n, t.current)
      ), vt = null;
      return;
    }
    e.flags & 32768 ? (xt || a === 1 ? t = !0 : Ci || (Ot & 536870912) !== 0 ? t = !1 : (Ia = t = !0, (a === 2 || a === 9 || a === 3 || a === 6) && (a = _e.current, a !== null && a.tag === 13 && (a.flags |= 16384))), Lg(e, t)) : Ac(e);
  }
  function Ac(t) {
    var e = t;
    do {
      if ((e.flags & 32768) !== 0) {
        Lg(
          e,
          Ia
        );
        return;
      }
      t = e.return;
      var n = Gy(
        e.alternate,
        e,
        ma
      );
      if (n !== null) {
        vt = n;
        return;
      }
      if (e = e.sibling, e !== null) {
        vt = e;
        return;
      }
      vt = e = t;
    } while (e !== null);
    ae === 0 && (ae = 5);
  }
  function Lg(t, e) {
    do {
      var n = Iy(t.alternate, t);
      if (n !== null) {
        n.flags &= 32767, vt = n;
        return;
      }
      if (n = t.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !e && (t = t.sibling, t !== null)) {
        vt = t;
        return;
      }
      vt = t = n;
    } while (t !== null);
    ae = 6, vt = null;
  }
  function Rg(t, e, n, a, i, r, f, m, A) {
    t.cancelPendingCommit = null;
    do
      yc();
    while (pe !== 0);
    if ((Ut & 6) !== 0) throw Error(u(327));
    if (e !== null) {
      if (e === t.current) throw Error(u(177));
      if (r = e.lanes | e.childLanes, r |= Hu, Au(
        t,
        n,
        r,
        f,
        m,
        A
      ), t === Ft && (vt = Ft = null, Ot = 0), wi = e, qa = t, ha = n, Fs = r, ks = i, Eg = a, (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0 ? (t.callbackNode = null, t.callbackPriority = 0, ev(ba, function() {
        return Qg(), null;
      })) : (t.callbackNode = null, t.callbackPriority = 0), a = (e.flags & 13878) !== 0, (e.subtreeFlags & 13878) !== 0 || a) {
        a = X.T, X.T = null, i = Z.p, Z.p = 2, f = Ut, Ut |= 4;
        try {
          Fy(t, e, n);
        } finally {
          Ut = f, Z.p = i, X.T = a;
        }
      }
      pe = 1, Ug(), Hg(), jg();
    }
  }
  function Ug() {
    if (pe === 1) {
      pe = 0;
      var t = qa, e = wi, n = (e.flags & 13878) !== 0;
      if ((e.subtreeFlags & 13878) !== 0 || n) {
        n = X.T, X.T = null;
        var a = Z.p;
        Z.p = 2;
        var i = Ut;
        Ut |= 4;
        try {
          gg(e, t);
          var r = rf, f = Sm(t.containerInfo), m = r.focusedElem, A = r.selectionRange;
          if (f !== m && m && m.ownerDocument && bm(
            m.ownerDocument.documentElement,
            m
          )) {
            if (A !== null && Mu(m)) {
              var C = A.start, L = A.end;
              if (L === void 0 && (L = C), "selectionStart" in m)
                m.selectionStart = C, m.selectionEnd = Math.min(
                  L,
                  m.value.length
                );
              else {
                var U = m.ownerDocument || document, D = U && U.defaultView || window;
                if (D.getSelection) {
                  var z = D.getSelection(), _ = m.textContent.length, ot = Math.min(A.start, _), It = A.end === void 0 ? ot : Math.min(A.end, _);
                  !z.extend && ot > It && (f = It, It = ot, ot = f);
                  var S = vm(
                    m,
                    ot
                  ), v = vm(
                    m,
                    It
                  );
                  if (S && v && (z.rangeCount !== 1 || z.anchorNode !== S.node || z.anchorOffset !== S.offset || z.focusNode !== v.node || z.focusOffset !== v.offset)) {
                    var T = U.createRange();
                    T.setStart(S.node, S.offset), z.removeAllRanges(), ot > It ? (z.addRange(T), z.extend(v.node, v.offset)) : (T.setEnd(v.node, v.offset), z.addRange(T));
                  }
                }
              }
            }
            for (U = [], z = m; z = z.parentNode; )
              z.nodeType === 1 && U.push({
                element: z,
                left: z.scrollLeft,
                top: z.scrollTop
              });
            for (typeof m.focus == "function" && m.focus(), m = 0; m < U.length; m++) {
              var R = U[m];
              R.element.scrollLeft = R.left, R.element.scrollTop = R.top;
            }
          }
          Bc = !!of, rf = of = null;
        } finally {
          Ut = i, Z.p = a, X.T = n;
        }
      }
      t.current = e, pe = 2;
    }
  }
  function Hg() {
    if (pe === 2) {
      pe = 0;
      var t = qa, e = wi, n = (e.flags & 8772) !== 0;
      if ((e.subtreeFlags & 8772) !== 0 || n) {
        n = X.T, X.T = null;
        var a = Z.p;
        Z.p = 2;
        var i = Ut;
        Ut |= 4;
        try {
          sg(t, e.alternate, e);
        } finally {
          Ut = i, Z.p = a, X.T = n;
        }
      }
      pe = 3;
    }
  }
  function jg() {
    if (pe === 4 || pe === 3) {
      pe = 0, ml();
      var t = qa, e = wi, n = ha, a = Eg;
      (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0 ? pe = 5 : (pe = 0, wi = qa = null, Xg(t, t.pendingLanes));
      var i = t.pendingLanes;
      if (i === 0 && (ka = null), no(n), e = e.stateNode, Be && typeof Be.onCommitFiberRoot == "function")
        try {
          Be.onCommitFiberRoot(
            Oa,
            e,
            void 0,
            (e.current.flags & 128) === 128
          );
        } catch {
        }
      if (a !== null) {
        e = X.T, i = Z.p, Z.p = 2, X.T = null;
        try {
          for (var r = t.onRecoverableError, f = 0; f < a.length; f++) {
            var m = a[f];
            r(m.value, {
              componentStack: m.stack
            });
          }
        } finally {
          X.T = e, Z.p = i;
        }
      }
      (ha & 3) !== 0 && yc(), Vn(t), i = t.pendingLanes, (n & 261930) !== 0 && (i & 42) !== 0 ? t === qs ? Vo++ : (Vo = 0, qs = t) : Vo = 0, Yo(0);
    }
  }
  function Xg(t, e) {
    (t.pooledCacheLanes &= e) === 0 && (e = t.pooledCache, e != null && (t.pooledCache = null, So(e)));
  }
  function yc() {
    return Ug(), Hg(), jg(), Qg();
  }
  function Qg() {
    if (pe !== 5) return !1;
    var t = qa, e = Fs;
    Fs = 0;
    var n = no(ha), a = X.T, i = Z.p;
    try {
      Z.p = 32 > n ? 32 : n, X.T = null, n = ks, ks = null;
      var r = qa, f = ha;
      if (pe = 0, wi = qa = null, ha = 0, (Ut & 6) !== 0) throw Error(u(331));
      var m = Ut;
      if (Ut |= 4, bg(r.current), Ag(
        r,
        r.current,
        f,
        n
      ), Ut = m, Yo(0, !1), Be && typeof Be.onPostCommitFiberRoot == "function")
        try {
          Be.onPostCommitFiberRoot(Oa, r);
        } catch {
        }
      return !0;
    } finally {
      Z.p = i, X.T = a, Xg(t, e);
    }
  }
  function Vg(t, e, n) {
    e = dn(n, e), e = Ts(t.stateNode, e, 2), t = Qa(t, e, 2), t !== null && (Jn(t, 2), Vn(t));
  }
  function Vt(t, e, n) {
    if (t.tag === 3)
      Vg(t, t, n);
    else
      for (; e !== null; ) {
        if (e.tag === 3) {
          Vg(
            e,
            t,
            n
          );
          break;
        } else if (e.tag === 1) {
          var a = e.stateNode;
          if (typeof e.type.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && (ka === null || !ka.has(a))) {
            t = dn(n, t), n = Yh(2), a = Qa(e, n, 2), a !== null && (Gh(
              n,
              a,
              e,
              t
            ), Jn(a, 2), Vn(a));
            break;
          }
        }
        e = e.return;
      }
  }
  function Ps(t, e, n) {
    var a = t.pingCache;
    if (a === null) {
      a = t.pingCache = new Ky();
      var i = /* @__PURE__ */ new Set();
      a.set(e, i);
    } else
      i = a.get(e), i === void 0 && (i = /* @__PURE__ */ new Set(), a.set(e, i));
    i.has(n) || (Ys = !0, i.add(n), t = _y.bind(null, t, e, n), e.then(t, t));
  }
  function _y(t, e, n) {
    var a = t.pingCache;
    a !== null && a.delete(e), t.pingedLanes |= t.suspendedLanes & n, t.warmLanes &= ~n, Ft === t && (Ot & n) === n && (ae === 4 || ae === 3 && (Ot & 62914560) === Ot && 300 > ie() - dc ? (Ut & 2) === 0 && Di(t, 0) : Gs |= n, Ni === Ot && (Ni = 0)), Vn(t);
  }
  function Yg(t, e) {
    e === 0 && (e = Wn()), t = Tl(t, e), t !== null && (Jn(t, e), Vn(t));
  }
  function $y(t) {
    var e = t.memoizedState, n = 0;
    e !== null && (n = e.retryLane), Yg(t, n);
  }
  function tv(t, e) {
    var n = 0;
    switch (t.tag) {
      case 31:
      case 13:
        var a = t.stateNode, i = t.memoizedState;
        i !== null && (n = i.retryLane);
        break;
      case 19:
        a = t.stateNode;
        break;
      case 22:
        a = t.stateNode._retryCache;
        break;
      default:
        throw Error(u(314));
    }
    a !== null && a.delete(e), Yg(t, n);
  }
  function ev(t, e) {
    return Zl(t, e);
  }
  var vc = null, Mi = null, Ws = !1, bc = !1, Js = !1, Za = 0;
  function Vn(t) {
    t !== Mi && t.next === null && (Mi === null ? vc = Mi = t : Mi = Mi.next = t), bc = !0, Ws || (Ws = !0, av());
  }
  function Yo(t, e) {
    if (!Js && bc) {
      Js = !0;
      do
        for (var n = !1, a = vc; a !== null; ) {
          if (t !== 0) {
            var i = a.pendingLanes;
            if (i === 0) var r = 0;
            else {
              var f = a.suspendedLanes, m = a.pingedLanes;
              r = (1 << 31 - Oe(42 | t) + 1) - 1, r &= i & ~(f & ~m), r = r & 201326741 ? r & 201326741 | 1 : r ? r | 2 : 0;
            }
            r !== 0 && (n = !0, kg(a, r));
          } else
            r = Ot, r = Pn(
              a,
              a === Ft ? r : 0,
              a.cancelPendingCommit !== null || a.timeoutHandle !== -1
            ), (r & 3) === 0 || Ln(a, r) || (n = !0, kg(a, r));
          a = a.next;
        }
      while (n);
      Js = !1;
    }
  }
  function nv() {
    Gg();
  }
  function Gg() {
    bc = Ws = !1;
    var t = 0;
    Za !== 0 && mv() && (t = Za);
    for (var e = ie(), n = null, a = vc; a !== null; ) {
      var i = a.next, r = Ig(a, e);
      r === 0 ? (a.next = null, n === null ? vc = i : n.next = i, i === null && (Mi = n)) : (n = a, (t !== 0 || (r & 3) !== 0) && (bc = !0)), a = i;
    }
    pe !== 0 && pe !== 5 || Yo(t), Za !== 0 && (Za = 0);
  }
  function Ig(t, e) {
    for (var n = t.suspendedLanes, a = t.pingedLanes, i = t.expirationTimes, r = t.pendingLanes & -62914561; 0 < r; ) {
      var f = 31 - Oe(r), m = 1 << f, A = i[f];
      A === -1 ? ((m & n) === 0 || (m & a) !== 0) && (i[f] = sn(m, e)) : A <= e && (t.expiredLanes |= m), r &= ~m;
    }
    if (e = Ft, n = Ot, n = Pn(
      t,
      t === e ? n : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a = t.callbackNode, n === 0 || t === e && (Qt === 2 || Qt === 9) || t.cancelPendingCommit !== null)
      return a !== null && a !== null && Pl(a), t.callbackNode = null, t.callbackPriority = 0;
    if ((n & 3) === 0 || Ln(t, n)) {
      if (e = n & -n, e === t.callbackPriority) return e;
      switch (a !== null && Pl(a), no(n)) {
        case 2:
        case 8:
          n = Jl;
          break;
        case 32:
          n = ba;
          break;
        case 268435456:
          n = hl;
          break;
        default:
          n = ba;
      }
      return a = Fg.bind(null, t), n = Zl(n, a), t.callbackPriority = e, t.callbackNode = n, e;
    }
    return a !== null && a !== null && Pl(a), t.callbackPriority = 2, t.callbackNode = null, 2;
  }
  function Fg(t, e) {
    if (pe !== 0 && pe !== 5)
      return t.callbackNode = null, t.callbackPriority = 0, null;
    var n = t.callbackNode;
    if (yc() && t.callbackNode !== n)
      return null;
    var a = Ot;
    return a = Pn(
      t,
      t === Ft ? a : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a === 0 ? null : (xg(t, a, e), Ig(t, ie()), t.callbackNode != null && t.callbackNode === n ? Fg.bind(null, t) : null);
  }
  function kg(t, e) {
    if (yc()) return null;
    xg(t, e, !0);
  }
  function av() {
    gv(function() {
      (Ut & 6) !== 0 ? Zl(
        Wl,
        nv
      ) : Gg();
    });
  }
  function _s() {
    if (Za === 0) {
      var t = pi;
      t === 0 && (t = gl, gl <<= 1, (gl & 261888) === 0 && (gl = 256)), Za = t;
    }
    return Za;
  }
  function qg(t) {
    return t == null || typeof t == "symbol" || typeof t == "boolean" ? null : typeof t == "function" ? t : Ma("" + t);
  }
  function Kg(t, e) {
    var n = e.ownerDocument.createElement("input");
    return n.name = e.name, n.value = e.value, t.id && n.setAttribute("form", t.id), e.parentNode.insertBefore(n, e), t = new FormData(t), n.parentNode.removeChild(n), t;
  }
  function lv(t, e, n, a, i) {
    if (e === "submit" && n && n.stateNode === i) {
      var r = qg(
        (i[oe] || null).action
      ), f = a.submitter;
      f && (e = (e = f[oe] || null) ? qg(e.formAction) : f.getAttribute("formAction"), e !== null && (r = e, f = null));
      var m = new zr(
        "action",
        "action",
        null,
        a,
        i
      );
      t.push({
        event: m,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (a.defaultPrevented) {
                if (Za !== 0) {
                  var A = f ? Kg(i, f) : new FormData(i);
                  ys(
                    n,
                    {
                      pending: !0,
                      data: A,
                      method: i.method,
                      action: r
                    },
                    null,
                    A
                  );
                }
              } else
                typeof r == "function" && (m.preventDefault(), A = f ? Kg(i, f) : new FormData(i), ys(
                  n,
                  {
                    pending: !0,
                    data: A,
                    method: i.method,
                    action: r
                  },
                  r,
                  A
                ));
            },
            currentTarget: i
          }
        ]
      });
    }
  }
  for (var $s = 0; $s < Uu.length; $s++) {
    var tf = Uu[$s], iv = tf.toLowerCase(), ov = tf[0].toUpperCase() + tf.slice(1);
    Tn(
      iv,
      "on" + ov
    );
  }
  Tn(Tm, "onAnimationEnd"), Tn(xm, "onAnimationIteration"), Tn(Cm, "onAnimationStart"), Tn("dblclick", "onDoubleClick"), Tn("focusin", "onFocus"), Tn("focusout", "onBlur"), Tn(Oy, "onTransitionRun"), Tn(Ey, "onTransitionStart"), Tn(Ty, "onTransitionCancel"), Tn(Nm, "onTransitionEnd"), $n("onMouseEnter", ["mouseout", "mouseover"]), $n("onMouseLeave", ["mouseout", "mouseover"]), $n("onPointerEnter", ["pointerout", "pointerover"]), $n("onPointerLeave", ["pointerout", "pointerover"]), Un(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Un(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Un("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Un(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Un(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Un(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Go = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), rv = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Go)
  );
  function Zg(t, e) {
    e = (e & 4) !== 0;
    for (var n = 0; n < t.length; n++) {
      var a = t[n], i = a.event;
      a = a.listeners;
      t: {
        var r = void 0;
        if (e)
          for (var f = a.length - 1; 0 <= f; f--) {
            var m = a[f], A = m.instance, C = m.currentTarget;
            if (m = m.listener, A !== r && i.isPropagationStopped())
              break t;
            r = m, i.currentTarget = C;
            try {
              r(i);
            } catch (L) {
              Ur(L);
            }
            i.currentTarget = null, r = A;
          }
        else
          for (f = 0; f < a.length; f++) {
            if (m = a[f], A = m.instance, C = m.currentTarget, m = m.listener, A !== r && i.isPropagationStopped())
              break t;
            r = m, i.currentTarget = C;
            try {
              r(i);
            } catch (L) {
              Ur(L);
            }
            i.currentTarget = null, r = A;
          }
      }
    }
  }
  function bt(t, e) {
    var n = e[ti];
    n === void 0 && (n = e[ti] = /* @__PURE__ */ new Set());
    var a = t + "__bubble";
    n.has(a) || (Pg(e, t, 2, !1), n.add(a));
  }
  function ef(t, e, n) {
    var a = 0;
    e && (a |= 4), Pg(
      n,
      t,
      a,
      e
    );
  }
  var Sc = "_reactListening" + Math.random().toString(36).slice(2);
  function nf(t) {
    if (!t[Sc]) {
      t[Sc] = !0, Cr.forEach(function(n) {
        n !== "selectionchange" && (rv.has(n) || ef(n, !1, t), ef(n, !0, t));
      });
      var e = t.nodeType === 9 ? t : t.ownerDocument;
      e === null || e[Sc] || (e[Sc] = !0, ef("selectionchange", !1, e));
    }
  }
  function Pg(t, e, n, a) {
    switch (Tp(e)) {
      case 2:
        var i = Uv;
        break;
      case 8:
        i = Hv;
        break;
      default:
        i = yf;
    }
    n = i.bind(
      null,
      e,
      n,
      t
    ), i = void 0, !Ou || e !== "touchstart" && e !== "touchmove" && e !== "wheel" || (i = !0), a ? i !== void 0 ? t.addEventListener(e, n, {
      capture: !0,
      passive: i
    }) : t.addEventListener(e, n, !0) : i !== void 0 ? t.addEventListener(e, n, {
      passive: i
    }) : t.addEventListener(e, n, !1);
  }
  function af(t, e, n, a, i) {
    var r = a;
    if ((e & 1) === 0 && (e & 2) === 0 && a !== null)
      t: for (; ; ) {
        if (a === null) return;
        var f = a.tag;
        if (f === 3 || f === 4) {
          var m = a.stateNode.containerInfo;
          if (m === i) break;
          if (f === 4)
            for (f = a.return; f !== null; ) {
              var A = f.tag;
              if ((A === 3 || A === 4) && f.stateNode.containerInfo === i)
                return;
              f = f.return;
            }
          for (; m !== null; ) {
            if (f = Na(m), f === null) return;
            if (A = f.tag, A === 5 || A === 6 || A === 26 || A === 27) {
              a = r = f;
              continue t;
            }
            m = m.parentNode;
          }
        }
        a = a.return;
      }
    tm(function() {
      var C = r, L = bu(n), U = [];
      t: {
        var D = wm.get(t);
        if (D !== void 0) {
          var z = zr, _ = t;
          switch (t) {
            case "keypress":
              if (Br(n) === 0) break t;
            case "keydown":
            case "keyup":
              z = ty;
              break;
            case "focusin":
              _ = "focus", z = Cu;
              break;
            case "focusout":
              _ = "blur", z = Cu;
              break;
            case "beforeblur":
            case "afterblur":
              z = Cu;
              break;
            case "click":
              if (n.button === 2) break t;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              z = am;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              z = G1;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              z = ay;
              break;
            case Tm:
            case xm:
            case Cm:
              z = k1;
              break;
            case Nm:
              z = iy;
              break;
            case "scroll":
            case "scrollend":
              z = V1;
              break;
            case "wheel":
              z = ry;
              break;
            case "copy":
            case "cut":
            case "paste":
              z = K1;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              z = im;
              break;
            case "toggle":
            case "beforetoggle":
              z = uy;
          }
          var ot = (e & 4) !== 0, It = !ot && (t === "scroll" || t === "scrollend"), S = ot ? D !== null ? D + "Capture" : null : D;
          ot = [];
          for (var v = C, T; v !== null; ) {
            var R = v;
            if (T = R.stateNode, R = R.tag, R !== 5 && R !== 26 && R !== 27 || T === null || S === null || (R = uo(v, S), R != null && ot.push(
              Io(v, R, T)
            )), It) break;
            v = v.return;
          }
          0 < ot.length && (D = new z(
            D,
            _,
            null,
            n,
            L
          ), U.push({ event: D, listeners: ot }));
        }
      }
      if ((e & 7) === 0) {
        t: {
          if (D = t === "mouseover" || t === "pointerover", z = t === "mouseout" || t === "pointerout", D && n !== vu && (_ = n.relatedTarget || n.fromElement) && (Na(_) || _[Ca]))
            break t;
          if ((z || D) && (D = L.window === L ? L : (D = L.ownerDocument) ? D.defaultView || D.parentWindow : window, z ? (_ = n.relatedTarget || n.toElement, z = C, _ = _ ? Na(_) : null, _ !== null && (It = h(_), ot = _.tag, _ !== It || ot !== 5 && ot !== 27 && ot !== 6) && (_ = null)) : (z = null, _ = C), z !== _)) {
            if (ot = am, R = "onMouseLeave", S = "onMouseEnter", v = "mouse", (t === "pointerout" || t === "pointerover") && (ot = im, R = "onPointerLeave", S = "onPointerEnter", v = "pointer"), It = z == null ? D : je(z), T = _ == null ? D : je(_), D = new ot(
              R,
              v + "leave",
              z,
              n,
              L
            ), D.target = It, D.relatedTarget = T, R = null, Na(L) === C && (ot = new ot(
              S,
              v + "enter",
              _,
              n,
              L
            ), ot.target = T, ot.relatedTarget = It, R = ot), It = R, z && _)
              e: {
                for (ot = cv, S = z, v = _, T = 0, R = S; R; R = ot(R))
                  T++;
                R = 0;
                for (var it = v; it; it = ot(it))
                  R++;
                for (; 0 < T - R; )
                  S = ot(S), T--;
                for (; 0 < R - T; )
                  v = ot(v), R--;
                for (; T--; ) {
                  if (S === v || v !== null && S === v.alternate) {
                    ot = S;
                    break e;
                  }
                  S = ot(S), v = ot(v);
                }
                ot = null;
              }
            else ot = null;
            z !== null && Wg(
              U,
              D,
              z,
              ot,
              !1
            ), _ !== null && It !== null && Wg(
              U,
              It,
              _,
              ot,
              !0
            );
          }
        }
        t: {
          if (D = C ? je(C) : window, z = D.nodeName && D.nodeName.toLowerCase(), z === "select" || z === "input" && D.type === "file")
            var Lt = mm;
          else if (fm(D))
            if (hm)
              Lt = vy;
            else {
              Lt = Ay;
              var tt = py;
            }
          else
            z = D.nodeName, !z || z.toLowerCase() !== "input" || D.type !== "checkbox" && D.type !== "radio" ? C && $t(C.elementType) && (Lt = mm) : Lt = yy;
          if (Lt && (Lt = Lt(t, C))) {
            dm(
              U,
              Lt,
              n,
              L
            );
            break t;
          }
          tt && tt(t, D, C), t === "focusout" && C && D.type === "number" && C.memoizedProps.value != null && F(D, "number", D.value);
        }
        switch (tt = C ? je(C) : window, t) {
          case "focusin":
            (fm(tt) || tt.contentEditable === "true") && (ci = tt, zu = C, yo = null);
            break;
          case "focusout":
            yo = zu = ci = null;
            break;
          case "mousedown":
            Lu = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Lu = !1, Om(U, n, L);
            break;
          case "selectionchange":
            if (Sy) break;
          case "keydown":
          case "keyup":
            Om(U, n, L);
        }
        var ht;
        if (wu)
          t: {
            switch (t) {
              case "compositionstart":
                var Et = "onCompositionStart";
                break t;
              case "compositionend":
                Et = "onCompositionEnd";
                break t;
              case "compositionupdate":
                Et = "onCompositionUpdate";
                break t;
            }
            Et = void 0;
          }
        else
          ri ? um(t, n) && (Et = "onCompositionEnd") : t === "keydown" && n.keyCode === 229 && (Et = "onCompositionStart");
        Et && (om && n.locale !== "ko" && (ri || Et !== "onCompositionStart" ? Et === "onCompositionEnd" && ri && (ht = em()) : (za = L, Eu = "value" in za ? za.value : za.textContent, ri = !0)), tt = Oc(C, Et), 0 < tt.length && (Et = new lm(
          Et,
          t,
          null,
          n,
          L
        ), U.push({ event: Et, listeners: tt }), ht ? Et.data = ht : (ht = sm(n), ht !== null && (Et.data = ht)))), (ht = fy ? dy(t, n) : my(t, n)) && (Et = Oc(C, "onBeforeInput"), 0 < Et.length && (tt = new lm(
          "onBeforeInput",
          "beforeinput",
          null,
          n,
          L
        ), U.push({
          event: tt,
          listeners: Et
        }), tt.data = ht)), lv(
          U,
          t,
          C,
          n,
          L
        );
      }
      Zg(U, e);
    });
  }
  function Io(t, e, n) {
    return {
      instance: t,
      listener: e,
      currentTarget: n
    };
  }
  function Oc(t, e) {
    for (var n = e + "Capture", a = []; t !== null; ) {
      var i = t, r = i.stateNode;
      if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || r === null || (i = uo(t, n), i != null && a.unshift(
        Io(t, i, r)
      ), i = uo(t, e), i != null && a.push(
        Io(t, i, r)
      )), t.tag === 3) return a;
      t = t.return;
    }
    return [];
  }
  function cv(t) {
    if (t === null) return null;
    do
      t = t.return;
    while (t && t.tag !== 5 && t.tag !== 27);
    return t || null;
  }
  function Wg(t, e, n, a, i) {
    for (var r = e._reactName, f = []; n !== null && n !== a; ) {
      var m = n, A = m.alternate, C = m.stateNode;
      if (m = m.tag, A !== null && A === a) break;
      m !== 5 && m !== 26 && m !== 27 || C === null || (A = C, i ? (C = uo(n, r), C != null && f.unshift(
        Io(n, C, A)
      )) : i || (C = uo(n, r), C != null && f.push(
        Io(n, C, A)
      ))), n = n.return;
    }
    f.length !== 0 && t.push({ event: e, listeners: f });
  }
  var uv = /\r\n?/g, sv = /\u0000|\uFFFD/g;
  function Jg(t) {
    return (typeof t == "string" ? t : "" + t).replace(uv, `
`).replace(sv, "");
  }
  function _g(t, e) {
    return e = Jg(e), Jg(t) === e;
  }
  function Gt(t, e, n, a, i, r) {
    switch (n) {
      case "children":
        typeof a == "string" ? e === "body" || e === "textarea" && a === "" || J(t, a) : (typeof a == "number" || typeof a == "bigint") && e !== "body" && J(t, "" + a);
        break;
      case "className":
        Xe(t, "class", a);
        break;
      case "tabIndex":
        Xe(t, "tabindex", a);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Xe(t, n, a);
        break;
      case "style":
        re(t, a, r);
        break;
      case "data":
        if (e !== "object") {
          Xe(t, "data", a);
          break;
        }
      case "src":
      case "href":
        if (a === "" && (e !== "a" || n !== "href")) {
          t.removeAttribute(n);
          break;
        }
        if (a == null || typeof a == "function" || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(n);
          break;
        }
        a = Ma("" + a), t.setAttribute(n, a);
        break;
      case "action":
      case "formAction":
        if (typeof a == "function") {
          t.setAttribute(
            n,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof r == "function" && (n === "formAction" ? (e !== "input" && Gt(t, e, "name", i.name, i, null), Gt(
            t,
            e,
            "formEncType",
            i.formEncType,
            i,
            null
          ), Gt(
            t,
            e,
            "formMethod",
            i.formMethod,
            i,
            null
          ), Gt(
            t,
            e,
            "formTarget",
            i.formTarget,
            i,
            null
          )) : (Gt(t, e, "encType", i.encType, i, null), Gt(t, e, "method", i.method, i, null), Gt(t, e, "target", i.target, i, null)));
        if (a == null || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(n);
          break;
        }
        a = Ma("" + a), t.setAttribute(n, a);
        break;
      case "onClick":
        a != null && (t.onclick = Zt);
        break;
      case "onScroll":
        a != null && bt("scroll", t);
        break;
      case "onScrollEnd":
        a != null && bt("scrollend", t);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(u(61));
          if (n = a.__html, n != null) {
            if (i.children != null) throw Error(u(60));
            t.innerHTML = n;
          }
        }
        break;
      case "multiple":
        t.multiple = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "muted":
        t.muted = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (a == null || typeof a == "function" || typeof a == "boolean" || typeof a == "symbol") {
          t.removeAttribute("xlink:href");
          break;
        }
        n = Ma("" + a), t.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          n
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, "" + a) : t.removeAttribute(n);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        a && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, "") : t.removeAttribute(n);
        break;
      case "capture":
      case "download":
        a === !0 ? t.setAttribute(n, "") : a !== !1 && a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, a) : t.removeAttribute(n);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        a != null && typeof a != "function" && typeof a != "symbol" && !isNaN(a) && 1 <= a ? t.setAttribute(n, a) : t.removeAttribute(n);
        break;
      case "rowSpan":
      case "start":
        a == null || typeof a == "function" || typeof a == "symbol" || isNaN(a) ? t.removeAttribute(n) : t.setAttribute(n, a);
        break;
      case "popover":
        bt("beforetoggle", t), bt("toggle", t), Hn(t, "popover", a);
        break;
      case "xlinkActuate":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          a
        );
        break;
      case "xlinkArcrole":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          a
        );
        break;
      case "xlinkRole":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          a
        );
        break;
      case "xlinkShow":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          a
        );
        break;
      case "xlinkTitle":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          a
        );
        break;
      case "xlinkType":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          a
        );
        break;
      case "xmlBase":
        En(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          a
        );
        break;
      case "xmlLang":
        En(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          a
        );
        break;
      case "xmlSpace":
        En(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          a
        );
        break;
      case "is":
        Hn(t, "is", a);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = Ve.get(n) || n, Hn(t, n, a));
    }
  }
  function lf(t, e, n, a, i, r) {
    switch (n) {
      case "style":
        re(t, a, r);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(u(61));
          if (n = a.__html, n != null) {
            if (i.children != null) throw Error(u(60));
            t.innerHTML = n;
          }
        }
        break;
      case "children":
        typeof a == "string" ? J(t, a) : (typeof a == "number" || typeof a == "bigint") && J(t, "" + a);
        break;
      case "onScroll":
        a != null && bt("scroll", t);
        break;
      case "onScrollEnd":
        a != null && bt("scrollend", t);
        break;
      case "onClick":
        a != null && (t.onclick = Zt);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!Nr.hasOwnProperty(n))
          t: {
            if (n[0] === "o" && n[1] === "n" && (i = n.endsWith("Capture"), e = n.slice(2, i ? n.length - 7 : void 0), r = t[oe] || null, r = r != null ? r[n] : null, typeof r == "function" && t.removeEventListener(e, r, i), typeof a == "function")) {
              typeof r != "function" && r !== null && (n in t ? t[n] = null : t.hasAttribute(n) && t.removeAttribute(n)), t.addEventListener(e, a, i);
              break t;
            }
            n in t ? t[n] = a : a === !0 ? t.setAttribute(n, "") : Hn(t, n, a);
          }
    }
  }
  function Ce(t, e, n) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        bt("error", t), bt("load", t);
        var a = !1, i = !1, r;
        for (r in n)
          if (n.hasOwnProperty(r)) {
            var f = n[r];
            if (f != null)
              switch (r) {
                case "src":
                  a = !0;
                  break;
                case "srcSet":
                  i = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(u(137, e));
                default:
                  Gt(t, e, r, f, n, null);
              }
          }
        i && Gt(t, e, "srcSet", n.srcSet, n, null), a && Gt(t, e, "src", n.src, n, null);
        return;
      case "input":
        bt("invalid", t);
        var m = r = f = i = null, A = null, C = null;
        for (a in n)
          if (n.hasOwnProperty(a)) {
            var L = n[a];
            if (L != null)
              switch (a) {
                case "name":
                  i = L;
                  break;
                case "type":
                  f = L;
                  break;
                case "checked":
                  A = L;
                  break;
                case "defaultChecked":
                  C = L;
                  break;
                case "value":
                  r = L;
                  break;
                case "defaultValue":
                  m = L;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (L != null)
                    throw Error(u(137, e));
                  break;
                default:
                  Gt(t, e, a, L, n, null);
              }
          }
        li(
          t,
          r,
          m,
          A,
          C,
          f,
          i,
          !1
        );
        return;
      case "select":
        bt("invalid", t), a = f = r = null;
        for (i in n)
          if (n.hasOwnProperty(i) && (m = n[i], m != null))
            switch (i) {
              case "value":
                r = m;
                break;
              case "defaultValue":
                f = m;
                break;
              case "multiple":
                a = m;
              default:
                Gt(t, e, i, m, n, null);
            }
        e = r, n = f, t.multiple = !!a, e != null ? g(t, !!a, e, !1) : n != null && g(t, !!a, n, !0);
        return;
      case "textarea":
        bt("invalid", t), r = i = a = null;
        for (f in n)
          if (n.hasOwnProperty(f) && (m = n[f], m != null))
            switch (f) {
              case "value":
                a = m;
                break;
              case "defaultValue":
                i = m;
                break;
              case "children":
                r = m;
                break;
              case "dangerouslySetInnerHTML":
                if (m != null) throw Error(u(91));
                break;
              default:
                Gt(t, e, f, m, n, null);
            }
        k(t, a, i, r);
        return;
      case "option":
        for (A in n)
          if (n.hasOwnProperty(A) && (a = n[A], a != null))
            switch (A) {
              case "selected":
                t.selected = a && typeof a != "function" && typeof a != "symbol";
                break;
              default:
                Gt(t, e, A, a, n, null);
            }
        return;
      case "dialog":
        bt("beforetoggle", t), bt("toggle", t), bt("cancel", t), bt("close", t);
        break;
      case "iframe":
      case "object":
        bt("load", t);
        break;
      case "video":
      case "audio":
        for (a = 0; a < Go.length; a++)
          bt(Go[a], t);
        break;
      case "image":
        bt("error", t), bt("load", t);
        break;
      case "details":
        bt("toggle", t);
        break;
      case "embed":
      case "source":
      case "link":
        bt("error", t), bt("load", t);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (C in n)
          if (n.hasOwnProperty(C) && (a = n[C], a != null))
            switch (C) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(u(137, e));
              default:
                Gt(t, e, C, a, n, null);
            }
        return;
      default:
        if ($t(e)) {
          for (L in n)
            n.hasOwnProperty(L) && (a = n[L], a !== void 0 && lf(
              t,
              e,
              L,
              a,
              n,
              void 0
            ));
          return;
        }
    }
    for (m in n)
      n.hasOwnProperty(m) && (a = n[m], a != null && Gt(t, e, m, a, n, null));
  }
  function fv(t, e, n, a) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var i = null, r = null, f = null, m = null, A = null, C = null, L = null;
        for (z in n) {
          var U = n[z];
          if (n.hasOwnProperty(z) && U != null)
            switch (z) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                A = U;
              default:
                a.hasOwnProperty(z) || Gt(t, e, z, null, a, U);
            }
        }
        for (var D in a) {
          var z = a[D];
          if (U = n[D], a.hasOwnProperty(D) && (z != null || U != null))
            switch (D) {
              case "type":
                r = z;
                break;
              case "name":
                i = z;
                break;
              case "checked":
                C = z;
                break;
              case "defaultChecked":
                L = z;
                break;
              case "value":
                f = z;
                break;
              case "defaultValue":
                m = z;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (z != null)
                  throw Error(u(137, e));
                break;
              default:
                z !== U && Gt(
                  t,
                  e,
                  D,
                  z,
                  a,
                  U
                );
            }
        }
        Ba(
          t,
          f,
          m,
          A,
          C,
          L,
          r,
          i
        );
        return;
      case "select":
        z = f = m = D = null;
        for (r in n)
          if (A = n[r], n.hasOwnProperty(r) && A != null)
            switch (r) {
              case "value":
                break;
              case "multiple":
                z = A;
              default:
                a.hasOwnProperty(r) || Gt(
                  t,
                  e,
                  r,
                  null,
                  a,
                  A
                );
            }
        for (i in a)
          if (r = a[i], A = n[i], a.hasOwnProperty(i) && (r != null || A != null))
            switch (i) {
              case "value":
                D = r;
                break;
              case "defaultValue":
                m = r;
                break;
              case "multiple":
                f = r;
              default:
                r !== A && Gt(
                  t,
                  e,
                  i,
                  r,
                  a,
                  A
                );
            }
        e = m, n = f, a = z, D != null ? g(t, !!n, D, !1) : !!a != !!n && (e != null ? g(t, !!n, e, !0) : g(t, !!n, n ? [] : "", !1));
        return;
      case "textarea":
        z = D = null;
        for (m in n)
          if (i = n[m], n.hasOwnProperty(m) && i != null && !a.hasOwnProperty(m))
            switch (m) {
              case "value":
                break;
              case "children":
                break;
              default:
                Gt(t, e, m, null, a, i);
            }
        for (f in a)
          if (i = a[f], r = n[f], a.hasOwnProperty(f) && (i != null || r != null))
            switch (f) {
              case "value":
                D = i;
                break;
              case "defaultValue":
                z = i;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (i != null) throw Error(u(91));
                break;
              default:
                i !== r && Gt(t, e, f, i, a, r);
            }
        N(t, D, z);
        return;
      case "option":
        for (var _ in n)
          if (D = n[_], n.hasOwnProperty(_) && D != null && !a.hasOwnProperty(_))
            switch (_) {
              case "selected":
                t.selected = !1;
                break;
              default:
                Gt(
                  t,
                  e,
                  _,
                  null,
                  a,
                  D
                );
            }
        for (A in a)
          if (D = a[A], z = n[A], a.hasOwnProperty(A) && D !== z && (D != null || z != null))
            switch (A) {
              case "selected":
                t.selected = D && typeof D != "function" && typeof D != "symbol";
                break;
              default:
                Gt(
                  t,
                  e,
                  A,
                  D,
                  a,
                  z
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var ot in n)
          D = n[ot], n.hasOwnProperty(ot) && D != null && !a.hasOwnProperty(ot) && Gt(t, e, ot, null, a, D);
        for (C in a)
          if (D = a[C], z = n[C], a.hasOwnProperty(C) && D !== z && (D != null || z != null))
            switch (C) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (D != null)
                  throw Error(u(137, e));
                break;
              default:
                Gt(
                  t,
                  e,
                  C,
                  D,
                  a,
                  z
                );
            }
        return;
      default:
        if ($t(e)) {
          for (var It in n)
            D = n[It], n.hasOwnProperty(It) && D !== void 0 && !a.hasOwnProperty(It) && lf(
              t,
              e,
              It,
              void 0,
              a,
              D
            );
          for (L in a)
            D = a[L], z = n[L], !a.hasOwnProperty(L) || D === z || D === void 0 && z === void 0 || lf(
              t,
              e,
              L,
              D,
              a,
              z
            );
          return;
        }
    }
    for (var S in n)
      D = n[S], n.hasOwnProperty(S) && D != null && !a.hasOwnProperty(S) && Gt(t, e, S, null, a, D);
    for (U in a)
      D = a[U], z = n[U], !a.hasOwnProperty(U) || D === z || D == null && z == null || Gt(t, e, U, D, a, z);
  }
  function $g(t) {
    switch (t) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function dv() {
    if (typeof performance.getEntriesByType == "function") {
      for (var t = 0, e = 0, n = performance.getEntriesByType("resource"), a = 0; a < n.length; a++) {
        var i = n[a], r = i.transferSize, f = i.initiatorType, m = i.duration;
        if (r && m && $g(f)) {
          for (f = 0, m = i.responseEnd, a += 1; a < n.length; a++) {
            var A = n[a], C = A.startTime;
            if (C > m) break;
            var L = A.transferSize, U = A.initiatorType;
            L && $g(U) && (A = A.responseEnd, f += L * (A < m ? 1 : (m - C) / (A - C)));
          }
          if (--a, e += 8 * (r + f) / (i.duration / 1e3), t++, 10 < t) break;
        }
      }
      if (0 < t) return e / t / 1e6;
    }
    return navigator.connection && (t = navigator.connection.downlink, typeof t == "number") ? t : 5;
  }
  var of = null, rf = null;
  function Ec(t) {
    return t.nodeType === 9 ? t : t.ownerDocument;
  }
  function tp(t) {
    switch (t) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function ep(t, e) {
    if (t === 0)
      switch (e) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return t === 1 && e === "foreignObject" ? 0 : t;
  }
  function cf(t, e) {
    return t === "textarea" || t === "noscript" || typeof e.children == "string" || typeof e.children == "number" || typeof e.children == "bigint" || typeof e.dangerouslySetInnerHTML == "object" && e.dangerouslySetInnerHTML !== null && e.dangerouslySetInnerHTML.__html != null;
  }
  var uf = null;
  function mv() {
    var t = window.event;
    return t && t.type === "popstate" ? t === uf ? !1 : (uf = t, !0) : (uf = null, !1);
  }
  var np = typeof setTimeout == "function" ? setTimeout : void 0, hv = typeof clearTimeout == "function" ? clearTimeout : void 0, ap = typeof Promise == "function" ? Promise : void 0, gv = typeof queueMicrotask == "function" ? queueMicrotask : typeof ap < "u" ? function(t) {
    return ap.resolve(null).then(t).catch(pv);
  } : np;
  function pv(t) {
    setTimeout(function() {
      throw t;
    });
  }
  function Pa(t) {
    return t === "head";
  }
  function lp(t, e) {
    var n = e, a = 0;
    do {
      var i = n.nextSibling;
      if (t.removeChild(n), i && i.nodeType === 8)
        if (n = i.data, n === "/$" || n === "/&") {
          if (a === 0) {
            t.removeChild(i), Ui(e);
            return;
          }
          a--;
        } else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&")
          a++;
        else if (n === "html")
          Fo(t.ownerDocument.documentElement);
        else if (n === "head") {
          n = t.ownerDocument.head, Fo(n);
          for (var r = n.firstChild; r; ) {
            var f = r.nextSibling, m = r.nodeName;
            r[vl] || m === "SCRIPT" || m === "STYLE" || m === "LINK" && r.rel.toLowerCase() === "stylesheet" || n.removeChild(r), r = f;
          }
        } else
          n === "body" && Fo(t.ownerDocument.body);
      n = i;
    } while (n);
    Ui(e);
  }
  function ip(t, e) {
    var n = t;
    t = 0;
    do {
      var a = n.nextSibling;
      if (n.nodeType === 1 ? e ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (e ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), a && a.nodeType === 8)
        if (n = a.data, n === "/$") {
          if (t === 0) break;
          t--;
        } else
          n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || t++;
      n = a;
    } while (n);
  }
  function sf(t) {
    var e = t.firstChild;
    for (e && e.nodeType === 10 && (e = e.nextSibling); e; ) {
      var n = e;
      switch (e = e.nextSibling, n.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          sf(n), io(n);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n.rel.toLowerCase() === "stylesheet") continue;
      }
      t.removeChild(n);
    }
  }
  function Av(t, e, n, a) {
    for (; t.nodeType === 1; ) {
      var i = n;
      if (t.nodeName.toLowerCase() !== e.toLowerCase()) {
        if (!a && (t.nodeName !== "INPUT" || t.type !== "hidden"))
          break;
      } else if (a) {
        if (!t[vl])
          switch (e) {
            case "meta":
              if (!t.hasAttribute("itemprop")) break;
              return t;
            case "link":
              if (r = t.getAttribute("rel"), r === "stylesheet" && t.hasAttribute("data-precedence"))
                break;
              if (r !== i.rel || t.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || t.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || t.getAttribute("title") !== (i.title == null ? null : i.title))
                break;
              return t;
            case "style":
              if (t.hasAttribute("data-precedence")) break;
              return t;
            case "script":
              if (r = t.getAttribute("src"), (r !== (i.src == null ? null : i.src) || t.getAttribute("type") !== (i.type == null ? null : i.type) || t.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && r && t.hasAttribute("async") && !t.hasAttribute("itemprop"))
                break;
              return t;
            default:
              return t;
          }
      } else if (e === "input" && t.type === "hidden") {
        var r = i.name == null ? null : "" + i.name;
        if (i.type === "hidden" && t.getAttribute("name") === r)
          return t;
      } else return t;
      if (t = An(t.nextSibling), t === null) break;
    }
    return null;
  }
  function yv(t, e, n) {
    if (e === "") return null;
    for (; t.nodeType !== 3; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !n || (t = An(t.nextSibling), t === null)) return null;
    return t;
  }
  function op(t, e) {
    for (; t.nodeType !== 8; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !e || (t = An(t.nextSibling), t === null)) return null;
    return t;
  }
  function ff(t) {
    return t.data === "$?" || t.data === "$~";
  }
  function df(t) {
    return t.data === "$!" || t.data === "$?" && t.ownerDocument.readyState !== "loading";
  }
  function vv(t, e) {
    var n = t.ownerDocument;
    if (t.data === "$~") t._reactRetry = e;
    else if (t.data !== "$?" || n.readyState !== "loading")
      e();
    else {
      var a = function() {
        e(), n.removeEventListener("DOMContentLoaded", a);
      };
      n.addEventListener("DOMContentLoaded", a), t._reactRetry = a;
    }
  }
  function An(t) {
    for (; t != null; t = t.nextSibling) {
      var e = t.nodeType;
      if (e === 1 || e === 3) break;
      if (e === 8) {
        if (e = t.data, e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&" || e === "F!" || e === "F")
          break;
        if (e === "/$" || e === "/&") return null;
      }
    }
    return t;
  }
  var mf = null;
  function rp(t) {
    t = t.nextSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "/$" || n === "/&") {
          if (e === 0)
            return An(t.nextSibling);
          e--;
        } else
          n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || e++;
      }
      t = t.nextSibling;
    }
    return null;
  }
  function cp(t) {
    t = t.previousSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
          if (e === 0) return t;
          e--;
        } else n !== "/$" && n !== "/&" || e++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function up(t, e, n) {
    switch (e = Ec(n), t) {
      case "html":
        if (t = e.documentElement, !t) throw Error(u(452));
        return t;
      case "head":
        if (t = e.head, !t) throw Error(u(453));
        return t;
      case "body":
        if (t = e.body, !t) throw Error(u(454));
        return t;
      default:
        throw Error(u(451));
    }
  }
  function Fo(t) {
    for (var e = t.attributes; e.length; )
      t.removeAttributeNode(e[0]);
    io(t);
  }
  var yn = /* @__PURE__ */ new Map(), sp = /* @__PURE__ */ new Set();
  function Tc(t) {
    return typeof t.getRootNode == "function" ? t.getRootNode() : t.nodeType === 9 ? t : t.ownerDocument;
  }
  var ga = Z.d;
  Z.d = {
    f: bv,
    r: Sv,
    D: Ov,
    C: Ev,
    L: Tv,
    m: xv,
    X: Nv,
    S: Cv,
    M: wv
  };
  function bv() {
    var t = ga.f(), e = gc();
    return t || e;
  }
  function Sv(t) {
    var e = wa(t);
    e !== null && e.tag === 5 && e.type === "form" ? Nh(e) : ga.r(t);
  }
  var zi = typeof document > "u" ? null : document;
  function fp(t, e, n) {
    var a = zi;
    if (a && typeof e == "string" && e) {
      var i = Le(e);
      i = 'link[rel="' + t + '"][href="' + i + '"]', typeof n == "string" && (i += '[crossorigin="' + n + '"]'), sp.has(i) || (sp.add(i), t = { rel: t, crossOrigin: n, href: e }, a.querySelector(i) === null && (e = a.createElement("link"), Ce(e, "link", t), Kt(e), a.head.appendChild(e)));
    }
  }
  function Ov(t) {
    ga.D(t), fp("dns-prefetch", t, null);
  }
  function Ev(t, e) {
    ga.C(t, e), fp("preconnect", t, e);
  }
  function Tv(t, e, n) {
    ga.L(t, e, n);
    var a = zi;
    if (a && t && e) {
      var i = 'link[rel="preload"][as="' + Le(e) + '"]';
      e === "image" && n && n.imageSrcSet ? (i += '[imagesrcset="' + Le(
        n.imageSrcSet
      ) + '"]', typeof n.imageSizes == "string" && (i += '[imagesizes="' + Le(
        n.imageSizes
      ) + '"]')) : i += '[href="' + Le(t) + '"]';
      var r = i;
      switch (e) {
        case "style":
          r = Li(t);
          break;
        case "script":
          r = Ri(t);
      }
      yn.has(r) || (t = x(
        {
          rel: "preload",
          href: e === "image" && n && n.imageSrcSet ? void 0 : t,
          as: e
        },
        n
      ), yn.set(r, t), a.querySelector(i) !== null || e === "style" && a.querySelector(ko(r)) || e === "script" && a.querySelector(qo(r)) || (e = a.createElement("link"), Ce(e, "link", t), Kt(e), a.head.appendChild(e)));
    }
  }
  function xv(t, e) {
    ga.m(t, e);
    var n = zi;
    if (n && t) {
      var a = e && typeof e.as == "string" ? e.as : "script", i = 'link[rel="modulepreload"][as="' + Le(a) + '"][href="' + Le(t) + '"]', r = i;
      switch (a) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          r = Ri(t);
      }
      if (!yn.has(r) && (t = x({ rel: "modulepreload", href: t }, e), yn.set(r, t), n.querySelector(i) === null)) {
        switch (a) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n.querySelector(qo(r)))
              return;
        }
        a = n.createElement("link"), Ce(a, "link", t), Kt(a), n.head.appendChild(a);
      }
    }
  }
  function Cv(t, e, n) {
    ga.S(t, e, n);
    var a = zi;
    if (a && t) {
      var i = _n(a).hoistableStyles, r = Li(t);
      e = e || "default";
      var f = i.get(r);
      if (!f) {
        var m = { loading: 0, preload: null };
        if (f = a.querySelector(
          ko(r)
        ))
          m.loading = 5;
        else {
          t = x(
            { rel: "stylesheet", href: t, "data-precedence": e },
            n
          ), (n = yn.get(r)) && hf(t, n);
          var A = f = a.createElement("link");
          Kt(A), Ce(A, "link", t), A._p = new Promise(function(C, L) {
            A.onload = C, A.onerror = L;
          }), A.addEventListener("load", function() {
            m.loading |= 1;
          }), A.addEventListener("error", function() {
            m.loading |= 2;
          }), m.loading |= 4, xc(f, e, a);
        }
        f = {
          type: "stylesheet",
          instance: f,
          count: 1,
          state: m
        }, i.set(r, f);
      }
    }
  }
  function Nv(t, e) {
    ga.X(t, e);
    var n = zi;
    if (n && t) {
      var a = _n(n).hoistableScripts, i = Ri(t), r = a.get(i);
      r || (r = n.querySelector(qo(i)), r || (t = x({ src: t, async: !0 }, e), (e = yn.get(i)) && gf(t, e), r = n.createElement("script"), Kt(r), Ce(r, "link", t), n.head.appendChild(r)), r = {
        type: "script",
        instance: r,
        count: 1,
        state: null
      }, a.set(i, r));
    }
  }
  function wv(t, e) {
    ga.M(t, e);
    var n = zi;
    if (n && t) {
      var a = _n(n).hoistableScripts, i = Ri(t), r = a.get(i);
      r || (r = n.querySelector(qo(i)), r || (t = x({ src: t, async: !0, type: "module" }, e), (e = yn.get(i)) && gf(t, e), r = n.createElement("script"), Kt(r), Ce(r, "link", t), n.head.appendChild(r)), r = {
        type: "script",
        instance: r,
        count: 1,
        state: null
      }, a.set(i, r));
    }
  }
  function dp(t, e, n, a) {
    var i = (i = ye.current) ? Tc(i) : null;
    if (!i) throw Error(u(446));
    switch (t) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n.precedence == "string" && typeof n.href == "string" ? (e = Li(n.href), n = _n(
          i
        ).hoistableStyles, a = n.get(e), a || (a = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, a)), a) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
          t = Li(n.href);
          var r = _n(
            i
          ).hoistableStyles, f = r.get(t);
          if (f || (i = i.ownerDocument || i, f = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, r.set(t, f), (r = i.querySelector(
            ko(t)
          )) && !r._p && (f.instance = r, f.state.loading = 5), yn.has(t) || (n = {
            rel: "preload",
            as: "style",
            href: n.href,
            crossOrigin: n.crossOrigin,
            integrity: n.integrity,
            media: n.media,
            hrefLang: n.hrefLang,
            referrerPolicy: n.referrerPolicy
          }, yn.set(t, n), r || Dv(
            i,
            t,
            n,
            f.state
          ))), e && a === null)
            throw Error(u(528, ""));
          return f;
        }
        if (e && a !== null)
          throw Error(u(529, ""));
        return null;
      case "script":
        return e = n.async, n = n.src, typeof n == "string" && e && typeof e != "function" && typeof e != "symbol" ? (e = Ri(n), n = _n(
          i
        ).hoistableScripts, a = n.get(e), a || (a = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, a)), a) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(u(444, t));
    }
  }
  function Li(t) {
    return 'href="' + Le(t) + '"';
  }
  function ko(t) {
    return 'link[rel="stylesheet"][' + t + "]";
  }
  function mp(t) {
    return x({}, t, {
      "data-precedence": t.precedence,
      precedence: null
    });
  }
  function Dv(t, e, n, a) {
    t.querySelector('link[rel="preload"][as="style"][' + e + "]") ? a.loading = 1 : (e = t.createElement("link"), a.preload = e, e.addEventListener("load", function() {
      return a.loading |= 1;
    }), e.addEventListener("error", function() {
      return a.loading |= 2;
    }), Ce(e, "link", n), Kt(e), t.head.appendChild(e));
  }
  function Ri(t) {
    return '[src="' + Le(t) + '"]';
  }
  function qo(t) {
    return "script[async]" + t;
  }
  function hp(t, e, n) {
    if (e.count++, e.instance === null)
      switch (e.type) {
        case "style":
          var a = t.querySelector(
            'style[data-href~="' + Le(n.href) + '"]'
          );
          if (a)
            return e.instance = a, Kt(a), a;
          var i = x({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null
          });
          return a = (t.ownerDocument || t).createElement(
            "style"
          ), Kt(a), Ce(a, "style", i), xc(a, n.precedence, t), e.instance = a;
        case "stylesheet":
          i = Li(n.href);
          var r = t.querySelector(
            ko(i)
          );
          if (r)
            return e.state.loading |= 4, e.instance = r, Kt(r), r;
          a = mp(n), (i = yn.get(i)) && hf(a, i), r = (t.ownerDocument || t).createElement("link"), Kt(r);
          var f = r;
          return f._p = new Promise(function(m, A) {
            f.onload = m, f.onerror = A;
          }), Ce(r, "link", a), e.state.loading |= 4, xc(r, n.precedence, t), e.instance = r;
        case "script":
          return r = Ri(n.src), (i = t.querySelector(
            qo(r)
          )) ? (e.instance = i, Kt(i), i) : (a = n, (i = yn.get(r)) && (a = x({}, n), gf(a, i)), t = t.ownerDocument || t, i = t.createElement("script"), Kt(i), Ce(i, "link", a), t.head.appendChild(i), e.instance = i);
        case "void":
          return null;
        default:
          throw Error(u(443, e.type));
      }
    else
      e.type === "stylesheet" && (e.state.loading & 4) === 0 && (a = e.instance, e.state.loading |= 4, xc(a, n.precedence, t));
    return e.instance;
  }
  function xc(t, e, n) {
    for (var a = n.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), i = a.length ? a[a.length - 1] : null, r = i, f = 0; f < a.length; f++) {
      var m = a[f];
      if (m.dataset.precedence === e) r = m;
      else if (r !== i) break;
    }
    r ? r.parentNode.insertBefore(t, r.nextSibling) : (e = n.nodeType === 9 ? n.head : n, e.insertBefore(t, e.firstChild));
  }
  function hf(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.title == null && (t.title = e.title);
  }
  function gf(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.integrity == null && (t.integrity = e.integrity);
  }
  var Cc = null;
  function gp(t, e, n) {
    if (Cc === null) {
      var a = /* @__PURE__ */ new Map(), i = Cc = /* @__PURE__ */ new Map();
      i.set(n, a);
    } else
      i = Cc, a = i.get(n), a || (a = /* @__PURE__ */ new Map(), i.set(n, a));
    if (a.has(t)) return a;
    for (a.set(t, null), n = n.getElementsByTagName(t), i = 0; i < n.length; i++) {
      var r = n[i];
      if (!(r[vl] || r[pt] || t === "link" && r.getAttribute("rel") === "stylesheet") && r.namespaceURI !== "http://www.w3.org/2000/svg") {
        var f = r.getAttribute(e) || "";
        f = t + f;
        var m = a.get(f);
        m ? m.push(r) : a.set(f, [r]);
      }
    }
    return a;
  }
  function pp(t, e, n) {
    t = t.ownerDocument || t, t.head.insertBefore(
      n,
      e === "title" ? t.querySelector("head > title") : null
    );
  }
  function Bv(t, e, n) {
    if (n === 1 || e.itemProp != null) return !1;
    switch (t) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof e.precedence != "string" || typeof e.href != "string" || e.href === "")
          break;
        return !0;
      case "link":
        if (typeof e.rel != "string" || typeof e.href != "string" || e.href === "" || e.onLoad || e.onError)
          break;
        switch (e.rel) {
          case "stylesheet":
            return t = e.disabled, typeof e.precedence == "string" && t == null;
          default:
            return !0;
        }
      case "script":
        if (e.async && typeof e.async != "function" && typeof e.async != "symbol" && !e.onLoad && !e.onError && e.src && typeof e.src == "string")
          return !0;
    }
    return !1;
  }
  function Ap(t) {
    return !(t.type === "stylesheet" && (t.state.loading & 3) === 0);
  }
  function Mv(t, e, n, a) {
    if (n.type === "stylesheet" && (typeof a.media != "string" || matchMedia(a.media).matches !== !1) && (n.state.loading & 4) === 0) {
      if (n.instance === null) {
        var i = Li(a.href), r = e.querySelector(
          ko(i)
        );
        if (r) {
          e = r._p, e !== null && typeof e == "object" && typeof e.then == "function" && (t.count++, t = Nc.bind(t), e.then(t, t)), n.state.loading |= 4, n.instance = r, Kt(r);
          return;
        }
        r = e.ownerDocument || e, a = mp(a), (i = yn.get(i)) && hf(a, i), r = r.createElement("link"), Kt(r);
        var f = r;
        f._p = new Promise(function(m, A) {
          f.onload = m, f.onerror = A;
        }), Ce(r, "link", a), n.instance = r;
      }
      t.stylesheets === null && (t.stylesheets = /* @__PURE__ */ new Map()), t.stylesheets.set(n, e), (e = n.state.preload) && (n.state.loading & 3) === 0 && (t.count++, n = Nc.bind(t), e.addEventListener("load", n), e.addEventListener("error", n));
    }
  }
  var pf = 0;
  function zv(t, e) {
    return t.stylesheets && t.count === 0 && Dc(t, t.stylesheets), 0 < t.count || 0 < t.imgCount ? function(n) {
      var a = setTimeout(function() {
        if (t.stylesheets && Dc(t, t.stylesheets), t.unsuspend) {
          var r = t.unsuspend;
          t.unsuspend = null, r();
        }
      }, 6e4 + e);
      0 < t.imgBytes && pf === 0 && (pf = 62500 * dv());
      var i = setTimeout(
        function() {
          if (t.waitingForImages = !1, t.count === 0 && (t.stylesheets && Dc(t, t.stylesheets), t.unsuspend)) {
            var r = t.unsuspend;
            t.unsuspend = null, r();
          }
        },
        (t.imgBytes > pf ? 50 : 800) + e
      );
      return t.unsuspend = n, function() {
        t.unsuspend = null, clearTimeout(a), clearTimeout(i);
      };
    } : null;
  }
  function Nc() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Dc(this, this.stylesheets);
      else if (this.unsuspend) {
        var t = this.unsuspend;
        this.unsuspend = null, t();
      }
    }
  }
  var wc = null;
  function Dc(t, e) {
    t.stylesheets = null, t.unsuspend !== null && (t.count++, wc = /* @__PURE__ */ new Map(), e.forEach(Lv, t), wc = null, Nc.call(t));
  }
  function Lv(t, e) {
    if (!(e.state.loading & 4)) {
      var n = wc.get(t);
      if (n) var a = n.get(null);
      else {
        n = /* @__PURE__ */ new Map(), wc.set(t, n);
        for (var i = t.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), r = 0; r < i.length; r++) {
          var f = i[r];
          (f.nodeName === "LINK" || f.getAttribute("media") !== "not all") && (n.set(f.dataset.precedence, f), a = f);
        }
        a && n.set(null, a);
      }
      i = e.instance, f = i.getAttribute("data-precedence"), r = n.get(f) || a, r === a && n.set(null, i), n.set(f, i), this.count++, a = Nc.bind(this), i.addEventListener("load", a), i.addEventListener("error", a), r ? r.parentNode.insertBefore(i, r.nextSibling) : (t = t.nodeType === 9 ? t.head : t, t.insertBefore(i, t.firstChild)), e.state.loading |= 4;
    }
  }
  var Ko = {
    $$typeof: nt,
    Provider: null,
    Consumer: null,
    _currentValue: ut,
    _currentValue2: ut,
    _threadCount: 0
  };
  function Rv(t, e, n, a, i, r, f, m, A) {
    this.tag = 1, this.containerInfo = t, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Al(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Al(0), this.hiddenUpdates = Al(null), this.identifierPrefix = a, this.onUncaughtError = i, this.onCaughtError = r, this.onRecoverableError = f, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = A, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function yp(t, e, n, a, i, r, f, m, A, C, L, U) {
    return t = new Rv(
      t,
      e,
      n,
      f,
      A,
      C,
      L,
      U,
      m
    ), e = 1, r === !0 && (e |= 24), r = Je(3, null, null, e), t.current = r, r.stateNode = t, e = Zu(), e.refCount++, t.pooledCache = e, e.refCount++, r.memoizedState = {
      element: a,
      isDehydrated: n,
      cache: e
    }, _u(r), t;
  }
  function vp(t) {
    return t ? (t = fi, t) : fi;
  }
  function bp(t, e, n, a, i, r) {
    i = vp(i), a.context === null ? a.context = i : a.pendingContext = i, a = Xa(e), a.payload = { element: n }, r = r === void 0 ? null : r, r !== null && (a.callback = r), n = Qa(t, a, e), n !== null && (qe(n, t, e), xo(n, t, e));
  }
  function Sp(t, e) {
    if (t = t.memoizedState, t !== null && t.dehydrated !== null) {
      var n = t.retryLane;
      t.retryLane = n !== 0 && n < e ? n : e;
    }
  }
  function Af(t, e) {
    Sp(t, e), (t = t.alternate) && Sp(t, e);
  }
  function Op(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = Tl(t, 67108864);
      e !== null && qe(e, t, 67108864), Af(t, 67108864);
    }
  }
  function Ep(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = nn();
      e = yl(e);
      var n = Tl(t, e);
      n !== null && qe(n, t, e), Af(t, e);
    }
  }
  var Bc = !0;
  function Uv(t, e, n, a) {
    var i = X.T;
    X.T = null;
    var r = Z.p;
    try {
      Z.p = 2, yf(t, e, n, a);
    } finally {
      Z.p = r, X.T = i;
    }
  }
  function Hv(t, e, n, a) {
    var i = X.T;
    X.T = null;
    var r = Z.p;
    try {
      Z.p = 8, yf(t, e, n, a);
    } finally {
      Z.p = r, X.T = i;
    }
  }
  function yf(t, e, n, a) {
    if (Bc) {
      var i = vf(a);
      if (i === null)
        af(
          t,
          e,
          a,
          Mc,
          n
        ), xp(t, a);
      else if (Xv(
        i,
        t,
        e,
        n,
        a
      ))
        a.stopPropagation();
      else if (xp(t, a), e & 4 && -1 < jv.indexOf(t)) {
        for (; i !== null; ) {
          var r = wa(i);
          if (r !== null)
            switch (r.tag) {
              case 3:
                if (r = r.stateNode, r.current.memoizedState.isDehydrated) {
                  var f = zn(r.pendingLanes);
                  if (f !== 0) {
                    var m = r;
                    for (m.pendingLanes |= 2, m.entangledLanes |= 2; f; ) {
                      var A = 1 << 31 - Oe(f);
                      m.entanglements[1] |= A, f &= ~A;
                    }
                    Vn(r), (Ut & 6) === 0 && (mc = ie() + 500, Yo(0));
                  }
                }
                break;
              case 31:
              case 13:
                m = Tl(r, 2), m !== null && qe(m, r, 2), gc(), Af(r, 2);
            }
          if (r = vf(a), r === null && af(
            t,
            e,
            a,
            Mc,
            n
          ), r === i) break;
          i = r;
        }
        i !== null && a.stopPropagation();
      } else
        af(
          t,
          e,
          a,
          null,
          n
        );
    }
  }
  function vf(t) {
    return t = bu(t), bf(t);
  }
  var Mc = null;
  function bf(t) {
    if (Mc = null, t = Na(t), t !== null) {
      var e = h(t);
      if (e === null) t = null;
      else {
        var n = e.tag;
        if (n === 13) {
          if (t = p(e), t !== null) return t;
          t = null;
        } else if (n === 31) {
          if (t = y(e), t !== null) return t;
          t = null;
        } else if (n === 3) {
          if (e.stateNode.current.memoizedState.isDehydrated)
            return e.tag === 3 ? e.stateNode.containerInfo : null;
          t = null;
        } else e !== t && (t = null);
      }
    }
    return Mc = t, null;
  }
  function Tp(t) {
    switch (t) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (_i()) {
          case Wl:
            return 2;
          case Jl:
            return 8;
          case ba:
          case Sa:
            return 32;
          case hl:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var Sf = !1, Wa = null, Ja = null, _a = null, Zo = /* @__PURE__ */ new Map(), Po = /* @__PURE__ */ new Map(), $a = [], jv = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function xp(t, e) {
    switch (t) {
      case "focusin":
      case "focusout":
        Wa = null;
        break;
      case "dragenter":
      case "dragleave":
        Ja = null;
        break;
      case "mouseover":
      case "mouseout":
        _a = null;
        break;
      case "pointerover":
      case "pointerout":
        Zo.delete(e.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Po.delete(e.pointerId);
    }
  }
  function Wo(t, e, n, a, i, r) {
    return t === null || t.nativeEvent !== r ? (t = {
      blockedOn: e,
      domEventName: n,
      eventSystemFlags: a,
      nativeEvent: r,
      targetContainers: [i]
    }, e !== null && (e = wa(e), e !== null && Op(e)), t) : (t.eventSystemFlags |= a, e = t.targetContainers, i !== null && e.indexOf(i) === -1 && e.push(i), t);
  }
  function Xv(t, e, n, a, i) {
    switch (e) {
      case "focusin":
        return Wa = Wo(
          Wa,
          t,
          e,
          n,
          a,
          i
        ), !0;
      case "dragenter":
        return Ja = Wo(
          Ja,
          t,
          e,
          n,
          a,
          i
        ), !0;
      case "mouseover":
        return _a = Wo(
          _a,
          t,
          e,
          n,
          a,
          i
        ), !0;
      case "pointerover":
        var r = i.pointerId;
        return Zo.set(
          r,
          Wo(
            Zo.get(r) || null,
            t,
            e,
            n,
            a,
            i
          )
        ), !0;
      case "gotpointercapture":
        return r = i.pointerId, Po.set(
          r,
          Wo(
            Po.get(r) || null,
            t,
            e,
            n,
            a,
            i
          )
        ), !0;
    }
    return !1;
  }
  function Cp(t) {
    var e = Na(t.target);
    if (e !== null) {
      var n = h(e);
      if (n !== null) {
        if (e = n.tag, e === 13) {
          if (e = p(n), e !== null) {
            t.blockedOn = e, Tr(t.priority, function() {
              Ep(n);
            });
            return;
          }
        } else if (e === 31) {
          if (e = y(n), e !== null) {
            t.blockedOn = e, Tr(t.priority, function() {
              Ep(n);
            });
            return;
          }
        } else if (e === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          t.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    t.blockedOn = null;
  }
  function zc(t) {
    if (t.blockedOn !== null) return !1;
    for (var e = t.targetContainers; 0 < e.length; ) {
      var n = vf(t.nativeEvent);
      if (n === null) {
        n = t.nativeEvent;
        var a = new n.constructor(
          n.type,
          n
        );
        vu = a, n.target.dispatchEvent(a), vu = null;
      } else
        return e = wa(n), e !== null && Op(e), t.blockedOn = n, !1;
      e.shift();
    }
    return !0;
  }
  function Np(t, e, n) {
    zc(t) && n.delete(e);
  }
  function Qv() {
    Sf = !1, Wa !== null && zc(Wa) && (Wa = null), Ja !== null && zc(Ja) && (Ja = null), _a !== null && zc(_a) && (_a = null), Zo.forEach(Np), Po.forEach(Np);
  }
  function Lc(t, e) {
    t.blockedOn === e && (t.blockedOn = null, Sf || (Sf = !0, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      Qv
    )));
  }
  var Rc = null;
  function wp(t) {
    Rc !== t && (Rc = t, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      function() {
        Rc === t && (Rc = null);
        for (var e = 0; e < t.length; e += 3) {
          var n = t[e], a = t[e + 1], i = t[e + 2];
          if (typeof a != "function") {
            if (bf(a || n) === null)
              continue;
            break;
          }
          var r = wa(n);
          r !== null && (t.splice(e, 3), e -= 3, ys(
            r,
            {
              pending: !0,
              data: i,
              method: n.method,
              action: a
            },
            a,
            i
          ));
        }
      }
    ));
  }
  function Ui(t) {
    function e(A) {
      return Lc(A, t);
    }
    Wa !== null && Lc(Wa, t), Ja !== null && Lc(Ja, t), _a !== null && Lc(_a, t), Zo.forEach(e), Po.forEach(e);
    for (var n = 0; n < $a.length; n++) {
      var a = $a[n];
      a.blockedOn === t && (a.blockedOn = null);
    }
    for (; 0 < $a.length && (n = $a[0], n.blockedOn === null); )
      Cp(n), n.blockedOn === null && $a.shift();
    if (n = (t.ownerDocument || t).$$reactFormReplay, n != null)
      for (a = 0; a < n.length; a += 3) {
        var i = n[a], r = n[a + 1], f = i[oe] || null;
        if (typeof r == "function")
          f || wp(n);
        else if (f) {
          var m = null;
          if (r && r.hasAttribute("formAction")) {
            if (i = r, f = r[oe] || null)
              m = f.formAction;
            else if (bf(i) !== null) continue;
          } else m = f.action;
          typeof m == "function" ? n[a + 1] = m : (n.splice(a, 3), a -= 3), wp(n);
        }
      }
  }
  function Dp() {
    function t(r) {
      r.canIntercept && r.info === "react-transition" && r.intercept({
        handler: function() {
          return new Promise(function(f) {
            return i = f;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function e() {
      i !== null && (i(), i = null), a || setTimeout(n, 20);
    }
    function n() {
      if (!a && !navigation.transition) {
        var r = navigation.currentEntry;
        r && r.url != null && navigation.navigate(r.url, {
          state: r.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var a = !1, i = null;
      return navigation.addEventListener("navigate", t), navigation.addEventListener("navigatesuccess", e), navigation.addEventListener("navigateerror", e), setTimeout(n, 100), function() {
        a = !0, navigation.removeEventListener("navigate", t), navigation.removeEventListener("navigatesuccess", e), navigation.removeEventListener("navigateerror", e), i !== null && (i(), i = null);
      };
    }
  }
  function Of(t) {
    this._internalRoot = t;
  }
  Uc.prototype.render = Of.prototype.render = function(t) {
    var e = this._internalRoot;
    if (e === null) throw Error(u(409));
    var n = e.current, a = nn();
    bp(n, a, t, e, null, null);
  }, Uc.prototype.unmount = Of.prototype.unmount = function() {
    var t = this._internalRoot;
    if (t !== null) {
      this._internalRoot = null;
      var e = t.containerInfo;
      bp(t.current, 2, null, t, null, null), gc(), e[Ca] = null;
    }
  };
  function Uc(t) {
    this._internalRoot = t;
  }
  Uc.prototype.unstable_scheduleHydration = function(t) {
    if (t) {
      var e = xa();
      t = { blockedOn: null, target: t, priority: e };
      for (var n = 0; n < $a.length && e !== 0 && e < $a[n].priority; n++) ;
      $a.splice(n, 0, t), n === 0 && Cp(t);
    }
  };
  var Bp = c.version;
  if (Bp !== "19.2.6")
    throw Error(
      u(
        527,
        Bp,
        "19.2.6"
      )
    );
  Z.findDOMNode = function(t) {
    var e = t._reactInternals;
    if (e === void 0)
      throw typeof t.render == "function" ? Error(u(188)) : (t = Object.keys(t).join(","), Error(u(268, t)));
    return t = M(e), t = t !== null ? w(t) : null, t = t === null ? null : t.stateNode, t;
  };
  var Vv = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: X,
    reconcilerVersion: "19.2.6"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Hc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Hc.isDisabled && Hc.supportsFiber)
      try {
        Oa = Hc.inject(
          Vv
        ), Be = Hc;
      } catch {
      }
  }
  return Jo.createRoot = function(t, e) {
    if (!d(t)) throw Error(u(299));
    var n = !1, a = "", i = jh, r = Xh, f = Qh;
    return e != null && (e.unstable_strictMode === !0 && (n = !0), e.identifierPrefix !== void 0 && (a = e.identifierPrefix), e.onUncaughtError !== void 0 && (i = e.onUncaughtError), e.onCaughtError !== void 0 && (r = e.onCaughtError), e.onRecoverableError !== void 0 && (f = e.onRecoverableError)), e = yp(
      t,
      1,
      !1,
      null,
      null,
      n,
      a,
      null,
      i,
      r,
      f,
      Dp
    ), t[Ca] = e.current, nf(t), new Of(e);
  }, Jo.hydrateRoot = function(t, e, n) {
    if (!d(t)) throw Error(u(299));
    var a = !1, i = "", r = jh, f = Xh, m = Qh, A = null;
    return n != null && (n.unstable_strictMode === !0 && (a = !0), n.identifierPrefix !== void 0 && (i = n.identifierPrefix), n.onUncaughtError !== void 0 && (r = n.onUncaughtError), n.onCaughtError !== void 0 && (f = n.onCaughtError), n.onRecoverableError !== void 0 && (m = n.onRecoverableError), n.formState !== void 0 && (A = n.formState)), e = yp(
      t,
      1,
      !0,
      e,
      n ?? null,
      a,
      i,
      A,
      r,
      f,
      m,
      Dp
    ), e.context = vp(null), n = e.current, a = nn(), a = yl(a), i = Xa(a), i.callback = null, Qa(n, i, a), n = a, e.current.lanes = n, Jn(e, n), Vn(e), t[Ca] = e.current, nf(t), new Uc(e);
  }, Jo.version = "19.2.6", Jo;
}
var Rp;
function Wv() {
  if (Rp) return Ef.exports;
  Rp = 1;
  function l() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(l);
      } catch (o) {
        console.error(o);
      }
  }
  return l(), Ef.exports = Pv(), Ef.exports;
}
var n0 = Wv(), Cf = { exports: {} }, _o = {};
var Up;
function Jv() {
  if (Up) return _o;
  Up = 1;
  var l = Symbol.for("react.transitional.element"), o = Symbol.for("react.fragment");
  function c(s, u, d) {
    var h = null;
    if (d !== void 0 && (h = "" + d), u.key !== void 0 && (h = "" + u.key), "key" in u) {
      d = {};
      for (var p in u)
        p !== "key" && (d[p] = u[p]);
    } else d = u;
    return u = d.ref, {
      $$typeof: l,
      type: s,
      key: h,
      ref: u !== void 0 ? u : null,
      props: d
    };
  }
  return _o.Fragment = o, _o.jsx = c, _o.jsxs = c, _o;
}
var Hp;
function _v() {
  return Hp || (Hp = 1, Cf.exports = Jv()), Cf.exports;
}
var b = _v();
function jp(l, o) {
  (o == null || o > l.length) && (o = l.length);
  for (var c = 0, s = Array(o); c < o; c++) s[c] = l[c];
  return s;
}
function $v(l) {
  if (Array.isArray(l)) return l;
}
function tb(l, o) {
  var c = l == null ? null : typeof Symbol < "u" && l[Symbol.iterator] || l["@@iterator"];
  if (c != null) {
    var s, u, d, h, p = [], y = !0, O = !1;
    try {
      if (d = (c = c.call(l)).next, o !== 0) for (; !(y = (s = d.call(c)).done) && (p.push(s.value), p.length !== o); y = !0) ;
    } catch (M) {
      O = !0, u = M;
    } finally {
      try {
        if (!y && c.return != null && (h = c.return(), Object(h) !== h)) return;
      } finally {
        if (O) throw u;
      }
    }
    return p;
  }
}
function eb() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nb(l, o) {
  return $v(l) || tb(l, o) || ab(l, o) || eb();
}
function ab(l, o) {
  if (l) {
    if (typeof l == "string") return jp(l, o);
    var c = {}.toString.call(l).slice(8, -1);
    return c === "Object" && l.constructor && (c = l.constructor.name), c === "Map" || c === "Set" ? Array.from(l) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? jp(l, o) : void 0;
  }
}
const a0 = Object.entries, Xp = Object.setPrototypeOf, lb = Object.isFrozen, ib = Object.getPrototypeOf, ob = Object.getOwnPropertyDescriptor;
let we = Object.freeze, De = Object.seal, Yi = Object.create, l0 = typeof Reflect < "u" && Reflect, Jf = l0.apply, _f = l0.construct;
we || (we = function(o) {
  return o;
});
De || (De = function(o) {
  return o;
});
Jf || (Jf = function(o, c) {
  for (var s = arguments.length, u = new Array(s > 2 ? s - 2 : 0), d = 2; d < s; d++)
    u[d - 2] = arguments[d];
  return o.apply(c, u);
});
_f || (_f = function(o) {
  for (var c = arguments.length, s = new Array(c > 1 ? c - 1 : 0), u = 1; u < c; u++)
    s[u - 1] = arguments[u];
  return new o(...s);
});
const $o = ge(Array.prototype.forEach), rb = ge(Array.prototype.lastIndexOf), Qp = ge(Array.prototype.pop), Hi = ge(Array.prototype.push), cb = ge(Array.prototype.splice), il = Array.isArray, ir = ge(String.prototype.toLowerCase), Nf = ge(String.prototype.toString), Vp = ge(String.prototype.match), tr = ge(String.prototype.replace), Yp = ge(String.prototype.indexOf), ub = ge(String.prototype.trim), sb = ge(Number.prototype.toString), fb = ge(Boolean.prototype.toString), Gp = typeof BigInt > "u" ? null : ge(BigInt.prototype.toString), Ip = typeof Symbol > "u" ? null : ge(Symbol.prototype.toString), Se = ge(Object.prototype.hasOwnProperty), er = ge(Object.prototype.toString), Ne = ge(RegExp.prototype.test), jl = db(TypeError);
function ge(l) {
  return function(o) {
    o instanceof RegExp && (o.lastIndex = 0);
    for (var c = arguments.length, s = new Array(c > 1 ? c - 1 : 0), u = 1; u < c; u++)
      s[u - 1] = arguments[u];
    return Jf(l, o, s);
  };
}
function db(l) {
  return function() {
    for (var o = arguments.length, c = new Array(o), s = 0; s < o; s++)
      c[s] = arguments[s];
    return _f(l, c);
  };
}
function Dt(l, o) {
  let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ir;
  if (Xp && Xp(l, null), !il(o))
    return l;
  let s = o.length;
  for (; s--; ) {
    let u = o[s];
    if (typeof u == "string") {
      const d = c(u);
      d !== u && (lb(o) || (o[s] = d), u = d);
    }
    l[u] = !0;
  }
  return l;
}
function mb(l) {
  for (let o = 0; o < l.length; o++)
    Se(l, o) || (l[o] = null);
  return l;
}
function Ue(l) {
  const o = Yi(null);
  for (const s of a0(l)) {
    var c = nb(s, 2);
    const u = c[0], d = c[1];
    Se(l, u) && (il(d) ? o[u] = mb(d) : d && typeof d == "object" && d.constructor === Object ? o[u] = Ue(d) : o[u] = d);
  }
  return o;
}
function hb(l) {
  switch (typeof l) {
    case "string":
      return l;
    case "number":
      return sb(l);
    case "boolean":
      return fb(l);
    case "bigint":
      return Gp ? Gp(l) : "0";
    case "symbol":
      return Ip ? Ip(l) : "Symbol()";
    case "undefined":
      return er(l);
    case "function":
    case "object": {
      if (l === null)
        return er(l);
      const o = l, c = Gn(o, "toString");
      if (typeof c == "function") {
        const s = c(o);
        return typeof s == "string" ? s : er(s);
      }
      return er(l);
    }
    default:
      return er(l);
  }
}
function Gn(l, o) {
  for (; l !== null; ) {
    const s = ob(l, o);
    if (s) {
      if (s.get)
        return ge(s.get);
      if (typeof s.value == "function")
        return ge(s.value);
    }
    l = ib(l);
  }
  function c() {
    return null;
  }
  return c;
}
function gb(l) {
  try {
    return Ne(l, ""), !0;
  } catch {
    return !1;
  }
}
const Fp = we(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), wf = we(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Df = we(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), pb = we(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Bf = we(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Ab = we(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), kp = we(["#text"]), qp = we(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Mf = we(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Kp = we(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), jc = we(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), yb = De(/{{[\w\W]*|^[\w\W]*}}/g), vb = De(/<%[\w\W]*|^[\w\W]*%>/g), bb = De(/\${[\w\W]*/g), Sb = De(/^data-[\-\w.\u00B7-\uFFFF]+$/), Ob = De(/^aria-[\-\w]+$/), Zp = De(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Eb = De(/^(?:\w+script|data):/i), Tb = De(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), xb = De(/^html$/i), Cb = De(/^[a-z][.\w]*(-[.\w]+)+$/i), Pp = De(/<[/\w!]/g), Nb = De(/<[/\w]/g), wb = De(/<\/no(script|embed|frames)/i), Db = De(/\/>/i), Yn = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, Bb = function() {
  return typeof window > "u" ? null : window;
}, Mb = function(o, c) {
  if (typeof o != "object" || typeof o.createPolicy != "function")
    return null;
  let s = null;
  const u = "data-tt-policy-suffix";
  c && c.hasAttribute(u) && (s = c.getAttribute(u));
  const d = "dompurify" + (s ? "#" + s : "");
  try {
    return o.createPolicy(d, {
      createHTML(h) {
        return h;
      },
      createScriptURL(h) {
        return h;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + d + " could not be created."), null;
  }
}, Wp = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, el = function(o, c, s, u) {
  return Se(o, c) && il(o[c]) ? Dt(u.base ? Ue(u.base) : {}, o[c], u.transform) : s;
};
function i0() {
  let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Bb();
  const o = (F) => i0(F);
  if (o.version = "3.4.11", o.removed = [], !l || !l.document || l.document.nodeType !== Yn.document || !l.Element)
    return o.isSupported = !1, o;
  let c = l.document;
  const s = c, u = s.currentScript;
  l.DocumentFragment;
  const d = l.HTMLTemplateElement, h = l.Node, p = l.Element, y = l.NodeFilter, O = l.NamedNodeMap;
  O === void 0 && (l.NamedNodeMap || l.MozNamedAttrMap), l.HTMLFormElement;
  const M = l.DOMParser, w = l.trustedTypes, x = p.prototype, $ = Gn(x, "cloneNode"), j = Gn(x, "remove"), q = Gn(x, "nextSibling"), I = Gn(x, "childNodes"), K = Gn(x, "parentNode"), H = Gn(x, "shadowRoot"), et = Gn(x, "attributes"), nt = h && h.prototype ? Gn(h.prototype, "nodeType") : null, V = h && h.prototype ? Gn(h.prototype, "nodeName") : null;
  if (typeof d == "function") {
    const F = c.createElement("template");
    F.content && F.content.ownerDocument && (c = F.content.ownerDocument);
  }
  let P, G = "", W, ct = !1, Tt = 0;
  const yt = function() {
    if (Tt > 0)
      throw jl('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, zt = function(g) {
    yt(), Tt++;
    try {
      return P.createHTML(g);
    } finally {
      Tt--;
    }
  }, Ct = function(g) {
    yt(), Tt++;
    try {
      return P.createScriptURL(g);
    } finally {
      Tt--;
    }
  }, le = function() {
    return ct || (W = Mb(w, u), ct = !0), W;
  }, Nt = c, Y = Nt.implementation, X = Nt.createNodeIterator, Z = Nt.createDocumentFragment, ut = Nt.getElementsByTagName, gt = s.importNode;
  let ft = Wp();
  o.isSupported = typeof a0 == "function" && typeof K == "function" && Y && Y.createHTMLDocument !== void 0;
  const Bt = yb, rt = vb, lt = bb, wt = Sb, ze = Ob, ye = Eb, Sn = Tb, On = Cb;
  let ve = Zp, kt = null;
  const fl = Dt({}, [...Fp, ...wf, ...Df, ...Bf, ...kp]);
  let qt = null;
  const Wi = Dt({}, [...qp, ...Mf, ...Kp, ...jc]);
  let Xt = Object.seal(Yi(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Zn = null, Kl = null;
  const Bn = Object.seal(Yi(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Ji = !0, dl = !0, Zl = !1, Pl = !0, Mn = !1, ml = !0, ie = !1, _i = !1, Wl = null, Jl = null, ba = !1, Sa = !1, hl = !1, _l = !1, Er = !0, Oa = !1;
  const Be = "user-content-";
  let cn = !0, Oe = !1, Ea = {}, un = null;
  const $i = Dt({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let gl = null;
  const pl = Dt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ta = null;
  const zn = Dt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Pn = "http://www.w3.org/1998/Math/MathML", Ln = "http://www.w3.org/2000/svg", sn = "http://www.w3.org/1999/xhtml";
  let Wn = sn, Al = !1, Jn = null;
  const Au = Dt({}, [Pn, Ln, sn], Nf), to = we(["mi", "mo", "mn", "ms", "mtext"]);
  let $l = Dt({}, to);
  const eo = we(["annotation-xml"]);
  let yl = Dt({}, eo);
  const no = Dt({}, ["title", "style", "font", "a", "script"]);
  let xa = null;
  const Tr = ["application/xhtml+xml", "text/html"], Rn = "text/html";
  let pt = null, oe = null;
  const Ca = c.createElement("form"), ti = function(g) {
    return g instanceof RegExp || g instanceof Function;
  }, ao = function() {
    let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (oe && oe === g)
      return;
    (!g || typeof g != "object") && (g = {}), g = Ue(g), xa = // eslint-disable-next-line unicorn/prefer-includes
    Tr.indexOf(g.PARSER_MEDIA_TYPE) === -1 ? Rn : g.PARSER_MEDIA_TYPE, pt = xa === "application/xhtml+xml" ? Nf : ir, kt = el(g, "ALLOWED_TAGS", fl, {
      transform: pt
    }), qt = el(g, "ALLOWED_ATTR", Wi, {
      transform: pt
    }), Jn = el(g, "ALLOWED_NAMESPACES", Au, {
      transform: Nf
    }), Ta = el(g, "ADD_URI_SAFE_ATTR", zn, {
      transform: pt,
      base: zn
    }), gl = el(g, "ADD_DATA_URI_TAGS", pl, {
      transform: pt,
      base: pl
    }), un = el(g, "FORBID_CONTENTS", $i, {
      transform: pt
    }), Zn = el(g, "FORBID_TAGS", Ue({}), {
      transform: pt
    }), Kl = el(g, "FORBID_ATTR", Ue({}), {
      transform: pt
    }), Ea = Se(g, "USE_PROFILES") ? g.USE_PROFILES && typeof g.USE_PROFILES == "object" ? Ue(g.USE_PROFILES) : g.USE_PROFILES : !1, Ji = g.ALLOW_ARIA_ATTR !== !1, dl = g.ALLOW_DATA_ATTR !== !1, Zl = g.ALLOW_UNKNOWN_PROTOCOLS || !1, Pl = g.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Mn = g.SAFE_FOR_TEMPLATES || !1, ml = g.SAFE_FOR_XML !== !1, ie = g.WHOLE_DOCUMENT || !1, Sa = g.RETURN_DOM || !1, hl = g.RETURN_DOM_FRAGMENT || !1, _l = g.RETURN_TRUSTED_TYPE || !1, ba = g.FORCE_BODY || !1, Er = g.SANITIZE_DOM !== !1, Oa = g.SANITIZE_NAMED_PROPS || !1, cn = g.KEEP_CONTENT !== !1, Oe = g.IN_PLACE || !1, ve = gb(g.ALLOWED_URI_REGEXP) ? g.ALLOWED_URI_REGEXP : Zp, Wn = typeof g.NAMESPACE == "string" ? g.NAMESPACE : sn, $l = Se(g, "MATHML_TEXT_INTEGRATION_POINTS") && g.MATHML_TEXT_INTEGRATION_POINTS && typeof g.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ue(g.MATHML_TEXT_INTEGRATION_POINTS) : Dt({}, to), yl = Se(g, "HTML_INTEGRATION_POINTS") && g.HTML_INTEGRATION_POINTS && typeof g.HTML_INTEGRATION_POINTS == "object" ? Ue(g.HTML_INTEGRATION_POINTS) : Dt({}, eo);
    const N = Se(g, "CUSTOM_ELEMENT_HANDLING") && g.CUSTOM_ELEMENT_HANDLING && typeof g.CUSTOM_ELEMENT_HANDLING == "object" ? Ue(g.CUSTOM_ELEMENT_HANDLING) : Yi(null);
    if (Xt = Yi(null), Se(N, "tagNameCheck") && ti(N.tagNameCheck) && (Xt.tagNameCheck = N.tagNameCheck), Se(N, "attributeNameCheck") && ti(N.attributeNameCheck) && (Xt.attributeNameCheck = N.attributeNameCheck), Se(N, "allowCustomizedBuiltInElements") && typeof N.allowCustomizedBuiltInElements == "boolean" && (Xt.allowCustomizedBuiltInElements = N.allowCustomizedBuiltInElements), De(Xt), Mn && (dl = !1), hl && (Sa = !0), Ea && (kt = Dt({}, kp), qt = Yi(null), Ea.html === !0 && (Dt(kt, Fp), Dt(qt, qp)), Ea.svg === !0 && (Dt(kt, wf), Dt(qt, Mf), Dt(qt, jc)), Ea.svgFilters === !0 && (Dt(kt, Df), Dt(qt, Mf), Dt(qt, jc)), Ea.mathMl === !0 && (Dt(kt, Bf), Dt(qt, Kp), Dt(qt, jc))), Bn.tagCheck = null, Bn.attributeCheck = null, Se(g, "ADD_TAGS") && (typeof g.ADD_TAGS == "function" ? Bn.tagCheck = g.ADD_TAGS : il(g.ADD_TAGS) && (kt === fl && (kt = Ue(kt)), Dt(kt, g.ADD_TAGS, pt))), Se(g, "ADD_ATTR") && (typeof g.ADD_ATTR == "function" ? Bn.attributeCheck = g.ADD_ATTR : il(g.ADD_ATTR) && (qt === Wi && (qt = Ue(qt)), Dt(qt, g.ADD_ATTR, pt))), Se(g, "ADD_URI_SAFE_ATTR") && il(g.ADD_URI_SAFE_ATTR) && Dt(Ta, g.ADD_URI_SAFE_ATTR, pt), Se(g, "FORBID_CONTENTS") && il(g.FORBID_CONTENTS) && (un === $i && (un = Ue(un)), Dt(un, g.FORBID_CONTENTS, pt)), Se(g, "ADD_FORBID_CONTENTS") && il(g.ADD_FORBID_CONTENTS) && (un === $i && (un = Ue(un)), Dt(un, g.ADD_FORBID_CONTENTS, pt)), cn && (kt["#text"] = !0), ie && Dt(kt, ["html", "head", "body"]), kt.table && (Dt(kt, ["tbody"]), delete Zn.tbody), g.TRUSTED_TYPES_POLICY) {
      if (typeof g.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw jl('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof g.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw jl('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const k = P;
      P = g.TRUSTED_TYPES_POLICY;
      try {
        G = zt("");
      } catch (J) {
        throw P = k, J;
      }
    } else g.TRUSTED_TYPES_POLICY === null ? (P = void 0, G = "") : (P === void 0 && (P = le()), P && typeof G == "string" && (G = zt("")));
    we && we(g), oe = g;
  }, xr = Dt({}, [...wf, ...Df, ...pb]), lo = Dt({}, [...Bf, ...Ab]), vl = function(g, N, k) {
    return N.namespaceURI === sn ? g === "svg" : N.namespaceURI === Pn ? g === "svg" && (k === "annotation-xml" || $l[k]) : !!xr[g];
  }, io = function(g, N, k) {
    return N.namespaceURI === sn ? g === "math" : N.namespaceURI === Ln ? g === "math" && yl[k] : !!lo[g];
  }, Na = function(g, N, k) {
    return N.namespaceURI === Ln && !yl[k] || N.namespaceURI === Pn && !$l[k] ? !1 : !lo[g] && (no[g] || !xr[g]);
  }, wa = function(g) {
    let N = K(g);
    (!N || !N.tagName) && (N = {
      namespaceURI: Wn,
      tagName: "template"
    });
    const k = ir(g.tagName), J = ir(N.tagName);
    return Jn[g.namespaceURI] ? g.namespaceURI === Ln ? vl(k, N, J) : g.namespaceURI === Pn ? io(k, N, J) : g.namespaceURI === sn ? Na(k, N, J) : !!(xa === "application/xhtml+xml" && Jn[g.namespaceURI]) : !1;
  }, je = function(g) {
    Hi(o.removed, {
      element: g
    });
    try {
      K(g).removeChild(g);
    } catch {
      if (j(g), !K(g))
        throw jl("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, _n = function(g) {
    const N = I(g);
    if (N) {
      const J = [];
      $o(N, (mt) => {
        Hi(J, mt);
      }), $o(J, (mt) => {
        try {
          j(mt);
        } catch {
        }
      });
    }
    const k = et(g);
    if (k)
      for (let J = k.length - 1; J >= 0; --J) {
        const mt = k[J], St = mt && mt.name;
        if (typeof St == "string")
          try {
            g.removeAttribute(St);
          } catch {
          }
      }
  }, Kt = function(g, N) {
    try {
      Hi(o.removed, {
        attribute: N.getAttributeNode(g),
        from: N
      });
    } catch {
      Hi(o.removed, {
        attribute: null,
        from: N
      });
    }
    if (N.removeAttribute(g), g === "is")
      if (Sa || hl)
        try {
          je(N);
        } catch {
        }
      else
        try {
          N.setAttribute(g, "");
        } catch {
        }
  }, Cr = function(g) {
    const N = et(g);
    if (N)
      for (let k = N.length - 1; k >= 0; --k) {
        const J = N[k], mt = J && J.name;
        if (!(typeof mt != "string" || qt[pt(mt)]))
          try {
            g.removeAttribute(mt);
          } catch {
          }
      }
  }, Nr = function(g) {
    const N = [g];
    for (; N.length > 0; ) {
      const k = N.pop();
      (nt ? nt(k) : k.nodeType) === Yn.element && Cr(k);
      const mt = I(k);
      if (mt)
        for (let St = mt.length - 1; St >= 0; --St)
          N.push(mt[St]);
    }
  }, Un = function(g) {
    let N = null, k = null;
    if (ba)
      g = "<remove></remove>" + g;
    else {
      const St = Vp(g, /^[\r\n\t ]+/);
      k = St && St[0];
    }
    xa === "application/xhtml+xml" && Wn === sn && (g = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + g + "</body></html>");
    const J = P ? zt(g) : g;
    if (Wn === sn)
      try {
        N = new M().parseFromString(J, xa);
      } catch {
      }
    if (!N || !N.documentElement) {
      N = Y.createDocument(Wn, "template", null);
      try {
        N.documentElement.innerHTML = Al ? G : J;
      } catch {
      }
    }
    const mt = N.body || N.documentElement;
    return g && k && mt.insertBefore(c.createTextNode(k), mt.childNodes[0] || null), Wn === sn ? ut.call(N, ie ? "html" : "body")[0] : ie ? N.documentElement : mt;
  }, $n = function(g) {
    return X.call(
      g.ownerDocument || g,
      g,
      // eslint-disable-next-line no-bitwise
      y.SHOW_ELEMENT | y.SHOW_COMMENT | y.SHOW_TEXT | y.SHOW_PROCESSING_INSTRUCTION | y.SHOW_CDATA_SECTION,
      null
    );
  }, ei = function(g) {
    return g = tr(g, Bt, " "), g = tr(g, rt, " "), g = tr(g, lt, " "), g;
  }, ni = function(g) {
    var N;
    g.normalize();
    const k = X.call(
      g.ownerDocument || g,
      g,
      // eslint-disable-next-line no-bitwise
      y.SHOW_TEXT | y.SHOW_COMMENT | y.SHOW_CDATA_SECTION | y.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let J = k.nextNode();
    for (; J; )
      J.data = ei(J.data), J = k.nextNode();
    const mt = (N = g.querySelectorAll) === null || N === void 0 ? void 0 : N.call(g, "template");
    mt && $o(mt, (St) => {
      Da(St.content) && ni(St.content);
    });
  }, bl = function(g) {
    const N = V ? V(g) : null;
    return typeof N != "string" || pt(N) !== "form" ? !1 : typeof g.nodeName != "string" || typeof g.textContent != "string" || typeof g.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    g.attributes !== et(g) || typeof g.removeAttribute != "function" || typeof g.setAttribute != "function" || typeof g.namespaceURI != "string" || typeof g.insertBefore != "function" || typeof g.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    g.nodeType !== nt(g) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    g.childNodes !== I(g);
  }, Da = function(g) {
    if (!nt || typeof g != "object" || g === null)
      return !1;
    try {
      return nt(g) === Yn.documentFragment;
    } catch {
      return !1;
    }
  }, Hn = function(g) {
    if (!nt || typeof g != "object" || g === null)
      return !1;
    try {
      return typeof nt(g) == "number";
    } catch {
      return !1;
    }
  };
  function Xe(F, g, N) {
    F.length !== 0 && $o(F, (k) => {
      k.call(o, g, N, oe);
    });
  }
  const En = function(g, N) {
    return !!(ml && g.hasChildNodes() && !Hn(g.firstElementChild) && Ne(Pp, g.textContent) && Ne(Pp, g.innerHTML) || ml && g.namespaceURI === sn && N === "style" && Hn(g.firstElementChild) || g.nodeType === Yn.processingInstruction || ml && g.nodeType === Yn.comment && Ne(Nb, g.data));
  }, Qe = function(g, N) {
    if (!Zn[N] && co(N) && (Xt.tagNameCheck instanceof RegExp && Ne(Xt.tagNameCheck, N) || Xt.tagNameCheck instanceof Function && Xt.tagNameCheck(N)))
      return !1;
    if (cn && !un[N]) {
      const k = K(g), J = I(g);
      if (J && k) {
        const mt = J.length;
        for (let St = mt - 1; St >= 0; --St) {
          const re = Oe ? J[St] : $(J[St], !0);
          k.insertBefore(re, q(g));
        }
      }
    }
    return je(g), !0;
  }, oo = function(g) {
    if (Xe(ft.beforeSanitizeElements, g, null), bl(g))
      return je(g), !0;
    const N = pt(V ? V(g) : g.nodeName);
    if (Xe(ft.uponSanitizeElement, g, {
      tagName: N,
      allowedTags: kt
    }), En(g, N))
      return je(g), !0;
    if (Zn[N] || !(Bn.tagCheck instanceof Function && Bn.tagCheck(N)) && !kt[N])
      return Qe(g, N);
    if ((nt ? nt(g) : g.nodeType) === Yn.element && !wa(g) || (N === "noscript" || N === "noembed" || N === "noframes") && Ne(wb, g.innerHTML))
      return je(g), !0;
    if (Mn && g.nodeType === Yn.text) {
      const J = ei(g.textContent);
      g.textContent !== J && (Hi(o.removed, {
        element: g.cloneNode()
      }), g.textContent = J);
    }
    return Xe(ft.afterSanitizeElements, g, null), !1;
  }, wr = function(g, N, k) {
    if (Kl[N] || Er && (N === "id" || N === "name") && (k in c || k in Ca))
      return !1;
    const J = qt[N] || Bn.attributeCheck instanceof Function && Bn.attributeCheck(N, g);
    if (!(dl && Ne(wt, N))) {
      if (!(Ji && Ne(ze, N))) {
        if (J) {
          if (!Ta[N]) {
            if (!Ne(ve, tr(k, Sn, ""))) {
              if (!((N === "src" || N === "xlink:href" || N === "href") && g !== "script" && Yp(k, "data:") === 0 && gl[g])) {
                if (!(Zl && !Ne(ye, tr(k, Sn, "")))) {
                  if (k)
                    return !1;
                }
              }
            }
          }
        } else if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(co(g) && (Xt.tagNameCheck instanceof RegExp && Ne(Xt.tagNameCheck, g) || Xt.tagNameCheck instanceof Function && Xt.tagNameCheck(g)) && (Xt.attributeNameCheck instanceof RegExp && Ne(Xt.attributeNameCheck, N) || Xt.attributeNameCheck instanceof Function && Xt.attributeNameCheck(N, g)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          N === "is" && Xt.allowCustomizedBuiltInElements && (Xt.tagNameCheck instanceof RegExp && Ne(Xt.tagNameCheck, k) || Xt.tagNameCheck instanceof Function && Xt.tagNameCheck(k)))
        ) return !1;
      }
    }
    return !0;
  }, ro = Dt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), co = function(g) {
    return !ro[ir(g)] && Ne(On, g);
  }, ai = function(g, N, k, J) {
    if (P && typeof w == "object" && typeof w.getAttributeType == "function" && !k)
      switch (w.getAttributeType(g, N)) {
        case "TrustedHTML":
          return zt(J);
        case "TrustedScriptURL":
          return Ct(J);
      }
    return J;
  }, yu = function(g, N, k, J) {
    try {
      k ? g.setAttributeNS(k, N, J) : g.setAttribute(N, J), bl(g) ? je(g) : Qp(o.removed);
    } catch {
      Kt(N, g);
    }
  }, Le = function(g) {
    Xe(ft.beforeSanitizeAttributes, g, null);
    const N = g.attributes;
    if (!N || bl(g))
      return;
    const k = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: qt,
      forceKeepAttr: void 0
    };
    let J = N.length;
    const mt = pt(g.nodeName);
    for (; J--; ) {
      const St = N[J], re = St.name, $t = St.namespaceURI, Ve = St.value, Pe = pt(re), Ma = Ve;
      let Zt = re === "value" ? Ma : ub(Ma);
      if (k.attrName = Pe, k.attrValue = Zt, k.keepAttr = !0, k.forceKeepAttr = void 0, Xe(ft.uponSanitizeAttribute, g, k), Zt = k.attrValue, Oa && (Pe === "id" || Pe === "name") && Yp(Zt, Be) !== 0 && (Kt(re, g), Zt = Be + Zt), ml && Ne(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Zt)) {
        Kt(re, g);
        continue;
      }
      if (Pe === "attributename" && Vp(Zt, "href")) {
        Kt(re, g);
        continue;
      }
      if (!k.forceKeepAttr) {
        if (!k.keepAttr) {
          Kt(re, g);
          continue;
        }
        if (!Pl && Ne(Db, Zt)) {
          Kt(re, g);
          continue;
        }
        if (Mn && (Zt = ei(Zt)), !wr(mt, Pe, Zt)) {
          Kt(re, g);
          continue;
        }
        Zt = ai(mt, Pe, $t, Zt), Zt !== Ma && yu(g, re, $t, Zt);
      }
    }
    Xe(ft.afterSanitizeAttributes, g, null);
  }, Ba = function(g) {
    let N = null;
    const k = $n(g);
    for (Xe(ft.beforeSanitizeShadowDOM, g, null); N = k.nextNode(); )
      if (Xe(ft.uponSanitizeShadowNode, N, null), oo(N), Le(N), Da(N.content) && Ba(N.content), (nt ? nt(N) : N.nodeType) === Yn.element) {
        const mt = H(N);
        Da(mt) && (li(mt), Ba(mt));
      }
    Xe(ft.afterSanitizeShadowDOM, g, null);
  }, li = function(g) {
    const N = [{
      node: g,
      shadow: null
    }];
    for (; N.length > 0; ) {
      const k = N.pop();
      if (k.shadow) {
        Ba(k.shadow);
        continue;
      }
      const J = k.node, St = (nt ? nt(J) : J.nodeType) === Yn.element, re = I(J);
      if (re)
        for (let $t = re.length - 1; $t >= 0; --$t)
          N.push({
            node: re[$t],
            shadow: null
          });
      if (St) {
        const $t = V ? V(J) : null;
        if (typeof $t == "string" && pt($t) === "template") {
          const Ve = J.content;
          Da(Ve) && N.push({
            node: Ve,
            shadow: null
          });
        }
      }
      if (St) {
        const $t = H(J);
        Da($t) && N.push({
          node: null,
          shadow: $t
        }, {
          node: $t,
          shadow: null
        });
      }
    }
  };
  return o.sanitize = function(F) {
    let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, N = null, k = null, J = null, mt = null;
    if (Al = !F, Al && (F = "<!-->"), typeof F != "string" && !Hn(F) && (F = hb(F), typeof F != "string"))
      throw jl("dirty is not a string, aborting");
    if (!o.isSupported)
      return F;
    _i ? (kt = Wl, qt = Jl) : ao(g), (ft.uponSanitizeElement.length > 0 || ft.uponSanitizeAttribute.length > 0) && (kt = Ue(kt)), ft.uponSanitizeAttribute.length > 0 && (qt = Ue(qt)), o.removed = [];
    const St = Oe && typeof F != "string" && Hn(F);
    if (St) {
      const Ve = V ? V(F) : F.nodeName;
      if (typeof Ve == "string") {
        const Pe = pt(Ve);
        if (!kt[Pe] || Zn[Pe])
          throw jl("root node is forbidden and cannot be sanitized in-place");
      }
      if (bl(F))
        throw jl("root node is clobbered and cannot be sanitized in-place");
      try {
        li(F);
      } catch (Pe) {
        throw _n(F), Pe;
      }
    } else if (Hn(F))
      N = Un("<!---->"), k = N.ownerDocument.importNode(F, !0), k.nodeType === Yn.element && k.nodeName === "BODY" || k.nodeName === "HTML" ? N = k : N.appendChild(k), li(k);
    else {
      if (!Sa && !Mn && !ie && // eslint-disable-next-line unicorn/prefer-includes
      F.indexOf("<") === -1)
        return P && _l ? zt(F) : F;
      if (N = Un(F), !N)
        return Sa ? null : _l ? G : "";
    }
    N && ba && je(N.firstChild);
    const re = $n(St ? F : N);
    try {
      for (; J = re.nextNode(); )
        oo(J), Le(J), Da(J.content) && Ba(J.content);
    } catch (Ve) {
      throw St && _n(F), Ve;
    }
    if (St)
      return $o(o.removed, (Ve) => {
        Ve.element && Nr(Ve.element);
      }), Mn && ni(F), F;
    if (Sa) {
      if (Mn && ni(N), hl)
        for (mt = Z.call(N.ownerDocument); N.firstChild; )
          mt.appendChild(N.firstChild);
      else
        mt = N;
      return (qt.shadowroot || qt.shadowrootmode) && (mt = gt.call(s, mt, !0)), mt;
    }
    let $t = ie ? N.outerHTML : N.innerHTML;
    return ie && kt["!doctype"] && N.ownerDocument && N.ownerDocument.doctype && N.ownerDocument.doctype.name && Ne(xb, N.ownerDocument.doctype.name) && ($t = "<!DOCTYPE " + N.ownerDocument.doctype.name + `>
` + $t), Mn && ($t = ei($t)), P && _l ? zt($t) : $t;
  }, o.setConfig = function() {
    let F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ao(F), _i = !0, Wl = kt, Jl = qt;
  }, o.clearConfig = function() {
    oe = null, _i = !1, Wl = null, Jl = null, P = W, G = "";
  }, o.isValidAttribute = function(F, g, N) {
    oe || ao({});
    const k = pt(F), J = pt(g);
    return wr(k, J, N);
  }, o.addHook = function(F, g) {
    typeof g == "function" && Se(ft, F) && Hi(ft[F], g);
  }, o.removeHook = function(F, g) {
    if (Se(ft, F)) {
      if (g !== void 0) {
        const N = rb(ft[F], g);
        return N === -1 ? void 0 : cb(ft[F], N, 1)[0];
      }
      return Qp(ft[F]);
    }
  }, o.removeHooks = function(F) {
    Se(ft, F) && (ft[F] = []);
  }, o.removeAllHooks = function() {
    ft = Wp();
  }, o;
}
i0();
function* o0(l = "id-", o = 0) {
  let c = o;
  for (; ; )
    c += 1, yield l + c;
}
let zf = !1;
const zb = (l, o) => {
  zf || (zf = !0, setTimeout(() => {
    l(), zf = !1;
  }, o));
};
var Lf = { exports: {} }, Rf, Jp;
function Lb() {
  if (Jp) return Rf;
  Jp = 1;
  var l = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Rf = l, Rf;
}
var Uf, _p;
function Rb() {
  if (_p) return Uf;
  _p = 1;
  var l = /* @__PURE__ */ Lb();
  function o() {
  }
  function c() {
  }
  return c.resetWarningCache = o, Uf = function() {
    function s(h, p, y, O, M, w) {
      if (w !== l) {
        var x = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw x.name = "Invariant Violation", x;
      }
    }
    s.isRequired = s;
    function u() {
      return s;
    }
    var d = {
      array: s,
      bigint: s,
      bool: s,
      func: s,
      number: s,
      object: s,
      string: s,
      symbol: s,
      any: s,
      arrayOf: u,
      element: s,
      elementType: s,
      instanceOf: u,
      node: s,
      objectOf: u,
      oneOf: u,
      oneOfType: u,
      shape: u,
      exact: u,
      checkPropTypes: c,
      resetWarningCache: o
    };
    return d.PropTypes = d, d;
  }, Uf;
}
var $p;
function Ub() {
  return $p || ($p = 1, Lf.exports = /* @__PURE__ */ Rb()()), Lf.exports;
}
var an = /* @__PURE__ */ Ub();
const E = /* @__PURE__ */ qv(an);
E.shape({
  event: E.string,
  action: E.string,
  name: E.string,
  region: E.string,
  section: E.string,
  component: E.string,
  type: E.string,
  text: E.string
});
const Mt = ({
  event: l = "",
  action: o = "",
  name: c = "",
  type: s = "",
  section: u = "",
  text: d = "",
  region: h = "",
  component: p = ""
}) => {
  const { dataLayer: y } = window, O = {
    event: l.toLowerCase(),
    action: o.toLowerCase(),
    name: c.toLowerCase(),
    type: s.toLowerCase(),
    region: h.toLowerCase(),
    section: u.toLowerCase(),
    text: d.toLowerCase(),
    component: p.toLowerCase()
  };
  y && y.push(O);
}, pr = ({ children: l }) => /* @__PURE__ */ b.jsx(b.Fragment, { children: l });
pr.propTypes = {
  children: E.oneOfType([
    E.arrayOf(E.node),
    E.node,
    E.string
  ])
};
var Hf = { exports: {} };
var tA;
function Hb() {
  return tA || (tA = 1, (function(l) {
    (function() {
      var o = {}.hasOwnProperty;
      function c() {
        for (var d = "", h = 0; h < arguments.length; h++) {
          var p = arguments[h];
          p && (d = u(d, s(p)));
        }
        return d;
      }
      function s(d) {
        if (typeof d == "string" || typeof d == "number")
          return d;
        if (typeof d != "object")
          return "";
        if (Array.isArray(d))
          return c.apply(null, d);
        if (d.toString !== Object.prototype.toString && !d.toString.toString().includes("[native code]"))
          return d.toString();
        var h = "";
        for (var p in d)
          o.call(d, p) && d[p] && (h = u(h, p));
        return h;
      }
      function u(d, h) {
        return h ? d ? d + " " + h : d + h : d;
      }
      l.exports ? (c.default = c, l.exports = c) : window.classNames = c;
    })();
  })(Hf)), Hf.exports;
}
Hb();
({
  ...pr.propTypes
});
const r0 = ({ children: l, className: o = "container", ...c }) => /* @__PURE__ */ b.jsx("div", { className: o, ...c, children: /* @__PURE__ */ b.jsx("div", { className: "row", children: l }) });
r0.propTypes = {
  children: pr.propTypes.children
};
({
  ...r0.propTypes
});
pr.propTypes.children, E.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
pr.propTypes.children;
function c0({
  packageName: l = "",
  component: o = "",
  type: c = "",
  configuration: s = {}
}) {
  if (!l || !o) {
    console.error("trackReactComponent: Missing required arguments.");
    return;
  }
  window.uds = window.uds || {}, window.uds.package = window.uds.package || {}, window.uds.package[l] = {
    component: o,
    type: c,
    configuration: s
  };
}
const eA = {
  alt: E.string,
  title: E.string,
  src: E.string,
  mobileSrc: E.string,
  brandLink: E.string
}, Fc = {
  baseUrl: E.string,
  parentOrg: E.string,
  parentOrgUrl: E.string,
  animate: E.bool
}, Xc = {
  loggedIn: E.bool,
  loginLink: E.string,
  logoutLink: E.string,
  userName: E.string
}, iu = {
  text: E.string.isRequired,
  color: E.oneOf(["gold", "maroon", "light", "dark"]),
  href: E.string,
  classes: E.string,
  onClick: E.func,
  onFocus: E.func
}, $f = E.shape({
  id: E.number,
  href: E.string,
  text: E.string,
  type: E.string,
  selected: E.bool,
  items: E.arrayOf(E.arrayOf(E.object)),
  buttons: E.arrayOf(E.shape(iu)),
  class: E.string
}), u0 = {
  isPartner: E.bool,
  navTree: E.arrayOf($f),
  partnerLogo: E.shape(eA),
  logo: E.shape(eA),
  title: E.string,
  parentOrg: Fc.parentOrg,
  parentOrgUrl: Fc.parentOrgUrl,
  baseUrl: Fc.baseUrl,
  loggedIn: Xc.loggedIn,
  userName: Xc.userName,
  loginLink: Xc.loginLink,
  onLoginClick: E.func,
  logoutLink: Xc.logoutLink,
  onLogoutClick: E.func,
  buttons: E.arrayOf(E.shape(iu)),
  breakpoint: E.oneOf(["Lg", "Xl"]),
  animateTitle: E.bool,
  expandOnHover: E.bool,
  mobileNavTree: E.arrayOf($f),
  hasNavigation: E.bool,
  searchUrl: E.string,
  site: E.string,
  renderDiv: E.oneOf(["true", "false"])
}, jb = {
  ...u0,
  headerTop: E.number,
  headerHeight: E.number,
  itemOpened: E.number,
  setItemOpened: E.func,
  mobileMenuOpen: E.bool,
  setMobileMenuOpen: E.func,
  singlePageAppReset: E.func
};
function Xb(l) {
  var o = /* @__PURE__ */ Object.create(null);
  return function(c) {
    return o[c] === void 0 && (o[c] = l(c)), o[c];
  };
}
var Qb = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Vb = /* @__PURE__ */ Xb(
  function(l) {
    return Qb.test(l) || l.charCodeAt(0) === 111 && l.charCodeAt(1) === 110 && l.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Jt = "-ms-", ur = "-moz-", Ht = "-webkit-", s0 = "comm", ou = "rule", Md = "decl", Yb = "@import", Gb = "@namespace", f0 = "@keyframes", Ib = "@layer", d0 = Math.abs, zd = String.fromCharCode, td = Object.assign;
function Fb(l, o) {
  return Ae(l, 0) ^ 45 ? (((o << 2 ^ Ae(l, 0)) << 2 ^ Ae(l, 1)) << 2 ^ Ae(l, 2)) << 2 ^ Ae(l, 3) : 0;
}
function m0(l) {
  return l.trim();
}
function pa(l, o) {
  return (l = o.exec(l)) ? l[0] : l;
}
function At(l, o, c) {
  return l.replace(o, c);
}
function kc(l, o, c) {
  return l.indexOf(o, c);
}
function Ae(l, o) {
  return l.charCodeAt(o) | 0;
}
function Gl(l, o, c) {
  return l.slice(o, c);
}
function Nn(l) {
  return l.length;
}
function h0(l) {
  return l.length;
}
function or(l, o) {
  return o.push(l), l;
}
function kb(l, o) {
  return l.map(o).join("");
}
function nA(l, o) {
  return l.filter(function(c) {
    return !pa(c, o);
  });
}
var ru = 1, Fi = 1, g0 = 0, bn = 0, he = 0, Ki = "";
function cu(l, o, c, s, u, d, h, p) {
  return { value: l, root: o, parent: c, type: s, props: u, children: d, line: ru, column: Fi, length: h, return: "", siblings: p };
}
function al(l, o) {
  return td(cu("", null, null, "", null, null, 0, l.siblings), l, { length: -l.length }, o);
}
function ji(l) {
  for (; l.root; )
    l = al(l.root, { children: [l] });
  or(l, l.siblings);
}
function qb() {
  return he;
}
function Kb() {
  return he = bn > 0 ? Ae(Ki, --bn) : 0, Fi--, he === 10 && (Fi = 1, ru--), he;
}
function wn() {
  return he = bn < g0 ? Ae(Ki, bn++) : 0, Fi++, he === 10 && (Fi = 1, ru++), he;
}
function ol() {
  return Ae(Ki, bn);
}
function qc() {
  return bn;
}
function uu(l, o) {
  return Gl(Ki, l, o);
}
function mr(l) {
  switch (l) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Zb(l) {
  return ru = Fi = 1, g0 = Nn(Ki = l), bn = 0, [];
}
function Pb(l) {
  return Ki = "", l;
}
function jf(l) {
  return m0(uu(bn - 1, ed(l === 91 ? l + 2 : l === 40 ? l + 1 : l)));
}
function Wb(l) {
  for (; (he = ol()) && he < 33; )
    wn();
  return mr(l) > 2 || mr(he) > 3 ? "" : " ";
}
function Jb(l, o) {
  for (; --o && wn() && !(he < 48 || he > 102 || he > 57 && he < 65 || he > 70 && he < 97); )
    ;
  return uu(l, qc() + (o < 6 && ol() == 32 && wn() == 32));
}
function ed(l) {
  for (; wn(); )
    switch (he) {
      // ] ) " '
      case l:
        return bn;
      // " '
      case 34:
      case 39:
        l !== 34 && l !== 39 && ed(he);
        break;
      // (
      case 40:
        l === 41 && ed(l);
        break;
      // \
      case 92:
        wn();
        break;
    }
  return bn;
}
function _b(l, o) {
  for (; wn() && l + he !== 57; )
    if (l + he === 84 && ol() === 47)
      break;
  return "/*" + uu(o, bn - 1) + "*" + zd(l === 47 ? l : wn());
}
function $b(l) {
  for (; !mr(ol()); )
    wn();
  return uu(l, bn);
}
function tS(l) {
  return Pb(Kc("", null, null, null, [""], l = Zb(l), 0, [0], l));
}
function Kc(l, o, c, s, u, d, h, p, y) {
  for (var O = 0, M = 0, w = h, x = 0, $ = 0, j = 0, q = 1, I = 1, K = 1, H = 0, et = "", nt = u, V = d, P = s, G = et; I; )
    switch (j = H, H = wn()) {
      // (
      case 40:
        if (j != 108 && Ae(G, w - 1) == 58) {
          kc(G += At(jf(H), "&", "&\f"), "&\f", d0(O ? p[O - 1] : 0)) != -1 && (K = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        G += jf(H);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        G += Wb(j);
        break;
      // \
      case 92:
        G += Jb(qc() - 1, 7);
        continue;
      // /
      case 47:
        switch (ol()) {
          case 42:
          case 47:
            or(eS(_b(wn(), qc()), o, c, y), y), (mr(j || 1) == 5 || mr(ol() || 1) == 5) && Nn(G) && Gl(G, -1, void 0) !== " " && (G += " ");
            break;
          default:
            G += "/";
        }
        break;
      // {
      case 123 * q:
        p[O++] = Nn(G) * K;
      // } ; \0
      case 125 * q:
      case 59:
      case 0:
        switch (H) {
          // \0 }
          case 0:
          case 125:
            I = 0;
          // ;
          case 59 + M:
            K == -1 && (G = At(G, /\f/g, "")), $ > 0 && (Nn(G) - w || q === 0 && j === 47) && or($ > 32 ? lA(G + ";", s, c, w - 1, y) : lA(At(G, " ", "") + ";", s, c, w - 2, y), y);
            break;
          // @ ;
          case 59:
            G += ";";
          // { rule/at-rule
          default:
            if (or(P = aA(G, o, c, O, M, u, p, et, nt = [], V = [], w, d), d), H === 123)
              if (M === 0)
                Kc(G, o, P, P, nt, d, w, p, V);
              else {
                switch (x) {
                  // c(ontainer)
                  case 99:
                    if (Ae(G, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (Ae(G, 2) === 97) break;
                  default:
                    M = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                M ? Kc(l, P, P, s && or(aA(l, P, P, 0, 0, u, p, et, u, nt = [], w, V), V), u, V, w, p, s ? nt : V) : Kc(G, P, P, P, [""], V, 0, p, V);
              }
        }
        O = M = $ = 0, q = K = 1, et = G = "", w = h;
        break;
      // :
      case 58:
        w = 1 + Nn(G), $ = j;
      default:
        if (q < 1) {
          if (H == 123)
            --q;
          else if (H == 125 && q++ == 0 && Kb() == 125)
            continue;
        }
        switch (G += zd(H), H * q) {
          // &
          case 38:
            K = M > 0 ? 1 : (G += "\f", -1);
            break;
          // ,
          case 44:
            p[O++] = (Nn(G) - 1) * K, K = 1;
            break;
          // @
          case 64:
            ol() === 45 && (G += jf(wn())), x = ol(), M = w = Nn(et = G += $b(qc())), H++;
            break;
          // -
          case 45:
            j === 45 && Nn(G) == 2 && (q = 0);
        }
    }
  return d;
}
function aA(l, o, c, s, u, d, h, p, y, O, M, w) {
  for (var x = u - 1, $ = u === 0 ? d : [""], j = h0($), q = 0, I = 0, K = 0; q < s; ++q)
    for (var H = 0, et = Gl(l, x + 1, x = d0(I = h[q])), nt = l; H < j; ++H)
      (nt = m0(I > 0 ? $[H] + " " + et : At(et, /&\f/g, $[H]))) && (y[K++] = nt);
  return cu(l, o, c, u === 0 ? ou : p, y, O, M, w);
}
function eS(l, o, c, s) {
  return cu(l, o, c, s0, zd(qb()), Gl(l, 2, -2), 0, s);
}
function lA(l, o, c, s, u) {
  return cu(l, o, c, Md, Gl(l, 0, s), Gl(l, s + 1, -1), s, u);
}
function p0(l, o, c) {
  switch (Fb(l, o)) {
    // color-adjust
    case 5103:
      return Ht + "print-" + l + l;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return Ht + l + l;
    // mask-composite
    case 4855:
      return Ht + l.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + l;
    // tab-size
    case 4789:
      return ur + l + l;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ht + l + ur + l + Jt + l + l;
    // writing-mode
    case 5936:
      switch (Ae(l, o + 11)) {
        // vertical-l(r)
        case 114:
          return Ht + l + Jt + At(l, /[svh]\w+-[tblr]{2}/, "tb") + l;
        // vertical-r(l)
        case 108:
          return Ht + l + Jt + At(l, /[svh]\w+-[tblr]{2}/, "tb-rl") + l;
        // horizontal(-)tb
        case 45:
          return Ht + l + Jt + At(l, /[svh]\w+-[tblr]{2}/, "lr") + l;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return Ht + l + Jt + l + l;
    // order
    case 6165:
      return Ht + l + Jt + "flex-" + l + l;
    // align-items
    case 5187:
      return Ht + l + At(l, /(\w+).+(:[^]+)/, Ht + "box-$1$2" + Jt + "flex-$1$2") + l;
    // align-self
    case 5443:
      return Ht + l + Jt + "flex-item-" + At(l, /flex-|-self/g, "") + (pa(l, /flex-|baseline/) ? "" : Jt + "grid-row-" + At(l, /flex-|-self/g, "")) + l;
    // align-content
    case 4675:
      return Ht + l + Jt + "flex-line-pack" + At(l, /align-content|flex-|-self/g, "") + l;
    // flex-shrink
    case 5548:
      return Ht + l + Jt + At(l, "shrink", "negative") + l;
    // flex-basis
    case 5292:
      return Ht + l + Jt + At(l, "basis", "preferred-size") + l;
    // flex-grow
    case 6060:
      return Ht + "box-" + At(l, "-grow", "") + Ht + l + Jt + At(l, "grow", "positive") + l;
    // transition
    case 4554:
      return Ht + At(l, /([^-])(transform)/g, "$1" + Ht + "$2") + l;
    // cursor
    case 6187:
      return At(At(At(l, /(zoom-|grab)/, Ht + "$1"), /(image-set)/, Ht + "$1"), l, "") + l;
    // background, background-image
    case 5495:
    case 3959:
      return At(l, /(image-set\([^]*)/, Ht + "$1$`$1");
    // justify-content
    case 4968:
      return At(At(l, /(.+:)(flex-)?(.*)/, Ht + "box-pack:$3" + Jt + "flex-pack:$3"), /space-between/, "justify") + Ht + l + l;
    // justify-self
    case 4200:
      if (!pa(l, /flex-|baseline/)) return Jt + "grid-column-align" + Gl(l, o) + l;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return Jt + At(l, "template-", "") + l;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return c && c.some(function(s, u) {
        return o = u, pa(s.props, /grid-\w+-end/);
      }) ? ~kc(l + (c = c[o].value), "span", 0) ? l : Jt + At(l, "-start", "") + l + Jt + "grid-row-span:" + (~kc(c, "span", 0) ? pa(c, /\d+/) : +pa(c, /\d+/) - +pa(l, /\d+/)) + ";" : Jt + At(l, "-start", "") + l;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return c && c.some(function(s) {
        return pa(s.props, /grid-\w+-start/);
      }) ? l : Jt + At(At(l, "-end", "-span"), "span ", "") + l;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return At(l, /(.+)-inline(.+)/, Ht + "$1$2") + l;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Nn(l) - 1 - o > 6)
        switch (Ae(l, o + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (Ae(l, o + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return At(l, /(.+:)(.+)-([^]+)/, "$1" + Ht + "$2-$3$1" + ur + (Ae(l, o + 3) == 108 ? "$3" : "$2-$3")) + l;
          // (s)tretch
          case 115:
            return ~kc(l, "stretch", 0) ? p0(At(l, "stretch", "fill-available"), o, c) + l : l;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return At(l, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(s, u, d, h, p, y, O) {
        return Jt + u + ":" + d + O + (h ? Jt + u + "-span:" + (p ? y : +y - +d) + O : "") + l;
      });
    // position: sticky
    case 4949:
      if (Ae(l, o + 6) === 121)
        return At(l, ":", ":" + Ht) + l;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (Ae(l, Ae(l, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return At(l, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Ht + (Ae(l, 14) === 45 ? "inline-" : "") + "box$3$1" + Ht + "$2$3$1" + Jt + "$2box$3") + l;
        // (inline-)?gri(d)
        case 100:
          return At(l, ":", ":" + Jt) + l;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return At(l, "scroll-", "scroll-snap-") + l;
  }
  return l;
}
function tu(l, o) {
  for (var c = "", s = 0; s < l.length; s++)
    c += o(l[s], s, l, o) || "";
  return c;
}
function nS(l, o, c, s) {
  switch (l.type) {
    case Ib:
      if (l.children.length) break;
    case Yb:
    case Gb:
    case Md:
      return l.return = l.return || l.value;
    case s0:
      return "";
    case f0:
      return l.return = l.value + "{" + tu(l.children, s) + "}";
    case ou:
      if (!Nn(l.value = l.props.join(","))) return "";
  }
  return Nn(c = tu(l.children, s)) ? l.return = l.value + "{" + c + "}" : "";
}
function aS(l) {
  var o = h0(l);
  return function(c, s, u, d) {
    for (var h = "", p = 0; p < o; p++)
      h += l[p](c, s, u, d) || "";
    return h;
  };
}
function lS(l) {
  return function(o) {
    o.root || (o = o.return) && l(o);
  };
}
function iS(l, o, c, s) {
  if (l.length > -1 && !l.return)
    switch (l.type) {
      case Md:
        l.return = p0(l.value, l.length, c);
        return;
      case f0:
        return tu([al(l, { value: At(l.value, "@", "@" + Ht) })], s);
      case ou:
        if (l.length)
          return kb(c = l.props, function(u) {
            switch (pa(u, s = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                ji(al(l, { props: [At(u, /:(read-\w+)/, ":" + ur + "$1")] })), ji(al(l, { props: [u] })), td(l, { props: nA(c, s) });
                break;
              // :placeholder
              case "::placeholder":
                ji(al(l, { props: [At(u, /:(plac\w+)/, ":" + Ht + "input-$1")] })), ji(al(l, { props: [At(u, /:(plac\w+)/, ":" + ur + "$1")] })), ji(al(l, { props: [At(u, /:(plac\w+)/, Jt + "input-$1")] })), ji(al(l, { props: [u] })), td(l, { props: nA(c, s) });
                break;
            }
            return "";
          });
    }
}
var jt = { env: { NODE_ENV: "production" } }, Xf, Qf;
const Il = typeof jt < "u" && jt.env !== void 0 && (jt.env.REACT_APP_SC_ATTR || jt.env.SC_ATTR) || "data-styled", A0 = "active", y0 = "data-styled-version", su = "6.4.2", Ld = `/*!sc*/
`, sr = typeof window < "u" && typeof document < "u";
function iA(l) {
  if (typeof jt < "u" && jt.env !== void 0) {
    const o = jt.env[l];
    if (o !== void 0 && o !== "") return o !== "false";
  }
}
const oS = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : (Qf = (Xf = iA("REACT_APP_SC_DISABLE_SPEEDY")) !== null && Xf !== void 0 ? Xf : iA("SC_DISABLE_SPEEDY")) !== null && Qf !== void 0 ? Qf : typeof jt < "u" && jt.env !== void 0 && jt.env.NODE_ENV !== "production"), rS = "sc-keyframes-", cS = {}, uS = jt.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?

`, 18: `Accessing \`useTheme\` hook outside of a \`<ThemeProvider>\` element.

\`\`\`jsx
import { useTheme } from 'styled-components';
export function StyledCompoent({ children }) {
  const theme = useTheme();
  return <div style={{ width: theme.sizes.full }}>{children}</div>;
}

import { StyledComponent } from './StyledComponent';
import { theme } from './theme';
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <StyledComponent />
    </ThemeProvider>
  );
}
\`\`\`

If you need access to the theme in an uncertain composition scenario, \`React.useContext(ThemeContext)\` will not emit an error if there is no \`ThemeProvider\` ancestor.
` } : {};
function Ar(l, ...o) {
  return jt.env.NODE_ENV === "production" ? new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${l} for more information.${o.length > 0 ? ` Args: ${o.join(", ")}` : ""}`) : new Error((function(...c) {
    let s = c[0];
    const u = [];
    for (let d = 1, h = c.length; d < h; d += 1) u.push(c[d]);
    return u.forEach((d) => {
      s = s.replace(/%[a-z]/, d);
    }), s;
  })(uS[l], ...o).trim());
}
const sS = 1 << 30;
let Zc = /* @__PURE__ */ new Map(), eu = /* @__PURE__ */ new Map(), Pc = 1;
const Qc = (l) => {
  if (Zc.has(l)) return Zc.get(l);
  for (; eu.has(Pc); ) Pc++;
  const o = Pc++;
  if (jt.env.NODE_ENV !== "production" && ((0 | o) < 0 || o > sS)) throw Ar(16, `${o}`);
  return Zc.set(l, o), eu.set(o, l), o;
}, fS = (l) => eu.get(l), dS = (l, o) => {
  Pc = o + 1, Zc.set(l, o), eu.set(o, l);
}, oA = /invalid hook call/i, Vc = /* @__PURE__ */ new Set(), v0 = (l, o) => {
  if (jt.env.NODE_ENV !== "production") {
    const c = `The component ${l}${o ? ` with the id of "${o}"` : ""} has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, s = console.error;
    try {
      let u = !0;
      console.error = (d, ...h) => {
        oA.test(d) ? (u = !1, Vc.delete(c)) : s(d, ...h);
      }, typeof ee.useState == "function" && ee.useState(null), u && !Vc.has(c) && (console.warn(c), Vc.add(c));
    } catch (u) {
      oA.test(u.message) && Vc.delete(c);
    } finally {
      console.error = s;
    }
  }
}, Rd = Object.freeze([]), ki = Object.freeze({});
function b0(l, o, c = ki) {
  return l.theme !== c.theme && l.theme || o || c.theme;
}
const mS = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, hS = /(^-|-$)/g;
function S0(l) {
  return l.replace(mS, "-").replace(hS, "");
}
const gS = /(a)(d)/gi, rA = (l) => String.fromCharCode(l + (l > 25 ? 39 : 97));
function O0(l) {
  let o, c = "";
  for (o = Math.abs(l); o > 52; o = o / 52 | 0) c = rA(o % 52) + c;
  return (rA(o % 52) + c).replace(gS, "$1-$2");
}
const nd = 5381, Vl = (l, o) => {
  let c = o.length;
  for (; c; ) l = 33 * l ^ o.charCodeAt(--c);
  return l;
}, E0 = (l) => Vl(nd, l);
function T0(l) {
  return O0(E0(l) >>> 0);
}
function Ud(l) {
  return jt.env.NODE_ENV !== "production" && typeof l == "string" && l || l.displayName || l.name || "Component";
}
function Wc(l) {
  return typeof l == "string" && (jt.env.NODE_ENV === "production" || l.charAt(0) === l.charAt(0).toLowerCase());
}
function pS(l) {
  return Wc(l) ? `styled.${l}` : `Styled(${Ud(l)})`;
}
const x0 = Symbol.for("react.memo"), AS = Symbol.for("react.forward_ref"), yS = { contextType: !0, defaultProps: !0, displayName: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, propTypes: !0, type: !0 }, vS = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, C0 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, bS = { [AS]: { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, [x0]: C0 };
function cA(l) {
  return ("type" in (o = l) && o.type.$$typeof) === x0 ? C0 : "$$typeof" in l ? bS[l.$$typeof] : yS;
  var o;
}
const SS = Object.defineProperty, OS = Object.getOwnPropertyNames, ES = Object.getOwnPropertySymbols, TS = Object.getOwnPropertyDescriptor, xS = Object.getPrototypeOf, CS = Object.prototype;
function N0(l, o, c) {
  if (typeof o != "string") {
    const s = xS(o);
    s && s !== CS && N0(l, s, c);
    const u = OS(o).concat(ES(o)), d = cA(l), h = cA(o);
    for (let p = 0; p < u.length; ++p) {
      const y = u[p];
      if (!(y in vS || c && c[y] || h && y in h || d && y in d)) {
        const O = TS(o, y);
        try {
          SS(l, y, O);
        } catch {
        }
      }
    }
  }
  return l;
}
function yr(l) {
  return typeof l == "function";
}
const NS = Symbol.for("react.forward_ref");
function Hd(l) {
  return l != null && (typeof l == "object" || typeof l == "function") && l.$$typeof === NS && "styledComponentId" in l;
}
function rr(l, o) {
  return l && o ? l + " " + o : l || o || "";
}
function ad(l, o) {
  return l.join("");
}
function Fl(l) {
  return l !== null && typeof l == "object" && l.constructor.name === Object.name && !("props" in l && l.$$typeof);
}
function ld(l, o, c = !1) {
  if (!c && !Fl(l) && !Array.isArray(l)) return o;
  if (Array.isArray(o)) for (let s = 0; s < o.length; s++) l[s] = ld(l[s], o[s]);
  else if (Fl(o)) for (const s in o) l[s] = ld(l[s], o[s]);
  return l;
}
function w0(l, o) {
  Object.defineProperty(l, "toString", { value: o });
}
const wS = class {
  constructor(l) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = l, this._cGroup = 0, this._cIndex = 0;
  }
  indexOfGroup(l) {
    if (l === this._cGroup) return this._cIndex;
    let o = this._cIndex;
    if (l > this._cGroup) for (let c = this._cGroup; c < l; c++) o += this.groupSizes[c];
    else for (let c = this._cGroup - 1; c >= l; c--) o -= this.groupSizes[c];
    return this._cGroup = l, this._cIndex = o, o;
  }
  insertRules(l, o) {
    if (l >= this.groupSizes.length) {
      const u = this.groupSizes, d = u.length;
      let h = d;
      for (; l >= h; ) if (h <<= 1, h < 0) throw Ar(16, `${l}`);
      this.groupSizes = new Uint32Array(h), this.groupSizes.set(u), this.length = h;
      for (let p = d; p < h; p++) this.groupSizes[p] = 0;
    }
    let c = this.indexOfGroup(l + 1), s = 0;
    for (let u = 0, d = o.length; u < d; u++) this.tag.insertRule(c, o[u]) && (this.groupSizes[l]++, c++, s++);
    s > 0 && this._cGroup > l && (this._cIndex += s);
  }
  clearGroup(l) {
    if (l < this.length) {
      const o = this.groupSizes[l], c = this.indexOfGroup(l), s = c + o;
      this.groupSizes[l] = 0;
      for (let u = c; u < s; u++) this.tag.deleteRule(c);
      o > 0 && this._cGroup > l && (this._cIndex -= o);
    }
  }
  getGroup(l) {
    let o = "";
    if (l >= this.length || this.groupSizes[l] === 0) return o;
    const c = this.groupSizes[l], s = this.indexOfGroup(l), u = s + c;
    for (let d = s; d < u; d++) o += this.tag.getRule(d) + Ld;
    return o;
  }
}, DS = `style[${Il}][${y0}="${su}"]`, BS = new RegExp(`^${Il}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), uA = (l) => typeof ShadowRoot < "u" && l instanceof ShadowRoot || "host" in l && l.nodeType === 11, id = (l) => {
  if (!l) return document;
  if (uA(l)) return l;
  if ("getRootNode" in l) {
    const o = l.getRootNode();
    if (uA(o)) return o;
  }
  return document;
}, MS = (l, o, c) => {
  const s = c.split(",");
  let u;
  for (let d = 0, h = s.length; d < h; d++) (u = s[d]) && l.registerName(o, u);
}, zS = (l, o) => {
  var c;
  const s = ((c = o.textContent) !== null && c !== void 0 ? c : "").split(Ld), u = [];
  for (let d = 0, h = s.length; d < h; d++) {
    const p = s[d].trim();
    if (!p) continue;
    const y = p.match(BS);
    if (y) {
      const O = 0 | parseInt(y[1], 10), M = y[2];
      O !== 0 && (dS(M, O), MS(l, M, y[3]), l.getTag().insertRules(O, u)), u.length = 0;
    } else u.push(p);
  }
}, Vf = (l) => {
  const o = id(l.options.target).querySelectorAll(DS);
  for (let c = 0, s = o.length; c < s; c++) {
    const u = o[c];
    u && u.getAttribute(Il) !== A0 && (zS(l, u), u.parentNode && u.parentNode.removeChild(u));
  }
};
let nr = !1;
function LS() {
  if (nr !== !1) return nr;
  if (typeof document < "u") {
    const l = document.head.querySelector('meta[property="csp-nonce"]');
    if (l) return nr = l.nonce || l.getAttribute("content") || void 0;
    const o = document.head.querySelector('meta[name="sc-nonce"]');
    if (o) return nr = o.getAttribute("content") || void 0;
  }
  return nr = typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}
const D0 = (l, o) => {
  const c = document.head, s = l || c, u = document.createElement("style"), d = ((y) => {
    const O = Array.from(y.querySelectorAll(`style[${Il}]`));
    return O[O.length - 1];
  })(s), h = d !== void 0 ? d.nextSibling : null;
  u.setAttribute(Il, A0), u.setAttribute(y0, su);
  const p = o || LS();
  return p && u.setAttribute("nonce", p), s.insertBefore(u, h), u;
}, RS = class {
  constructor(l, o) {
    this.element = D0(l, o), this.element.appendChild(document.createTextNode("")), this.sheet = ((c) => {
      var s;
      if (c.sheet) return c.sheet;
      const u = (s = c.getRootNode().styleSheets) !== null && s !== void 0 ? s : document.styleSheets;
      for (let d = 0, h = u.length; d < h; d++) {
        const p = u[d];
        if (p.ownerNode === c) return p;
      }
      throw Ar(17);
    })(this.element), this.length = 0;
  }
  insertRule(l, o) {
    try {
      return this.sheet.insertRule(o, l), this.length++, !0;
    } catch {
      return !1;
    }
  }
  deleteRule(l) {
    this.sheet.deleteRule(l), this.length--;
  }
  getRule(l) {
    const o = this.sheet.cssRules[l];
    return o && o.cssText ? o.cssText : "";
  }
}, US = class {
  constructor(l, o) {
    this.element = D0(l, o), this.nodes = this.element.childNodes, this.length = 0;
  }
  insertRule(l, o) {
    if (l <= this.length && l >= 0) {
      const c = document.createTextNode(o);
      return this.element.insertBefore(c, this.nodes[l] || null), this.length++, !0;
    }
    return !1;
  }
  deleteRule(l) {
    this.element.removeChild(this.nodes[l]), this.length--;
  }
  getRule(l) {
    return l < this.length ? this.nodes[l].textContent : "";
  }
};
let sA = sr;
const HS = { isServer: !sr, useCSSOMInjection: !oS };
class vr {
  static registerId(o) {
    return Qc(o);
  }
  constructor(o = ki, c = {}, s) {
    this.options = Object.assign(Object.assign({}, HS), o), this.gs = c, this.keyframeIds = /* @__PURE__ */ new Set(), this.names = new Map(s), this.server = !!o.isServer, !this.server && sr && sA && (sA = !1, Vf(this)), w0(this, () => ((u) => {
      const d = u.getTag(), { length: h } = d;
      let p = "";
      for (let y = 0; y < h; y++) {
        const O = fS(y);
        if (O === void 0) continue;
        const M = u.names.get(O);
        if (M === void 0 || !M.size) continue;
        const w = d.getGroup(y);
        if (w.length === 0) continue;
        const x = Il + ".g" + y + '[id="' + O + '"]';
        let $ = "";
        for (const j of M) j.length > 0 && ($ += j + ",");
        p += w + x + '{content:"' + $ + '"}' + Ld;
      }
      return p;
    })(this));
  }
  rehydrate() {
    !this.server && sr && Vf(this);
  }
  reconstructWithOptions(o, c = !0) {
    const s = new vr(Object.assign(Object.assign({}, this.options), o), this.gs, c && this.names || void 0);
    return s.keyframeIds = new Set(this.keyframeIds), !this.server && sr && o.target !== this.options.target && id(this.options.target) !== id(o.target) && Vf(s), s;
  }
  allocateGSInstance(o) {
    return this.gs[o] = (this.gs[o] || 0) + 1;
  }
  getTag() {
    return this.tag || (this.tag = (o = (({ useCSSOMInjection: c, target: s, nonce: u }) => c ? new RS(s, u) : new US(s, u))(this.options), new wS(o)));
    var o;
  }
  hasNameForId(o, c) {
    var s, u;
    return (u = (s = this.names.get(o)) === null || s === void 0 ? void 0 : s.has(c)) !== null && u !== void 0 && u;
  }
  registerName(o, c) {
    Qc(o), o.startsWith(rS) && this.keyframeIds.add(o);
    const s = this.names.get(o);
    s ? s.add(c) : this.names.set(o, /* @__PURE__ */ new Set([c]));
  }
  insertRules(o, c, s) {
    this.registerName(o, c), this.getTag().insertRules(Qc(o), s);
  }
  clearNames(o) {
    this.names.has(o) && this.names.get(o).clear();
  }
  clearRules(o) {
    this.getTag().clearGroup(Qc(o)), this.clearNames(o);
  }
  clearTag() {
    this.tag = void 0;
  }
}
const B0 = /* @__PURE__ */ new WeakSet(), jS = { animationIterationCount: 1, aspectRatio: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexShrink: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, scale: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
function XS(l, o) {
  return o == null || typeof o == "boolean" || o === "" ? "" : typeof o != "number" || o === 0 || l in jS || l.startsWith("--") ? String(o).trim() : o + "px";
}
const Xl = 47;
function fA(l) {
  if (l.charCodeAt(0) === 45 && l.charCodeAt(1) === 45) return l;
  let o = "";
  for (let c = 0; c < l.length; c++) {
    const s = l.charCodeAt(c);
    o += s >= 65 && s <= 90 ? "-" + String.fromCharCode(s + 32) : l[c];
  }
  return o.startsWith("ms-") ? "-" + o : o;
}
const QS = Symbol.for("sc-keyframes");
function od(l) {
  return typeof l == "object" && l !== null && QS in l;
}
function M0(l) {
  return yr(l) && !(l.prototype && l.prototype.isReactComponent);
}
const z0 = (l) => l == null || l === !1 || l === "", VS = Symbol.for("react.client.reference");
function dA(l) {
  return l.$$typeof === VS;
}
function mA(l) {
  const o = l.$$id, c = (o && o.includes("#") ? o.split("#").pop() : o) || l.name || "unknown";
  console.warn(`Interpolating a client component (${c}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function L0(l, o) {
  for (const c in l) {
    const s = l[c];
    l.hasOwnProperty(c) && !z0(s) && (Array.isArray(s) && B0.has(s) || yr(s) ? o.push(fA(c) + ":", s, ";") : Fl(s) ? (o.push(c + " {"), L0(s, o), o.push("}")) : o.push(fA(c) + ": " + XS(c, s) + ";"));
  }
}
function rl(l, o, c, s, u = []) {
  if (z0(l)) return u;
  const d = typeof l;
  if (d === "string") return u.push(l), u;
  if (d === "function") {
    if (dA(l)) return jt.env.NODE_ENV !== "production" && mA(l), u;
    if (M0(l) && o) {
      const h = l(o);
      return jt.env.NODE_ENV === "production" || typeof h != "object" || Array.isArray(h) || od(h) || Fl(h) || h === null || console.error(`${Ud(l)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), rl(h, o, c, s, u);
    }
    return u.push(l), u;
  }
  if (Array.isArray(l)) {
    for (let h = 0; h < l.length; h++) rl(l[h], o, c, s, u);
    return u;
  }
  return Hd(l) ? (u.push(`.${l.styledComponentId}`), u) : od(l) ? (c ? (l.inject(c, s), u.push(l.getName(s))) : u.push(l), u) : dA(l) ? (jt.env.NODE_ENV !== "production" && mA(l), u) : Fl(l) ? l.toString !== Object.prototype.toString ? (u.push(l.toString()), u) : (L0(l, u), u) : (u.push(l.toString()), u);
}
const YS = E0(su);
class GS {
  constructor(o, c, s) {
    this.rules = o, this.componentId = c, this.baseHash = Vl(YS, c), this.baseStyle = s, vr.registerId(c);
  }
  generateAndInjectStyles(o, c, s) {
    let u = this.baseStyle ? this.baseStyle.generateAndInjectStyles(o, c, s) : "";
    {
      let d = "";
      for (let h = 0; h < this.rules.length; h++) {
        const p = this.rules[h];
        if (typeof p == "string") d += p;
        else if (p) if (M0(p)) {
          const y = p(o);
          typeof y == "string" ? d += y : y != null && y !== !1 && (jt.env.NODE_ENV === "production" || typeof y != "object" || Array.isArray(y) || od(y) || Fl(y) || console.error(`${Ud(p)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), d += ad(rl(y, o, c, s)));
        } else d += ad(rl(p, o, c, s));
      }
      if (d) {
        this.dynamicNameCache || (this.dynamicNameCache = /* @__PURE__ */ new Map());
        const h = s.hash ? s.hash + d : d;
        let p = this.dynamicNameCache.get(h);
        if (!p) {
          if (p = O0(Vl(Vl(this.baseHash, s.hash), d) >>> 0), this.dynamicNameCache.size >= 200) {
            const y = this.dynamicNameCache.keys().next().value;
            y !== void 0 && this.dynamicNameCache.delete(y);
          }
          this.dynamicNameCache.set(h, p);
        }
        if (!c.hasNameForId(this.componentId, p)) {
          const y = s(d, "." + p, void 0, this.componentId);
          c.insertRules(this.componentId, p, y);
        }
        u = rr(u, p);
      }
    }
    return u;
  }
}
const IS = /&/g;
function R0(l, o) {
  let c = 0;
  for (; --o >= 0 && l.charCodeAt(o) === 92; ) c++;
  return !(1 & ~c);
}
function Yf(l) {
  const o = l.length;
  let c = "", s = 0, u = 0, d = 0, h = !1, p = !1;
  for (let y = 0; y < o; y++) {
    const O = l.charCodeAt(y);
    if (d !== 0 || h || O !== Xl || l.charCodeAt(y + 1) !== 42) if (h) O === 42 && l.charCodeAt(y + 1) === Xl && (h = !1, y++);
    else if (O !== 34 && O !== 39 || R0(l, y)) {
      if (d === 0) if (O === 123) u++;
      else if (O === 125) {
        if (u--, u < 0) {
          p = !0;
          let M = y + 1;
          for (; M < o; ) {
            const w = l.charCodeAt(M);
            if (w === 59 || w === 10) break;
            M++;
          }
          M < o && l.charCodeAt(M) === 59 && M++, u = 0, y = M - 1, s = M;
          continue;
        }
        u === 0 && (c += l.substring(s, y + 1), s = y + 1);
      } else O === 59 && u === 0 && (c += l.substring(s, y + 1), s = y + 1);
    } else d === 0 ? d = O : d === O && (d = 0);
    else h = !0, y++;
  }
  return p || u !== 0 || d !== 0 ? (s < o && u === 0 && d === 0 && (c += l.substring(s)), c) : l;
}
function U0(l, o) {
  const c = o + " ", s = "," + c;
  for (let u = 0; u < l.length; u++) {
    const d = l[u];
    if (d.type === "rule") {
      d.value = (c + d.value).replaceAll(",", s);
      const h = d.props, p = [];
      for (let y = 0; y < h.length; y++) p[y] = c + h[y];
      d.props = p;
    }
    Array.isArray(d.children) && d.type !== "@keyframes" && U0(d.children, o);
  }
  return l;
}
function FS({ options: l = ki, plugins: o = Rd } = ki) {
  let c, s, u;
  const d = (x, $, j) => j.startsWith(s) && j.endsWith(s) && j.replaceAll(s, "").length > 0 ? `.${c}` : x, h = o.slice();
  h.push((x) => {
    x.type === ou && x.value.includes("&") && (u || (u = new RegExp(`\\${s}\\b`, "g")), x.props[0] = x.props[0].replace(IS, s).replace(u, d));
  }), l.prefix && h.push(iS), h.push(nS);
  let p = [];
  const y = aS(h.concat(lS((x) => p.push(x)))), O = (x, $ = "", j = "", q = "&") => {
    c = q, s = $, u = void 0;
    const I = (function(H) {
      const et = H.indexOf("//") !== -1, nt = H.indexOf("}") !== -1;
      if (!et && !nt) return H;
      if (!et) return Yf(H);
      const V = H.length;
      let P = "", G = 0, W = 0, ct = 0, Tt = 0, yt = 0, zt = !1;
      for (; W < V; ) {
        const Ct = H.charCodeAt(W);
        if (Ct !== 34 && Ct !== 39 || R0(H, W)) if (ct === 0) if (Ct === Xl && W + 1 < V && H.charCodeAt(W + 1) === 42) {
          for (W += 2; W + 1 < V && (H.charCodeAt(W) !== 42 || H.charCodeAt(W + 1) !== Xl); ) W++;
          W += 2;
        } else if (Ct !== 40) if (Ct !== 41) if (Tt > 0) W++;
        else if (Ct === 42 && W + 1 < V && H.charCodeAt(W + 1) === Xl) P += H.substring(G, W), W += 2, G = W, zt = !0;
        else if (Ct === Xl && W + 1 < V && H.charCodeAt(W + 1) === Xl) {
          for (P += H.substring(G, W); W < V && H.charCodeAt(W) !== 10; ) W++;
          G = W, zt = !0;
        } else Ct === 123 ? yt++ : Ct === 125 && yt--, W++;
        else Tt > 0 && Tt--, W++;
        else Tt++, W++;
        else W++;
        else ct === 0 ? ct = Ct : ct === Ct && (ct = 0), W++;
      }
      return zt ? (G < V && (P += H.substring(G)), yt === 0 ? P : Yf(P)) : yt === 0 ? H : Yf(H);
    })(x);
    let K = tS(j || $ ? j + " " + $ + " { " + I + " }" : I);
    return l.namespace && (K = U0(K, l.namespace)), p = [], tu(K, y), p;
  }, M = l;
  let w = nd;
  for (let x = 0; x < o.length; x++) o[x].name || Ar(15), w = Vl(w, o[x].name);
  return M != null && M.namespace && (w = Vl(w, M.namespace)), M != null && M.prefix && (w = Vl(w, "p")), O.hash = w !== nd ? w.toString() : "", O;
}
const kS = new vr(), qS = FS(), H0 = ee.createContext({ shouldForwardProp: void 0, styleSheet: kS, stylis: qS, stylisPlugins: void 0 });
H0.Consumer;
function j0() {
  return ee.useContext(H0);
}
const jd = ee.createContext(void 0);
jd.Consumer;
const hA = Object.prototype.hasOwnProperty, Gf = {};
function KS(l, o) {
  const c = typeof l != "string" ? "sc" : S0(l);
  Gf[c] = (Gf[c] || 0) + 1;
  const s = c + "-" + T0(su + c + Gf[c]);
  return o ? o + "-" + s : s;
}
let If;
function ZS(l, o, c) {
  const s = Hd(l), u = l, d = !Wc(l), { attrs: h = Rd, componentId: p = KS(o.displayName, o.parentComponentId), displayName: y = pS(l) } = o, O = o.displayName && o.componentId ? S0(o.displayName) + "-" + o.componentId : o.componentId || p, M = s && u.attrs ? u.attrs.concat(h).filter(Boolean) : h;
  let { shouldForwardProp: w } = o;
  if (s && u.shouldForwardProp) {
    const q = u.shouldForwardProp;
    if (o.shouldForwardProp) {
      const I = o.shouldForwardProp;
      w = (K, H) => q(K, H) && I(K, H);
    } else w = q;
  }
  const x = new GS(c, O, s ? u.componentStyle : void 0);
  function $(q, I) {
    return (function(K, H, et) {
      const { attrs: nt, componentStyle: V, defaultProps: P, foldedComponentIds: G, styledComponentId: W, target: ct } = K, Tt = ee.useContext(jd), yt = j0(), zt = K.shouldForwardProp || yt.shouldForwardProp;
      jt.env.NODE_ENV !== "production" && ee.useDebugValue && ee.useDebugValue(W);
      const Ct = b0(H, Tt, P) || ki;
      let le, Nt;
      {
        const ut = ee.useRef(null), gt = ut.current;
        if (gt !== null && gt[1] === Ct && gt[2] === yt.styleSheet && gt[3] === yt.stylis && gt[7] === V && (function(ft, Bt, rt) {
          const lt = ft, wt = Bt;
          let ze = 0;
          for (const ye in wt) if (hA.call(wt, ye) && (ze++, lt[ye] !== wt[ye])) return !1;
          return ze === rt;
        })(gt[0], H, gt[4])) le = gt[5], Nt = gt[6];
        else {
          le = (function(Bt, rt, lt) {
            const wt = Object.assign(Object.assign({}, rt), { className: void 0, theme: lt }), ze = Bt.length > 1;
            for (let ye = 0; ye < Bt.length; ye++) {
              const Sn = Bt[ye], On = yr(Sn) ? Sn(ze ? Object.assign({}, wt) : wt) : Sn;
              for (const ve in On) ve === "className" ? wt.className = rr(wt.className, On[ve]) : ve === "style" ? wt.style = Object.assign(Object.assign({}, wt.style), On[ve]) : ve in rt && rt[ve] === void 0 || (wt[ve] = On[ve]);
            }
            return "className" in rt && typeof rt.className == "string" && (wt.className = rr(wt.className, rt.className)), wt;
          })(nt, H, Ct), Nt = (function(Bt, rt, lt, wt) {
            const ze = Bt.generateAndInjectStyles(rt, lt, wt);
            return jt.env.NODE_ENV !== "production" && ee.useDebugValue && ee.useDebugValue(ze), ze;
          })(V, le, yt.styleSheet, yt.stylis);
          let ft = 0;
          for (const Bt in H) hA.call(H, Bt) && ft++;
          ut.current = [H, Ct, yt.styleSheet, yt.stylis, ft, le, Nt, V];
        }
      }
      jt.env.NODE_ENV !== "production" && K.warnTooManyClasses && K.warnTooManyClasses(Nt);
      const Y = le.as || ct, X = (function(ut, gt, ft, Bt) {
        const rt = {};
        for (const lt in ut) ut[lt] === void 0 || lt[0] === "$" || lt === "as" || lt === "theme" && ut.theme === ft || (lt === "forwardedAs" ? rt.as = ut.forwardedAs : Bt && !Bt(lt, gt) || (rt[lt] = ut[lt], Bt || jt.env.NODE_ENV !== "development" || Vb(lt) || (If || (If = /* @__PURE__ */ new Set())).has(lt) || !Wc(gt) || gt.includes("-") || (If.add(lt), console.warn(`styled-components: it looks like an unknown prop "${lt}" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via \`<StyleSheetManager shouldForwardProp={...}>\` (connect an API like \`@emotion/is-prop-valid\`) or consider using transient props (\`$\` prefix for automatic filtering.)`))));
        return rt;
      })(le, Y, Ct, zt);
      let Z = rr(G, W);
      return Nt && (Z += " " + Nt), le.className && (Z += " " + le.className), X[Wc(Y) && Y.includes("-") ? "class" : "className"] = Z, et && (X.ref = et), e0(Y, X);
    })(j, q, I);
  }
  $.displayName = y;
  let j = ee.forwardRef($);
  return j.attrs = M, j.componentStyle = x, j.displayName = y, j.shouldForwardProp = w, j.foldedComponentIds = s ? rr(u.foldedComponentIds, u.styledComponentId) : "", j.styledComponentId = O, j.target = s ? u.target : l, Object.defineProperty(j, "defaultProps", { get() {
    return this._foldedDefaultProps;
  }, set(q) {
    this._foldedDefaultProps = s ? (function(I, ...K) {
      for (const H of K) ld(I, H, !0);
      return I;
    })({}, u.defaultProps, q) : q;
  } }), jt.env.NODE_ENV !== "production" && (v0(y, O), j.warnTooManyClasses = /* @__PURE__ */ ((q, I) => {
    let K = {}, H = !1;
    return (et) => {
      !H && (K[et] = !0, Object.keys(K).length >= 200) && (console.warn(`Over 200 classes were generated for component ${q}${I ? ` with the id of "${I}"` : ""}.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), H = !0, K = {});
    };
  })(y, O)), w0(j, () => `.${j.styledComponentId}`), d && N0(j, l, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), j;
}
var PS = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]);
function gA(l, o) {
  const c = [l[0]];
  for (let s = 0, u = o.length; s < u; s += 1) c.push(o[s], l[s + 1]);
  return c;
}
const pA = (l) => (B0.add(l), l);
function fu(l, ...o) {
  if (yr(l) || Fl(l)) return pA(rl(gA(Rd, [l, ...o])));
  const c = l;
  return o.length === 0 && c.length === 1 && typeof c[0] == "string" ? rl(c) : pA(rl(gA(c, o)));
}
function rd(l, o, c = ki) {
  if (!o) throw Ar(1, o);
  const s = (u, ...d) => l(o, c, fu(u, ...d));
  return s.attrs = (u) => rd(l, o, Object.assign(Object.assign({}, c), { attrs: Array.prototype.concat(c.attrs, u).filter(Boolean) })), s.withConfig = (u) => rd(l, o, Object.assign(Object.assign({}, c), u)), s;
}
const X0 = (l) => rd(ZS, l), He = X0;
PS.forEach((l) => {
  He[l] = X0(l);
});
class WS {
  constructor(o, c) {
    this.instanceRules = /* @__PURE__ */ new Map(), this.rules = o, this.componentId = c, this.isStatic = (function(s) {
      for (let u = 0; u < s.length; u += 1) {
        const d = s[u];
        if (yr(d) && !Hd(d)) return !1;
      }
      return !0;
    })(o), vr.registerId(this.componentId);
  }
  removeStyles(o, c) {
    this.instanceRules.delete(o), this.rebuildGroup(c);
  }
  renderStyles(o, c, s, u) {
    const d = this.componentId;
    if (this.isStatic) {
      if (s.hasNameForId(d, d + o)) this.instanceRules.has(o) || this.computeRules(o, c, s, u);
      else {
        const p = this.computeRules(o, c, s, u);
        s.insertRules(d, p.name, p.rules);
      }
      return;
    }
    const h = this.instanceRules.get(o);
    if (this.computeRules(o, c, s, u), !s.server && h) {
      const p = h.rules, y = this.instanceRules.get(o).rules;
      if (p.length === y.length) {
        let O = !0;
        for (let M = 0; M < p.length; M++) if (p[M] !== y[M]) {
          O = !1;
          break;
        }
        if (O) return;
      }
    }
    this.rebuildGroup(s);
  }
  computeRules(o, c, s, u) {
    const d = ad(rl(this.rules, c, s, u)), h = { name: this.componentId + o, rules: u(d, "") };
    return this.instanceRules.set(o, h), h;
  }
  rebuildGroup(o) {
    const c = this.componentId;
    o.clearRules(c);
    for (const s of this.instanceRules.values()) o.insertRules(c, s.name, s.rules);
  }
}
function JS(l, ...o) {
  const c = fu(l, ...o), s = `sc-global-${T0(JSON.stringify(c))}`, u = new WS(c, s);
  jt.env.NODE_ENV !== "production" && v0(s);
  const d = (p) => {
    const y = j0(), O = ee.useContext(jd);
    let M;
    {
      const w = ee.useRef(null);
      w.current === null && (w.current = y.styleSheet.allocateGSInstance(s)), M = w.current;
    }
    jt.env.NODE_ENV !== "production" && ee.Children.count(p.children) && console.warn(`The global style component ${s} was given child JSX. createGlobalStyle does not render children.`), jt.env.NODE_ENV !== "production" && c.some((w) => typeof w == "string" && w.indexOf("@import") !== -1) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), y.styleSheet.server && h(M, p, y.styleSheet, O, y.stylis);
    {
      const w = u.isStatic ? [M, y.styleSheet, u] : [M, p, y.styleSheet, O, y.stylis, u], x = ee.useRef(u);
      ee.useLayoutEffect(() => {
        y.styleSheet.server || (x.current !== u && (y.styleSheet.clearRules(s), x.current = u), h(M, p, y.styleSheet, O, y.stylis));
      }, w), ee.useLayoutEffect(() => () => {
        y.styleSheet.server || u.removeStyles(M, y.styleSheet);
      }, [M, y.styleSheet, u]);
    }
    return y.styleSheet.server && u.instanceRules.delete(M), null;
  };
  function h(p, y, O, M, w) {
    if (u.isStatic) u.renderStyles(p, cS, O, w);
    else {
      const x = Object.assign(Object.assign({}, y), { theme: b0(y, M, d.defaultProps) });
      u.renderStyles(p, x, O, w);
    }
  }
  return ee.memo(d);
}
jt.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://styled-components.com/docs/basics#react-native`);
const Yc = `__sc-${Il}__`;
jt.env.NODE_ENV !== "production" && jt.env.NODE_ENV !== "test" && typeof window < "u" && (window[Yc] || (window[Yc] = 0), window[Yc] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[Yc] += 1);
const Xd = "#8c1d40", Qd = "#ffc627", qn = "#ffffff", AA = "#000000", on = "#191919", Jc = "#BFBFBF", ln = "#d0d0d0", _S = "#e8e8e8", $S = "#bfbfbf", t3 = "#495057", e3 = He.a`
  font-family:
    Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
  color: ${on};
  padding: 0.5rem 1rem;
  border-radius: 400rem;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  transition: 0.03s ease-in-out;
  cursor: pointer;
  & + a {
    margin-left: 1rem;
  }
  &:hover {
    transform: scale(1.05);
  }
  &.button-light {
    background-color: ${$S} !important;
    color: ${AA} !important;
  }
  &.button-gold {
    background-color: ${Qd} !important;
    color: ${AA} !important;
  }
  &.button-dark {
    background-color: ${on} !important;
    color: ${qn} !important;
  }
  &.button-maroon {
    background-color: ${Xd} !important;
    color: ${qn} !important;
  }
`, Zi = ({
  href: l,
  color: o,
  text: c,
  classes: s,
  onClick: u,
  onKeyDown: d,
  onFocus: h,
  as: p,
  ...y
}) => /* @__PURE__ */ b.jsx(
  e3,
  {
    href: l,
    className: `button-${o} ${s ?? ""}`,
    onClick: u,
    onKeyDown: d,
    onFocus: h,
    as: p,
    ...y,
    children: c
  }
);
Zi.propTypes = { ...iu };
const n3 = {
  prefix: "fas",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
}, a3 = n3, l3 = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, cd = l3, Q0 = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, i3 = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, o3 = i3;
var r3 = { env: { NODE_ENV: "production" } };
function c3(l, o, c) {
  return (o = s3(o)) in l ? Object.defineProperty(l, o, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : l[o] = c, l;
}
function yA(l, o) {
  var c = Object.keys(l);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(l);
    o && (s = s.filter(function(u) {
      return Object.getOwnPropertyDescriptor(l, u).enumerable;
    })), c.push.apply(c, s);
  }
  return c;
}
function Q(l) {
  for (var o = 1; o < arguments.length; o++) {
    var c = arguments[o] != null ? arguments[o] : {};
    o % 2 ? yA(Object(c), !0).forEach(function(s) {
      c3(l, s, c[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(l, Object.getOwnPropertyDescriptors(c)) : yA(Object(c)).forEach(function(s) {
      Object.defineProperty(l, s, Object.getOwnPropertyDescriptor(c, s));
    });
  }
  return l;
}
function u3(l, o) {
  if (typeof l != "object" || !l) return l;
  var c = l[Symbol.toPrimitive];
  if (c !== void 0) {
    var s = c.call(l, o);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(l);
}
function s3(l) {
  var o = u3(l, "string");
  return typeof o == "symbol" ? o : o + "";
}
const vA = () => {
};
let Vd = {}, V0 = {}, Y0 = null, G0 = {
  mark: vA,
  measure: vA
};
try {
  typeof window < "u" && (Vd = window), typeof document < "u" && (V0 = document), typeof MutationObserver < "u" && (Y0 = MutationObserver), typeof performance < "u" && (G0 = performance);
} catch {
}
const {
  userAgent: bA = ""
} = Vd.navigator || {}, cl = Vd, _t = V0, SA = Y0, Gc = G0;
cl.document;
const va = !!_t.documentElement && !!_t.head && typeof _t.addEventListener == "function" && typeof _t.createElement == "function", I0 = ~bA.indexOf("MSIE") || ~bA.indexOf("Trident/");
var f3 = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, d3 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, F0 = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, m3 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, k0 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], Me = "classic", du = "duotone", h3 = "sharp", g3 = "sharp-duotone", q0 = [Me, du, h3, g3], p3 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, A3 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, y3 = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), v3 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, b3 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], OA = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, S3 = ["kit"], O3 = {
  kit: {
    "fa-kit": "fak"
  }
}, E3 = ["fak", "fakd"], T3 = {
  kit: {
    fak: "fa-kit"
  }
}, EA = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, Ic = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, x3 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], C3 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], N3 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, w3 = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, D3 = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, ud = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, B3 = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], sd = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...x3, ...B3], M3 = ["solid", "regular", "light", "thin", "duotone", "brands"], K0 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], z3 = K0.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), L3 = [...Object.keys(D3), ...M3, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Ic.GROUP, Ic.SWAP_OPACITY, Ic.PRIMARY, Ic.SECONDARY].concat(K0.map((l) => "".concat(l, "x"))).concat(z3.map((l) => "w-".concat(l))), R3 = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const Aa = "___FONT_AWESOME___", fd = 16, Z0 = "fa", P0 = "svg-inline--fa", kl = "data-fa-i2svg", dd = "data-fa-pseudo-element", U3 = "data-fa-pseudo-element-pending", Yd = "data-prefix", Gd = "data-icon", TA = "fontawesome-i2svg", H3 = "async", j3 = ["HTML", "HEAD", "STYLE", "SCRIPT"], W0 = (() => {
  try {
    return r3.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function br(l) {
  return new Proxy(l, {
    get(o, c) {
      return c in o ? o[c] : o[Me];
    }
  });
}
const J0 = Q({}, F0);
J0[Me] = Q(Q(Q(Q({}, {
  "fa-duotone": "duotone"
}), F0[Me]), OA.kit), OA["kit-duotone"]);
const X3 = br(J0), md = Q({}, v3);
md[Me] = Q(Q(Q(Q({}, {
  duotone: "fad"
}), md[Me]), EA.kit), EA["kit-duotone"]);
const xA = br(md), hd = Q({}, ud);
hd[Me] = Q(Q({}, hd[Me]), T3.kit);
const Id = br(hd), gd = Q({}, w3);
gd[Me] = Q(Q({}, gd[Me]), O3.kit);
br(gd);
const Q3 = f3, _0 = "fa-layers-text", V3 = d3, Y3 = Q({}, p3);
br(Y3);
const G3 = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Ff = m3, I3 = [...S3, ...L3], fr = cl.FontAwesomeConfig || {};
function F3(l) {
  var o = _t.querySelector("script[" + l + "]");
  if (o)
    return o.getAttribute(l);
}
function k3(l) {
  return l === "" ? !0 : l === "false" ? !1 : l === "true" ? !0 : l;
}
_t && typeof _t.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((o) => {
  let [c, s] = o;
  const u = k3(F3(c));
  u != null && (fr[s] = u);
});
const $0 = {
  styleDefault: "solid",
  familyDefault: Me,
  cssPrefix: Z0,
  replacementClass: P0,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
fr.familyPrefix && (fr.cssPrefix = fr.familyPrefix);
const qi = Q(Q({}, $0), fr);
qi.autoReplaceSvg || (qi.observeMutations = !1);
const at = {};
Object.keys($0).forEach((l) => {
  Object.defineProperty(at, l, {
    enumerable: !0,
    set: function(o) {
      qi[l] = o, dr.forEach((c) => c(at));
    },
    get: function() {
      return qi[l];
    }
  });
});
Object.defineProperty(at, "familyPrefix", {
  enumerable: !0,
  set: function(l) {
    qi.cssPrefix = l, dr.forEach((o) => o(at));
  },
  get: function() {
    return qi.cssPrefix;
  }
});
cl.FontAwesomeConfig = at;
const dr = [];
function q3(l) {
  return dr.push(l), () => {
    dr.splice(dr.indexOf(l), 1);
  };
}
const nl = fd, Fn = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function K3(l) {
  if (!l || !va)
    return;
  const o = _t.createElement("style");
  o.setAttribute("type", "text/css"), o.innerHTML = l;
  const c = _t.head.childNodes;
  let s = null;
  for (let u = c.length - 1; u > -1; u--) {
    const d = c[u], h = (d.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(h) > -1 && (s = d);
  }
  return _t.head.insertBefore(o, s), l;
}
const Z3 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function hr() {
  let l = 12, o = "";
  for (; l-- > 0; )
    o += Z3[Math.random() * 62 | 0];
  return o;
}
function Pi(l) {
  const o = [];
  for (let c = (l || []).length >>> 0; c--; )
    o[c] = l[c];
  return o;
}
function Fd(l) {
  return l.classList ? Pi(l.classList) : (l.getAttribute("class") || "").split(" ").filter((o) => o);
}
function t1(l) {
  return "".concat(l).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function P3(l) {
  return Object.keys(l || {}).reduce((o, c) => o + "".concat(c, '="').concat(t1(l[c]), '" '), "").trim();
}
function mu(l) {
  return Object.keys(l || {}).reduce((o, c) => o + "".concat(c, ": ").concat(l[c].trim(), ";"), "");
}
function kd(l) {
  return l.size !== Fn.size || l.x !== Fn.x || l.y !== Fn.y || l.rotate !== Fn.rotate || l.flipX || l.flipY;
}
function W3(l) {
  let {
    transform: o,
    containerWidth: c,
    iconWidth: s
  } = l;
  const u = {
    transform: "translate(".concat(c / 2, " 256)")
  }, d = "translate(".concat(o.x * 32, ", ").concat(o.y * 32, ") "), h = "scale(".concat(o.size / 16 * (o.flipX ? -1 : 1), ", ").concat(o.size / 16 * (o.flipY ? -1 : 1), ") "), p = "rotate(".concat(o.rotate, " 0 0)"), y = {
    transform: "".concat(d, " ").concat(h, " ").concat(p)
  }, O = {
    transform: "translate(".concat(s / 2 * -1, " -256)")
  };
  return {
    outer: u,
    inner: y,
    path: O
  };
}
function J3(l) {
  let {
    transform: o,
    width: c = fd,
    height: s = fd,
    startCentered: u = !1
  } = l, d = "";
  return u && I0 ? d += "translate(".concat(o.x / nl - c / 2, "em, ").concat(o.y / nl - s / 2, "em) ") : u ? d += "translate(calc(-50% + ".concat(o.x / nl, "em), calc(-50% + ").concat(o.y / nl, "em)) ") : d += "translate(".concat(o.x / nl, "em, ").concat(o.y / nl, "em) "), d += "scale(".concat(o.size / nl * (o.flipX ? -1 : 1), ", ").concat(o.size / nl * (o.flipY ? -1 : 1), ") "), d += "rotate(".concat(o.rotate, "deg) "), d;
}
var _3 = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function e1() {
  const l = Z0, o = P0, c = at.cssPrefix, s = at.replacementClass;
  let u = _3;
  if (c !== l || s !== o) {
    const d = new RegExp("\\.".concat(l, "\\-"), "g"), h = new RegExp("\\--".concat(l, "\\-"), "g"), p = new RegExp("\\.".concat(o), "g");
    u = u.replace(d, ".".concat(c, "-")).replace(h, "--".concat(c, "-")).replace(p, ".".concat(s));
  }
  return u;
}
let CA = !1;
function kf() {
  at.autoAddCss && !CA && (K3(e1()), CA = !0);
}
var $3 = {
  mixout() {
    return {
      dom: {
        css: e1,
        insertCss: kf
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        kf();
      },
      beforeI2svg() {
        kf();
      }
    };
  }
};
const ya = cl || {};
ya[Aa] || (ya[Aa] = {});
ya[Aa].styles || (ya[Aa].styles = {});
ya[Aa].hooks || (ya[Aa].hooks = {});
ya[Aa].shims || (ya[Aa].shims = []);
var kn = ya[Aa];
const n1 = [], a1 = function() {
  _t.removeEventListener("DOMContentLoaded", a1), nu = 1, n1.map((l) => l());
};
let nu = !1;
va && (nu = (_t.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(_t.readyState), nu || _t.addEventListener("DOMContentLoaded", a1));
function tO(l) {
  va && (nu ? setTimeout(l, 0) : n1.push(l));
}
function Sr(l) {
  const {
    tag: o,
    attributes: c = {},
    children: s = []
  } = l;
  return typeof l == "string" ? t1(l) : "<".concat(o, " ").concat(P3(c), ">").concat(s.map(Sr).join(""), "</").concat(o, ">");
}
function NA(l, o, c) {
  if (l && l[o] && l[o][c])
    return {
      prefix: o,
      iconName: c,
      icon: l[o][c]
    };
}
var qf = function(o, c, s, u) {
  var d = Object.keys(o), h = d.length, p = c, y, O, M;
  for (s === void 0 ? (y = 1, M = o[d[0]]) : (y = 0, M = s); y < h; y++)
    O = d[y], M = p(M, o[O], O, o);
  return M;
};
function eO(l) {
  const o = [];
  let c = 0;
  const s = l.length;
  for (; c < s; ) {
    const u = l.charCodeAt(c++);
    if (u >= 55296 && u <= 56319 && c < s) {
      const d = l.charCodeAt(c++);
      (d & 64512) == 56320 ? o.push(((u & 1023) << 10) + (d & 1023) + 65536) : (o.push(u), c--);
    } else
      o.push(u);
  }
  return o;
}
function pd(l) {
  const o = eO(l);
  return o.length === 1 ? o[0].toString(16) : null;
}
function nO(l, o) {
  const c = l.length;
  let s = l.charCodeAt(o), u;
  return s >= 55296 && s <= 56319 && c > o + 1 && (u = l.charCodeAt(o + 1), u >= 56320 && u <= 57343) ? (s - 55296) * 1024 + u - 56320 + 65536 : s;
}
function wA(l) {
  return Object.keys(l).reduce((o, c) => {
    const s = l[c];
    return !!s.icon ? o[s.iconName] = s.icon : o[c] = s, o;
  }, {});
}
function Ad(l, o) {
  let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: s = !1
  } = c, u = wA(o);
  typeof kn.hooks.addPack == "function" && !s ? kn.hooks.addPack(l, wA(o)) : kn.styles[l] = Q(Q({}, kn.styles[l] || {}), u), l === "fas" && Ad("fa", o);
}
const {
  styles: gr,
  shims: aO
} = kn, l1 = Object.keys(Id), lO = l1.reduce((l, o) => (l[o] = Object.keys(Id[o]), l), {});
let qd = null, i1 = {}, o1 = {}, r1 = {}, c1 = {}, u1 = {};
function iO(l) {
  return ~I3.indexOf(l);
}
function oO(l, o) {
  const c = o.split("-"), s = c[0], u = c.slice(1).join("-");
  return s === l && u !== "" && !iO(u) ? u : null;
}
const s1 = () => {
  const l = (s) => qf(gr, (u, d, h) => (u[h] = qf(d, s, {}), u), {});
  i1 = l((s, u, d) => (u[3] && (s[u[3]] = d), u[2] && u[2].filter((p) => typeof p == "number").forEach((p) => {
    s[p.toString(16)] = d;
  }), s)), o1 = l((s, u, d) => (s[d] = d, u[2] && u[2].filter((p) => typeof p == "string").forEach((p) => {
    s[p] = d;
  }), s)), u1 = l((s, u, d) => {
    const h = u[2];
    return s[d] = d, h.forEach((p) => {
      s[p] = d;
    }), s;
  });
  const o = "far" in gr || at.autoFetchSvg, c = qf(aO, (s, u) => {
    const d = u[0];
    let h = u[1];
    const p = u[2];
    return h === "far" && !o && (h = "fas"), typeof d == "string" && (s.names[d] = {
      prefix: h,
      iconName: p
    }), typeof d == "number" && (s.unicodes[d.toString(16)] = {
      prefix: h,
      iconName: p
    }), s;
  }, {
    names: {},
    unicodes: {}
  });
  r1 = c.names, c1 = c.unicodes, qd = hu(at.styleDefault, {
    family: at.familyDefault
  });
};
q3((l) => {
  qd = hu(l.styleDefault, {
    family: at.familyDefault
  });
});
s1();
function Kd(l, o) {
  return (i1[l] || {})[o];
}
function rO(l, o) {
  return (o1[l] || {})[o];
}
function Ql(l, o) {
  return (u1[l] || {})[o];
}
function f1(l) {
  return r1[l] || {
    prefix: null,
    iconName: null
  };
}
function cO(l) {
  const o = c1[l], c = Kd("fas", l);
  return o || (c ? {
    prefix: "fas",
    iconName: c
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function ul() {
  return qd;
}
const d1 = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function uO(l) {
  let o = Me;
  const c = l1.reduce((s, u) => (s[u] = "".concat(at.cssPrefix, "-").concat(u), s), {});
  return q0.forEach((s) => {
    (l.includes(c[s]) || l.some((u) => lO[s].includes(u))) && (o = s);
  }), o;
}
function hu(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: c = Me
  } = o, s = X3[c][l];
  if (c === du && !l)
    return "fad";
  const u = xA[c][l] || xA[c][s], d = l in kn.styles ? l : null;
  return u || d || null;
}
function sO(l) {
  let o = [], c = null;
  return l.forEach((s) => {
    const u = oO(at.cssPrefix, s);
    u ? c = u : s && o.push(s);
  }), {
    iconName: c,
    rest: o
  };
}
function DA(l) {
  return l.sort().filter((o, c, s) => s.indexOf(o) === c);
}
function gu(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: c = !1
  } = o;
  let s = null;
  const u = sd.concat(C3), d = DA(l.filter((w) => u.includes(w))), h = DA(l.filter((w) => !sd.includes(w))), p = d.filter((w) => (s = w, !k0.includes(w))), [y = null] = p, O = uO(d), M = Q(Q({}, sO(h)), {}, {
    prefix: hu(y, {
      family: O
    })
  });
  return Q(Q(Q({}, M), hO({
    values: l,
    family: O,
    styles: gr,
    config: at,
    canonical: M,
    givenPrefix: s
  })), fO(c, s, M));
}
function fO(l, o, c) {
  let {
    prefix: s,
    iconName: u
  } = c;
  if (l || !s || !u)
    return {
      prefix: s,
      iconName: u
    };
  const d = o === "fa" ? f1(u) : {}, h = Ql(s, u);
  return u = d.iconName || h || u, s = d.prefix || s, s === "far" && !gr.far && gr.fas && !at.autoFetchSvg && (s = "fas"), {
    prefix: s,
    iconName: u
  };
}
const dO = q0.filter((l) => l !== Me || l !== du), mO = Object.keys(ud).filter((l) => l !== Me).map((l) => Object.keys(ud[l])).flat();
function hO(l) {
  const {
    values: o,
    family: c,
    canonical: s,
    givenPrefix: u = "",
    styles: d = {},
    config: h = {}
  } = l, p = c === du, y = o.includes("fa-duotone") || o.includes("fad"), O = h.familyDefault === "duotone", M = s.prefix === "fad" || s.prefix === "fa-duotone";
  if (!p && (y || O || M) && (s.prefix = "fad"), (o.includes("fa-brands") || o.includes("fab")) && (s.prefix = "fab"), !s.prefix && dO.includes(c) && (Object.keys(d).find((x) => mO.includes(x)) || h.autoFetchSvg)) {
    const x = y3.get(c).defaultShortPrefixId;
    s.prefix = x, s.iconName = Ql(s.prefix, s.iconName) || s.iconName;
  }
  return (s.prefix === "fa" || u === "fa") && (s.prefix = ul() || "fas"), s;
}
class gO {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var o = arguments.length, c = new Array(o), s = 0; s < o; s++)
      c[s] = arguments[s];
    const u = c.reduce(this._pullDefinitions, {});
    Object.keys(u).forEach((d) => {
      this.definitions[d] = Q(Q({}, this.definitions[d] || {}), u[d]), Ad(d, u[d]);
      const h = Id[Me][d];
      h && Ad(h, u[d]), s1();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(o, c) {
    const s = c.prefix && c.iconName && c.icon ? {
      0: c
    } : c;
    return Object.keys(s).map((u) => {
      const {
        prefix: d,
        iconName: h,
        icon: p
      } = s[u], y = p[2];
      o[d] || (o[d] = {}), y.length > 0 && y.forEach((O) => {
        typeof O == "string" && (o[d][O] = p);
      }), o[d][h] = p;
    }), o;
  }
}
let BA = [], Gi = {};
const Ii = {}, pO = Object.keys(Ii);
function AO(l, o) {
  let {
    mixoutsTo: c
  } = o;
  return BA = l, Gi = {}, Object.keys(Ii).forEach((s) => {
    pO.indexOf(s) === -1 && delete Ii[s];
  }), BA.forEach((s) => {
    const u = s.mixout ? s.mixout() : {};
    if (Object.keys(u).forEach((d) => {
      typeof u[d] == "function" && (c[d] = u[d]), typeof u[d] == "object" && Object.keys(u[d]).forEach((h) => {
        c[d] || (c[d] = {}), c[d][h] = u[d][h];
      });
    }), s.hooks) {
      const d = s.hooks();
      Object.keys(d).forEach((h) => {
        Gi[h] || (Gi[h] = []), Gi[h].push(d[h]);
      });
    }
    s.provides && s.provides(Ii);
  }), c;
}
function yd(l, o) {
  for (var c = arguments.length, s = new Array(c > 2 ? c - 2 : 0), u = 2; u < c; u++)
    s[u - 2] = arguments[u];
  return (Gi[l] || []).forEach((h) => {
    o = h.apply(null, [o, ...s]);
  }), o;
}
function ql(l) {
  for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
    c[s - 1] = arguments[s];
  (Gi[l] || []).forEach((d) => {
    d.apply(null, c);
  });
}
function sl() {
  const l = arguments[0], o = Array.prototype.slice.call(arguments, 1);
  return Ii[l] ? Ii[l].apply(null, o) : void 0;
}
function vd(l) {
  l.prefix === "fa" && (l.prefix = "fas");
  let {
    iconName: o
  } = l;
  const c = l.prefix || ul();
  if (o)
    return o = Ql(c, o) || o, NA(m1.definitions, c, o) || NA(kn.styles, c, o);
}
const m1 = new gO(), yO = () => {
  at.autoReplaceSvg = !1, at.observeMutations = !1, ql("noAuto");
}, vO = {
  i2svg: function() {
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return va ? (ql("beforeI2svg", l), sl("pseudoElements2svg", l), sl("i2svg", l)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: o
    } = l;
    at.autoReplaceSvg === !1 && (at.autoReplaceSvg = !0), at.observeMutations = !0, tO(() => {
      SO({
        autoReplaceSvgRoot: o
      }), ql("watch", l);
    });
  }
}, bO = {
  icon: (l) => {
    if (l === null)
      return null;
    if (typeof l == "object" && l.prefix && l.iconName)
      return {
        prefix: l.prefix,
        iconName: Ql(l.prefix, l.iconName) || l.iconName
      };
    if (Array.isArray(l) && l.length === 2) {
      const o = l[1].indexOf("fa-") === 0 ? l[1].slice(3) : l[1], c = hu(l[0]);
      return {
        prefix: c,
        iconName: Ql(c, o) || o
      };
    }
    if (typeof l == "string" && (l.indexOf("".concat(at.cssPrefix, "-")) > -1 || l.match(Q3))) {
      const o = gu(l.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: o.prefix || ul(),
        iconName: Ql(o.prefix, o.iconName) || o.iconName
      };
    }
    if (typeof l == "string") {
      const o = ul();
      return {
        prefix: o,
        iconName: Ql(o, l) || l
      };
    }
  }
}, rn = {
  noAuto: yO,
  config: at,
  dom: vO,
  parse: bO,
  library: m1,
  findIconDefinition: vd,
  toHtml: Sr
}, SO = function() {
  let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: o = _t
  } = l;
  (Object.keys(kn.styles).length > 0 || at.autoFetchSvg) && va && at.autoReplaceSvg && rn.dom.i2svg({
    node: o
  });
};
function pu(l, o) {
  return Object.defineProperty(l, "abstract", {
    get: o
  }), Object.defineProperty(l, "html", {
    get: function() {
      return l.abstract.map((c) => Sr(c));
    }
  }), Object.defineProperty(l, "node", {
    get: function() {
      if (!va) return;
      const c = _t.createElement("div");
      return c.innerHTML = l.html, c.children;
    }
  }), l;
}
function OO(l) {
  let {
    children: o,
    main: c,
    mask: s,
    attributes: u,
    styles: d,
    transform: h
  } = l;
  if (kd(h) && c.found && !s.found) {
    const {
      width: p,
      height: y
    } = c, O = {
      x: p / y / 2,
      y: 0.5
    };
    u.style = mu(Q(Q({}, d), {}, {
      "transform-origin": "".concat(O.x + h.x / 16, "em ").concat(O.y + h.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: u,
    children: o
  }];
}
function EO(l) {
  let {
    prefix: o,
    iconName: c,
    children: s,
    attributes: u,
    symbol: d
  } = l;
  const h = d === !0 ? "".concat(o, "-").concat(at.cssPrefix, "-").concat(c) : d;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: Q(Q({}, u), {}, {
        id: h
      }),
      children: s
    }]
  }];
}
function Zd(l) {
  const {
    icons: {
      main: o,
      mask: c
    },
    prefix: s,
    iconName: u,
    transform: d,
    symbol: h,
    title: p,
    maskId: y,
    titleId: O,
    extra: M,
    watchable: w = !1
  } = l, {
    width: x,
    height: $
  } = c.found ? c : o, j = E3.includes(s), q = [at.replacementClass, u ? "".concat(at.cssPrefix, "-").concat(u) : ""].filter((V) => M.classes.indexOf(V) === -1).filter((V) => V !== "" || !!V).concat(M.classes).join(" ");
  let I = {
    children: [],
    attributes: Q(Q({}, M.attributes), {}, {
      "data-prefix": s,
      "data-icon": u,
      class: q,
      role: M.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(x, " ").concat($)
    })
  };
  const K = j && !~M.classes.indexOf("fa-fw") ? {
    width: "".concat(x / $ * 16 * 0.0625, "em")
  } : {};
  w && (I.attributes[kl] = ""), p && (I.children.push({
    tag: "title",
    attributes: {
      id: I.attributes["aria-labelledby"] || "title-".concat(O || hr())
    },
    children: [p]
  }), delete I.attributes.title);
  const H = Q(Q({}, I), {}, {
    prefix: s,
    iconName: u,
    main: o,
    mask: c,
    maskId: y,
    transform: d,
    symbol: h,
    styles: Q(Q({}, K), M.styles)
  }), {
    children: et,
    attributes: nt
  } = c.found && o.found ? sl("generateAbstractMask", H) || {
    children: [],
    attributes: {}
  } : sl("generateAbstractIcon", H) || {
    children: [],
    attributes: {}
  };
  return H.children = et, H.attributes = nt, h ? EO(H) : OO(H);
}
function MA(l) {
  const {
    content: o,
    width: c,
    height: s,
    transform: u,
    title: d,
    extra: h,
    watchable: p = !1
  } = l, y = Q(Q(Q({}, h.attributes), d ? {
    title: d
  } : {}), {}, {
    class: h.classes.join(" ")
  });
  p && (y[kl] = "");
  const O = Q({}, h.styles);
  kd(u) && (O.transform = J3({
    transform: u,
    startCentered: !0,
    width: c,
    height: s
  }), O["-webkit-transform"] = O.transform);
  const M = mu(O);
  M.length > 0 && (y.style = M);
  const w = [];
  return w.push({
    tag: "span",
    attributes: y,
    children: [o]
  }), d && w.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [d]
  }), w;
}
function TO(l) {
  const {
    content: o,
    title: c,
    extra: s
  } = l, u = Q(Q(Q({}, s.attributes), c ? {
    title: c
  } : {}), {}, {
    class: s.classes.join(" ")
  }), d = mu(s.styles);
  d.length > 0 && (u.style = d);
  const h = [];
  return h.push({
    tag: "span",
    attributes: u,
    children: [o]
  }), c && h.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [c]
  }), h;
}
const {
  styles: Kf
} = kn;
function bd(l) {
  const o = l[0], c = l[1], [s] = l.slice(4);
  let u = null;
  return Array.isArray(s) ? u = {
    tag: "g",
    attributes: {
      class: "".concat(at.cssPrefix, "-").concat(Ff.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(at.cssPrefix, "-").concat(Ff.SECONDARY),
        fill: "currentColor",
        d: s[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(at.cssPrefix, "-").concat(Ff.PRIMARY),
        fill: "currentColor",
        d: s[1]
      }
    }]
  } : u = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: s
    }
  }, {
    found: !0,
    width: o,
    height: c,
    icon: u
  };
}
const xO = {
  found: !1,
  width: 512,
  height: 512
};
function CO(l, o) {
  !W0 && !at.showMissingIcons && l && console.error('Icon with name "'.concat(l, '" and prefix "').concat(o, '" is missing.'));
}
function Sd(l, o) {
  let c = o;
  return o === "fa" && at.styleDefault !== null && (o = ul()), new Promise((s, u) => {
    if (c === "fa") {
      const d = f1(l) || {};
      l = d.iconName || l, o = d.prefix || o;
    }
    if (l && o && Kf[o] && Kf[o][l]) {
      const d = Kf[o][l];
      return s(bd(d));
    }
    CO(l, o), s(Q(Q({}, xO), {}, {
      icon: at.showMissingIcons && l ? sl("missingIconAbstract") || {} : {}
    }));
  });
}
const zA = () => {
}, Od = at.measurePerformance && Gc && Gc.mark && Gc.measure ? Gc : {
  mark: zA,
  measure: zA
}, cr = 'FA "6.7.2"', NO = (l) => (Od.mark("".concat(cr, " ").concat(l, " begins")), () => h1(l)), h1 = (l) => {
  Od.mark("".concat(cr, " ").concat(l, " ends")), Od.measure("".concat(cr, " ").concat(l), "".concat(cr, " ").concat(l, " begins"), "".concat(cr, " ").concat(l, " ends"));
};
var Pd = {
  begin: NO,
  end: h1
};
const _c = () => {
};
function LA(l) {
  return typeof (l.getAttribute ? l.getAttribute(kl) : null) == "string";
}
function wO(l) {
  const o = l.getAttribute ? l.getAttribute(Yd) : null, c = l.getAttribute ? l.getAttribute(Gd) : null;
  return o && c;
}
function DO(l) {
  return l && l.classList && l.classList.contains && l.classList.contains(at.replacementClass);
}
function BO() {
  return at.autoReplaceSvg === !0 ? $c.replace : $c[at.autoReplaceSvg] || $c.replace;
}
function MO(l) {
  return _t.createElementNS("http://www.w3.org/2000/svg", l);
}
function zO(l) {
  return _t.createElement(l);
}
function g1(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: c = l.tag === "svg" ? MO : zO
  } = o;
  if (typeof l == "string")
    return _t.createTextNode(l);
  const s = c(l.tag);
  return Object.keys(l.attributes || []).forEach(function(d) {
    s.setAttribute(d, l.attributes[d]);
  }), (l.children || []).forEach(function(d) {
    s.appendChild(g1(d, {
      ceFn: c
    }));
  }), s;
}
function LO(l) {
  let o = " ".concat(l.outerHTML, " ");
  return o = "".concat(o, "Font Awesome fontawesome.com "), o;
}
const $c = {
  replace: function(l) {
    const o = l[0];
    if (o.parentNode)
      if (l[1].forEach((c) => {
        o.parentNode.insertBefore(g1(c), o);
      }), o.getAttribute(kl) === null && at.keepOriginalSource) {
        let c = _t.createComment(LO(o));
        o.parentNode.replaceChild(c, o);
      } else
        o.remove();
  },
  nest: function(l) {
    const o = l[0], c = l[1];
    if (~Fd(o).indexOf(at.replacementClass))
      return $c.replace(l);
    const s = new RegExp("".concat(at.cssPrefix, "-.*"));
    if (delete c[0].attributes.id, c[0].attributes.class) {
      const d = c[0].attributes.class.split(" ").reduce((h, p) => (p === at.replacementClass || p.match(s) ? h.toSvg.push(p) : h.toNode.push(p), h), {
        toNode: [],
        toSvg: []
      });
      c[0].attributes.class = d.toSvg.join(" "), d.toNode.length === 0 ? o.removeAttribute("class") : o.setAttribute("class", d.toNode.join(" "));
    }
    const u = c.map((d) => Sr(d)).join(`
`);
    o.setAttribute(kl, ""), o.innerHTML = u;
  }
};
function RA(l) {
  l();
}
function p1(l, o) {
  const c = typeof o == "function" ? o : _c;
  if (l.length === 0)
    c();
  else {
    let s = RA;
    at.mutateApproach === H3 && (s = cl.requestAnimationFrame || RA), s(() => {
      const u = BO(), d = Pd.begin("mutate");
      l.map(u), d(), c();
    });
  }
}
let Wd = !1;
function A1() {
  Wd = !0;
}
function Ed() {
  Wd = !1;
}
let au = null;
function UA(l) {
  if (!SA || !at.observeMutations)
    return;
  const {
    treeCallback: o = _c,
    nodeCallback: c = _c,
    pseudoElementsCallback: s = _c,
    observeMutationsRoot: u = _t
  } = l;
  au = new SA((d) => {
    if (Wd) return;
    const h = ul();
    Pi(d).forEach((p) => {
      if (p.type === "childList" && p.addedNodes.length > 0 && !LA(p.addedNodes[0]) && (at.searchPseudoElements && s(p.target), o(p.target)), p.type === "attributes" && p.target.parentNode && at.searchPseudoElements && s(p.target.parentNode), p.type === "attributes" && LA(p.target) && ~G3.indexOf(p.attributeName))
        if (p.attributeName === "class" && wO(p.target)) {
          const {
            prefix: y,
            iconName: O
          } = gu(Fd(p.target));
          p.target.setAttribute(Yd, y || h), O && p.target.setAttribute(Gd, O);
        } else DO(p.target) && c(p.target);
    });
  }), va && au.observe(u, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function RO() {
  au && au.disconnect();
}
function UO(l) {
  const o = l.getAttribute("style");
  let c = [];
  return o && (c = o.split(";").reduce((s, u) => {
    const d = u.split(":"), h = d[0], p = d.slice(1);
    return h && p.length > 0 && (s[h] = p.join(":").trim()), s;
  }, {})), c;
}
function HO(l) {
  const o = l.getAttribute("data-prefix"), c = l.getAttribute("data-icon"), s = l.innerText !== void 0 ? l.innerText.trim() : "";
  let u = gu(Fd(l));
  return u.prefix || (u.prefix = ul()), o && c && (u.prefix = o, u.iconName = c), u.iconName && u.prefix || (u.prefix && s.length > 0 && (u.iconName = rO(u.prefix, l.innerText) || Kd(u.prefix, pd(l.innerText))), !u.iconName && at.autoFetchSvg && l.firstChild && l.firstChild.nodeType === Node.TEXT_NODE && (u.iconName = l.firstChild.data)), u;
}
function jO(l) {
  const o = Pi(l.attributes).reduce((u, d) => (u.name !== "class" && u.name !== "style" && (u[d.name] = d.value), u), {}), c = l.getAttribute("title"), s = l.getAttribute("data-fa-title-id");
  return at.autoA11y && (c ? o["aria-labelledby"] = "".concat(at.replacementClass, "-title-").concat(s || hr()) : (o["aria-hidden"] = "true", o.focusable = "false")), o;
}
function XO() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Fn,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function HA(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: c,
    prefix: s,
    rest: u
  } = HO(l), d = jO(l), h = yd("parseNodeAttributes", {}, l);
  let p = o.styleParser ? UO(l) : [];
  return Q({
    iconName: c,
    title: l.getAttribute("title"),
    titleId: l.getAttribute("data-fa-title-id"),
    prefix: s,
    transform: Fn,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: u,
      styles: p,
      attributes: d
    }
  }, h);
}
const {
  styles: QO
} = kn;
function y1(l) {
  const o = at.autoReplaceSvg === "nest" ? HA(l, {
    styleParser: !1
  }) : HA(l);
  return ~o.extra.classes.indexOf(_0) ? sl("generateLayersText", l, o) : sl("generateSvgReplacementMutation", l, o);
}
function VO() {
  return [...b3, ...sd];
}
function jA(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!va) return Promise.resolve();
  const c = _t.documentElement.classList, s = (M) => c.add("".concat(TA, "-").concat(M)), u = (M) => c.remove("".concat(TA, "-").concat(M)), d = at.autoFetchSvg ? VO() : k0.concat(Object.keys(QO));
  d.includes("fa") || d.push("fa");
  const h = [".".concat(_0, ":not([").concat(kl, "])")].concat(d.map((M) => ".".concat(M, ":not([").concat(kl, "])"))).join(", ");
  if (h.length === 0)
    return Promise.resolve();
  let p = [];
  try {
    p = Pi(l.querySelectorAll(h));
  } catch {
  }
  if (p.length > 0)
    s("pending"), u("complete");
  else
    return Promise.resolve();
  const y = Pd.begin("onTree"), O = p.reduce((M, w) => {
    try {
      const x = y1(w);
      x && M.push(x);
    } catch (x) {
      W0 || x.name === "MissingIcon" && console.error(x);
    }
    return M;
  }, []);
  return new Promise((M, w) => {
    Promise.all(O).then((x) => {
      p1(x, () => {
        s("active"), s("complete"), u("pending"), typeof o == "function" && o(), y(), M();
      });
    }).catch((x) => {
      y(), w(x);
    });
  });
}
function YO(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  y1(l).then((c) => {
    c && p1([c], o);
  });
}
function GO(l) {
  return function(o) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = (o || {}).icon ? o : vd(o || {});
    let {
      mask: u
    } = c;
    return u && (u = (u || {}).icon ? u : vd(u || {})), l(s, Q(Q({}, c), {}, {
      mask: u
    }));
  };
}
const IO = function(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: c = Fn,
    symbol: s = !1,
    mask: u = null,
    maskId: d = null,
    title: h = null,
    titleId: p = null,
    classes: y = [],
    attributes: O = {},
    styles: M = {}
  } = o;
  if (!l) return;
  const {
    prefix: w,
    iconName: x,
    icon: $
  } = l;
  return pu(Q({
    type: "icon"
  }, l), () => (ql("beforeDOMElementCreation", {
    iconDefinition: l,
    params: o
  }), at.autoA11y && (h ? O["aria-labelledby"] = "".concat(at.replacementClass, "-title-").concat(p || hr()) : (O["aria-hidden"] = "true", O.focusable = "false")), Zd({
    icons: {
      main: bd($),
      mask: u ? bd(u.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: w,
    iconName: x,
    transform: Q(Q({}, Fn), c),
    symbol: s,
    title: h,
    maskId: d,
    titleId: p,
    extra: {
      attributes: O,
      styles: M,
      classes: y
    }
  })));
};
var FO = {
  mixout() {
    return {
      icon: GO(IO)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(l) {
        return l.treeCallback = jA, l.nodeCallback = YO, l;
      }
    };
  },
  provides(l) {
    l.i2svg = function(o) {
      const {
        node: c = _t,
        callback: s = () => {
        }
      } = o;
      return jA(c, s);
    }, l.generateSvgReplacementMutation = function(o, c) {
      const {
        iconName: s,
        title: u,
        titleId: d,
        prefix: h,
        transform: p,
        symbol: y,
        mask: O,
        maskId: M,
        extra: w
      } = c;
      return new Promise((x, $) => {
        Promise.all([Sd(s, h), O.iconName ? Sd(O.iconName, O.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((j) => {
          let [q, I] = j;
          x([o, Zd({
            icons: {
              main: q,
              mask: I
            },
            prefix: h,
            iconName: s,
            transform: p,
            symbol: y,
            maskId: M,
            title: u,
            titleId: d,
            extra: w,
            watchable: !0
          })]);
        }).catch($);
      });
    }, l.generateAbstractIcon = function(o) {
      let {
        children: c,
        attributes: s,
        main: u,
        transform: d,
        styles: h
      } = o;
      const p = mu(h);
      p.length > 0 && (s.style = p);
      let y;
      return kd(d) && (y = sl("generateAbstractTransformGrouping", {
        main: u,
        transform: d,
        containerWidth: u.width,
        iconWidth: u.width
      })), c.push(y || u.icon), {
        children: c,
        attributes: s
      };
    };
  }
}, kO = {
  mixout() {
    return {
      layer(l) {
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: c = []
        } = o;
        return pu({
          type: "layer"
        }, () => {
          ql("beforeDOMElementCreation", {
            assembler: l,
            params: o
          });
          let s = [];
          return l((u) => {
            Array.isArray(u) ? u.map((d) => {
              s = s.concat(d.abstract);
            }) : s = s.concat(u.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(at.cssPrefix, "-layers"), ...c].join(" ")
            },
            children: s
          }];
        });
      }
    };
  }
}, qO = {
  mixout() {
    return {
      counter(l) {
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: c = null,
          classes: s = [],
          attributes: u = {},
          styles: d = {}
        } = o;
        return pu({
          type: "counter",
          content: l
        }, () => (ql("beforeDOMElementCreation", {
          content: l,
          params: o
        }), TO({
          content: l.toString(),
          title: c,
          extra: {
            attributes: u,
            styles: d,
            classes: ["".concat(at.cssPrefix, "-layers-counter"), ...s]
          }
        })));
      }
    };
  }
}, KO = {
  mixout() {
    return {
      text(l) {
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: c = Fn,
          title: s = null,
          classes: u = [],
          attributes: d = {},
          styles: h = {}
        } = o;
        return pu({
          type: "text",
          content: l
        }, () => (ql("beforeDOMElementCreation", {
          content: l,
          params: o
        }), MA({
          content: l,
          transform: Q(Q({}, Fn), c),
          title: s,
          extra: {
            attributes: d,
            styles: h,
            classes: ["".concat(at.cssPrefix, "-layers-text"), ...u]
          }
        })));
      }
    };
  },
  provides(l) {
    l.generateLayersText = function(o, c) {
      const {
        title: s,
        transform: u,
        extra: d
      } = c;
      let h = null, p = null;
      if (I0) {
        const y = parseInt(getComputedStyle(o).fontSize, 10), O = o.getBoundingClientRect();
        h = O.width / y, p = O.height / y;
      }
      return at.autoA11y && !s && (d.attributes["aria-hidden"] = "true"), Promise.resolve([o, MA({
        content: o.innerHTML,
        width: h,
        height: p,
        transform: u,
        title: s,
        extra: d,
        watchable: !0
      })]);
    };
  }
};
const ZO = new RegExp('"', "ug"), XA = [1105920, 1112319], QA = Q(Q(Q(Q({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), A3), R3), N3), Td = Object.keys(QA).reduce((l, o) => (l[o.toLowerCase()] = QA[o], l), {}), PO = Object.keys(Td).reduce((l, o) => {
  const c = Td[o];
  return l[o] = c[900] || [...Object.entries(c)][0][1], l;
}, {});
function WO(l) {
  const o = l.replace(ZO, ""), c = nO(o, 0), s = c >= XA[0] && c <= XA[1], u = o.length === 2 ? o[0] === o[1] : !1;
  return {
    value: pd(u ? o[0] : o),
    isSecondary: s || u
  };
}
function JO(l, o) {
  const c = l.replace(/^['"]|['"]$/g, "").toLowerCase(), s = parseInt(o), u = isNaN(s) ? "normal" : s;
  return (Td[c] || {})[u] || PO[c];
}
function VA(l, o) {
  const c = "".concat(U3).concat(o.replace(":", "-"));
  return new Promise((s, u) => {
    if (l.getAttribute(c) !== null)
      return s();
    const h = Pi(l.children).filter((x) => x.getAttribute(dd) === o)[0], p = cl.getComputedStyle(l, o), y = p.getPropertyValue("font-family"), O = y.match(V3), M = p.getPropertyValue("font-weight"), w = p.getPropertyValue("content");
    if (h && !O)
      return l.removeChild(h), s();
    if (O && w !== "none" && w !== "") {
      const x = p.getPropertyValue("content");
      let $ = JO(y, M);
      const {
        value: j,
        isSecondary: q
      } = WO(x), I = O[0].startsWith("FontAwesome");
      let K = Kd($, j), H = K;
      if (I) {
        const et = cO(j);
        et.iconName && et.prefix && (K = et.iconName, $ = et.prefix);
      }
      if (K && !q && (!h || h.getAttribute(Yd) !== $ || h.getAttribute(Gd) !== H)) {
        l.setAttribute(c, H), h && l.removeChild(h);
        const et = XO(), {
          extra: nt
        } = et;
        nt.attributes[dd] = o, Sd(K, $).then((V) => {
          const P = Zd(Q(Q({}, et), {}, {
            icons: {
              main: V,
              mask: d1()
            },
            prefix: $,
            iconName: H,
            extra: nt,
            watchable: !0
          })), G = _t.createElementNS("http://www.w3.org/2000/svg", "svg");
          o === "::before" ? l.insertBefore(G, l.firstChild) : l.appendChild(G), G.outerHTML = P.map((W) => Sr(W)).join(`
`), l.removeAttribute(c), s();
        }).catch(u);
      } else
        s();
    } else
      s();
  });
}
function _O(l) {
  return Promise.all([VA(l, "::before"), VA(l, "::after")]);
}
function $O(l) {
  return l.parentNode !== document.head && !~j3.indexOf(l.tagName.toUpperCase()) && !l.getAttribute(dd) && (!l.parentNode || l.parentNode.tagName !== "svg");
}
function YA(l) {
  if (va)
    return new Promise((o, c) => {
      const s = Pi(l.querySelectorAll("*")).filter($O).map(_O), u = Pd.begin("searchPseudoElements");
      A1(), Promise.all(s).then(() => {
        u(), Ed(), o();
      }).catch(() => {
        u(), Ed(), c();
      });
    });
}
var tE = {
  hooks() {
    return {
      mutationObserverCallbacks(l) {
        return l.pseudoElementsCallback = YA, l;
      }
    };
  },
  provides(l) {
    l.pseudoElements2svg = function(o) {
      const {
        node: c = _t
      } = o;
      at.searchPseudoElements && YA(c);
    };
  }
};
let GA = !1;
var eE = {
  mixout() {
    return {
      dom: {
        unwatch() {
          A1(), GA = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        UA(yd("mutationObserverCallbacks", {}));
      },
      noAuto() {
        RO();
      },
      watch(l) {
        const {
          observeMutationsRoot: o
        } = l;
        GA ? Ed() : UA(yd("mutationObserverCallbacks", {
          observeMutationsRoot: o
        }));
      }
    };
  }
};
const IA = (l) => {
  let o = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return l.toLowerCase().split(" ").reduce((c, s) => {
    const u = s.toLowerCase().split("-"), d = u[0];
    let h = u.slice(1).join("-");
    if (d && h === "h")
      return c.flipX = !0, c;
    if (d && h === "v")
      return c.flipY = !0, c;
    if (h = parseFloat(h), isNaN(h))
      return c;
    switch (d) {
      case "grow":
        c.size = c.size + h;
        break;
      case "shrink":
        c.size = c.size - h;
        break;
      case "left":
        c.x = c.x - h;
        break;
      case "right":
        c.x = c.x + h;
        break;
      case "up":
        c.y = c.y - h;
        break;
      case "down":
        c.y = c.y + h;
        break;
      case "rotate":
        c.rotate = c.rotate + h;
        break;
    }
    return c;
  }, o);
};
var nE = {
  mixout() {
    return {
      parse: {
        transform: (l) => IA(l)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(l, o) {
        const c = o.getAttribute("data-fa-transform");
        return c && (l.transform = IA(c)), l;
      }
    };
  },
  provides(l) {
    l.generateAbstractTransformGrouping = function(o) {
      let {
        main: c,
        transform: s,
        containerWidth: u,
        iconWidth: d
      } = o;
      const h = {
        transform: "translate(".concat(u / 2, " 256)")
      }, p = "translate(".concat(s.x * 32, ", ").concat(s.y * 32, ") "), y = "scale(".concat(s.size / 16 * (s.flipX ? -1 : 1), ", ").concat(s.size / 16 * (s.flipY ? -1 : 1), ") "), O = "rotate(".concat(s.rotate, " 0 0)"), M = {
        transform: "".concat(p, " ").concat(y, " ").concat(O)
      }, w = {
        transform: "translate(".concat(d / 2 * -1, " -256)")
      }, x = {
        outer: h,
        inner: M,
        path: w
      };
      return {
        tag: "g",
        attributes: Q({}, x.outer),
        children: [{
          tag: "g",
          attributes: Q({}, x.inner),
          children: [{
            tag: c.icon.tag,
            children: c.icon.children,
            attributes: Q(Q({}, c.icon.attributes), x.path)
          }]
        }]
      };
    };
  }
};
const Zf = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function FA(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return l.attributes && (l.attributes.fill || o) && (l.attributes.fill = "black"), l;
}
function aE(l) {
  return l.tag === "g" ? l.children : [l];
}
var lE = {
  hooks() {
    return {
      parseNodeAttributes(l, o) {
        const c = o.getAttribute("data-fa-mask"), s = c ? gu(c.split(" ").map((u) => u.trim())) : d1();
        return s.prefix || (s.prefix = ul()), l.mask = s, l.maskId = o.getAttribute("data-fa-mask-id"), l;
      }
    };
  },
  provides(l) {
    l.generateAbstractMask = function(o) {
      let {
        children: c,
        attributes: s,
        main: u,
        mask: d,
        maskId: h,
        transform: p
      } = o;
      const {
        width: y,
        icon: O
      } = u, {
        width: M,
        icon: w
      } = d, x = W3({
        transform: p,
        containerWidth: M,
        iconWidth: y
      }), $ = {
        tag: "rect",
        attributes: Q(Q({}, Zf), {}, {
          fill: "white"
        })
      }, j = O.children ? {
        children: O.children.map(FA)
      } : {}, q = {
        tag: "g",
        attributes: Q({}, x.inner),
        children: [FA(Q({
          tag: O.tag,
          attributes: Q(Q({}, O.attributes), x.path)
        }, j))]
      }, I = {
        tag: "g",
        attributes: Q({}, x.outer),
        children: [q]
      }, K = "mask-".concat(h || hr()), H = "clip-".concat(h || hr()), et = {
        tag: "mask",
        attributes: Q(Q({}, Zf), {}, {
          id: K,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [$, I]
      }, nt = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: H
          },
          children: aE(w)
        }, et]
      };
      return c.push(nt, {
        tag: "rect",
        attributes: Q({
          fill: "currentColor",
          "clip-path": "url(#".concat(H, ")"),
          mask: "url(#".concat(K, ")")
        }, Zf)
      }), {
        children: c,
        attributes: s
      };
    };
  }
}, iE = {
  provides(l) {
    let o = !1;
    cl.matchMedia && (o = cl.matchMedia("(prefers-reduced-motion: reduce)").matches), l.missingIconAbstract = function() {
      const c = [], s = {
        fill: "currentColor"
      }, u = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      c.push({
        tag: "path",
        attributes: Q(Q({}, s), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const d = Q(Q({}, u), {}, {
        attributeName: "opacity"
      }), h = {
        tag: "circle",
        attributes: Q(Q({}, s), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return o || h.children.push({
        tag: "animate",
        attributes: Q(Q({}, u), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: Q(Q({}, d), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), c.push(h), c.push({
        tag: "path",
        attributes: Q(Q({}, s), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: o ? [] : [{
          tag: "animate",
          attributes: Q(Q({}, d), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), o || c.push({
        tag: "path",
        attributes: Q(Q({}, s), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: Q(Q({}, d), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: c
      };
    };
  }
}, oE = {
  hooks() {
    return {
      parseNodeAttributes(l, o) {
        const c = o.getAttribute("data-fa-symbol"), s = c === null ? !1 : c === "" ? !0 : c;
        return l.symbol = s, l;
      }
    };
  }
}, rE = [$3, FO, kO, qO, KO, tE, eE, nE, lE, iE, oE];
AO(rE, {
  mixoutsTo: rn
});
rn.noAuto;
rn.config;
rn.library;
rn.dom;
const xd = rn.parse;
rn.findIconDefinition;
rn.toHtml;
const cE = rn.icon;
rn.layer;
rn.text;
rn.counter;
var Cd = { env: { NODE_ENV: "production" } };
function Nd(l, o) {
  (o == null || o > l.length) && (o = l.length);
  for (var c = 0, s = Array(o); c < o; c++) s[c] = l[c];
  return s;
}
function uE(l) {
  if (Array.isArray(l)) return l;
}
function sE(l) {
  if (Array.isArray(l)) return Nd(l);
}
function ll(l, o, c) {
  return (o = yE(o)) in l ? Object.defineProperty(l, o, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : l[o] = c, l;
}
function fE(l) {
  if (typeof Symbol < "u" && l[Symbol.iterator] != null || l["@@iterator"] != null) return Array.from(l);
}
function dE(l, o) {
  var c = l == null ? null : typeof Symbol < "u" && l[Symbol.iterator] || l["@@iterator"];
  if (c != null) {
    var s, u, d, h, p = [], y = !0, O = !1;
    try {
      if (d = (c = c.call(l)).next, o !== 0) for (; !(y = (s = d.call(c)).done) && (p.push(s.value), p.length !== o); y = !0) ;
    } catch (M) {
      O = !0, u = M;
    } finally {
      try {
        if (!y && c.return != null && (h = c.return(), Object(h) !== h)) return;
      } finally {
        if (O) throw u;
      }
    }
    return p;
  }
}
function mE() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hE() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kA(l, o) {
  var c = Object.keys(l);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(l);
    o && (s = s.filter(function(u) {
      return Object.getOwnPropertyDescriptor(l, u).enumerable;
    })), c.push.apply(c, s);
  }
  return c;
}
function In(l) {
  for (var o = 1; o < arguments.length; o++) {
    var c = arguments[o] != null ? arguments[o] : {};
    o % 2 ? kA(Object(c), !0).forEach(function(s) {
      ll(l, s, c[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(l, Object.getOwnPropertyDescriptors(c)) : kA(Object(c)).forEach(function(s) {
      Object.defineProperty(l, s, Object.getOwnPropertyDescriptor(c, s));
    });
  }
  return l;
}
function gE(l, o) {
  if (l == null) return {};
  var c, s, u = pE(l, o);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(l);
    for (s = 0; s < d.length; s++) c = d[s], o.indexOf(c) === -1 && {}.propertyIsEnumerable.call(l, c) && (u[c] = l[c]);
  }
  return u;
}
function pE(l, o) {
  if (l == null) return {};
  var c = {};
  for (var s in l) if ({}.hasOwnProperty.call(l, s)) {
    if (o.indexOf(s) !== -1) continue;
    c[s] = l[s];
  }
  return c;
}
function qA(l, o) {
  return uE(l) || dE(l, o) || v1(l, o) || mE();
}
function wd(l) {
  return sE(l) || fE(l) || v1(l) || hE();
}
function AE(l, o) {
  if (typeof l != "object" || !l) return l;
  var c = l[Symbol.toPrimitive];
  if (c !== void 0) {
    var s = c.call(l, o);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(l);
}
function yE(l) {
  var o = AE(l, "string");
  return typeof o == "symbol" ? o : o + "";
}
function lu(l) {
  "@babel/helpers - typeof";
  return lu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, lu(l);
}
function v1(l, o) {
  if (l) {
    if (typeof l == "string") return Nd(l, o);
    var c = {}.toString.call(l).slice(8, -1);
    return c === "Object" && l.constructor && (c = l.constructor.name), c === "Map" || c === "Set" ? Array.from(l) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? Nd(l, o) : void 0;
  }
}
var vE = "7.0.0", Dd;
try {
  var bE = require("@fortawesome/fontawesome-svg-core/package.json");
  Dd = bE.version;
} catch {
  Dd = typeof Cd < "u" && Cd.env.FA_VERSION || "7.0.0";
}
function SE(l) {
  var o = l.beat, c = l.fade, s = l.beatFade, u = l.bounce, d = l.shake, h = l.flash, p = l.spin, y = l.spinPulse, O = l.spinReverse, M = l.pulse, w = l.fixedWidth, x = l.inverse, $ = l.border, j = l.listItem, q = l.flip, I = l.size, K = l.rotation, H = l.pull, et = l.swapOpacity, nt = l.rotateBy, V = l.widthAuto, P = OE(Dd, vE), G = ll(ll(ll(ll(ll(ll({
    "fa-beat": o,
    "fa-fade": c,
    "fa-beat-fade": s,
    "fa-bounce": u,
    "fa-shake": d,
    "fa-flash": h,
    "fa-spin": p,
    "fa-spin-reverse": O,
    "fa-spin-pulse": y,
    "fa-pulse": M,
    "fa-fw": w,
    "fa-inverse": x,
    "fa-border": $,
    "fa-li": j,
    "fa-flip": q === !0,
    "fa-flip-horizontal": q === "horizontal" || q === "both",
    "fa-flip-vertical": q === "vertical" || q === "both"
  }, "fa-".concat(I), typeof I < "u" && I !== null), "fa-rotate-".concat(K), typeof K < "u" && K !== null && K !== 0), "fa-pull-".concat(H), typeof H < "u" && H !== null), "fa-swap-opacity", et), "fa-rotate-by", P && nt), "fa-width-auto", P && V);
  return Object.keys(G).map(function(W) {
    return G[W] ? W : null;
  }).filter(function(W) {
    return W;
  });
}
function OE(l, o) {
  for (var c = l.split("-"), s = qA(c, 2), u = s[0], d = s[1], h = o.split("-"), p = qA(h, 2), y = p[0], O = p[1], M = u.split("."), w = y.split("."), x = 0; x < Math.max(M.length, w.length); x++) {
    var $ = M[x] || "0", j = w[x] || "0", q = parseInt($, 10), I = parseInt(j, 10);
    if (q !== I)
      return q > I;
  }
  for (var K = 0; K < Math.max(M.length, w.length); K++) {
    var H = M[K] || "0", et = w[K] || "0";
    if (H !== et && H.length !== et.length)
      return H.length < et.length;
  }
  return !(d && !O);
}
function EE(l) {
  return l = l - 0, l === l;
}
function b1(l) {
  return EE(l) ? l : (l = l.replace(/[\-_\s]+(.)?/g, function(o, c) {
    return c ? c.toUpperCase() : "";
  }), l.substr(0, 1).toLowerCase() + l.substr(1));
}
var TE = ["style"];
function xE(l) {
  return l.charAt(0).toUpperCase() + l.slice(1);
}
function CE(l) {
  return l.split(";").map(function(o) {
    return o.trim();
  }).filter(function(o) {
    return o;
  }).reduce(function(o, c) {
    var s = c.indexOf(":"), u = b1(c.slice(0, s)), d = c.slice(s + 1).trim();
    return u.startsWith("webkit") ? o[xE(u)] = d : o[u] = d, o;
  }, {});
}
function S1(l, o) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof o == "string")
    return o;
  var s = (o.children || []).map(function(y) {
    return S1(l, y);
  }), u = Object.keys(o.attributes || {}).reduce(function(y, O) {
    var M = o.attributes[O];
    switch (O) {
      case "class":
        y.attrs.className = M, delete o.attributes.class;
        break;
      case "style":
        y.attrs.style = CE(M);
        break;
      default:
        O.indexOf("aria-") === 0 || O.indexOf("data-") === 0 ? y.attrs[O.toLowerCase()] = M : y.attrs[b1(O)] = M;
    }
    return y;
  }, {
    attrs: {}
  }), d = c.style, h = d === void 0 ? {} : d, p = gE(c, TE);
  return u.attrs.style = In(In({}, u.attrs.style), h), l.apply(void 0, [o.tag, In(In({}, u.attrs), p)].concat(wd(s)));
}
var O1 = !1;
try {
  O1 = Cd.env.NODE_ENV === "production";
} catch {
}
function NE() {
  if (!O1 && console && typeof console.error == "function") {
    var l;
    (l = console).error.apply(l, arguments);
  }
}
function KA(l) {
  if (l && lu(l) === "object" && l.prefix && l.iconName && l.icon)
    return l;
  if (xd.icon)
    return xd.icon(l);
  if (l === null)
    return null;
  if (l && lu(l) === "object" && l.prefix && l.iconName)
    return l;
  if (Array.isArray(l) && l.length === 2)
    return {
      prefix: l[0],
      iconName: l[1]
    };
  if (typeof l == "string")
    return {
      prefix: "fas",
      iconName: l
    };
}
function Pf(l, o) {
  return Array.isArray(o) && o.length > 0 || !Array.isArray(o) && o ? ll({}, l, o) : {};
}
var ZA = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  // the fixedWidth property has been deprecated as of version 7
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  rotateBy: !1,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1,
  widthAuto: !1
}, Ke = /* @__PURE__ */ ee.forwardRef(function(l, o) {
  var c = In(In({}, ZA), l), s = c.icon, u = c.mask, d = c.symbol, h = c.className, p = c.title, y = c.titleId, O = c.maskId, M = KA(s), w = Pf("classes", [].concat(wd(SE(c)), wd((h || "").split(" ")))), x = Pf("transform", typeof c.transform == "string" ? xd.transform(c.transform) : c.transform), $ = Pf("mask", KA(u)), j = cE(M, In(In(In(In({}, w), x), $), {}, {
    symbol: d,
    title: p,
    titleId: y,
    maskId: O
  }));
  if (!j)
    return NE("Could not find icon", M), null;
  var q = j.abstract, I = {
    ref: o
  };
  return Object.keys(c).forEach(function(K) {
    ZA.hasOwnProperty(K) || (I[K] = c[K]);
  }), wE(q[0], I);
});
Ke.displayName = "FontAwesomeIcon";
Ke.propTypes = {
  beat: E.bool,
  border: E.bool,
  beatFade: E.bool,
  bounce: E.bool,
  className: E.string,
  fade: E.bool,
  flash: E.bool,
  mask: E.oneOfType([E.object, E.array, E.string]),
  maskId: E.string,
  // the fixedWidth property has been deprecated as of version 7
  fixedWidth: E.bool,
  inverse: E.bool,
  flip: E.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: E.oneOfType([E.object, E.array, E.string]),
  listItem: E.bool,
  pull: E.oneOf(["right", "left"]),
  pulse: E.bool,
  rotation: E.oneOf([0, 90, 180, 270]),
  rotateBy: E.bool,
  shake: E.bool,
  size: E.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: E.bool,
  spinPulse: E.bool,
  spinReverse: E.bool,
  symbol: E.oneOfType([E.bool, E.string]),
  title: E.string,
  titleId: E.string,
  transform: E.oneOfType([E.string, E.object]),
  swapOpacity: E.bool,
  widthAuto: E.bool
};
var wE = S1.bind(null, ee.createElement);
const E1 = ({
  columnIndex: l,
  column: { title: o, links: c },
  isOpen: s = !1,
  onToggle: u
}) => {
  const [d, h] = vn(s), y = typeof window < "u" ? window.innerWidth >= 1260 : !1, [O, M] = vn(y), w = Yl(null);
  Ze(() => {
    !O && u && x(s), h(s);
  }, [s, O, u]), Ze(() => {
    const j = window.matchMedia("screen and (min-width: 1260px)"), q = (I) => M(I.matches);
    return j.addEventListener("change", q), q(j), () => j.removeEventListener("change", q);
  }, []);
  const x = (j) => {
    const q = w == null ? void 0 : w.current;
    if (!q || !q.animate) return;
    q.classList.add("footer-collapsing");
    const I = q.animate(
      [
        {
          maxHeight: j ? `${q.scrollHeight}px` : "0px"
        }
      ],
      {
        duration: 250,
        easing: "ease-in-out",
        fill: "forwards"
      }
    );
    I.onfinish = () => {
      q.classList.remove("footer-collapsing"), j ? q.classList.add("footer-column-show") : q.classList.remove("footer-column-show");
    };
  }, $ = () => {
    if (O) {
      h(!0);
      return;
    }
    u ? u() : h((j) => {
      const q = !j;
      return x(q), q;
    });
  };
  return /* @__PURE__ */ b.jsx("div", { className: "col-xl flex-footer testname-column", children: /* @__PURE__ */ b.jsxs("div", { className: "card accordion-item desktop-disable-xl", children: [
    /* @__PURE__ */ b.jsx("div", { className: "footer-accordion-header", children: /* @__PURE__ */ b.jsx("div", { className: "h5", children: O ? /* @__PURE__ */ b.jsx("p", { className: "accordion-button", children: o }) : /* @__PURE__ */ b.jsxs(
      "button",
      {
        id: `footlink-header-${l}`,
        className: "footer-accordion-button",
        "aria-expanded": d || O,
        "aria-controls": `footlink-${l}`,
        onClick: $,
        type: "button",
        disabled: O,
        children: [
          o,
          /* @__PURE__ */ b.jsx(
            Ke,
            {
              className: d || O ? "column-open" : "",
              icon: Q0
            }
          )
        ]
      }
    ) }) }),
    /* @__PURE__ */ b.jsx(
      "div",
      {
        id: `footlink-${l}`,
        className: "footer-accordion-body",
        role: "region",
        ref: w,
        children: c.map((j) => /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: j.url,
            title: j.title,
            children: j.text
          },
          `footlink-${o}-link-${j.text}`
        ))
      }
    )
  ] }) });
};
E1.propTypes = {
  columnIndex: E.number.isRequired,
  column: an.shape({
    title: E.string,
    links: an.arrayOf(
      an.shape({
        url: E.string.isRequired,
        title: E.string,
        text: E.string.isRequired
      })
    )
  }),
  isOpen: E.bool,
  onToggle: E.func
};
const Jd = ({
  contact: { title: l = "", contactLink: o = "", contributionLink: c = "", columns: s }
}) => {
  const [u, d] = vn(
    /** @type {number | null} */
    null
  );
  return /* @__PURE__ */ b.jsx("div", { className: "wrapper", id: "wrapper-footer-columns", "data-testid": "contact", children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "footer-columns", children: /* @__PURE__ */ b.jsxs("div", { className: "row", "data-testid": "columns-container", children: [
    /* @__PURE__ */ b.jsxs("div", { className: "col-xl-3", id: "info-column", children: [
      /* @__PURE__ */ b.jsx("div", { className: "h5", children: l }),
      o && /* @__PURE__ */ b.jsx("p", { className: "contact-link", children: /* @__PURE__ */ b.jsx("a", { href: o, children: "Contact Us" }) }),
      c && /* @__PURE__ */ b.jsx(
        "p",
        {
          className: "contribute-button",
          "data-testid": "contact-contribution-link",
          children: /* @__PURE__ */ b.jsx(
            Zi,
            {
              color: "gold",
              href: c,
              text: "Support ASU",
              classes: "btn"
            }
          )
        }
      )
    ] }),
    s && s.length && /* @__PURE__ */ b.jsx(b.Fragment, { children: s.map((h, p) => /* @__PURE__ */ b.jsx(
      E1,
      {
        columnIndex: p,
        column: h,
        isOpen: u === p,
        onToggle: () => {
          d(
            u === p ? null : p
          );
        }
      },
      `footlink-${h.title}`
    )) })
  ] }) }) });
};
Jd.propTypes = {
  contact: an.shape({
    title: E.string.isRequired,
    contactLink: E.string.isRequired,
    contributionLink: E.string,
    columns: an.arrayOf(
      an.shape({
        title: E.string,
        links: an.arrayOf(
          an.shape({
            url: E.string.isRequired,
            title: E.string,
            text: E.string.isRequired
          })
        )
      })
    )
  })
};
const DE = "data:image/png;base64,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", Xi = {
  MAPS_AND_LOCATIONS: "https://www.asu.edu/about/locations-maps",
  JOBS: "https://cfo.asu.edu/applicant",
  DIRECTORY: "https://search.asu.edu/?search-tabs=web_dir_faculty_staff",
  CONTACT_ASU: "https://www.asu.edu/about/contact",
  MY_ASU: "https://my.asu.edu/",
  RANKINGS: "https://www.asu.edu/rankings"
}, ar = {
  COPYRIGHT_AND_TRADEMARK: "https://www.asu.edu/about/copyright-trademark",
  ACCESSIBILITY_REPORT: "https://accessibility.asu.edu/report",
  PRIVACY: "https://www.asu.edu/about/privacy",
  TERMS_OF_USE: "https://www.asu.edu/about/terms-of-use",
  EMERGENCY: "https://www.asu.edu/emergency/"
}, Qi = {
  type: "internal link",
  section: "secondary footer"
}, BE = () => /* @__PURE__ */ b.jsx(
  "div",
  {
    className: "wrapper",
    id: "wrapper-footer-innovation",
    "data-testid": "innovation",
    children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "footer-innovation", children: /* @__PURE__ */ b.jsx("div", { className: "row", children: /* @__PURE__ */ b.jsx("div", { className: "col", children: /* @__PURE__ */ b.jsxs("div", { className: "d-flex footer-innovation-links", children: [
      /* @__PURE__ */ b.jsxs("nav", { className: "nav", "aria-label": "University Services", children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Xi.MAPS_AND_LOCATIONS,
            onFocus: () => Mt({
              ...Qi,
              text: "maps and locations"
            }),
            children: "Maps and Locations"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Xi.JOBS,
            onFocus: () => Mt({
              ...Qi,
              text: "jobs"
            }),
            children: "Jobs"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Xi.DIRECTORY,
            onFocus: () => Mt({
              ...Qi,
              text: "directory"
            }),
            children: "Directory"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Xi.CONTACT_ASU,
            onFocus: () => Mt({
              ...Qi,
              text: "contact asu"
            }),
            children: "Contact ASU"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Xi.MY_ASU,
            onFocus: () => Mt({
              ...Qi,
              text: "my asu"
            }),
            children: "My ASU"
          }
        )
      ] }),
      /* @__PURE__ */ b.jsx(
        "a",
        {
          className: "img-link",
          href: Xi.RANKINGS,
          onFocus: () => Mt({
            ...Qi,
            text: "#1 in the u.s. for innovation"
          }),
          children: /* @__PURE__ */ b.jsx(
            "img",
            {
              src: DE,
              alt: "Repeatedly ranked #1 on 30+ lists in the last 3 years",
              width: "459",
              height: "100",
              loading: "lazy",
              decoding: "async"
            }
          )
        }
      )
    ] }) }) }) })
  }
), lr = {
  type: "internal link",
  section: "tertiary footer"
}, ME = () => {
  function l() {
    try {
      return window.location.href;
    } catch (o) {
      return console.error(o), "";
    }
  }
  return /* @__PURE__ */ b.jsx("div", { className: "wrapper", id: "wrapper-footer-colophon", "data-testid": "legal", children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "footer-colophon", children: /* @__PURE__ */ b.jsx("div", { className: "row", children: /* @__PURE__ */ b.jsx("div", { className: "col", children: /* @__PURE__ */ b.jsxs(
    "nav",
    {
      className: "nav colophon",
      "aria-label": "University Legal and Compliance",
      children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: ar.COPYRIGHT_AND_TRADEMARK,
            onFocus: () => Mt({
              ...lr,
              text: "copyright and trademark"
            }),
            children: "Copyright and Trademark"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: `${ar.ACCESSIBILITY_REPORT}#a11yref=${l()}`,
            onFocus: () => Mt({
              ...lr,
              text: "accessibility"
            }),
            children: "Accessibility"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: ar.TERMS_OF_USE,
            onFocus: () => Mt({
              ...lr,
              text: "terms of use"
            }),
            children: "Terms of Use"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: ar.EMERGENCY,
            onFocus: () => Mt({
              ...lr,
              text: "emergency"
            }),
            children: "Emergency"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: ar.PRIVACY,
            onFocus: () => Mt({
              ...lr,
              text: "privacy"
            }),
            children: "Privacy"
          }
        ),
        /* @__PURE__ */ b.jsx("button", { type: "button", id: "manualConsentoptout", children: "Manage my privacy settings" })
      ]
    }
  ) }) }) }) });
};
const zE = {
  prefix: "fab",
  iconName: "square-instagram",
  icon: [448, 512, ["instagram-square"], "e055", "M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"]
}, LE = zE, RE = {
  prefix: "fab",
  iconName: "square-youtube",
  icon: [448, 512, [61798, "youtube-square"], "f431", "M282 256.2l-95.2-54.1V310.3L282 256.2zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm14.4 136.1c7.6 28.6 7.6 88.2 7.6 88.2s0 59.6-7.6 88.1c-4.2 15.8-16.5 27.7-32.2 31.9C337.9 384 224 384 224 384s-113.9 0-142.2-7.6c-15.7-4.2-28-16.1-32.2-31.9C42 315.9 42 256.3 42 256.3s0-59.7 7.6-88.2c4.2-15.8 16.5-28.2 32.2-32.4C110.1 128 224 128 224 128s113.9 0 142.2 7.7c15.7 4.2 28 16.6 32.2 32.4z"]
}, UE = RE, HE = {
  prefix: "fab",
  iconName: "square-facebook",
  icon: [448, 512, ["facebook-square"], "f082", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
}, jE = HE, XE = {
  prefix: "fab",
  iconName: "linkedin",
  icon: [448, 512, [], "f08c", "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"]
}, QE = {
  prefix: "fab",
  iconName: "square-x-twitter",
  icon: [448, 512, [], "e61a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"]
}, VE = "data:image/png;base64,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", Vi = {
  type: "external link",
  section: "primary footer"
}, _d = ({
  social: {
    logoUrl: l,
    unitLogo: o = VE,
    mediaLinks: c = {
      facebook: "",
      twitter: "",
      linkedIn: "",
      instagram: "",
      youtube: ""
    }
  }
}) => /* @__PURE__ */ b.jsx("div", { className: "wrapper", id: "wrapper-endorsed-footer", "data-testid": "social", children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "endorsed-footer", children: /* @__PURE__ */ b.jsxs("div", { className: "row", children: [
  /* @__PURE__ */ b.jsx("div", { className: "col-md", id: "endorsed-logo", children: /* @__PURE__ */ b.jsx(
    "a",
    {
      href: l,
      onFocus: () => Mt({
        ...Vi,
        type: "internal link",
        text: "asu logo"
      }),
      children: /* @__PURE__ */ b.jsx(
        "img",
        {
          src: o,
          alt: "ASU University Technology Office Arizona State University."
        }
      )
    }
  ) }),
  c && /* @__PURE__ */ b.jsx("div", { className: "col-md", id: "social-media", children: /* @__PURE__ */ b.jsxs("nav", { className: "nav", "aria-label": "Social Media", children: [
    c.facebook && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.facebook,
        "data-testid": "facebook",
        onFocus: () => Mt({
          ...Vi,
          text: "facebook icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ke,
          {
            title: "Facebook Social Media Icon",
            icon: jE,
            className: "social-icon"
          }
        )
      }
    ),
    c.twitter && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.twitter,
        "data-testid": "twitter",
        onFocus: () => Mt({
          ...Vi,
          text: "twitter icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ke,
          {
            title: "Twitter Social Media Icon",
            icon: QE,
            className: "social-icon"
          }
        )
      }
    ),
    c.instagram && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.instagram,
        "data-testid": "instagram",
        onFocus: () => Mt({
          ...Vi,
          text: "instagram icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ke,
          {
            title: "Instagram Social Media Icon",
            icon: LE,
            className: "social-icon"
          }
        )
      }
    ),
    c.youtube && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.youtube,
        "data-testid": "youtube",
        onFocus: () => Mt({
          ...Vi,
          text: "youtube icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ke,
          {
            title: "YouTube Social Media Icon",
            icon: UE,
            className: "social-icon"
          }
        )
      }
    ),
    c.linkedIn && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.linkedIn,
        "data-testid": "linkedin",
        onFocus: () => Mt({
          ...Vi,
          text: "linkedin icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ke,
          {
            title: "LinkedIn Social Media Icon",
            icon: XE,
            className: "social-icon"
          }
        )
      }
    )
  ] }) })
] }) }) });
_d.propTypes = {
  social: an.shape({
    unitLogo: E.string,
    mediaLinks: an.shape({
      facebook: E.string,
      twitter: E.string,
      linkedIn: E.string,
      instagram: E.string,
      youtube: E.string
    })
  })
};
const YE = fu`
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
`, GE = fu`
  display: flex;
  align-items: center;
`, IE = He.footer`
  // Variables
  --color-divider-darker: #1e1e1e;
  --color-base-white: #ffffff;
  --color-base-grey-2: #e8e8e8;
  --color-base-gold: #ffc627;
  --color-divider-lighter: #393939;
  --color-base-grey-7: #191919;
  --color-base-grey-4: #bfbfbf;

  // Base Styles
  * {
    box-sizing: border-box;
    font-family:
      Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
    line-height: 1.5rem;

    a:focus,
    button:focus {
      outline: none;
      box-shadow:
        0 0 0 2px var(--color-base-white),
        0 0 0 4px var(--color-base-grey-7) !important;
      -webkit-tap-highlight-color: transparent;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }

  .btn,
  a[class^="button-"] {
    text-decoration: none !important;
    padding: 1rem 2rem;
    white-space: nowrap;
    line-height: 1rem;
    width: max-content !important;
    font-size: 1rem;
    display: inline-block;
    &:active {
      transform: scale(0.95);
    }
  }

  h5,
  .h5 {
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: -0.015rem;
    margin: 1rem 0;
  }

  .nav {
    display: flex;
    flex-wrap: wrap;
    ${YE}
  }

  // Footer Sections
  #wrapper-endorsed-footer,
  #wrapper-footer-columns {
    background: var(--color-divider-darker);

    h5,
    .h5 {
      color: var(--color-base-white);
      font-weight: 700;
    }
  }

  #wrapper-endorsed-footer {
    a {
      color: var(--color-base-grey-2);
    }

    & + #wrapper-footer-columns {
      border-top: 2px solid var(--color-divider-lighter);
    }
  }

  #wrapper-footer-innovation {
    background-color: var(--color-base-gold);
  }

  #wrapper-footer-colophon {
    background-color: var(--color-base-grey-2);
  }

  #wrapper-footer-innovation,
  #wrapper-footer-colophon {
    a {
      margin-right: 1.5rem;
      text-decoration: none;
      color: var(--color-base-grey-7);
    }
  }

  // Endorsed Footer
  #endorsed-logo {
    --endorsed-logo-display: block;
    --endorsed-logo-padding-top: 12px;
    --endorsed-logo-padding-bottom: 12px;
    --endorsed-logo-img-max-height: 6rem;
    --endorsed-logo-img-width: 100%;
    --endorsed-logo-img-max-width: 320px;
    padding-top: var(--endorsed-logo-padding-top);
    padding-bottom: var(--endorsed-logo-padding-bottom);
    display: var(--endorsed-logo-display);
    align-items: center;

    img {
      width: var(--endorsed-logo-img-width);
      max-width: var(--endorsed-logo-img-max-width);
      height: auto;
      max-height: var(--endorsed-logo-img-max-height);
      transform: scale(1.13);
      padding: 0;
      margin: 0;
    }

    @media (min-width: 768px) {
      --endorsed-logo-display: flex;
      --endorsed-logo-padding-top: 20px;
      --endorsed-logo-padding-bottom: 20px;
      --endorsed-logo-img-max-height: 6rem;
      --endorsed-logo-img-width: auto;
    }
  }

  #endorsed-footer {
    #social-media {
      .nav {
        padding-bottom: 1.5rem;

        .nav-link .social-icon {
          &:hover {
            color: var(--color-base-white);
          }
        }

        @media (min-width: 768px) {
          padding: 2.5rem 0;
          justify-content: flex-end;
        }
      }

      .nav-link {
        padding: 0.75rem 1rem 0.5rem 1rem;
        font-size: 2rem;
        color: var(--color-base-grey-4);
        line-height: 1;
        padding-top: 7px;

        &:first-child {
          @media (max-width: 575.98px) {
            padding-left: 0;
          }
        }

        &:last-child {
          @media (min-width: 768px) {
            /* padding-right: 0; */
          }
        }
      }
    }
  }

  // Footer Columns
  #footer-columns {
    #info-column {
      .contact-link {
        margin-bottom: 1.5rem;

        a {
          color: var(--color-base-grey-2);
          line-height: 1.5rem;
          text-decoration: underline;

          &:hover {
            color: var(--color-base-gold);
          }
        }
      }

      .contribute-button {
        margin-bottom: 1.5rem;
      }
    }

    .flex-footer {
      .accordion-item,
      .footer-accordion-header,
      .footer-accordion-body {
        background: var(--color-divider-darker);
        color: var(--color-base-white);
        border: 0;
      }

      .footer-accordion-header {
        border-top: 1px solid var(--color-divider-lighter);
        padding-left: 0;

        h5,
        .h5 {
          margin: 0;
          a,
          .footer-accordion-button {
            ${GE}
            justify-content: space-between;
          }
        }

        a,
        .footer-accordion-button {
          color: var(--color-base-grey-2);
          padding: 1.5rem 0;
          text-decoration: none;
          background: none;
          border: none;
          font: inherit;
          color: inherit;
          cursor: pointer;
          text-align: inherit;
          width: 100%;
          transition: background-color 0.15s ease;

          &:hover {
            background: var(--color-divider-darker);
          }

          svg,
          fa-chevron-up {
            margin-left: 1rem;
            transition: 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            margin-left: 0.5rem;
            font-size: 1rem;

            &.column-open {
              transform: rotate(180deg);
            }
          }
        }

        @media (min-width: 1260px) {
          border-top: 0;
          padding: 0;
          a,
          .footer-accordion-button {
            padding: 0;
            cursor: default;
          }

          span {
            display: none;
          }
        }
      }

      .footer-accordion-body {
        display: none;
        overflow: hidden;
        padding: 0 0 0 1.5rem;

        &.footer-collapsing {
          display: block;
          max-height: 0px;
        }
        &.footer-column-show {
          display: block;
          max-height: 1000px;
        }

        .nav-link {
          color: var(--color-base-grey-2);
          padding: 0 0 1rem;
          line-height: 1.5rem;
          text-decoration: none;
          display: block;

          &:hover {
            color: var(--color-base-gold);
            text-decoration: underline;
          }
        }

        @media (min-width: 1260px) {
          padding: 0;
          display: block;
          min-height: fit-content;
          overflow: visible;
        }
      }
    }

    @media (min-width: 1260px) {
      padding-bottom: 3rem;
      padding-top: 3rem;
      h5,
      .h5 {
        margin: 0 0 1.5rem 0;
      }
      .footer-accordion-header:has(.h5, h5) {
        h5,
        .h5 {
          margin: 0 0 1.5rem 0;
        }
      }
    }
  }

  // Footer Innovation
  #footer-innovation {
    .footer-innovation-links {
      justify-content: space-between;
      align-items: center;
      font-weight: 700;

      .img-link {
        order: 2;
        margin-right: 0;
        transform: translate(1.5rem, 0);
        padding-top: 24px;
        padding-bottom: 24px;

        img {
          height: auto;
          width: auto;
          max-width: 320px;
        }
      }

      .nav-link {
        padding: 0;
      }

      @media (max-width: 991.98px) {
        flex-direction: column;
        padding: 0.5rem 0;

        .img-link {
          margin-right: 0;
          transform: none;

          img {
            width: 100%;
            height: auto;
            order: -1;
          }
        }

        .nav {
          display: grid;
          grid-template-rows: 1fr 1fr 1fr;
          grid-auto-flow: column;
          justify-items: start;
          width: 100%;

          .nav-link {
            margin-right: 0;
            padding: 0.5rem 0;

            &:nth-child(n + 4) {
              justify-self: end;
            }
          }
        }
      }
      @media (min-width: 991.98px) {
        .img-link {
          padding-right: 16px;
        }
      }
      @media (max-width: 576px) {
        .img-link {
          img {
            max-width: 100%;
          }
        }
      }
    }
  }

  // Footer Colophon
  #wrapper-footer-colophon {
    .colophon {
      margin: 1rem 0;
    }

    .nav-link {
      padding: 0;
    }

    @media (max-width: 767.98px) {
      .nav {
        display: grid;
        grid-template-rows: 1fr 1fr 1fr;
        grid-auto-flow: column;
        justify-items: start;
        width: 100%;

        .nav-link {
          margin-right: 0;
          padding: 0.5rem 0;

          &:nth-child(n + 4) {
            justify-self: end;
          }
        }
      }
    }
  }

  //footer manual consent opt-out
  .footer-legal-links,
  .footer-menu,
  .nav {
    &.colophon #manualConsentoptout,
    #manualConsentoptout {
      color: #484848;
      border: none;
      background-color: transparent;
      width: auto;
      cursor: pointer;
      padding: 0;
      text-align: right;
      justify-self: end;
      font-size: 1rem;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  // Bootstrap Default Stylings
  .row {
    --bs-gutter-x: 24px;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--bs-gutter-y));
    margin-right: calc(-0.5 * var(--bs-gutter-x));
    margin-left: calc(-0.5 * var(--bs-gutter-x));

    > * {
      flex-shrink: 0;
      width: 100%;
      max-width: 100%;
      padding-right: calc(var(--bs-gutter-x) * 0.5);
      padding-left: calc(var(--bs-gutter-x) * 0.5);
      margin-top: var(--bs-gutter-y);
    }
  }

  .col {
    flex: 1 0 0%;
  }

  .d-flex {
    display: flex;
  }

  .container {
    --bs-gutter-x: 24px;
    --bs-gutter-y: 0;
    width: 100%;
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    margin-right: auto;
    margin-left: auto;
  }

  @media (max-width: 767.98px) {
    .container,
    .container-fluid,
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  @media (min-width: 576px) {
    .container {
      max-width: 540px;
    }
  }

  @media (min-width: 768px) {
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
      max-width: 768px;
    }
    .col-md {
      flex: 1 0 0%;
    }
  }

  @media (min-width: 992px) {
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
      max-width: 992px;
    }
  }

  @media (min-width: 1260px) {
    .col-xl-3 {
      flex: 0 0 auto;
      width: 25%;
    }
    .col-xl {
      flex: 1 0 0%;
    }
    .accordion-item {
      svg,
      .fa-chevron-up {
        display: none;
      }
    }
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
      max-width: 1224px;
    }
  }
`, FE = () => /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
  /* @__PURE__ */ b.jsx(BE, {}),
  /* @__PURE__ */ b.jsx(ME, {})
] }), T1 = ({ social: l, contact: o }) => (Ze(() => {
  typeof window < "u" && c0({
    packageName: "component-StyledFooter",
    component: "Component Footer",
    type: "NA",
    configuration: {
      social: l,
      contact: o
    }
  });
}, []), /* @__PURE__ */ b.jsxs(IE, { role: "contentinfo", children: [
  l && /* @__PURE__ */ b.jsx(_d, { social: l }),
  o && /* @__PURE__ */ b.jsx(Jd, { contact: o }),
  /* @__PURE__ */ b.jsx(FE, {})
] }));
T1.propTypes = {
  social: an.shape(_d.propTypes),
  contact: an.shape(Jd.propTypes)
};
const kE = (l, o, c) => {
  n0.createRoot(c).render(ee.createElement(l, o));
}, ET = ({ targetSelector: l, props: o }) => {
  kE(T1, o, document.querySelector(l));
}, qE = "data:image/png;base64,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", KE = { Lg: "992px", Xl: "1260px" }, x1 = Gv(), C1 = ({ initialValue: l, children: o }) => {
  const c = {
    ...l,
    breakpoint: KE[l.breakpoint]
  };
  return /* @__PURE__ */ b.jsx(x1.Provider, { value: c, children: o });
};
C1.propTypes = {
  initialValue: E.shape(jb).isRequired,
  children: E.node.isRequired
};
const Kn = () => {
  const l = Iv(x1);
  if (l === void 0)
    throw new Error("useAppContext must be used within a AppContextProvider");
  return l;
}, st = "uds-hdr-", B = {
  // Login component
  LOGIN_STATUS: `${st}login-status`,
  USER_NAME: `${st}name`,
  SIGNOUT: `${st}signout`,
  // Navigation
  NAV_LINK: `${st}nav-link`,
  NAV_ITEM_SELECTED: `${st}nav-item-selected`,
  OPEN_LINK: `${st}open-link`,
  ICON_NAV_ITEM: `${st}icon-nav-item`,
  MOBILE_ONLY: `${st}mobile-only`,
  CHEVRON_ICON: `${st}chevron-icon`,
  OPEN: `${st}open`,
  // Dropdown
  HEADER_DROPDOWN: (l) => `${st}header-dropdown-${l}`,
  OPENED: `${st}opened`,
  DROPDOWN_CONTAINER: `${st}dropdown-container`,
  DROPDOWN_CONTAINER_COLUMN: `${st}dropdown-container-column`,
  DROPDOWN_BUTTON_CONTAINER: `${st}dropdown-button-container`,
  // Search
  SEARCH_BUTTON: `${st}search-button`,
  OPEN_SEARCH: `${st}open-search`,
  SEARCH_ICON: `${st}search-icon`,
  SUBMIT_BUTTON: `${st}submit-button`,
  SUBMIT_SEARCH: `${st}submit-search`,
  // Header sections
  UNIVERSAL_NAV: `${st}universal-nav`,
  HEADER_TOP: `${st}header-top`,
  LINKS_CONTAINER: `${st}links-container`,
  HEADER_MAIN: `${st}header-main`,
  CONTENT_CONTAINER: `${st}content-container`,
  NAV_LIST: `${st}nav-list`,
  BUTTONS_CONTAINER: `${st}buttons-container`,
  NAV_BUTTON: `${st}nav-button`,
  UL_HEADING: `${st}ul-heading`,
  // Title
  TITLE: `${st}title`,
  PARTNER_TITLE: `${st}partner-title`,
  UNIT_NAME: `${st}unit-name`,
  SUBUNIT_NAME: `${st}subunit-name`,
  TITLE_SUBUNIT_NAME: `${st}title-subunit-name`,
  EXPAND_TITLE: `${st}expand-title`,
  NO_NAVIGATION: `${st}no-navigation`,
  // Partner/Logo
  PARTNER: `${st}partner`,
  PARTNERS_LOGOS: `${st}partners-logos`,
  LOGO_VERT: `${st}vert`,
  LOGO_HORIZ: `${st}horiz`,
  // Menu icons
  MENU_SEARCH_ICON: `${st}menu-search-icon`,
  MENU_CLOSE_ICON: `${st}menu-close-icon`,
  NAVBAR: "navbar",
  NAVBAR_EXPAND_XL: "navbar-expand-xl",
  NAVBAR_BRAND: "navbar-brand",
  NAVBAR_TOGGLER: "navbar-toggler",
  NAVBAR_NAV: "navbar-nav",
  NAV_ITEM: "nav-item",
  COLLAPSED: "collapsed",
  CONTAINER: "container",
  CONTAINER_XL: "container-xl",
  FORM_CONTROL: "form-control",
  VISUALLY_HIDDEN: "visually-hidden",
  VISUALLY_HIDDEN_FOCUSABLE: "visually-hidden-focusable",
  MOBILE_MENU_OPEN: `${st}mobile-menu-open`
}, PA = (l) => B.HEADER_DROPDOWN(l), Dn = (...l) => l.filter(Boolean).join(" "), Or = (l) => {
  const o = window == null ? void 0 : window.matchMedia(`(max-width: ${l})`), [c, s] = vn(o == null ? void 0 : o.matches), u = (d) => {
    s(d.matches);
  };
  return Ze(() => (o.addEventListener("change", u), () => o.removeEventListener("change", u)), []), c;
}, ZE = He.div`
  background-color: ${_S};
  padding: 0.5rem 0rem;
  transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
  .${B.HEADER_TOP} {
    height: 100%;
    .nav {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .${B.LINKS_CONTAINER} {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;
        .${B.NAV_LINK} {
          color: ${on};
          font-size: 0.75rem;
          line-height: 1;
          white-space: nowrap;
          text-decoration: none;
          display: flex;
          align-items: center;

          &:hover {
            text-decoration: underline;
          }

          &.visually-hidden-focusable:not(:focus):not(:active) {
            clip: rect(0 0 0 0);
            clip-path: inset(100%);
            height: 1px;
            overflow: hidden;
            position: absolute;
            white-space: nowrap;
            width: 1px;
          }
        }
      }
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    min-height: auto;
    position: sticky;
    bottom: 0;
    padding: 0;
    .${B.HEADER_TOP} {
      width: 100%;
      .nav {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column-reverse;
        .${B.LINKS_CONTAINER} {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-auto-flow: row;
          justify-items: start;
          width: 100%;
          gap: 0;
          border-top: 1px solid ${ln};
          border-left: 1px solid ${ln};
          .${B.NAV_LINK} {
            white-space: normal;
            margin-right: 0;
            text-align: center;
            width: 100%;
            font-size: 0.875rem;
            padding: 1rem 1.5rem;
            border-bottom: 1px solid ${ln};
            border-right: 1px solid ${ln};
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;

            &.visually-hidden-focusable:not(:focus):not(:active) {
              border: none;
            }
          }
        }
      }
    }
  }

  @media screen and (orientation: landscape) and (max-width: ${({
  breakpoint: l
}) => l}) {
    .${B.HEADER_TOP} .nav .${B.LINKS_CONTAINER} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }
`, PE = He.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
  > a {
    padding: 0;
    margin: 0;
    color: ${on};
    text-decoration: none;
    line-height: 1;
    vertical-align: middle;
  }
  > span.${B.USER_NAME} {
    font-weight: 700;
    line-height: 1;
  }
  > a.${B.SIGNOUT}:before {
    content: "(";
    margin-left: 4px;
  }
  > a.${B.SIGNOUT}:after {
    content: ") ";
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    margin-right: 0;
    justify-content: center;
  }
`, WA = {
  section: "topbar"
}, WE = () => {
  const {
    loggedIn: l,
    userName: o,
    logoutLink: c,
    loginLink: s,
    onLoginClick: u,
    onLogoutClick: d,
    breakpoint: h
  } = Kn();
  return (
    // @ts-ignore
    /* @__PURE__ */ b.jsx(
      PE,
      {
        className: Dn(B.NAV_LINK, B.LOGIN_STATUS),
        breakpoint: h,
        children: l ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
          o ? /* @__PURE__ */ b.jsx("span", { className: B.USER_NAME, "data-testid": "user-name", children: o }) : "",
          /* @__PURE__ */ b.jsx(
            "a",
            {
              className: B.SIGNOUT,
              href: c,
              onFocus: () => Mt({
                ...WA,
                text: "sign out"
              }),
              onClick: (p) => d == null ? void 0 : d(p),
              children: "Sign Out"
            }
          )
        ] }) : /* @__PURE__ */ b.jsx(
          "a",
          {
            href: s,
            onFocus: () => Mt({
              ...WA,
              text: "sign in"
            }),
            onClick: (p) => u == null ? void 0 : u(p),
            children: "Sign In"
          }
        )
      }
    )
  );
}, JE = He.form`
  display: flex;
  align-items: center;
  button {
    border: none;
    background: transparent;
    cursor: pointer;
  }
  .${B.SEARCH_BUTTON} {
    transition: cubic-bezier(0.19, 1, 0.19, 1);
    font-size: 0.75rem;
    line-height: 1;
    color: ${on};
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    span {
      margin-right: 0.25rem;
    }
  }
  input[name="q"] {
    width: 200px;
    background-color: ${qn};
    border: 0;
    border-radius: 0;
    padding: 0.5rem 0.5rem;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1;
    color: ${t3};
    border: 1px solid ${ln};
    outline: ${on};
    margin-left: 1.5rem;
    display: unset;
    vertical-align: middle;

    &::placeholder {
      font-size: 0.75rem;
      line-height: 1;
    }
    &:focus,
    &:focus-visible {
      border: 1px solid ${on};
    }
  }
  .${B.SUBMIT_BUTTON} {
    margin-left: 0.5rem;
  }
  .${B.CLOSE_SEARCH} {
    background-color: ${qn};
    border: 1px solid ${ln};
    border-radius: 100%;
    padding: 0.45rem 0.75rem;
    margin-left: 0.5rem;
  }
  &.${B.OPEN_SEARCH} {
    margin-left: -1rem;
    .${B.SEARCH_BUTTON} {
      transform: translate(1.9rem);
      pointer-events: none;
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    padding: 0 1rem 1rem;
    label {
      position: relative;
      font-size: 0.875rem;
      margin-bottom: 0;
      width: 100%;
      svg.${B.SEARCH_ICON} {
        position: absolute;
        top: 50%;
        left: 1rem;
        transform: translate(0, -50%);
      }
      input[name="q"] {
        width: 100%;
        margin: 0;
        padding: 0.5rem 3rem 0.5rem 2.25rem;
        font-size: 1rem;
        line-height: 1.5;

        &::placeholder {
          font-size: 1rem;
          line-height: 1.5;
        }

        &::-webkit-search-cancel-button,
        &::-webkit-search-decoration,
        &::-webkit-search-results-button,
        &::-webkit-search-results-decoration {
          display: none;
        }
      }
      .${B.SUBMIT_SEARCH} {
        position: absolute;
        top: 50%;
        right: 0.5rem;
        transform: translate(0, -50%);
        border-radius: 50%;
        width: 2rem;
        height: 2rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        background-color: ${Xd};
        color: ${qn};
        font-size: 0.75rem;
      }
    }
  }
`, Bd = ({
  inputRef: l,
  hasInputValue: o,
  setHasInputValue: c,
  isMobile: s,
  style: u = {},
  className: d = "",
  onBlur: h
}) => {
  const p = (O) => {
    const M = O.target.value;
    c(M.length > 0);
  }, y = {
    ref: l,
    className: `form-control ${d}`,
    type: "search",
    name: "q",
    placeholder: "Search asu.edu",
    required: !0,
    onChange: p,
    onBlur: h,
    style: {
      paddingLeft: o && s ? "1rem" : void 0,
      ...u
    }
  };
  return s ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    !o && /* @__PURE__ */ b.jsx(
      Ke,
      {
        className: B.SEARCH_ICON,
        icon: cd
      }
    ),
    /* @__PURE__ */ b.jsx("input", { ...y }),
    o && /* @__PURE__ */ b.jsx(
      "button",
      {
        type: "submit",
        "aria-label": "Submit search",
        className: B.SUBMIT_SEARCH,
        children: /* @__PURE__ */ b.jsx(Ke, { icon: cd, size: "lg" })
      }
    )
  ] }) : /* @__PURE__ */ b.jsx("input", { ...y });
};
Bd.propTypes = {
  inputRef: E.shape({
    current: E.instanceOf(Element)
  }).isRequired,
  hasInputValue: E.bool.isRequired,
  setHasInputValue: E.func.isRequired,
  isMobile: E.bool.isRequired,
  style: E.object,
  className: E.string,
  onBlur: E.func
};
const JA = {
  event: "search",
  action: "type",
  name: "onenter",
  type: "main search",
  region: "navbar",
  section: "topbar"
}, N1 = () => {
  const { breakpoint: l, searchUrl: o = "", site: c = "" } = Kn(), s = Or(l), u = Yl(null), [d, h] = vn(!1), [p, y] = vn(!1);
  Ze(() => {
    var w;
    d && typeof ((w = u == null ? void 0 : u.current) == null ? void 0 : w.focus) == "function" && u.current.focus();
  }, [d]);
  const O = (w) => {
    const x = w == null ? void 0 : w.currentTarget;
    w.preventDefault();
    const $ = x && x.elements ? (
      /** @type {HTMLInputElement|null} */
      x.elements.namedItem("q")
    ) : null;
    Mt({
      ...JA,
      text: $ ? $.value : ""
    }), setTimeout(() => {
      typeof (x == null ? void 0 : x.submit) == "function" && x.submit();
    }, 100);
  }, M = () => {
    h((w) => {
      const x = !w;
      return Mt({
        ...JA,
        event: "link",
        action: "click",
        name: "onclick",
        text: x ? "search icon" : "close search icon"
      }), x;
    });
  };
  return /* @__PURE__ */ b.jsx("search", { children: /* @__PURE__ */ b.jsxs(
    JE,
    {
      breakpoint: l,
      action: o,
      onSubmit: O,
      method: "get",
      name: "gs",
      className: d ? B.OPEN_SEARCH : "",
      "data-testid": "universal-nav-search-form",
      role: "search",
      children: [
        s ? /* @__PURE__ */ b.jsx("label", { children: /* @__PURE__ */ b.jsx(
          Bd,
          {
            inputRef: u,
            hasInputValue: p,
            setHasInputValue: y,
            isMobile: s
          }
        ) }) : /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
          !d && /* @__PURE__ */ b.jsxs(
            "button",
            {
              type: "button",
              "aria-label": "Search asu.edu",
              onClick: M,
              className: B.SEARCH_BUTTON,
              "data-testid": "search-button",
              children: [
                /* @__PURE__ */ b.jsx("span", { children: "Search" }),
                /* @__PURE__ */ b.jsx(Ke, { icon: cd })
              ]
            }
          ),
          d && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
            /* @__PURE__ */ b.jsx(
              Bd,
              {
                inputRef: u,
                hasInputValue: p,
                setHasInputValue: y,
                isMobile: s,
                onBlur: () => {
                  p || h(!1);
                }
              }
            ),
            /* @__PURE__ */ b.jsx(
              Zi,
              {
                color: "dark",
                text: "Search",
                as: "button",
                classes: B.SUBMIT_BUTTON
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ b.jsx("input", { name: "url_host", value: c, type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "site", value: "default_collection", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "sort", value: "date:D:L:d1", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "output", value: "xml_no_dtd", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "ie", value: "UTF-8", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "oe", value: "UTF-8", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "client", value: "asu_frontend", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "proxystylesheet", value: "asu_frontend", type: "hidden" })
      ]
    }
  ) });
}, _E = {
  event: "link",
  action: "click",
  name: "onclick",
  region: "navbar",
  type: "internal link",
  section: "topbar",
  text: ""
}, w1 = () => {
  const { breakpoint: l } = Kn(), o = Or(l);
  function c() {
    try {
      return window.location.href;
    } catch (u) {
      return console.error(u), "";
    }
  }
  const s = [
    {
      className: Dn(
        B.NAV_LINK,
        B.VISUALLY_HIDDEN_FOCUSABLE
      ),
      href: "#skip-to-content",
      text: "Skip to main content"
    },
    {
      className: Dn(
        B.NAV_LINK,
        B.VISUALLY_HIDDEN_FOCUSABLE
      ),
      href: `https://accessibility.asu.edu/report#a11yref=${c()}`,
      text: "Report an accessibility problem"
    },
    {
      className: B.NAV_LINK,
      href: "https://asu.edu",
      text: "ASU Home"
    },
    {
      className: B.NAV_LINK,
      href: "https://my.asu.edu",
      text: "My ASU"
    },
    {
      className: B.NAV_LINK,
      href: "https://www.asu.edu/academics/colleges-schools",
      text: "Colleges and Schools"
    }
  ];
  return /* @__PURE__ */ b.jsx(
    ZE,
    {
      breakpoint: l,
      className: B.UNIVERSAL_NAV,
      "data-testid": "universal-navbar",
      "data-elastic-exclude": "data-elastic-exclude",
      children: /* @__PURE__ */ b.jsx("div", { className: "container-xl", children: /* @__PURE__ */ b.jsx("div", { className: B.HEADER_TOP, children: /* @__PURE__ */ b.jsxs("nav", { className: "nav", "aria-label": "ASU Global", children: [
        /* @__PURE__ */ b.jsxs("div", { className: B.LINKS_CONTAINER, children: [
          s.map((u) => /* @__PURE__ */ b.jsx(
            "a",
            {
              className: u.className,
              href: u.href,
              onClick: () => Mt({ ..._E, text: u.text }),
              children: u.text
            },
            u.href
          )),
          /* @__PURE__ */ b.jsx(WE, {})
        ] }),
        !o && /* @__PURE__ */ b.jsx(N1, {})
      ] }) }) })
    }
  );
}, $E = He.div`
  background-color: ${qn};
  border-bottom: 1px solid ${ln};
  padding: 0 12px;
  .navbar {
    padding: 0;
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
  }
  .navbar.${B.MOBILE_MENU_OPEN} {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto auto 1fr;
    grid-template-areas:
      "logo . toggler"
      "title title title"
      "search search search"
      "nav nav nav";

    height: calc(100dvh - ${({ headerTop: l }) => l}px);
    overflow: hidden;
    .${B.PARTNER_TITLE}, .navbar-brand {
      grid-area: logo;
      grid-column: 1;
      grid-row: 1;
    }
    .navbar-toggler {
      grid-area: toggler;
      grid-column: 3;
      grid-row: 1;
    }
    .${B.EXPAND_TITLE} {
      grid-area: title;
    }
    & > * {
      grid-column: 1 / -1;
    }
    & > form {
      grid-area: search;
    }
    & > nav {
      grid-area: nav;
      display: grid;
      grid-template-rows: 1fr auto;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
  .navbar-brand {
    .${B.LOGO_VERT} {
      display: block;
      height: 72px;
      width: auto;
      margin: 20px 1rem 20px 0;
    }
    .${B.LOGO_HORIZ} {
      display: none;
    }
  }
  .navbar-toggler {
    display: none;
  }
  .${B.EXPAND_TITLE} {
    width: 100%;
  }
  @media (min-width: ${({ breakpoint: l }) => l}) {
    .${B.NO_NAVIGATION} {
      margin-top: 16px;
      display: flex;
      align-items: center;
      .${B.TITLE} {
        width: 100%;
      }
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    padding: 0;
    .navbar {
      padding: 1.5rem 0 0 0;
      flex-wrap: wrap;
      justify-content: space-between;
      &.${B.PARTNER} {
        flex-direction: row-reverse;
      }
    }
    .${B.PARTNER} .${B.CONTENT_CONTAINER} {
      min-height: calc(100vh - 240px);
    }
    .navbar-brand {
      padding: 0;
      margin: 0;

      .${B.LOGO_VERT} {
        display: none;
      }

      .${B.LOGO_HORIZ} {
        display: block;
        height: 32px;
        width: auto;
        margin-bottom: 1rem;
        margin-left: 2rem;
      }
    }
    .navbar-toggler {
      display: initial;
      background: transparent;
      color: ${on};
      border: 0;
      border-radius: 0;
      font-size: 1.25rem;
      margin-right: 2rem;
      cursor: pointer;
      min-width: 44px;
      min-height: 44px;
      padding: 0.25rem 0.45rem;

      .${B.MENU_SEARCH_ICON} {
        display: none;
      }

      &.collapsed {
        .${B.MENU_SEARCH_ICON} {
          width: 24px;
          height: auto;
          display: unset;
        }
        .${B.MENU_CLOSE_ICON} {
          display: none;
        }
      }
      .${B.NO_NAVIGATION} + nav .${B.BUTTONS_CONTAINER} {
        border-top: 1px solid ${Jc};
      }
    }
  }
`, D1 = "data:image/png;base64,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", B1 = "data:image/png;base64,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", tT = He.a`
  display: unset;
  padding: 0;
  margin: 0;
  font-size: unset;
  line-height: unset;
  white-space: unset;
`, eT = () => {
  const { logo: l } = Kn();
  return /* @__PURE__ */ b.jsxs(
    tT,
    {
      href: (l == null ? void 0 : l.brandLink) ?? "https://asu.edu",
      className: B.NAVBAR_BRAND,
      "data-testid": "logo",
      onFocus: () => Mt({ text: "asu logo" }),
      children: [
        /* @__PURE__ */ b.jsx(
          "img",
          {
            className: B.LOGO_VERT,
            src: (l == null ? void 0 : l.src) ?? D1,
            alt: (l == null ? void 0 : l.alt) ?? "Arizona State University logo",
            title: (l == null ? void 0 : l.title) ?? "ASU homepage",
            width: "303",
            height: "234",
            decoding: "async",
            fetchpriority: "high"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "img",
          {
            className: B.LOGO_HORIZ,
            src: (l == null ? void 0 : l.mobileSrc) ?? B1,
            alt: (l == null ? void 0 : l.alt) ?? "Arizona State University logo",
            title: (l == null ? void 0 : l.title) ?? "ASU homepage",
            width: "400",
            height: "72",
            decoding: "async",
            fetchpriority: "high"
          }
        )
      ]
    }
  );
}, nT = He.nav`
  white-space: nowrap;
  > .${B.CONTENT_CONTAINER} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: none;
    height: auto;
    margin: inherit;
    font-size: inherit;
    color: inherit;
    flex-direction: row;
  }
  .${B.NAV_LIST} {
    display: flex;
    margin: 0;
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    > .${B.CONTENT_CONTAINER} {
      flex-direction: column;
      justify-content: flex-start;
      overflow-y: auto;
      min-height: 0;
      > *:last-child {
        margin-bottom: min(75px, 15vw);
      }
    }
    .${B.NAV_LIST} {
      flex-direction: column;
      width: 100%;
    }
    .${B.BUTTONS_CONTAINER} {
      display: flex;
      align-items: center;
      padding: 1rem 2rem;
      width: 100%;
    }
  }
`, aT = He.div`
  --container-width: 1200px;
  --gap: 2rem;
  position: fixed;
  background-color: ${qn};
  border: 1px solid ${ln};
  margin: 0;
  z-index: 1031;
  visibility: hidden;
  white-space: normal;
  &.${B.OPENED} {
    visibility: visible;
  }
  &.mega {
    width: min(var(--container-width), 100%);
    left: calc((100% - var(--container-width)) / 2);
  }
  &.aligned-right:not(.mega) {
    position: absolute;
    right: 0;
  }
  > .${B.DROPDOWN_CONTAINER} {
    max-width: var(--container-width);
    margin: 0 auto;
    /*
      max-height is calculated from
      100% view Height
      minus header
      minus 2rem padding
      minus 4rem cta buttons - future we could add a ref to measure if needed
    */
    max-height: calc(
      100vh - ${({ headerHeight: l }) => l}px - 2rem - 4rem
    );
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    justify-content: stretch;

    .${B.DROPDOWN_CONTAINER_COLUMN} {
      --span: 1; /* component overrides using inline style */
      --col: 1; /* component overrides using inline style */
      width: calc(var(--container-width) / var(--cols) * var(--span));
      padding: var(--gap);
      padding-bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      row-gap: var(--gap);

      & > *:last-child {
        padding-bottom: var(--gap);
      }

      &:not(:last-child) {
        border-right: 1px solid ${ln};
      }
    }

    .${B.UL_HEADING} {
      margin-top: 0;
      font-size: 1.5rem;
      letter-spacing: -0.035em;
      font-weight: 700;
      text-align: left;
      opacity: 1;
      margin: 0;
      margin-bottom: -1.5rem;
      line-height: calc(100% + 0.12em);
    }
    ul {
      --ul-gap: 1rem;
      &:is(:last-child) {
        flex-grow: 0;
      }
      margin: 0;
      width: calc(
        var(--container-width) / var(--cols, 1) * var(--span, 1) - var(--gap) *
          2
      );
      display: flex;
      flex-direction: row;
      column-gap: var(--ul-gap);
      flex-wrap: wrap;
      .${B.NAV_LINK} {
        padding: 0;
        flex-basis: calc(
          (100% / var(--span)) - var(--ul-gap) * (var(--span) - 1) / var(--span)
        );
        a {
          width: 100%;
          display: inline-block;
          margin: 0.75rem 0;
          position: relative;
          line-height: 1rem;
          color: ${on};
          &:hover {
            color: ${Xd};
            text-decoration: underline;
          }
        }
        & + .${B.NAV_BUTTON} {
          width: 100%;
          margin-top: auto;
          padding-top: var(--gap);
          & + .${B.NAV_BUTTON} {
            margin-top: 1rem;
          }
        }
      }
    }
  }

  .${B.NAV_BUTTON} {
    flex: 1 1;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-wrap: nowrap;
    width: fit-content;
  }
  .${B.DROPDOWN_BUTTON_CONTAINER} {
    border-top: 1px solid ${ln};
    border-bottom: 1px solid ${ln};
    > div {
      max-width: var(--container-width);
      margin: 0 auto;
      display: flex;
      padding: 1rem 2rem;
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    position: initial;
    border: none;
    max-height: unset;
    visibility: visible;
    display: none;
    &.${B.OPENED} {
      display: block;
    }
    > .${B.DROPDOWN_CONTAINER} {
      max-width: 100%;
      max-height: unset;
      overflow-y: unset;
      overflow-x: unset;
      flex-direction: column;

      .${B.DROPDOWN_CONTAINER_COLUMN} {
        width: 100%;
        border-right: unset;
        &:not(:first-child) {
          padding-top: 0;
        }
      }
      ul {
        width: 100%;
        max-width: 100%;
        padding: 0;
        &:not(:last-child) {
          border: none;
        }
        .${B.UL_HEADING} {
          font-size: 1.25rem;
        }
        .${B.NAV_BUTTON} {
          // padding-top: 1.5rem;
        }
        .${B.NAV_LINK} {
          flex-basis: 100%;
          padding: 0 1rem;
          &:not(:last-child) {
            border-bottom: 1px solid ${ln};
          }
          a {
            padding: 1rem 0;
            margin: 0;
          }
        }
      }
    }
    .${B.DROPDOWN_BUTTON_CONTAINER} {
      margin-top: 0;
      > div {
        max-width: 100%;
        padding: 1rem 3rem;
      }
    }
  }
`, lT = {
  event: "link",
  action: "click",
  name: "onclick",
  type: "internal link",
  region: "navbar",
  section: "main navbar",
  component: "dropdown menu",
  text: ""
}, M1 = ({ text: l }) => /* @__PURE__ */ b.jsx("h3", { className: B.UL_HEADING, children: l });
M1.propTypes = {
  text: E.string
};
const z1 = ({ link: l, dropdownName: o, handleLinkEvent: c }) => /* @__PURE__ */ b.jsx("div", { className: B.NAV_BUTTON, children: /* @__PURE__ */ b.jsx(
  Zi,
  {
    text: l.text,
    color: l.color || "maroon",
    href: l.href,
    onClick: (s) => c(s, l),
    onKeyDown: (s) => c(s, l)
  }
) });
z1.propTypes = {
  link: E.shape({
    text: E.string,
    color: E.string,
    href: E.string
  }),
  dropdownName: E.string,
  handleLinkEvent: E.func
};
const L1 = ({ link: l, dropdownName: o, handleLinkEvent: c }) => /* @__PURE__ */ b.jsx("li", { className: B.NAV_LINK, children: /* @__PURE__ */ b.jsx(
  "a",
  {
    ...l.href ? {} : { tabIndex: 0 },
    href: l.href,
    onClick: (s) => c(s, l),
    onKeyDown: (s) => c(s, l),
    children: l.text
  }
) });
L1.propTypes = {
  link: E.shape({
    text: E.string,
    href: E.string
  }),
  dropdownName: E.string,
  handleLinkEvent: E.func
};
const R1 = ({
  dropdownName: l,
  items: o = [],
  buttons: c = [],
  classes: s = "",
  listId: u,
  opened: d,
  parentLink: h
}) => {
  const {
    breakpoint: p,
    headerHeight: y,
    setItemOpened: O,
    setMobileMenuOpen: M,
    mobileMenuOpen: w
  } = Kn(), x = o.reduce((V, P) => P != null && P[0] ? V + (P[0].span || 1) : V, 0), $ = x > 2, j = Yl(null), [q, I] = vn(!1), K = o.length > 1;
  Ze(() => {
    var V;
    if (typeof window < "u" && j.current) {
      const P = (V = j == null ? void 0 : j.current) == null ? void 0 : V.getBoundingClientRect().left, G = window.innerWidth * 0.55;
      I(P > G);
    }
  }, []), Ze(() => {
    var V;
    d && ((V = j == null ? void 0 : j.current) != null && V.parentElement) && j.current.parentElement.scrollIntoView(
      /** @type {ScrollIntoViewOptions} */
      {
        behavior: "smooth",
        block: "start"
      }
    );
  }, [j, d]);
  const H = (V) => V == null ? void 0 : V.stopPropagation(), et = (V, P) => {
    var Ct, le;
    const { key: G, type: W, target: ct } = V, Tt = ct == null ? void 0 : ct.parentElement, yt = () => {
      var Y;
      const Nt = (Y = Tt == null ? void 0 : Tt.nextElementSibling) == null ? void 0 : Y.firstChild;
      typeof (Nt == null ? void 0 : Nt.focus) == "function" && Nt.focus();
    }, zt = () => {
      var Y;
      const Nt = (Y = Tt == null ? void 0 : Tt.previousElementSibling) == null ? void 0 : Y.firstChild;
      typeof (Nt == null ? void 0 : Nt.focus) == "function" && Nt.focus();
    };
    H(V), G === "ArrowDown" ? (V.preventDefault(), yt()) : G === "ArrowUp" ? (V.preventDefault(), zt()) : G === "Escape" && d ? (O(), typeof ((Ct = h == null ? void 0 : h.current) == null ? void 0 : Ct.focus) == "function" && h.current.focus()) : G === "Escape" && !d && w ? M(!1) : (G === "Enter" || G === " " || W === "click") && (M(!1), O(), (le = P == null ? void 0 : P.onClick) == null || le.call(P, V), Mt({ ...lT, text: P.text }));
  }, nt = (V, P) => {
    if (!V) return null;
    const G = `${V.text}-${V.href}-${P}`;
    return V.type === "heading" ? /* @__PURE__ */ b.jsx(M1, { text: V.text }, G) : V.type === "button" ? /* @__PURE__ */ b.jsx(
      z1,
      {
        link: V,
        dropdownName: l,
        handleLinkEvent: et
      },
      G
    ) : /* @__PURE__ */ b.jsx(
      L1,
      {
        link: V,
        dropdownName: l,
        handleLinkEvent: et
      },
      G
    );
  };
  return /* @__PURE__ */ b.jsxs(
    aT,
    {
      ref: j,
      className: `${s}${q ? " aligned-right" : ""}${$ ? " mega" : ""}`,
      breakpoint: p,
      headerHeight: y,
      children: [
        /* @__PURE__ */ b.jsx(
          "div",
          {
            style: { "--cols": x < 3 ? 4 : x },
            id: K ? u : "",
            className: B.DROPDOWN_CONTAINER,
            children: /* @__PURE__ */ b.jsx(b.Fragment, { children: o == null ? void 0 : o.map((V, P) => {
              const W = o0(`dropdown-item-${P}-`).next().value;
              return V != null && V.length ? /* @__PURE__ */ b.jsx(
                "div",
                {
                  className: B.DROPDOWN_CONTAINER_COLUMN,
                  style: { "--span": V[0].span || 1 },
                  id: K ? `${u}-${W}` : u,
                  children: (() => {
                    let ct = [];
                    const Tt = [];
                    return V.forEach((yt, zt) => {
                      yt.type === "heading" ? (ct.length > 0 && (Tt.push(ct), ct = []), Tt.push([yt])) : yt.type === "button" ? (ct.length > 0 && (Tt.push(ct), ct = []), Tt.push([yt])) : ct.push(yt);
                    }), ct.length > 0 && Tt.push(ct), Tt.map((yt, zt) => {
                      const Ct = `${W}-group-${zt}`;
                      return yt.length === 1 && yt[0].type === "heading" || yt.length === 1 && yt[0].type === "button" ? nt(yt[0], zt) : /* @__PURE__ */ b.jsx("ul", { children: yt.map((le, Nt) => nt(le, Nt)) }, Ct);
                    });
                  })()
                },
                `${u}-${W}`
              ) : null;
            }) })
          }
        ),
        c.length > 0 && /* @__PURE__ */ b.jsx("div", { className: B.DROPDOWN_BUTTON_CONTAINER, children: /* @__PURE__ */ b.jsx("div", { children: c.map((V, P) => /* @__PURE__ */ b.jsx(
          Zi,
          {
            color: V.color,
            text: V.text,
            href: V.href,
            onClick: H
          },
          `${V.text}-${V.href || P}`
        )) }) })
      ]
    }
  );
};
R1.propTypes = {
  dropdownName: E.string,
  items: E.arrayOf(
    E.arrayOf(
      E.shape({
        text: E.string,
        selected: E.bool,
        onClick: E.func,
        href: E.string
      })
    )
  ),
  buttons: E.arrayOf(E.shape(iu)),
  classes: E.string,
  listId: E.string,
  opened: E.bool,
  setItemOpened: E.func,
  parentLink: E.shape({
    current: E.instanceOf(HTMLElement)
  })
};
const iT = He.li`
  position: relative;
  padding: 0;
  max-width: 100%;
  margin: 0 0.5rem 0 0;
  &:has(.${B.OPEN_LINK}) > a:after,
  &:hover > a:after {
    width: calc(100% + 24px);
  }
  > a {
    display: inline-block;
    padding: 0.5rem 0.75rem;
    line-height: 1rem;
    color: ${on};

    &[aria-expanded="true"] {
      background-color: ${qn};
      position: sticky;
      top: 0;
      z-index: 1;
    }
    &:after {
      transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      content: "";
      display: block;
      height: 0.5rem;
      position: relative;
      top: 0.6rem;
      right: 12px;
      width: 0;
      background-image: linear-gradient(
        to right,
        transparent 0.5%,
        ${Qd} 0.5%
      );
    }
    &.${B.NAV_ITEM_SELECTED}:after {
      width: calc(100% + 24px);
    }
    &.nav-item {
      display: block;
    }
    > span {
      position: relative;
      .${B.CHEVRON_ICON} {
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
        margin-left: 0.5rem;
        font-size: 0.75rem;

        &.${B.OPEN} {
          transform: rotate(180deg);
        }
      }
    }
    .${B.MOBILE_ONLY} {
      display: none;
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    border-bottom: 1px solid ${Jc};
    margin: 0;
    &:first-child {
      border-top: 1px solid ${Jc};
    }
    &:hover > a:after {
      width: 100%;
    }
    .${B.ICON_NAV_ITEM} {
      display: none;
    }
    > a {
      padding: 1rem 2rem 0.75rem;
      width: 100%;
      &.${B.OPEN_LINK} {
        border-bottom: 1px solid ${Jc};
      }
      &:after {
        right: 0;
        top: 0.8rem;
      }
      &.${B.NAV_ITEM_SELECTED}:after {
        width: 100%;
      }
      > span {
        display: flex;
        justify-content: space-between;
        .${B.CHEVRON_ICON} {
          font-size: 1.25rem;
        }
      }
      .${B.MOBILE_ONLY} {
        display: initial;
      }
    }
  }
`, oT = {
  event: "collapse",
  type: "click"
}, Wf = {
  event: "link",
  action: "click",
  name: "onclick",
  type: "internal link",
  region: "navbar",
  section: "main navbar",
  component: "navigation link",
  text: ""
}, U1 = ({ children: l }) => /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
  /* @__PURE__ */ b.jsx(
    Ke,
    {
      icon: a3,
      className: B.ICON_NAV_ITEM,
      alt: ""
    }
  ),
  /* @__PURE__ */ b.jsx("span", { className: B.MOBILE_ONLY, children: l })
] });
U1.propTypes = {
  children: E.node
};
const H1 = ({ link: l, setItemOpened: o, itemOpened: c }) => {
  const s = Yl(null), u = Yl(null), d = l.id === c, {
    breakpoint: h,
    expandOnHover: p = !1,
    title: y,
    mobileMenuOpen: O = !1,
    setMobileMenuOpen: M
  } = Kn(), w = Or(h);
  Ze(() => {
    const I = (H) => {
      var et;
      d && !w && !((et = s == null ? void 0 : s.current) != null && et.contains(H == null ? void 0 : H.target)) && o();
    }, K = () => {
      requestAnimationFrame(() => {
        const H = s.current;
        d && !w && H && !H.contains(document.activeElement) && o();
      });
    };
    return document.addEventListener("click", I, !0), document.addEventListener("focusin", K), () => {
      document.removeEventListener("click", I, !0), document.removeEventListener("focusin", K);
    };
  }, [d, o, w]);
  const x = Fv(() => {
    var I;
    return l.type === "icon-home" ? /* @__PURE__ */ b.jsx(U1, { children: l.text }) : /* @__PURE__ */ b.jsxs("span", { children: [
      l.text,
      !!((I = l.items) != null && I.length) && /* @__PURE__ */ b.jsx(
        Ke,
        {
          icon: Q0,
          className: Dn(
            B.CHEVRON_ICON,
            d && B.OPEN
          ),
          alt: ""
        }
      )
    ] });
  }, [l]), $ = () => {
    var et;
    const I = !!((et = l.items) != null && et.length), K = d ? "close" : "open", { text: H } = l;
    Mt(
      // @ts-ignore
      I ? {
        ...Wf,
        ...oT,
        action: K,
        text: H
      } : {
        ...Wf,
        text: l.type === "icon-home" ? "home button" : H
      }
    );
  }, j = (I) => {
    var et, nt, V, P;
    if (!l.items && (l.href || l.onClick) && (I.key === "Enter" || I.key === " " || I.type === "click")) {
      Mt({ ...Wf, text: l.text }), M(!1), o(), (et = l.onClick) == null || et.call(l, I);
      return;
    }
    const { key: K } = I;
    if ([
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Enter",
      " ",
      "Escape",
      "Click"
    ].includes(K)) {
      if (I.preventDefault(), K === "Escape" && d) {
        typeof ((nt = s == null ? void 0 : s.current) == null ? void 0 : nt.focus) == "function" && s.current.focus(), o();
        return;
      }
      if (K === "Escape" && !d && O) {
        M(!1);
        return;
      }
      if ((K === "Enter" || K === " ") && (l.items ? o() : (M(!1), o(), (V = l.onClick) == null || V.call(l, I)), $()), (K === "ArrowDown" || K === "ArrowRight") && d) {
        const G = document.querySelector(
          `.${PA(l.id)} li.${B.NAV_LINK} a`
        );
        typeof (G == null ? void 0 : G.focus) == "function" && G.focus();
      }
    } else I.type === "click" && l.items ? (I.preventDefault(), $(), o()) : I.type === "click" && ($(), (P = l.onClick) == null || P.call(l, I));
  }, q = () => {
    p && !w && (o(), $());
  };
  return /* @__PURE__ */ b.jsxs(
    iT,
    {
      breakpoint: h,
      ref: s,
      onMouseEnter: q,
      onMouseLeave: q,
      children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            onKeyDown: j,
            onClick: j,
            href: l.href,
            ...l.items ? { "aria-expanded": d } : {},
            ...l.href ? {} : { tabIndex: 0 },
            "aria-owns": l.items ? `dropdown-${l.id}` : null,
            className: Dn(
              l.class,
              l.selected && B.NAV_ITEM_SELECTED,
              d && B.OPEN_LINK
            ),
            "data-testid": "nav-item",
            title: l.type === "icon-home" && y ? `${y} home page` : l.text,
            ref: u,
            children: x
          }
        ),
        l.items && /* @__PURE__ */ b.jsx(
          R1,
          {
            items: l.items,
            buttons: l.buttons,
            dropdownName: l.text,
            classes: Dn(
              PA(l.id),
              d && B.OPENED
            ),
            listId: `dropdown-${l.id}`,
            opened: d,
            parentLink: u
          }
        )
      ]
    }
  );
};
H1.propTypes = {
  link: $f,
  setItemOpened: E.func,
  itemOpened: E.number
};
const rT = "Header buttons cannot have both an onClick and an href property as this breaks accessibility. Please remove one", _A = () => {
  const {
    navTree: l = [],
    mobileNavTree: o = [],
    buttons: c = [],
    breakpoint: s,
    itemOpened: u,
    setItemOpened: d
  } = Kn(), h = Or(s), p = (w) => {
    u === w ? d(() => {
    }) : setTimeout(() => d(() => w), 1);
  }, y = (w) => {
    w.onClick && w.href && console.error(rT);
  }, O = (w) => () => {
    Mt({
      event: "link",
      action: "click",
      name: "onclick",
      region: "navbar",
      type: "internal link",
      section: "main navbar",
      text: w.text
    }), w.onClick && w.onClick();
  }, M = (w, x) => {
    const $ = { ...w, id: x }, q = o0(`${w.text}-${x}-`).next().value;
    return /* @__PURE__ */ b.jsx(
      H1,
      {
        link: $,
        setItemOpened: () => p(x),
        itemOpened: u
      },
      q
    );
  };
  return (
    // @ts-ignore
    /* @__PURE__ */ b.jsxs(nT, { breakpoint: s, "data-testid": "navigation", "aria-label": "Site", children: [
      ((l == null ? void 0 : l.length) || (o == null ? void 0 : o.length) || (c == null ? void 0 : c.length)) && /* @__PURE__ */ b.jsxs("div", { className: B.CONTENT_CONTAINER, children: [
        ((l == null ? void 0 : l.length) || (o == null ? void 0 : o.length)) && /* @__PURE__ */ b.jsx("ul", { className: B.NAV_LIST, children: o != null && o.length && h ? o == null ? void 0 : o.map((w, x) => M(w, x)) : l == null ? void 0 : l.map((w, x) => M(w, x)) }),
        !!(c != null && c.length) && /* @__PURE__ */ b.jsx(
          "form",
          {
            className: B.BUTTONS_CONTAINER,
            "data-testid": "buttons-container",
            children: c.map((w) => (y(w), /* @__PURE__ */ e0(
              Zi,
              {
                ...w,
                key: w.text,
                onClick: O(w)
              }
            )))
          }
        )
      ] }),
      h && /* @__PURE__ */ b.jsx(w1, {})
    ] })
  );
}, cT = "data:image/png;base64,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", uT = He.div`
  margin: 0.5rem 0;
  a {
    display: inline-block;
    &:not(:last-child) {
      border-right: 1px solid ${ln};
      margin-right: 1.5rem;
      padding-right: 1.5rem;
    }
    img {
      height: 52px;
      width: auto;
      &.${B.LOGO_VERT} {
        display: initial;
      }
      &.${B.LOGO_HORIZ} {
        display: none;
      }
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    margin: 0.5rem 0 1rem 1rem;
    a {
      &:not(:last-child) {
        margin-right: 1rem;
        padding-right: 1rem;
      }
      img {
        height: 32px;
        width: auto;
        &.${B.LOGO_VERT} {
          display: none;
        }
        &.${B.LOGO_HORIZ} {
          height: 24px;
          width: auto;
          display: initial;
        }
      }
    }
  }
  @media (max-width: 370px) {
    margin: 0.5rem 0 1rem 0.5rem;
    a {
      &:not(:last-child) {
        margin-right: 0.5rem;
        padding-right: 0.5rem;
      }
      img {
        height: 29px;
        &.${B.LOGO_HORIZ} {
          height: 21px;
        }
      }
    }
  }
`, sT = () => {
  const { partnerLogo: l, logo: o, breakpoint: c } = Kn();
  return (
    // @ts-ignore
    /* @__PURE__ */ b.jsxs(uT, { breakpoint: c, "data-testid": "partner", children: [
      /* @__PURE__ */ b.jsx(
        "a",
        {
          href: (l == null ? void 0 : l.brandLink) ?? "https://starbucks.asu.edu/",
          onClick: () => Mt({
            event: "link",
            action: "click",
            name: "onclick",
            region: "navbar",
            type: "internal link",
            section: "main navbar",
            text: "partner logo"
          }),
          children: /* @__PURE__ */ b.jsx(
            "img",
            {
              src: (l == null ? void 0 : l.src) ?? cT,
              alt: (l == null ? void 0 : l.alt) ?? "ASU Starbucks logo",
              width: "232",
              height: "81",
              decoding: "async",
              fetchpriority: "high"
            }
          )
        }
      ),
      /* @__PURE__ */ b.jsxs(
        "a",
        {
          href: (o == null ? void 0 : o.brandLink) ?? "https://asu.edu",
          onClick: () => Mt({ text: "asu logo" }),
          children: [
            /* @__PURE__ */ b.jsx(
              "img",
              {
                className: B.LOGO_VERT,
                src: (o == null ? void 0 : o.src) ?? D1,
                alt: (o == null ? void 0 : o.alt) ?? "Arizona State University logo",
                width: "303",
                height: "234",
                decoding: "async",
                fetchpriority: "high"
              }
            ),
            /* @__PURE__ */ b.jsx(
              "img",
              {
                className: B.LOGO_HORIZ,
                src: (o == null ? void 0 : o.mobileSrc) ?? B1,
                alt: (o == null ? void 0 : o.alt) ?? "Arizona State University logo",
                width: "400",
                height: "72",
                decoding: "async",
                fetchpriority: "high"
              }
            )
          ]
        }
      )
    ] })
  );
}, fT = (l, o) => {
  const c = new Date(l);
  return c.setMinutes(c.getMinutes() + o), c;
}, dT = (l) => {
  const o = "localhost", c = "title_loaded", s = /* @__PURE__ */ new Date(), u = l || window.location.hostname, d = localStorage.getItem("title_loaded"), h = s.getTime() > parseInt(d, 10), p = u === o, y = document.referrer.includes(u);
  if (p || !y && (!d || h)) {
    const M = fT(s, 10).getTime();
    return localStorage.setItem(c, M.toString()), !0;
  }
  return !1;
}, mT = {
  "992px": "993px",
  "1260px": "1261px"
}, $A = He.div`
  line-height: 1;
  font-size: 1rem;
  font-weight: 700;
  padding: 0 2rem 1rem 2rem;
  letter-spacing: -1px;
  display: inline-block;
  margin: 0;
  width: max-content;

  &.active {
    background-position: -200%;
  }

  > .${B.UNIT_NAME} {
    display: none;
  }
  .${B.UNIT_NAME},
    .${B.SUBUNIT_NAME},
    .${B.TITLE_SUBUNIT_NAME} {
    color: ${on};
  }

  .${B.SUBUNIT_NAME}, .${B.TITLE_SUBUNIT_NAME} {
    background-image: linear-gradient(
      to right,
      transparent 51%,
      ${Qd} 51%,
      95%,
      transparent
    );
    background-position: 0 0;
    background-size: 200%;
    display: inline-block;
    transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
    transition-duration: 1.5s;
    &.active {
      background-position: -200%;
    }
  }

  @media (min-width: ${({ breakpoint: l }) => mT[l]}) {
    line-height: 1;
    font-weight: 700;
    padding: 0;
    margin: 1rem 0 0.5rem 0;
    > .${B.UNIT_NAME} {
      font-size: 1rem;
      margin-bottom: 0.5rem;
      display: block;

      :hover {
        text-decoration: underline;
      }
    }
    .${B.SUBUNIT_NAME} {
      font-size: 1.5rem;
      margin-bottom: 0;
      display: inline-block;

      :hover {
        text-decoration: underline;
      }
    }
    .${B.TITLE_SUBUNIT_NAME} {
      font-size: 2rem;
      font-weight: 700;
      display: inline-block;
      margin: 0.5rem 0 0.5rem 0;

      :hover {
        text-decoration: underline;
      }
    }
  }
`, j1 = () => {
  const [l, o] = vn(!1), { title: c, parentOrg: s, parentOrgUrl: u, baseUrl: d, breakpoint: h, animateTitle: p } = Kn();
  return Ze(() => {
    if (p !== !1) {
      let y = d === "/" ? window.location.hostname : d;
      !y.includes(window.location.hostname) && y.indexOf("/") === 0 && (y = window.location.hostname + y), dT(y) && o(!0);
    }
  }, [l, p, d]), s ? /* @__PURE__ */ b.jsxs(
    $A,
    {
      breakpoint: h,
      className: B.TITLE,
      "data-testid": "title",
      children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: B.UNIT_NAME,
            href: u,
            onClick: () => Mt({
              event: "link",
              action: "click",
              name: "onclick",
              region: "navbar",
              type: "internal link",
              section: "main navbar",
              text: s
            }),
            title: `${s} home page`,
            children: s
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: Dn(
              B.SUBUNIT_NAME,
              l && "active"
            ),
            href: d,
            onClick: () => Mt({
              event: "link",
              action: "click",
              name: "onclick",
              region: "navbar",
              type: "internal link",
              section: "main navbar",
              text: c
            }),
            title: `${c} home page`,
            children: c
          }
        )
      ]
    }
  ) : /* @__PURE__ */ b.jsx(
    $A,
    {
      breakpoint: h,
      className: B.TITLE,
      "data-testid": "title",
      children: /* @__PURE__ */ b.jsx(
        "a",
        {
          className: Dn(
            B.TITLE_SUBUNIT_NAME,
            l && "active"
          ),
          href: d,
          onClick: () => Mt({
            event: "link",
            action: "click",
            name: "onclick",
            region: "navbar",
            type: "internal link",
            section: "main navbar",
            text: c
          }),
          title: `${c} home page`,
          children: c
        }
      )
    }
  );
};
j1.propTypes = { ...Fc };
const hT = () => {
  const {
    breakpoint: l,
    isPartner: o,
    hasNavigation: c,
    itemOpened: s,
    setItemOpened: u,
    mobileMenuOpen: d,
    setMobileMenuOpen: h,
    mobileMenuToggleRef: p,
    headerTop: y
  } = Kn(), O = Or(l), M = () => {
    h((x) => !x);
  };
  Ze(() => (document.body.style.overflow = d || s !== void 0 ? "hidden" : "unset", () => {
    document.body.style.overflow = "unset";
  }), [d, s, O]), Ze(() => {
    h(!1), u();
  }, [O]);
  const w = () => {
    M(), Mt({
      event: "collapse",
      action: d ? "close" : "open",
      type: "click",
      text: "menu button tablet"
    });
  };
  return /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    !O && /* @__PURE__ */ b.jsx(w1, {}),
    /* @__PURE__ */ b.jsx($E, { breakpoint: l, headerTop: y, children: /* @__PURE__ */ b.jsx("div", { className: "container-xl", children: /* @__PURE__ */ b.jsx("div", { className: B.HEADER_MAIN, children: /* @__PURE__ */ b.jsxs(
      "div",
      {
        className: Dn(
          B.NAVBAR,
          B.NAVBAR_EXPAND_XL,
          o && B.PARTNER,
          d && B.MOBILE_MENU_OPEN
        ),
        children: [
          !o && /* @__PURE__ */ b.jsx(eT, {}),
          /* @__PURE__ */ b.jsxs(
            "button",
            {
              ref: p,
              className: Dn(
                B.NAVBAR_TOGGLER,
                !d && B.COLLAPSED
              ),
              type: "button",
              onClick: w,
              "aria-label": d ? "Close menu" : "Open menu",
              "aria-expanded": d,
              children: [
                /* @__PURE__ */ b.jsx(
                  "img",
                  {
                    src: qE,
                    alt: "Menu and Search Icon",
                    className: B.MENU_SEARCH_ICON
                  }
                ),
                /* @__PURE__ */ b.jsx(
                  Ke,
                  {
                    icon: o3,
                    alt: "",
                    className: B.MENU_CLOSE_ICON
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ b.jsxs(
            "div",
            {
              className: Dn(
                !o && B.EXPAND_TITLE,
                o && B.PARTNER_TITLE,
                !c && B.NO_NAVIGATION
              ),
              children: [
                o ? /* @__PURE__ */ b.jsx(sT, {}) : /* @__PURE__ */ b.jsx(j1, {}),
                !O && /* @__PURE__ */ b.jsx(_A, {})
              ]
            }
          ),
          d && O && /* @__PURE__ */ b.jsx(N1, {}),
          d && O && /* @__PURE__ */ b.jsx(_A, {})
        ]
      }
    ) }) }) })
  ] });
}, gT = (l, o) => l == null ? void 0 : l.findIndex(
  (c) => {
    var s;
    return (c == null ? void 0 : c.href) === o || // !Some applications might send invalid items props as an empty string
    Array.isArray(c.items) && ((s = c.items) == null ? void 0 : s.flat().find(({ href: u }) => u === o));
  }
), pT = (l) => l == null ? void 0 : l.find((o) => o.selected), t0 = (l) => {
  if (!Array.isArray(l) || l.length === 0 || pT(l))
    return l;
  let o = "";
  if (window != null && window.location && (o = window.location.pathname + window.location.search), !o)
    return l;
  const c = gT(l, o);
  if (c === -1)
    return l;
  const s = [...l];
  return s[c].selected = !0, s;
}, X1 = { Lg: "992px", Xl: "1260px" }, AT = JS`
  html {
    scrollbar-gutter: stable;
  }
`, yT = He.header`
  font-family:
    Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  .container-xl {
    height: 100%;
    max-width: 1224px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
  }
  button,
  a {
    text-decoration: none;
    &:focus {
      outline: none !important;
      box-shadow:
        0px 0px 0px 2px ${qn},
        0px 0px 0px 4px ${on} !important;
    }
  }
  @media (min-width: ${({ breakpoint: l }) => X1[l]}) {
    &.scrolled {
      .${B.TITLE} {
        margin: 0.5rem 0 0 0;
      }
      a.${B.UNIT_NAME} {
        display: none;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      a.${B.SUBUNIT_NAME} {
        margin: 0.52rem 0;
      }
      a.${B.SUBUNIT_NAME}, a.${B.TITLE_SUBUNIT_NAME} {
        font-size: 1.5em;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      .navbar-brand img {
        height: 64px;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
        margin: 12px 1rem 12px 0;
      }
    }
  }
  @media (max-width: 1260px) {
    .container-xl {
      padding-left: 0;
      padding-right: 0;
      max-width: 100%;
    }
  }
`, vT = He.div`
  font-family:
    Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  .container-xl {
    height: 100%;
    max-width: 1224px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
  }
  button,
  a {
    text-decoration: none;
    &:focus {
      outline: none !important;
      box-shadow:
        0px 0px 0px 2px ${qn},
        0px 0px 0px 4px ${on} !important;
    }
  }
  @media (min-width: ${({ breakpoint: l }) => X1[l]}) {
    &.scrolled {
      .${B.TITLE} {
        margin: 0.5rem 0 0 0;
      }
      a.${B.UNIT_NAME} {
        display: none;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      a.${B.SUBUNIT_NAME} {
        margin: 0.52rem 0;
      }
      a.${B.SUBUNIT_NAME}, a.${B.TITLE_SUBUNIT_NAME} {
        font-size: 1.5em;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      .navbar-brand img {
        height: 64px;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
        margin: 12px 1rem 12px 0;
      }
    }
  }
  @media (max-width: 1260px) {
    .container-xl {
      padding-left: 0;
      padding-right: 0;
      max-width: 100%;
    }
  }
`, Q1 = ({
  isPartner: l = !1,
  navTree: o,
  title: c,
  baseUrl: s = "/",
  parentOrg: u,
  parentOrgUrl: d,
  partnerLogo: h,
  logo: p,
  loggedIn: y,
  userName: O,
  loginLink: M,
  onLoginClick: w,
  logoutLink: x,
  onLogoutClick: $,
  buttons: j,
  breakpoint: q = "Xl",
  animateTitle: I = !1,
  expandOnHover: K = !1,
  mobileNavTree: H,
  searchUrl: et,
  site: nt,
  renderDiv: V = "false"
}) => {
  const P = t0(o) || [], G = t0(H) || [], W = Yl(null), ct = Yl(null), [Tt, yt] = vn(void 0), [zt, Ct] = vn(!1), [le, Nt] = vn(150), [Y, X] = vn(0), Z = (rt = void 0) => {
    yt(rt);
  }, ut = (rt = !1) => {
    ct != null && ct.current && typeof ct.current.focus == "function" && ct.current.focus(), Ct(rt);
  }, gt = () => {
    W != null && W.current && (W.current.focus(), typeof window < "u" && window.scrollTo(0, 0)), ut(), Z(), typeof document < "u" && (document.body.style.overflow = "unset");
  }, ft = () => {
    if (typeof window > "u") return;
    const rt = window.scrollY;
    W != null && W.current && (rt > W.current.getBoundingClientRect().top ? W.current.classList.add("scrolled") : W.current.classList.remove("scrolled"), X(W.current.getBoundingClientRect().top), Nt(W.current.getBoundingClientRect().bottom));
  };
  Ze(() => {
    typeof window < "u" && c0({
      packageName: "component-header",
      component: "Component Header",
      type: "NA",
      configuration: {
        site: nt,
        isPartner: l,
        searchUrl: et,
        navTree: P,
        parentOrg: u,
        buttons: j,
        mobileNavTree: G
      }
    });
  }, []), Ze(() => {
    W != null && W.current && (Nt(W.current.getBoundingClientRect().bottom), X(W.current.getBoundingClientRect().top));
  }, [W, zt]), Ze(() => {
    if (typeof window > "u") return;
    const rt = () => zb(ft, 100);
    return window.addEventListener("scroll", rt), () => {
      window.removeEventListener("scroll", rt);
    };
  }, []);
  const Bt = () => {
    const rt = V === "true" ? vT : yT;
    return /* @__PURE__ */ b.jsx(rt, { id: "asuHeader", breakpoint: q, ref: W, children: /* @__PURE__ */ b.jsx(hT, {}) });
  };
  return /* @__PURE__ */ b.jsxs(
    C1,
    {
      initialValue: {
        isPartner: l,
        navTree: P,
        title: c,
        baseUrl: s,
        parentOrg: u,
        parentOrgUrl: d,
        partnerLogo: h,
        logo: p,
        loggedIn: y,
        userName: O,
        loginLink: M,
        onLoginClick: w,
        logoutLink: x,
        onLogoutClick: $,
        buttons: j,
        breakpoint: q,
        animateTitle: I,
        expandOnHover: K,
        mobileNavTree: G,
        hasNavigation: !!(P != null && P.length) || !!(G != null && G.length),
        searchUrl: et,
        headerTop: Y,
        headerHeight: le,
        itemOpened: Tt,
        setItemOpened: Z,
        mobileMenuOpen: zt,
        setMobileMenuOpen: ut,
        singlePageAppReset: gt,
        mobileMenuToggleRef: ct,
        site: nt
      },
      children: [
        /* @__PURE__ */ b.jsx(AT, {}),
        Bt()
      ]
    }
  );
};
Q1.propTypes = { ...u0 };
const bT = (l, o, c) => {
  n0.createRoot(c).render(ee.createElement(l, o));
}, TT = ({ targetSelector: l, props: o }) => {
  bT(Q1, o, document.querySelector(l));
};
export {
  T1 as ASUFooter,
  Q1 as ASUHeader,
  ET as initASUFooter,
  TT as initGlobalHeader
};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.4.11 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.11/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
